export const SCAN_RESULTS = [
    {
        title: "part-a-000-0",
        gabc: "In(cg)  (fg) that(hf) day(hg) the(g) mountains(g)  (g) sha}l(g) drop(hi) down(g) new(hg) wine,(f)  and(f) the(g) hills(g) shall(h) flow(j) with(g) milk(h) and(g) ho(g) ney,(gfd)  al(ik)  (f) le(fg) lu(g) ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-000.png",
        nextFileName: "./pages/part-a-001.png",
    },
    {
        title: "part-a-000-1",
        gabc: "Be(fg) joy(gjkji) -(kj)ful,(kj) 0(j) daughter(ji)  (h) of(hj) Si-(hg)on,(g) and(g) ex-(g) ceeding(g)  (g) glad,(fe) O(f) daughter(d)  (e) of(fh) Je-(h)ru-(g)sa-(fg)lem,(gfd)  al(ef) -(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-000.png",
        nextFileName: "./pages/part-a-001.png",
    },
    {
        title: "part-a-001-0",
        gabc: "e-(f)hold,(h) the(g) Lord(eg) cometh,(fe)  (d) and(e) all(e) his(e) Saints(df) with(hhi)  him;(h) and(h) there(h) shall(h) be(i) in(g) that(h) day(f) a(e) great(de) light,(fe)  al-(f)le-(e)lu-(d)ia.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png",
    },
    {
        title: "part-a-001-1",
        gabc: "o,(e) there(f) cometh(i)  (i) a(hi) mighty(j)  (h) TR(i) T(i) R(i) he(f) a-(i)lone(g)  reneweth(h)  (fe) -(f)&amp;(e) ru-(d)sa-(e)=(gfg) al(h) —~le(h) —lu(f) 1ia.(f) I(i)  (h)  (i)  (j) |(h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png",
    },
    {
        title: "part-a-001-2",
        gabc: "R(fdef) I(g) Thy(f) mer-(dc)cy,(df) O(fe) Lord.(e) &amp;(fdef) us.(g)  And(c) grant(df) us(f) thy(f) sal(fd) va(f) =(g) Thy(f) mer(dc) cy.(df) ",
        groupIndex: 2,
        filename: "./pages/part-a-001.png",
        nextFileName: "./pages/part-a-002.png",
    },
    {
        title: "part-a-002-0",
        gabc: "f.(c) Glory(g)  (g) be(g) to(g) the(g) Fa-(fh)ther,(h) and(h) to(g) the(h) Son,(f) and(f)  to(f) the(f) Ho(fd) ly(df) Ghost.(g) Shew(fd)  (ef) us.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png",
    },
    {
        title: "part-a-002-1",
        gabc: "a(e) a(c) a(e) a(g)  (h) .-(h) (f)  (g) L](g) &amp;(h)  (f) a(g) [(f) ](e)  (d) e(e)  2(g)  (f) a(d)  (e) ](f)  (e)  (d) (O(c)  (c) a(e)  (f) a(g) a(f)  (e) [(d)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png",
    },
    {
        title: "part-a-002-2",
        gabc: "h&#39;.‘F-(d) (d)  (f) Name(g) of(f) the(h) Lord(h) com(hjijkj) eth(hih) from(h)  a(gf) far:(ghihghg) and(g) his(eg) glo-(hg)-(fg)tilleth(fe) ul-(c)7(dgge) l-(fe) earth.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-002.png",
        nextFileName: "./pages/part-a-003.png",
    },
    {
        title: "part-a-003-0",
        gabc: ";(gi)  (f)  (f)  (fh)  (e) ~(fh)  (hg)  (fg)  (g)  (i)  (hg)  (f)  (g) .(hg)  (f)  (ef)  (f)  I(ig~)  (fi)  (f)  (fi)  (h) M(hg)  (fg)  (fe) u-(e)&amp;(e) =(f)  (g)  (hg)  (f)  (gf)  (ef)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png",
    },
    {
        title: "part-a-003-1",
        gabc: "s(e)  (c) N(e) 0(g)  (h) g(i)  (h) :(h)  (g)  (h)  (j) T(j)  (ig)  (h)  (i)  (h)  These(h) &quot;(h)  (i) [](g) Melodies(eg) 0(f)  (e) -(d)0(e) [(c) 0(e) 0(g)  (h) 0(i) the(h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png",
    },
    {
        title: "part-a-003-2",
        gabc: "Fear(j) [(hgf) Ma-(gh)ry,(gh) for(f) thou(g) hast(g) found(h) fa(ijkji) vour(gh) with(i)  the(h) Lord:(g) behold,(g)  (h) thou(ge) shalt(f) *(gh) it(fed) and(d) bring(def) forth(fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-003.png",
        nextFileName: "./pages/part-a-004.png",
    },
    {
        title: "part-a-004-0",
        gabc: "a(h) Son,(gfd) al-(ef)le-(fg)1lu-(g)1a.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-004.png",
        nextFileName: "./pages/part-a-005.png",
    },
    {
        title: "part-a-004-1",
        gabc: "L(c) ift(dhi) up(h) thine(hjj) evyes,(h) to(g) Je(ghg) ru-(fe)sa-(fg)lem,(gfed) and(d) see(fgh)  the(g) pow—er(h)  (g) of(f) the(g) King:(gh) be-(d)hold(e) the(f) Sa(g) viour(ge) I(f)  com-(f)eth(fe) to(d) loose(fe) thee(dc) from(e) thy(fe) chain.(d) [(h) ®(g) &amp;(f)  (gf) »(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-004.png",
        nextFileName: "./pages/part-a-005.png",
    },
    {
        title: "part-a-005-0",
        gabc: "eck(f) ye(e) the(f) Lord(hi) Twhile(h) he(i) may(j) be(h) found:(i) cgl](fi) e(g) E(h)  on(ef) him(f) while(e) he(d) is(e) -(fg)al-(h)le-(h).(f) ia,(f) ol(i) :&quot;hl(h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png",
    },
    {
        title: "part-a-005-1",
        gabc: "A(h) ter(hg) T(hiih) cometh(h)  (hg) one(hiih) migh-(h)ti(h) er(g) than(fg) I,(e) the(e)  latchet(fg)  (f) of(f) whose(efede) shoes(ed) I(def) am(f) not(e) wor-(fe)thy(f) to(f)  =(fg) loose.(e) R(h)  (f) ](h) i(i) T(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png",
    },
    {
        title: "part-a-005-2",
        gabc: "I(h) will(hi) waittup(i)  (i) on(h) the(i) Lord(j) my(h) Saviour:(i)  (i) and(i)  I(gi) will(hg) look(f) for(e) him(f) while(e) he(d) 1is(e) near,(fg)  al(h) le(h) lu(f) ia.(f)  (i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-005.png",
        nextFileName: "./pages/part-a-006.png",
    },
    {
        title: "part-a-006-0",
        gabc: "ut(e) of(f) E-(hi)gypt!(i) have(i) I(i) call_ed(i)  (h) my(hj) Son:(i) e(gihg)  shall(f) come(f) to(e) o(de) his(fh) people.(f)  (f) [(i) S(h)  (i) —-(j) (h) B(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-006.png",
        nextFileName: "./pages/part-a-007.png",
    },
    {
        title: "part-a-006-1",
        gabc: "“(c) 0(d) Lord,(f) in(fg) peace;(g) T(f) visit(g) us(h) .(i) thy(j) sal-(ih) (g)  vation,(g)  (g) that(fih) we(fg) a(i) e(h) rejoice(g) before(f)  (e) thee(d) with(c) a(d)  a(e) Perfect(d) heart.(c)  (h)  (g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-006.png",
        nextFileName: "./pages/part-a-007.png",
    },
    {
        title: "part-a-007-0",
        gabc: "B(dd) ia,(c) e(d) o(ef) st(g) e(fe)  (ddc) Fin(f) e(g) o(h)  of(g) hea-(hg)ven,(f) with(f) pow-(f)er(e) and(f) great(fg) glo(fe) .,(dc)  al(d) —le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png",
    },
    {
        title: "part-a-007-1",
        gabc: "i-(cg) (g) ontis(g) our(g) strong(ig) ci(fg) ty,(g) T(e) Saviour(g)  (f) will(g)  God(fe) ap-(de)point(f) with(ed) in(c) .(c) for(ghgfg) walls(g) and(gj) bul-(j) warks:(g) o-(g)pen(g) ye(h) the(f) gates,(geedef) for(f) God(fe) himsel(d)  (ef)  is(d) with(dc) al(cd) le-(d)lu(c) ia.(c)  (h)  (g)  (f)  (eg) ",
        groupIndex: 1,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png",
    },
    {
        title: "part-a-007-2",
        gabc: "a(c)  (e) in(e) a(e) time(g) ap(h) point-(ihj)ed,(i) the(i) Lord(jh) will(hi) come,(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-007.png",
        nextFileName: "./pages/part-a-008.png",
    },
    {
        title: "part-a-008-0",
        gabc: "and(h) will(fh) not(fg) lie:(ef) though(d) he(f) tar-(hhi)ry,(i) wait(h) for(f) him:(fe)  [(e) he(e) a(e) -(ef)surely(dc) he(d) ,(f) not(f) -(e)ry,(ed)  (c)  al(cd) le(de) lu(e) a-(e)1ia.(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png",
    },
    {
        title: "part-a-008-1",
        gabc: "B(g) =(hj) our(j) Lord(j) shall(j) come(j) with(h) pow-(ih)er,(g) to(g) en-(h) lighten(j)  (i) the(g) eyes(gh) of(f) his(g) .(f) servants,(fd) al(f) le(fg) -(e)ia.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png",
    },
    {
        title: "part-a-008-2",
        gabc: "rt(fg) thou(g)  (h) should(g)  (j) come,(jih) or(j) do(ji) we(hg) look(fgh) for(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-008.png",
        nextFileName: "./pages/part-a-009.png",
    },
    {
        title: "part-a-009-0",
        gabc: "an-(h)oth-(g)er?(g) Go(j) and(i) shew(j) John(h) those(gf) things(egh) whjgy,(hgf)  ye(h) do(ji) see:(g) the(hj) blind(j) receive(i)  (jk) their(h) sight,(hg) the(g)  dead(h) are(fg) rais-(gh)ed,(h) and(j) the(jk) poor(kjih) have(i) the(h) g0s-(ji)pe](g)  preached(hg)  (f) un-(g)to(gh) them,(h) al(j) -(hjhf)lu-(hh)ia,(g)  (j)  (i)  (j)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-009.png",
        nextFileName: "./pages/part-a-010.png",
    },
    {
        title: "part-a-009-1",
        gabc: "lessed(gj)  (h) art(g) thou,(h) [(gf) =(gh) -(gh)a(g) thou(gf) 0(g) be-(h)liey-(h) ed(j) the(k) Lord:(jkj) and(h) there(i) shall(j) be(h) a(h) per(g) formance(h)  (g)  in(fg) thee(g) of(gh) those(fe) things(d) which(e) were(f) told(gh) thee(h)  from(g) the(fg) AP(gfd) al(ef) L(fg) TN(g) ia.(g) I(j)  (i) g(j) e(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-009.png",
        nextFileName: "./pages/part-a-010.png",
    },
    {
        title: "part-a-010-0",
        gabc: "e-(f)hold(e) the(f) King(h) shall(ij)  (i) the(i) Lord(hi) of(j) the(h) earth,(i)  and(i) he(f) shall(i) take(g) a-(h)way(f) the(e) yoke(f) of(e) our(de) cap-(fh)ti-(f)vi-(f)ty.(f)   (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png",
    },
    {
        title: "part-a-010-1",
        gabc: "he(f) voice(f) of(f) one(e) T(f) W(e) the(d)  (f) g(hhi) wilderness,(h) ey(h) Prepare(i) T(hi)  ye(f) the(f) way(fe) of(f) the(e) Lord,(d) make(d) %(de) in(e) the(f)  des—ert(de)  (e) a(f) highway(h)  (e) for(e) our(fe) God.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png",
    },
    {
        title: "part-a-010-2",
        gabc: "i-(hi)on,(i) thou(h) shalt(i) be(j) re-(h)new-(i)ed,(i) and(f) shalt(i) see(g) thy(h)  (f)  righteous(f) e(fe) One,(fe) he(d) that(e) cometh(f)  (g) un-(h)to(hg) thee.(f) ](i) ](h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-010.png",
        nextFileName: "./pages/part-a-011.png",
    },
    {
        title: "part-a-011-0",
        gabc: "[(e) that(f) cometh(h)  (h) af-(h)ter(ij) me(i) tis(h) preferred(i)  (j) =(i) be-(h);(i) .(i)  the(i) latchet(fi) a(g) of(h) whose(fe) shoes(f) I(e) am(d) L)(e) worthy(f)  (g) ¢,(h)  -(h)-(f)n—(i) =(h)  (i) &quot;~(j) =(h) 4(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png",
    },
    {
        title: "part-a-011-1",
        gabc: "S(c) ing(g) un-(h)to(i) the(j) Lord(ij) Ta(hf) new(h) song;(g) and(i) his(hf) praise(h)  from(gi)  (g) the(h) end(hi) of(f) the(f) earth.(e)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png",
    },
    {
        title: "part-a-011-2",
        gabc: "B(c)  (c)  (d) e_fore(f) me(fg) there(g) was(g) no(g) God(gh) form-(h)ed,(hghihgg) neither(f) [](g) ",
        groupIndex: 2,
        filename: "./pages/part-a-011.png",
        nextFileName: "./pages/part-a-012.png",
    },
    {
        title: "part-a-012-0",
        gabc: "shall(gh) there(g) be(hg) af-(f)ter(ghg) me:(hih) un-(f)to(h) me(j) ev-(h)ery(g) knee(fe)  shall(def) bow,(fc) and(fe) me(g) shall(fe) ev-(dc)ery(df) tongue(g) confess.(fe)  (d)  a(h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-012.png",
        nextFileName: "./pages/part-a-013.png",
    },
    {
        title: "part-a-012-1",
        gabc: "T(ikc)  (c) he(f) Lord(h) will(g) surely(h)  (g) .(e) and(f) will(gh) not(ef) tarry:(d)  (d) and(d)  will(f) bring(g) to(g) light(g) the(g) hid-(h)den(fg) things(g) of(fgh) darkness,(f)  (f)  and(f) will(g) ma(h) ni(g) fest(h) him-(g)sel(e) to(f) all(fg) na-(fe)tionms,(cd)  al(d) le(efe) lu(d) ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-012.png",
        nextFileName: "./pages/part-a-013.png",
    },
    {
        title: "part-a-013-0",
        gabc: "J(c)  (c)  (e) 1&#39;jow,&#39;(f)  (g)  (fe) with(f) great(d) rejoicing,(ef)  (fh)  (g) for(hj)  .(hi) Saviour(hg) :(h) cometh(g) un-(f)to(fe) thee,(d) al(e) le-(de)—(c) ia.(c) 1(h) &quot;](g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png",
    },
    {
        title: "part-a-013-1",
        gabc: "I(ik)  (g) win(gfd) place(fe) sal-(fg)va-(fh)tion(g) Tin(fh) Si-(h)on,(g) and(h) in(j) Je-(g) ru-(ik) (hg) sa-(fg)lem(g) my(hg) glo-(fe)ry,(d) al(f) -(fg)1lu-(g)ia.(g) |(j) =(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png",
    },
    {
        title: "part-a-013-2",
        gabc: "et(gicd)  (ff) us(e) live(f)  (g) righteously(h) and(i)  (gh) godly,T(f)  (f) looking(e)  (f) for(h)  e(gi) that(fe) blessed(g) I(ig) hope,(hg) and(e) the(f) coming(h) s(g) of(e) the(g) Lord.(f)   (gi)  (h)  (g)  (e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-013.png",
        nextFileName: "./pages/part-a-014.png",
    },
    {
        title: "part-a-014-0",
        gabc: "lessed(gj)  (h) art(g) thou,T(h) 0(gf) Ma-(gh)ry,(gh) for(g) thou(gf) hast(g) be-(h)liev-(h) ed(j) the(k) Lord:(jkj) and(h) there(i) shall(j) be(h) a(h) performance(g)  (h)  (g)  in(gf~) thee(g) of(hg) those(fe) things(d) which(e) were(f) told(gh) thee(h)  from(g) the(fg) Lord,(gfd) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (i) |(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-014.png",
        nextFileName: "./pages/part-a-015.png",
    },
    {
        title: "part-a-014-1",
        gabc: "rt(fg) thou(g) he(h) Tthat(g) should(j) come,(jih) or(j) do(ji) we(hg) look(gh) for(i)  an—oth—er?(h)  (g)  (g) Go(j) and(i) shew(j) John(h) those(gf) things(gh) which(hgf)  ye(h) do(ji) see:(g) the(hj) blind(j) 1(i) receive(jk) their(h) sight,(hg) the(g)  poor(jih) have(i) the(h) gos-(ji)pel(g)  dead(h) are(gf) rais-(gh)ed,(h) and(j) the(jk)  —(hg) preached(f) un-(g)to(gh) them,(h) al(j) v(hjhf) lu-(hh)ia.(g) -(j) (i)  (j) 0(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-014.png",
        nextFileName: "./pages/part-a-015.png",
    },
    {
        title: "part-a-015-0",
        gabc: "O(fhhg) 0(hfgfef) -(f)camest(f)  (f)  (f) out(g) of(f) the(f) mouth(gh) of(f)  the(ig)  (g) Most(ef) High,(e) and(f) reachest(cf)  (f) from(f) one(g) end(f) to(f) an-(f)oth-(g)er,(f)  mightily(gi)  (g)  (h) and(ijijkj)  (ij) sweetly(j) -(i)or-(h)der-(hg)ing(fh) all(h) things:(e)  v(gi) Come(ehhg) and(f) teach(gfef) us(fec) the(ef) way(hg) of(e) prudence.(gh)  (f) &quot;(h) pa(gf) e(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-015.png",
        nextFileName: "./pages/part-a-016.png",
    },
    {
        title: "part-a-015-1",
        gabc: "O(hgi)  (fhhg) a-(hf) (gf)  (df) and(f)  (f) Leader(g)  (f) of(f) the(f) house(g) of(hf) Is-(g) ra-(gi) (f) el,(e) who(f)  (cf) appearedst(f)  (f) in(f) the(f) bush(g) to(f) Mo(g) ses(f) in(f)  a(i)  (f) flame(g) of(h) fire,(ijijkj) and(j) gavest(j)  (i) him(h) the(h) law(hg) in(fh)  Si-(hgi) (h) nai:(e) Come(ehhg) and(h) redeem(f)  (gfef) us(fec) with(e) an(f) n(hg)  (e)  ed(g) arm.(f) N(h)  (gf)  (hg) 62(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-015.png",
        nextFileName: "./pages/part-a-016.png",
    },
    {
        title: "part-a-016-0",
        gabc: "(O(ig~)  (fhhg) PBoot(hf) of(gf)  (ef) Jesse,(f) which(f) standest(g)  (f) for(f) an(f) ensign(g)  (f)  of(gh) the(fg) people,(f)  (e) at(f) whom(cf) kings(fg) shall(f) shut(g) their(h)  mouths,(g)  (jijijkj) un-(j)to(i) whom(j) the(i) Gentiles(h)  (fh) shall(fe) seek:(e) Come(ehhg)  and(gi)  (h) de-(f)liv-(gf)er(ef) us,(fe) and(ef) tarry(hg)  (eg) not.(f) -(h) (gf) ‘I(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-016.png",
        nextFileName: "./pages/part-a-017.png",
    },
    {
        title: "part-a-016-1",
        gabc: "()(fhhg) Key(hf) of(gf)  (ef) -(f)and(f) Sceptre(g)  (f) of(f) the(f) house(g) of(hf) Is-(g) ra-(gi) (f) el;(e) that(f) o-(cf) (f) penest(f) and(f) no(g) man(f) shutteth,(fh)  (ijijkj) and(j) shut-(j) test(gi)  (i) and(h) no(hg) man(fh) o-(h)&quot;e(fgfe) peneth:(e) Come,(eh) and(g) bring(h) the(f) pri-(g) soners(hig~)  (f)  (f) out(fe) of(f) the(h) prison-(h)CH(fgfe) house,(e) them(eh) that(g) sit(h) in(f)  v(ig~) darkness(gfef)  (fe) and(e) the(f) 0(hg) shadow(e) of(h) death.(f) m(h)  (gf) e(hg)  (e) ](f) ",
        groupIndex: 1,
        filename: "./pages/part-a-016.png",
        nextFileName: "./pages/part-a-017.png",
    },
    {
        title: "part-a-017-0",
        gabc: "()(ig~)  (fhhg) Day(hfgfef) -(f)of(g)  (f)  (f) the(f) Light(gh) ev_er.(f)  (g)  last-(f)ing,(e) and(f) Sun(cf) of(f)  (g) righteousness:(h)  (ijijkj) Come(ji) ang(gh)  en-(gi) (fh)  (h) a(e) them(eh) that(g) sit(h) in(f) darkness(gfef)  (fe) a(e) the(f)  N(gi) A(hg) dow(e) of(gh) death.(f) IS(h) A(gf) A(hg) S(e) Mol(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png",
    },
    {
        title: "part-a-017-1",
        gabc: "[(hig~) O(fhhg) King(hf) of(gf) N(ef) Nations,+and(f) -(fh)their(g) i(f) Desire;(e) the(f) Cor-(cf) v(gi) ner-(gh)stone,(ijijkj) who(ji) makest(hg) v(fh) both(hhg) e(e) Come(ehhg) and(f) save(gf)  .(gi) o(ef) e(fec) whom(e) thou(f) ;(hg) [(e) of(gh) clay.(f) 11(h)  (gf) O(hg) &quot;1(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png",
    },
    {
        title: "part-a-017-2",
        gabc: "~(fhhg) Em(hf) &quot;~(gf) u-(ef)-(f)our(f) King(g) and(fh) Lawgiver,(g)  (f)  (e) the(f) De-(cf)",
        groupIndex: 2,
        filename: "./pages/part-a-017.png",
        nextFileName: "./pages/part-a-018.png",
    },
    {
        title: "part-a-018-0",
        gabc: "-(g)sire(fg) of(f) all(gh) o(j) tions(jijkj) and(j) their(hg) [(fh) Salvation:(h) ](e) Come(ehhg)  |(ig~) and(f) save(gfef) us,(fe)  (c) O(ef) Lord(hg) our(eg) God.(f) e(h) i(gf) A(hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-018.png",
        nextFileName: "./pages/part-a-019.png",
    },
    {
        title: "part-a-018-1",
        gabc: "0(hg~)  (fhhg) Virgin(h)  (f) of(gf) virgins,T(ef)  (f) how(gh) shall(fg) this(f) be?(e)  for(f) neither(cf)  (f) be-(f)fore(g) thee(f) was(f) a~ny(g)  (f) seen(g) like(h)  [(ig~) thee,(kijijkj) nor(ji) shall(h) there(hg) be(fh) af-(h)ter.(e) Daughters(eh)  (g)  of(ig~)  (h) Je-(f)ru-(gf)sa-(ef)lem,(f) -(fe)mar-(f)vel(h) ye(h) at(fgfe) me?(e)  The(hg~)  (eh) thing(hg) which(f) ye(gf) be-(ef)hold(fec) is(f) a(e) di-(f)vine(hg)  mys(ig~)  (e) te(gh) ry.(f) 1.~(f)  (h) &amp;/(gf)  (hg) 5(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-018.png",
        nextFileName: "./pages/part-a-019.png",
    },
    {
        title: "part-a-019-0",
        gabc: "e-(f)hold(e) the(f) Lord(h) shall(ij) _——_——_—_ﬁ(i) the(i) Prince(i) of(h) the(i)  kings(jk)  kings(j) of(i) the(h) earth:(i) bless-(gi)ed(hg) —(fe) they(f) that(e) 4,(d)  a(e) -(fg)ed(h) to(h) meet(f) him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png",
    },
    {
        title: "part-a-019-1",
        gabc: "hen(h) the(h) Son(h) of(hg) man(hiih)  (fghg) shall(e)  (hhg) he(f)  (fe) find(de)  faith(f) on(g) the(f) earth?(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png",
    },
    {
        title: "part-a-019-2",
        gabc: "0,(df) now(hf) com-(hi) (h) the(h) E(f) 0(e) of(f) the(e) :(d) wherein(d) a(e)  God(ig~)  (fe) N~(d) forth(ef) his(f) Son(h) in-(e)to(f) the(e) world.(d) |(h) I(i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-019.png",
        nextFileName: "./pages/part-a-020.png",
    },
    {
        title: "part-a-020-0",
        gabc: "he(f) Lord(e) shall(f) go(hi) forthTout(i)  (i) of(h) his(i) ho(j) Iy(h) place:(i)  he(gihg) shall(ef) come(f) to(e) save(de) his(fh) people.(f)  (f) &#39;(i) 7(h)  (i)  (j) |(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png",
    },
    {
        title: "part-a-020-1",
        gabc: "rop(f) down,(e) ye(f) heavens,(h)  (h) from(h) a-(ij)bove,(i) and(i) let(h) the(i)  skies(jh) pour(i) down(ij)  (h) righteousness:(g)  (f) let(f) the(i) earth(h) o(f) —pen,(f)  a(e) let(d) 0(e) bring(fg) forth(h) [(h) salvation.(f) e(f) &amp;(i) v(h) &amp;(i) 1(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png",
    },
    {
        title: "part-a-020-2",
        gabc: "end,(e) O(f) Lord,(h) the(hi) Lamb,T(i) the(i) Ruler(h)  (i) of(j) the(h) land,(i)  from(i) the(i) rock(fi) of(g) the(h) de-(fe)sert(f) un-(e)to(d) the(e) mount(f) of(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-020.png",
        nextFileName: "./pages/part-a-021.png",
    },
    {
        title: "part-a-021-0",
        gabc: "the(h) daughter(hg)  (hi) of(hg) Si-(f)on.(f) —(i) -(h) (i) =(j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png",
    },
    {
        title: "part-a-021-1",
        gabc: "That(c)  (c)  (e) thy(f) way,(h) O(ij) O(i) be(h)  (i) known(j) -(i)on(h) earth,(i)  thy(ig~)  (gihg) saving(f) »(e) health(f) a(e) mong(de) all(fh) nations.(f)  (f) |(i) R(h)  (i)  (j)  (h) |(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png",
    },
    {
        title: "part-a-021-2",
        gabc: "he(dd) ](c) was(d) .(ef) en(g) by(fe) Moses,(d)  (d) but(fg) grace(hg) and(gf) truth(f)  came(f) by(g) a(e) sus(fe) Christ.(d) ~(h) i(g) _(f) A(gh) ®(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png",
    },
    {
        title: "part-a-021-3",
        gabc: "T(c)  (c) he(d) prophets(dd) ](c) did(d) foretell(fe)  (ddc) that(f) a(g) Saviour(h)  (g) should(gf)  be(f) born(f) of(f) the(g) Virgin(e)  (ef) -(d)ry.(d) TR(h) e(g) -(f) (gh) :_H(g) ",
        groupIndex: 3,
        filename: "./pages/part-a-021.png",
        nextFileName: "./pages/part-a-022.png",
    },
    {
        title: "part-a-022-0",
        gabc: "T(ig~) he(f) Spi-(fgh)rit(f) Tof(f) the(f) Lord(fe) is(f) -(hg)on(e) me:(e) he(f) hath(g)  sent(g)  (f) me(e) to(g) preach(i) the(h) gospel(h)  (h) to(i) the(hg) poor.(f) Il(h) I(g) S|(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png",
    },
    {
        title: "part-a-022-1",
        gabc: "For(f) Si-(h)on’s(hi) sake(i) TI(i) will(h) not(i) S(j) my(ih) peace,(i) B(i) until(f) the(i)  righteous-(g) (h) ness(f) thereof(e)  (f) go(e) forth(de) as(fh) brightness(f)  (f) s(i) T(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png",
    },
    {
        title: "part-a-022-2",
        gabc: "Tell(ig~)  (h) it(hi) out(i) -(i)mong(h) the(i) nations,(j)  (i) and(h) say:Be-(i) (i) hold,(fi)  —(gi)  (gh) &quot;=(fe) 4(ef) Sa-(de)=(fh) @(f) 0@(f) 0w(i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png",
    },
    {
        title: "part-a-022-3",
        gabc: "ron(f) Si-(gh)on(h) draweth(h)  (g) nigh(h) the(ef) Lord(g) Al-(f)migh-(d)ty(d) to(d) ",
        groupIndex: 3,
        filename: "./pages/part-a-022.png",
        nextFileName: "./pages/part-a-023.png",
    },
    {
        title: "part-a-023-0",
        gabc: "bring(fe) salvation(fg)  (fe) [](c) un-(eg)to(e) o(fe) people.(d)  (d)  (h)  (g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png",
    },
    {
        title: "part-a-023-1",
        gabc: "urn(he) thee(f) &#39;a-(ed)gein,(efe) O(de)  (e) at(gh) the(if) last,(hg) and(i) do(i) pg(h)  de-(h)lay(ij) to(i) come(hghih) un-(ef)to(fh) thy(gf) servants.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png",
    },
    {
        title: "part-a-023-2",
        gabc: "F(c)  (c) ron(f) |(gh)  (h) Si_on(h) cometh(g) he(h) that(g) is(e) to(f) reign(g) as(fe) Lord:(d)  Fn-(f) (gh) man—u-(gf)el(f) is(fe) his(dc) migh-(d)ty(efe) Name.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png",
    },
    {
        title: "part-a-023-3",
        gabc: "Lord(g)  (hj) is(j) our(h) Lawgiver,(j)  (i) t(i) the(g) Lord(hi) is(i) our(h) King,(g) he(i)  .(h) himself(j) will(i) come,(g) and(h) will(f) save(g) us.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 3,
        filename: "./pages/part-a-023.png",
        nextFileName: "./pages/part-a-024.png",
    },
    {
        title: "part-a-024-0",
        gabc: "B(gi) e(fi) ve(hg) steadfast,T(ef)  (f) and(f) see(f) the(h) sal-(g)va-(e)tion(e) of(g) 0(e)  —(gi) Lord(f) with(gh) you.(f) I(h) a7(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png",
    },
    {
        title: "part-a-024-1",
        gabc: "U(e) to(f) thee,(h) 0(hi) Lord,(i) Tdo(i) I(i) lift(i) up(h) my(ij) soul:(i)  =(fi) and(g) de-(h)liv—-(f)I(e) me,(fe) for(d) I(e) flee(fg) S(h) to(hg) thee,(hi)  0(hg) Lord.(f)  (i)  (h)  (i)  (j)  (h) :(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png",
    },
    {
        title: "part-a-024-2",
        gabc: "C(gi) ome,(h) 0(hi) l..ord,T(i) and(i) do(hi) not(jh) tarry:(i)  (i) forgive(i)  (fi) the(g)  of(h) s(fe) ces(fe) of(d) thy(e) people(f)  (h) Is-(f)ra-(f)el.(f) W(i)  (h)  (hj)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-024.png",
        nextFileName: "./pages/part-a-025.png",
    },
    {
        title: "part-a-025-0",
        gabc: "Consi—der(f)  (hi) T(i) how(i) great(h) and(i) glorious(j)  (i) is(h) he(i) who(fi) en-(g) (h) tereth(fe)  in(fe) for(d) the(e) salva-(fg) (h) tion(hg) of(hi) his(hg) people.(f)  (f) =(i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png",
    },
    {
        title: "part-a-025-1",
        gabc: "His(d) Kingdom(dd)  (c) shall(d) be(efg) 1n-(fe)creas(d) d,(dc) and(c) of(d) his(f) peace(ff)  there(f) shall(ef) be(g) no(fe) end.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png",
    },
    {
        title: "part-a-025-2",
        gabc: "I(g) the(hi) Lord(i) tbring(j) near(h) my(i) e(i) righteousness;(h)  (g) it(h) shall(i) not(h) be(i)  far(g) off,(e) and(g) my(g) salvation(h)  (g)  (f) shall(g) not(gf) tar-(e)ry.(e) e(j)  (h) 1(j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png",
    },
    {
        title: "part-a-025-3",
        gabc: "Prepare(f)  (f) thyself,(i)  (h) O(g) Is-(e)ra-(f)el,(f) to(f) meet(h) thy(g) (B(e) Saviour,(e) for(ge)  he(fh) cometh.(f)  (f) [(h) &amp;(g)  (e) =(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-025.png",
        nextFileName: "./pages/part-a-026.png",
    },
    {
        title: "part-a-026-0",
        gabc: "will(hi)  (i)  (i)  (h) look(ij) -(h)to(i) the(j) Lord,(i) and(i) 1(f)  (i)  will(i) -(gh)for(f) the(e) God(f) of(e) my(de) sal-(fh)va-(f)tion.(f) |—I(i)  (h)  (hj)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png",
    },
    {
        title: "part-a-026-1",
        gabc: "Al(gj) ge-(h) (g)  (h) ne—ra—tions&#39;l&#39;(g) shall(fg) call(g) me(gh) blessed:(f)  (f) for(fg)  God(h) hath(g) re-(f)gard-(g)ed(h) the(h) low-(jk)1i-(j)ness(jijkj) of(h) his(h)  [(j) handmaiden.(g) a-(g)T(j) 00&quot;(i) I—I(j)  (h) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png",
    },
    {
        title: "part-a-026-2",
        gabc: "A(c)  (e) wake,(d) a(ef) ..(e) ta-(e)rise,(gh) O(i) Je(hf) ru-(h)sa-(h)lem:(g) loose(i)  thy-(i)self(i) from(h) the(h) bands(hj) of(i) thy(h) neck,(hghih) O(f) cap-(f).(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-026.png",
        nextFileName: "./pages/part-a-027.png",
    },
    {
        title: "part-a-027-0",
        gabc: "daughter(f)  (h) of(g) Si(ff) on.(e)  (h)  (g)  (h) .(f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png",
    },
    {
        title: "part-a-027-1",
        gabc: "B(j) hold(ji) the(hg) handmaid(ih~)  (h) of(gh) the(h) Lord;(g) -(ge)it(g) I————(f) ](e)  me(f) ac-(d)a(e) ing(f) to(fgh) thy(h) word.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png",
    },
    {
        title: "part-a-027-2",
        gabc: "R(c)  (h) joice(hg) ye(f) Twith(f) Je-(e)ru-(f)sa-(h)em;(hiih) and(fh) be(hi) glad(j) with(ih)  her,(hif) all(fi) ye(h) that(gh) love(f) her,(ed) for-(ef)o(d) er.(d) e(h)  (i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png",
    },
    {
        title: "part-a-027-3",
        gabc: "—(c)  (dc) is(f) the(g)  (fh) witnessTwhich(h)  (h) John(hj) bare,(hg) saying:(fh)  (g) He(g) that(g)  i(g) 2(eg) af-(h)ter(g) e(fgh) is(e) =(c) preferred(eg) I(e) be-(fe)fore(d) me.(d) I(hg) IMMa_dp(f) ——(gh) Al(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-027.png",
        nextFileName: "./pages/part-a-028.png",
    },
    {
        title: "part-a-028-0",
        gabc: "Blow(f) ye(c) the(d) trumpet(dhi)  (h) Tin(hgfg) Si(fghghi) on,(hgg) for(f) the(g) day(h) of(g) 3(f)  Lord(g) is(dg) nigh&#39;(gfed) ———(fed) at(cdfede) hand:(ed) behold,(f)  (fg) he(fe) cometh(c)  (d) to(f) say,(ed)  us,(def) al-(c)le-(d)lu-(fg)ia,(fe) al-(g)le(fe) lu-(d)ia.(d) &quot;(h) =(g) 3(f)  (fh) I(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-028.png",
        nextFileName: "./pages/part-a-029.png",
    },
    {
        title: "part-a-028-1",
        gabc: "TtheDesire(ik)  (d)  (dc)  (f)  (g) of(fh)  (h) all(h) nations(ih)  (g) shall(fh) come:(g) and(g) the(g) house(g)  ](e) the(g) Lord(h) shall(g) be(f)  (f) filledwith(g)  (f)  (fe) al-(dc) (d)  (efe) lu-(d)ia.(d)  .(h)  (g) Erunt(f) prava(gh)  (gf)  T(c) He(cd) crooked(dh) 1(hi) shall(h) be(g) made(h) straight,and(hg)  (f) the(g) rough(hgef) ple(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-028.png",
        nextFileName: "./pages/part-a-029.png",
    },
    {
        title: "part-a-029-0",
        gabc: "plain:(ki~)  (d) come,(fg) C(f) Lord,(d) and(fe) do(g) not(f) tarty,(fe)  (dc) al-(d)le-(efe)lu-(d)ia.(d)  4(h)  (g) Omnipotens(f)  (fh)  (g)  Thine(gi)  (h) Almighty(gh)  (f) |(fe) A(f) N(hg) Lord,(e) leapeth(g)  (h) down(i) from(hg) heaven(f)  (f)  out(h) of(g) thy(h) royal(i)  (h) throne,(ge) al-(f)le(ghg) lu-(f)ia.(f) IS(h) I(g) W(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-029.png",
        nextFileName: "./pages/part-a-030.png",
    },
    {
        title: "part-a-029-1",
        gabc: "0(g) Ju-(g)dah(gfd) and(e)  (f)  (gh) be(h)  (g)  (g) ye(g) mot(ih) dismayed:(g)  (ghgf)  (f)  to-(j) (ji) morrow(h) go(hk) ye(j) forth,(ihg) and(g) the(e) Lord(gh) himself(ef)  (d) will(ef) be(h)  (h)  with(h) you,(gfd) al-(f)le-(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-029.png",
        nextFileName: "./pages/part-a-030.png",
    },
    {
        title: "part-a-030-0",
        gabc: "e(h) shall(fg) know(h) this(gf) T(e) that(e) the(e) Lord(f) will(de) come;(eef) and(h)  in(f) the(h) a(gf) morning(e) ye(f) shall(de) see(df) his(f) glory.(e)  (e) 1(h)  (f)  (h) 4(i)  (h)  -(ig~)To-(f) (e) morrothhe(f)  (h) i-(h)ni-(h)qui-(h)ty(h) of(h) the(ij) earth(i) shall(h) be(i)  blotted(g)  (j)  (h) out:(i) and(f) the(i) Saviour(g)  (h) of(f) the(e) world(fe) shall(de)  B/(g) reign(g) o(h) ver(hg) us.(f) +(i)  (h)  (i) &quot;(j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-030.png",
        nextFileName: "./pages/part-a-031.png",
    },
    {
        title: "part-a-030-1",
        gabc: "Tihe(c)  (dc) Lord(f) will(hg) come,(h) go(h) ye(hj) out(h) to(g) meet(hg) him,(e) saying:(ff)  (d)  Great(hihh) is(g) his(jh) do-(j)min-(jih)ion,(h) and(hgg) of(f) his(gh) kingdom(gf)  (g) there(h)  shall(g) be(f) no(gf) end:(d) the(g) migh-(ggg)ty(gd) God,(efd) the(e) Gov-(f)er-(de)mor,(dc)  (c)  the(cd) T(ffe) of(fg) peace,(g) al-(e)le-(fe)lu-(d)ia.(d) e(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-030.png",
        nextFileName: "./pages/part-a-031.png",
    },
    {
        title: "part-a-031-0",
        gabc: "T(c)  (h) o-(h)morrow(h) ye(h) shall(h) have(f) salvation,(h)  (gf)  (ef) saith(d) the(f) Lord(fh)  God(g) of(f) .-(e)hosts.(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png",
    },
    {
        title: "part-a-031-1",
        gabc: "_(fg) shall(f) know(g) this(gh) day(hg) That(f) the(gh) Lord(gfd) will(fg) 1~(gf)  Ye(fg) shall(f) know.(g) And(h) in(hi) the(h) morning(gh)  (g) ye(h) shall(g) see(g)  his(f) glory.(gh) I(hg) That(f) the(gh) Lord.(gfd) ¥.Glory(h)  (h) be.(h) Ea(fg) shall(f) know.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png",
    },
    {
        title: "part-a-031-2",
        gabc: "The(ccgd) Saviour(fg)  (ghg) Tof(f) the(ghg) world(hih) shall(f) o(h) arise.(ji) as(gh) the(h) sun:(g) and(f)  shall(g) come(hg) down(f) in-(g)to(fe) the(d) Virgin’s(f)  (f) womb,(df) ;s(c) the(d) show-(fg) ers(g) up-(f)on(h) the(ji) grass,(gfd) al(ef) le(fg) -(g)ia.(g) ITa(j)  (i) &quot;5(j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-031.png",
        nextFileName: "./pages/part-a-032.png",
    },
    {
        title: "part-a-032-0",
        gabc: "he(gd) King(fe) of(gf)  (g) highly(g)  (g)  (h) ex-(g)alt-(hg)ed,(f) for(gf) whose(gh)  counte-(i) (h) nance(g) all(gf) the(d) earth(fh) longeth.(g)  (g) I—I(j)  (i)  (j)  (h)  (g)  counte-(j) (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png",
    },
    {
        title: "part-a-032-1",
        gabc: "he(e) King(g) of(h) peace(i) tis(h) highly(f)  (h) ex-(g)alt-(e)ed,(e) exceeding(f)  (h)  (h)  (h)  all(h) the(g) kings(fgh) of(h) the(f) whole(gf) earth.(e) A(j)  (i) e,(h) Aol(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png",
    },
    {
        title: "part-a-032-2",
        gabc: "now(fg) ye(g) that(g) the(g) kingdom(h)  (g) of(f) God(g) .is(gh) nigh:(f) ve-(f)ri-(h)ly(j)  I(j) say(k) un-(i)to(j) you,(h) it(gf) will(e) not(fg) 2.(g) &amp;(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-032.png",
        nextFileName: "./pages/part-a-033.png",
    },
    {
        title: "part-a-033-0",
        gabc: "ift(ddc) up(d) your(fe) heads,(ddc) for(f) be-(h)hold,(gh) your(g) redemption(f)  (fg)  (g)  nigh.(dc)  (fe)  (d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png",
    },
    {
        title: "part-a-033-1",
        gabc: "Ye(fg) shall(f) know(fedc) this(fghi) day(h) That(h) the(ij) Lord(ihgfe) will(fhgf) come.(f) Ye(fg)  shall(f) know.(fedc) V.(c) And(f) in(g) the(f) morning(fh)  (f) ye(g) shall(f) see(fe) Mis(dc)  glory.(fghi)  (h) That(h) the(ij) Lord.(ihgfe) Glory(f)  (f) be(g) to(f) the(f) Father(gh)  (f) and(g)  and(ki~)  (fe)  (dc)  (c)  (c) to(df) the(f) Ho(gih) 1y(gf) Ghost.(f) Ye(fg) shall(f) know.(fedc) ",
        groupIndex: 1,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png",
    },
    {
        title: "part-a-033-2",
        gabc: "N(c)  (d) 0,(efg) o(gf) [(ed) 4(f) EaE(edc)  (d) 8(ce)  (g)  (gh)  (h)  0,(hg)  (gj)  (ihg) o(h) 4(hj) i(g)  (gf) e(e)  (dc)  (d)  (de)  (e)  4(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-033.png",
        nextFileName: "./pages/part-a-034.png",
    },
    {
        title: "part-a-034-0",
        gabc: "hen(g) the(gd) sun(fgh) hath(g) risen(gh) T(g) in(h) the(g) heavens,(h)  (h) ye(g) sha]](g)  see(h) the(gf) King(g) of(h) kings,(hijg) proceeding(gh)  (h) o,(ghgf) from(hgi) the(h) Father,(g)  (g)  A(ik)  (ge) a(g) =(f) bridegroom(d) out(def) of(fgh) his(h) chamber.(g)  (g) e(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png",
    },
    {
        title: "part-a-034-1",
        gabc: "PSALM(h)  (h)  (h)  (h)  (f)  (h)  (h)  (h)  (g)  (f) ANTIPHONS(h)  (h)  (de)  (h)  (h)  (h)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png",
    },
    {
        title: "part-a-034-2",
        gabc: "P/(dhcgic) beheld(h)  (g)  (h) ye,(fhg) 0(ef) shepherds?(h)  (g) Tell(eg) usg;(f) D(f)  (e) to(f)  us(h) the(g) tidings,(eg)  (f) on(f) earth(ef) who(h) hath(g)  (e) appeared?(g)  (f)  We(ig~)  (f) saw(e) the(f) new-(hg)born(e) Infant,(g)  (f) and(e) the(f) choir(hg) .(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-034.png",
        nextFileName: "./pages/part-a-035.png",
    },
    {
        title: "part-a-035-0",
        gabc: "An-(gi) (hi) gels,(h) praising(h)  (h) the(i) Lord(g) together,(h)  (f)  (f) al-(f)[(e) lu-(f)ia,(h)  v(hgi) al-(g)le-(e)lu-(gfg)ia.(f) e(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png",
    },
    {
        title: "part-a-035-1",
        gabc: "She(gi)  (h) that(g) 0(h) travailed(g) T(f) hath(g) borne(f) the(e) Monarch(gg)  (f) whose(f)  Name(f) is(e) ev-(f)er-(h)b(fgfe) ing:(e) she(f) hath(cf) the(f) joy(g) of(f) a(f)  |(gi) mo(gh) ther,(kijijkj) with(j) the(i) -(h)honour(g) of(ih) vir-(g)gi-(hg)ni-(f)ty;(f) before(f)  (h)  her(gi)  (g) none(h) hath(g) been(f) seen(gf) like(ef) her,(fe)  (c) nor(ef) shall(h) there(e)  LI(gi) be(gh) af-(f)ter,(fec) al-(e)le-(ef)lu-(f)ia.(f) e(h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png",
    },
    {
        title: "part-a-035-2",
        gabc: "T(c) he(e) An-(e)gel(i) g(i) e(i) T(i) the(h) e(i)  (kji) o(i) e(hi) R(k) ",
        groupIndex: 2,
        filename: "./pages/part-a-035.png",
        nextFileName: "./pages/part-a-036.png",
    },
    {
        title: "part-a-036-0",
        gabc: "I(i) bring(j) you(i) joy-(jkj)ful(i) tidings:(j)  (i) for(ig) un-(ji)to(i) you(h) is(hi) bop,(h)  this(f) day(gh) the(f) world(gh) s(f) Redeemer,(fe)  (d) al-(ef)le-(f)lu-(e)ia.(e) |(j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-a-036.png",
        nextFileName: "./pages/part-a-037.png",
    },
    {
        title: "part-a-036-1",
        gabc: "[](e) was(ei) Twith(i) the(i) An-(h)gel(g) a(i) mul-(k)ti-(i)tude(i) of(h) the(g)  heavenly(j)  (j)  (i) host,(h) praising(j)  (ih) God,(h) and(fgh) say-(iji)ing,(hf) Glo-(g)ry(f)  8(e) God(fg) in(fg) the(ef) highest,(f)  (f) and(f) on(gh) earth(ijji) peace(efeded) to(def) men(g)  of(h) good(fe) will,(d) al(ef) °(f) 1lu-(e)ia.(e) [(j) &amp;(i)  (h)  (gi)  U(c)  (f) to(fg) us(gh) this(fg)  (g) Child(g)  (gh) is(e) born,(fg) a(e) Son(f) is(e) given:(d)  (d)  [](c) his(d) Name(f) shall(fg) the(gff)  (g) mighty(hij)  (ji) God,(ghiih) al-(h)le-(g)lu-(e)18(f)  al(gh) le-(h)lu-(g)ia.(g) =(j) 1(i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-036.png",
        nextFileName: "./pages/part-a-037.png",
    },
    {
        title: "part-a-037-0",
        gabc: "he(f) Word(f) was(e) made(g) flesh,(h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  The(f) Word.(f) And(f) dwelt(f) a-(e)mong(g) us.(h) Al-(h)le-(hg)lu-(g)ia.(f)  ¥.(c) Glory(f) S(f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h)  to(h) the(g) Ho-(h)ly(g) Ghost.(gf) The(f) Word.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-037.png",
        nextFileName: "./pages/part-a-038.png",
    },
    {
        title: "part-a-037-1",
        gabc: " (d)  (e)  (f)  (gh)  (d)  (efg)  (fe)  (e)  (g)  (hj)  (j)  (ji)   (hg)  (hi)  (i)  (i)  (h)  (hjk)  (j)  (ji)  (hg)  (h)  (gf)   (edffgh)  (d)  (e)  (f)  (gh)  (gf)  (g)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-037.png",
        nextFileName: "./pages/part-a-038.png",
    },
    {
        title: "part-a-038-0",
        gabc: "lo-(fgh) (g) to(g) God(h) in(g) the(h) highest,(h)  (gh) and(f) on(f) earth(f)  (e)  peace(ik)  (g) to(h) men(hj) of(gh) good(fgh) will,(hgf) al-(fh) (fe) le_lu_ia&#39;(d)  (ef) a1(ggh)  le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-038.png",
        nextFileName: "./pages/part-a-039.png",
    },
    {
        title: "part-a-038-1",
        gabc: "n(d) the(d) day(f) .(c) thy(d) pow-(dhi)er(h) shall(h) the(h) peo—ple(h)  (hghihgg) £f(f)  (g)  thee(h) free-(h)will(gf) of-(fh) (fe) fer—ings(d) with(f) an(fg) ho-(fe)ly(cd) worship:(d) LR(c)  the(d) dew(f) of(f) thy(f) birth(ffg) is(f) of(gh) the(fe) womb(dc) of(d) the(efe) morning(d) -(d) i(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-038.png",
        nextFileName: "./pages/part-a-039.png",
    },
    {
        title: "part-a-039-0",
        gabc: "T(c) he(e) Lord(e) hath(g) sent(hi) T(fh) re-(fg)demption(e) un-(h)to(h) his(f) people:(h)  (g)  he(i) hath(i) com-(h) (iji) ed(hghih) his(h) co-(f)ve(e) nant(ffh) for(gf) ev-(e)er.(e)  a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png",
    },
    {
        title: "part-a-039-1",
        gabc: "U(gi) n-(gi)to(i) the(j) ](i) ](i) a-(ij) (i) ri-(i)seth(hih) up(hg) light(hf) in(gh)  the(hg) darkness:(e) _-(e)the(f) Lord(h) is(f) mer-(h)ci-(h)ful,(gf) loving,(ef) O(g) and(f)  righteous.(gi)  (e)  (e)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png",
    },
    {
        title: "part-a-039-2",
        gabc: "a(e) the(f) Lord(hhi) %(hi) is(jh) mercy,(i)  (i) and(ig) with(hg) him(fe) 1is(fe)  plent(d) eous(e)  (f) redemption.(h)  (f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-039.png",
        nextFileName: "./pages/part-a-040.png",
    },
    {
        title: "part-a-040-0",
        gabc: "O(f) the(h) fruit(j) |(i) thy(ihjhg) bo-(hg)dy(fh) shall(j) I(ig) set(i) up-(j)on(hi)  thy(h) seat.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png",
    },
    {
        title: "part-a-040-1",
        gabc: "T(c) he(fg) Word(fe) was(dc) made(fg) flesh,(hii) Al-(hij)le(ihgfe) lu-(gh)ia,(f) al-(dc)le(ifgiihgfe)  lu-(gg)ia.(f) The(fg) Word.(fe) And(ffgh) dwelt(fe)  (dc) us.(fg)  (i) Al(hhj)  le(iihgfe) lu-(fgh)ia.(f) .(c) Glory(f)  (f) be.(g) The(fg)  (fe) ",
        groupIndex: 1,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png",
    },
    {
        title: "part-a-040-2",
        gabc: "T(c)  (d)  (dh) the(hg) Christ(i) is(hg) born;(fh) to-(f)day(fg) hath(g) a(g) Saviour(g)  (h)  (g)  L(g) pear-(hgf)ed:(f) to-(f)day(gh) on(h) earth(hhg) An-(i)e(h) are(g) -(fh)singing(h)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-040.png",
        nextFileName: "./pages/part-a-041.png",
    },
    {
        title: "part-a-041-0",
        gabc: "—(hg) Archangels(i)  (h) rejoicing:(g)  (fh)  (h) to-(h)day(jkjih) the(h) righteous(hgi)  (h) exult(g) =(fh)  and(h) say,(fgh) Glory(fgh)  (fe) to(d) God(ef) in(gh) the(g) highest,(fe)  (dc) al(d) le-(efe)lu-(d)ia.(d)   (h)  (g)  (f)  (gf)  (fgh) ",
        groupIndex: 0,
        filename: "./pages/part-a-041.png",
        nextFileName: "./pages/part-a-042.png",
    },
    {
        title: "part-a-041-1",
        gabc: "And(c)  (j) St:ephen,T(ih)  (g) full(fgh) of(fe) faith(d) and(ef) power,(gh)  (h) did(j) great(kj)  wonders(hj)  (g) and(gh) mir-(g)a-(fe)cles(d) a-(ef)mong(gh) the(h) people.(g)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-041.png",
        nextFileName: "./pages/part-a-042.png",
    },
    {
        title: "part-a-042-0",
        gabc: "stoned(c)  (gg)  (f)  (h)  (j) calling(ig)  (j)  (h) up-(g)on(g) the(g) Lord(h) and(g) say-(hg) ing,(f) s(fh) lay(j) not(i) this(j) sin(hf) to(gh) their(h) charge.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png",
    },
    {
        title: "part-a-042-1",
        gabc: "a(e) a(e) of(g) the(h)  (i) e(g)  (h) sweet(ij) un-(h)to(f) Stephen:(h)  (g)  him(i) doth(h) every(f)  (h) soul(gf) of(d) the(f) =(hf) righteous(gf) follow.(e)  (e) B(j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png",
    },
    {
        title: "part-a-042-2",
        gabc: "a(e) -(h)T(f) ](e) -(h)un-(f)to(h) thee,(g) for-(i)as-(i)much(hf) as(h) my(h)  flesh(gh) hath(f) been(e) ston-(gh)ed(f) for(e) thee,(h) 0(f) my(f) God.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png",
    },
    {
        title: "part-a-042-3",
        gabc: "tephen(fg)  (g) Tsaw(f) the(hj) heavens(jji)  (h) O-(j)pen-(hg)ed;(g) he(g) saw,(h) and(fg) ",
        groupIndex: 3,
        filename: "./pages/part-a-042.png",
        nextFileName: "./pages/part-a-043.png",
    },
    {
        title: "part-a-043-0",
        gabc: "en-(gh)ter’d(h) in:(g) how(hj) blessed(j)  (i) is(j) the(k) man(hg) un-(h)[(g) whom(ef)  heav’&#39;n(gh) stood(h) o-(g)pen.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png",
    },
    {
        title: "part-a-043-1",
        gabc: "e-(f)hold,(h) T(hi)  (i) _—\\—(hi)  (j)  (h) o-(i)pen-(i)ed;(i) and(fi) Jesus(g)  (h)  -(ef)=(fe) on(d) the(e) right(fg) hand(h) of(hg) God.(f) e(i) &amp;(h)  (i) ————(j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png",
    },
    {
        title: "part-a-043-2",
        gabc: "T(c) hou(f) hast(f) crowned(g)  (h) him(hg) With(g) glory(f)  (g) and(fgh) s(g) honour,(fd) O(fg) Lord.(gf)  Thou(f) hast(f) crowned.(g)  (gh) And(h) madest(hi)  (h) him(h) to(h) have(h) do-(h)min-(gh) ion(g) of(g) the(h) works(g) of(f) thy(gh) hands.(hg) With(g) glory.(f)  (g)  Glory(h)  (h) be.(h) Thou(f) hast(f) crowned.(g)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-043.png",
        nextFileName: "./pages/part-a-044.png",
    },
    {
        title: "part-a-044-0",
        gabc: "R(g) )(g) D(f)  (e)  (d) (a8(fhg)  (fg) =(g) [T(hjji)  (h)  (hg)  &quot;(h)  (ig) [(h)  (g) =————===(f) =(g) &amp;(g) @(f)  (g) @(h) 20(j)  (g) e(hih)  ¥.(h) Devout(h) men(ghg) a(e)  (f) Stephen(hg) to(fg) his(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-044.png",
        nextFileName: "./pages/part-a-045.png",
    },
    {
        title: "part-a-044-1",
        gabc: "nd(j) Stephen,(ih)  (g) full(fgh) of(fe) faith(d) and(ef) power,(h)  (h) did(j) great(j)  wonders(hj)  (g) and(gh) mir-(g)a-(fe)cles(d) &amp;(f) mong(gh) the(h) e(g) people.(g) a1(j)  (h)  (j) 1(k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-044.png",
        nextFileName: "./pages/part-a-045.png",
    },
    {
        title: "part-a-045-0",
        gabc: "T(c) hou(f) hast(gh) set(hg) Up-(f)on(f) his(gh) head,(gf)  (d) O(fg) Lord.(gf) Thou(f)  hast(ik)  (fh) set.(hg) A(hi) crown(g) of(f) pure(gh) gold.(hg) Up-(f)on(f) his(gh) head.(gfd)  Glory(h)  (h) be.(h) Thou(f) hast(fh) set.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png",
    },
    {
        title: "part-a-045-1",
        gabc: ".(g) a(g) a(f)  (e)  (d) fa(fhg) a(fg) o(g) T(hjji) =(h) Jao(hg) =(h) |(ig)  TR(h)  (g)  (f) e(g)  (g) N(f) R(g)  (h)  (j) R(g)  (hih)  5.(h) Stephen(h) a(ghg) the(e)  (f) heavens(hg) opened.(fg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png",
    },
    {
        title: "part-a-045-2",
        gabc: "D(c)  (fh) e—vout(j) menfcar-(ig)ri-(j)ed(h)  (g) e(g) Stephen(g) to(h) his(g) bu-(ghg)ri-(f)al,(f)  ———(f) made(hj) great(ji) la-(jk)men-(h)ta-(h)tion(gf) o(fh) ver(h) him.(g) |(j) B(i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-045.png",
        nextFileName: "./pages/part-a-046.png",
    },
    {
        title: "part-a-046-0",
        gabc: "T(c) his(f) i.s(c) the(d) same(dhi) John,T(hh) who(h) leaned(h)  (h) on(h) the(h) Lord’&#39;s(h)  bo—som(h)  (hghihgg) at(g) the(f) last(fh) sup-(fed)per:(d) the(f) blessed(f)  (fe) A—POStl.e&#39;,(def)  (dc)  (c)  whom(c)  (d)  (f) were(f) revealed(f)  (fg)  (f) the(f) secret(f)  (ef) thingsof(g)  (fe) heaven,(d)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-046.png",
        nextFileName: "./pages/part-a-047.png",
    },
    {
        title: "part-a-046-1",
        gabc: "nght(ik)  (d) worthy(dc) ;(f) of(g) honourt(fh)  (h) is(h) blessed(h)  (g) Yo,(i) the(h) A-(g) (fh) postle,(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-046.png",
        nextFileName: "./pages/part-a-047.png",
    },
    {
        title: "part-a-047-0",
        gabc: "who(g) leaned(g)  (g) on(g) the(g) Lord’s(eg) bo—som(hg)  (f) at(fg) the(e) last(fe) R(d) supper.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png",
    },
    {
        title: "part-a-047-1",
        gabc: "This(c)  (g) is(h) that(j) dis—ci-(h) (j) ple(i) Twhich(h) tes-(g)ti-(h)fi-(h)eth(h) of(h) these(hg)  things:(g) and(g) we(g) know(i) that(h) his(h) tes-(j)ti-(i)mo-(g)ny(h) is(gf) true.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png",
    },
    {
        title: "part-a-047-2",
        gabc: "T(c) his(g) ismy(h)  (j) dis-(h)ci-(j)ple,f(i) if(h) I(g) will(h) that(i) he(h) tarry(g)  (g)  till(hf) T(gg) T(e) I(j)  (h) I—_I(j) N(ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png",
    },
    {
        title: "part-a-047-3",
        gabc: "T(c) here(d) be(dc) some(fg) standing(f)  (gh) here(h) which(h) shall(hi) not(g) taste(f)  (g) ",
        groupIndex: 3,
        filename: "./pages/part-a-047.png",
        nextFileName: "./pages/part-a-048.png",
    },
    {
        title: "part-a-048-0",
        gabc: "of(ki)  (h) death(g) till(g) they(eg) see(h) the(g) Son(fg) of(f) man(ef) -(g)hjg(fe)  kingdom.(d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png",
    },
    {
        title: "part-a-048-1",
        gabc: ".e-(ikc) (cdc)  (f) hold,my(g) servant,&#39;f&#39;(fh)  (h) mine(h) e-(g)lect,(i) whom(h) I(g) have(g)  chosen:(ik)  (fh)  (g) I(g) have(eg) put(hg) my(fg) spi-(ec)rit(eg) up-(fe)on(d) him.(d) &quot;=(h)  (g)  (f) dp(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png",
    },
    {
        title: "part-a-048-2",
        gabc: "heir(f) sound(g) is(f) gone(gh) out(hg) In-(g)to(fd) all(fg) lands.(gf) Their(f)  sound.(g) And(h) their(h) words(hi) in-(h)to(fh) the(g) ends(gf) of(g) the(gh) world.(hg)  In-(g)to.(fd) Glory(h)  (h) be.:(h) Their(f) sound.(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-048.png",
        nextFileName: "./pages/part-a-049.png",
    },
    {
        title: "part-a-049-0",
        gabc: ":(g)  (g) A(f)  (e)  (d) &amp;(fhg) &amp;(fg) &amp;(g) I(hjji) SN(h) &quot;(hg) ORI(h)  :(ig) &amp;(h)  (g) -(f)&amp;(g) &amp;(g) &amp;(f)  (g) &quot;(h)  (j) a(g) &quot;(ihih)  V.(h) This(h) is(ghg) a(e) disciple(f)  (hg) which(fg)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-049.png",
        nextFileName: "./pages/part-a-050.png",
    },
    {
        title: "part-a-049-1",
        gabc: "his(f) is(c) the(d) same(idhi) John,(hh) who(h) leaned(h)  (h) on(h) the(h) Lord’s(h)  bo(h) som(hghihgg) at(g) the(f) last(gh) sup-(fed)per:(d) the(f) bless—ed(f) |(fe)  A-(def)pos-(dc)((c) [](c) to(d) whom(f) were(f) revealed(f)  (fg)  (f) the(f) se-(f)cret(def)  things(g) ‘of(fe) hea-(d)ven.(d) *(h) o(g) _(f) ¢(gh) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-049.png",
        nextFileName: "./pages/part-a-050.png",
    },
    {
        title: "part-a-050-0",
        gabc: "hou(f) shalt(f) .(g) them(f) princes(gh) :(hg) In(fd) all(fg) lands.(gf) Thou(f)  shalt(jk)  shalt(f) make.(g) They(hi) shall(h) re-(h)T(gh) R(g) thy(gf) ey(g)  (gh) OLord,(hg)  .(df) all(fg) lands.(gf) Glory(h)  (h) be.(h) Thou(f) shalt(f) make.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-050.png",
        nextFileName: "./pages/part-a-051.png",
    },
    {
        title: "part-a-050-1",
        gabc: "T(c) here(f) went(efddc) this(d) saying(fg)  (f) a-(f)broad(g) a-(h)mong(gh) the(h) s(fgf) brethren,(f)  that(f) that(fg) dis(f) ci(giih) ple(gh) should(f) not(ef) die:(f) yet(f) -(gh)sus(f)  said(g) not(f) un—to(f) LR(e) him,(df) He(gh) shall(f) not(ef) die;(f) .(c) If(d) I(f)  will(fg) that(f) he(f) tar-(fhihg)ry(hg) till(fg)  (gf) I(h)  (hg) come.(fgf)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-050.png",
        nextFileName: "./pages/part-a-051.png",
    },
    {
        title: "part-a-051-0",
        gabc: "These(c)  (dh) are(hi) t(hghihgg) which(f) were(g) not(h) de_fil-(g) (h) ed(g) with(f) women;(f)  (d)  for(g) they(g) are(g) virgins:(hgf)  (f) and(e) they(f) follow(g)  (f) the(fe)  (ddc)  whither-(d)[](c) ev-(d)er(f)  (e) he(fgf) goeth.(d)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-051.png",
        nextFileName: "./pages/part-a-052.png",
    },
    {
        title: "part-a-051-1",
        gabc: "He-(d)rod(dc) was(f)  (g) exceeding(f)  (gh) wrot.h,&#39;f(h) and(h) slew(ih) ma-(g)ny(g) chil-(fh) dren(g) in(g) N(g) Bethlehem(e)  (g) Ju-(hg)dah,(fg) the(ec) =(e) ty(g) of(e) Da-(fe)vid.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-051.png",
        nextFileName: "./pages/part-a-052.png",
    },
    {
        title: "part-a-052-0",
        gabc: "F(c) rom(f) two(g) years(h) old(i) and(g) un-(gh)der,(f) did(f) He-(h)rod(g) slay(hi) a]j(f)  the(gi)  (h) male(gh) children,(ff)  (e) for(e) the(f) sake(hg) of(e) the(g) Lord.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png",
    },
    {
        title: "part-a-052-1",
        gabc: "T(ki~)  (c)  (c) heir(fh) AngelsTdo(g)  (gf)  (f) al-(hf~)ways(j) be-(i)hold(hj) the(i) face(g) of(h) my(h)  Fa(g) ther.(g) -(j) (i) &quot;(j)  (h) a7(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png",
    },
    {
        title: "part-a-052-2",
        gabc: "I(hcgi) n(ff) Ra-(e)ma(f) there(g) was(h) heard(i) a(hg) T(f) e(e) voice,(f) la—men—ta—tion(h) Y(h) and(fh)  [(g) a(g) &quot;(f) &amp;(e) e(e) [(ge) chel(f) weeping(h)  (g) for(ef) her(hg) &amp;(f) children.(f)  &amp;(gi)  (h)  (g)  (e)  (g)  e(g) neath(ihij) the(i) al-(g) (g) tarTall(g) the(g) e(ghggh) do(fh) cry(jj) a-(j)loud:(jkjh) ",
        groupIndex: 2,
        filename: "./pages/part-a-052.png",
        nextFileName: "./pages/part-a-053.png",
    },
    {
        title: "part-a-053-0",
        gabc: "Shall(jj) not(j) our(jkjh) blood(j) be(h) a-(h)ven-(hg)ged,(f) O(gh) our(h) Cod.(g)  .(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png",
    },
    {
        title: "part-a-053-1",
        gabc: "Be(f) glad,(g) O(f) ye(f) L(gh) righteous,(hg) And(f) re-(gh)joice(gf)  (d) in(f) the(g) Lord.(gf)  Be(f) glad.(g) And(hi) be(h) joy-(h)ful,(g) all(g) ye(h) that(g) are(f) true(g)  of(gh) heart.(hg) And(f) T,(fgh) joice.(gfd) Glory(h) v(h) be.(h) N(f) glad.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png",
    },
    {
        title: "part-a-053-2",
        gabc: ".(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d)  (ce)  (g)  (gh)  (h)  (hg)   (gj)  (ihg)  (h)  (hj)  (g)  (gf)  (e)  (dc)  (d)  (de)  (e)  (c)  x.(c)  (d)  (eg)  (gf)  (ed)  (f)  (edc)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-053.png",
        nextFileName: "./pages/part-a-054.png",
    },
    {
        title: "part-a-054-0",
        gabc: "hese(dh) are(hi) they(hghihgg) which(f) were(g) not(h) de-(g)fil-(h)ed(g) with(f) Wo-(g) (gf) nep,(d)  for(g) they(g) are(g) vir-(hgf)gins:(f) and(e) they(f) ](g) follow(f) the(fe) La;mb(ddc)  whither-(d)a(c) ev-(d)er(f)  (e) he(fgf) goeth.(d)  (d)  (h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-054.png",
        nextFileName: "./pages/part-a-055.png",
    },
    {
        title: "part-a-054-1",
        gabc: "et(f) the(f) “(g) righteous(f) re-(gh)L(hg) ¥(fd)  (fg) T(gf) Let(f) the(f)  (g)  .(g) righteous.(f) Let(hi) them(h) al-(fgh)so(g) be(g) merry(h) ,(g) and(f) joyful.(gh)  (hg)  Be-(fd)fore(fg) God.(gf) Glory(h)  (h) be.(h) Let(f) the(f) righteous:(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-054.png",
        nextFileName: "./pages/part-a-055.png",
    },
    {
        title: "part-a-055-0",
        gabc: "hen(e) were(f) in-(h)no-(i)cent(g) childrenT(h)  (f) slain(f)  (fe) in-(h)stead(f) of(eh)  Christ(gi)  (hiih) by(h) a(i) wick-(j)ed(h) ru-(ih)ler;(f) the(e) ve-(ef)ry(fe) [](hg) sucklings(hi)  were(gi)  (h) put(f) to(ef) death:(f) spotless,(f)  (fe) [(c) follow(fe~)  (f) a(hg) Lamb(f)  himsel(gi)  (eh)  (hiih) and(hihij) say(j) for(ih) ev-(ih)er:(f) Glory(f)  (f) be(hg) to(hih) thee,(f)  0(gi)  (ef) Lord.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-055.png",
        nextFileName: "./pages/part-a-056.png",
    },
    {
        title: "part-a-056-0",
        gabc: "hile(gd) all(fgh) thlngsTwere(g)  (gd) in(fg) qui-(h)et(fe) silence,(def)  (f) and(dg) that(fg)  night(h) e(g) in(h) the(g) midst(hj) =(hj) her(h) swift(gf) &quot;-(g)thine(g) A]_(g)  mighty(f)  (f) .(cd) O(fgh) Lord,(h) leaped(f)  (g) down(fgh) out(f) a(e) thy(d) royal(h)  (ij)  throne,(hgf) al-(gh)le-(h)lu-(g)1ia.(g) [(j) &quot;(i)  (j)  (h) a(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-056.png",
        nextFileName: "./pages/part-a-057.png",
    },
    {
        title: "part-a-056-1",
        gabc: "he(f) Child(cf) Je—sus(df)  (ffg) Tincreased(df)  (fgh)  (h) in(h) wisdom(hj)  (h) and(fg) sta-(fghgf)ture(fggf)  in(f) the(f) sight(fg) of(df) God(d) and(cf) man.(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-056.png",
        nextFileName: "./pages/part-a-057.png",
    },
    {
        title: "part-a-057-0",
        gabc: "od,(gff) for(d) his(fg) great(hg) love(hghihgg) wherewith(fh)  (ji) he(hg) lov_ed(hi)  (hg) us,(g)  hath(hf) sent(h) his(f) own(g) Son(ffdefedc) in(d) the(f) T&quot;(hg) likeness(fg) of(g) sin-(ij)ful(h)  flesh,(hgf) al-(hg)le-(h)lu-(g)ia.(g) LAUDS(j) g(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-057.png",
        nextFileName: "./pages/part-a-058.png",
    },
    {
        title: "part-a-057-1",
        gabc: "wondrous(efddc)  (gf~)  (gf) in-(g)I(ghg) —(f) The(f) Cre-(f)a-(g)tor(fe) of(g) man-(gh) kind,(f) taking(f)  (f) up-(f)on(fhihg) him(g) a(g) living(i)  (h) bo-(g)dy,(f) vouchsafed(f)  (g)  (f)  to(f) be(f) born(g) of(f) a(f) Vir-(fhihg)[(hg) and(g)  (g) proceeding(h)  (g) forth(fg) as(f)  Man,(fe) without(df)  (fe) seed,(cd) hath(cd) made(fg) us(f) partakers(f)  (gh)  (g) of(hj) bhis(hg)  Di_vi_ni_ty.(hg)  (f)  (f)  (f) 103(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-057.png",
        nextFileName: "./pages/part-a-058.png",
    },
    {
        title: "part-a-058-0",
        gabc: "W(c) hen(de) thou(g) wast(jh~) bornT_in—ef-(j) (h) fa—bly(j)  (i)  (h) of(gf) a(gh) Virgip,(hg)  (g)  then(gh) were(i) the(j) Scriptures(h) .(gf) =(gh) fulfilled:(e) &amp;(e) thou(h) camest(j)  (i) down(jjk)  like(j) the(i) rain(j) in-(h)to(h) a(g) fleece(i) of(j) wool,(h) to(h) bring(j) sa]_(i)  va-(ji)tion(gh) un-(h)to(gf) all(g) mankind:(gh)  (e) we(hi) praise(g) thee,(ef) 0(g) &amp;(ghg)  God.(e)  (ji)  (hi)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-058.png",
        nextFileName: "./pages/part-a-059.png",
    },
    {
        title: "part-a-058-1",
        gabc: "n(d) the(ef) bush(g) twhich(g) -(gfdefg)ses(fe) saw(e) un-(d)con-(fe~)sum-(g)ed,(g) we(g)  a(g) acknowl(g) edge(f) the(gh)  (h) preservation(gh)  (e)  (e) of(dh) thy(hg) glo-(hi)ri-(h)ous(h) vir-(fg) gi-(g)ni-(gf)ty:(e) ho-(h)ly(gf) Mother(g)  (e) of(ef) God,(d) intercede(f)  (g)  (h) for(g) thy(f)  an(gg) children.(e)  (h)  (g)  (h)  (ji)  (hg)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-058.png",
        nextFileName: "./pages/part-a-059.png",
    },
    {
        title: "part-a-059-0",
        gabc: "T(c) he(d) Root(e) of(f) Jes-(g)sel(e) hath(ghfe) bud-(d)ded:(dfddc) the(dc) Star(f) hath(g)  come(h) out(f) of(g) Ja—cob:(g)  (f) a(g) Virgin(h)  (g) hath(f) borne(f) the(f) Sa-(fgfd) :(d) we(gh) praise(ffe) thee,(ce) 0(ge) our(fe) God.(d) &quot;(h) =(g) ¥(f)  (fh) pll(gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-059.png",
        nextFileName: "./pages/part-a-060.png",
    },
    {
        title: "part-a-059-1",
        gabc: "L(gi) 0,(df)  (h)  (h) brought(h)  (hg) forth(f) to(ed) us(e) the(ef) Sa-(d)viour;(d)  whom(d) when(e) John(f) be-(e)held,(f) he(df) cri-(h)ed(fh) saying:(f)  (f) Fe-(f)hold(h)  the(g) Lamb(h) of(gf) God,(fe) which(d) &#39;:tmw(f) taketh(e) a-(d)way(f) theTsin(de)  (fee) of(d)  ](e) R(ed) al(def) i(ed) =(de) TP(d) |(h) ——a(i) I(g)  (h) -(fh) -(dcc)of(c) the(c)  fs1n(f) of(d) the(d) world,(d)  he(f) Lord(f) a(e) declared(g) *(h) Al(h) -(hg)lu-(g)ia,(f) al(d) -(fg)lu-(gf)ia.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-059.png",
        nextFileName: "./pages/part-a-060.png",
    },
    {
        title: "part-a-060-0",
        gabc: "The(f) Lord.(f) His(f) sal-(e)va-(g)tion.(h) B.(h)  (hg) [(g)  (f)  ¥(ik) Glory(f)  (f) be.(f) The(f) Lord.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png",
    },
    {
        title: "part-a-060-1",
        gabc: " (ki~)  (d)  (e)  (f)  (gh)  (d)  (eg)  (fe)  (e)  (g)  (hj)  (j)  (ji)  .(i)  (hg)  (hi)  (i)  (i)  (h)  (hjk)  (j)  (ji)  (hg)  (h)  (gf)  V.(ik)  (edfgh)  (d)  (e)  (f)  (gh)  (gf)  (g)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png",
    },
    {
        title: "part-a-060-2",
        gabc: "great(c)  (g)  (g) and(f) wondrous(f)  (d) my-(f)ste-(e)ry(df) Tis(f) made(g) known(h) to(g)  us(hj) this(gh) day;(h) L(g) new(g) thing(f) is(h) wrought(j) in(k) both(i)  na-(j)tures:(h) God(g) is(f) made(gh) man;(g) that(g) A(gf) was,(h) P(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-060.png",
        nextFileName: "./pages/part-a-061.png",
    },
    {
        title: "part-a-061-0",
        gabc: ".(gg) mained,(d) and(d) .(c) which(d) was(ff) not,(f) he(fe) as-(d)sum-(f) (hg) ed;(h) suf-(j) fering(j)  (j) no(k) confusion,(i)  (j)  (h) nor(hf) yet(hj) di-(i)vi-(g)sion.(g)  (j) &quot;(i)  (j) a](h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-061.png",
        nextFileName: "./pages/part-a-062.png",
    },
    {
        title: "part-a-061-1",
        gabc: "T(fefhihgff) is(g) e(e) my-(f)ste-(h)](hg) of(f) the(e) in(f) he(fhihgfgf) ritance:(ef) .(f)  the(f) womb(h) of(i) her(j) that(i) knew(j) not(hg) man(f) is(h) be-(hg)come(f) the(e)  temple(f)  (g) of(h) the(g) Godhead:(f)  (f) by(f) taking(ef)  (f) flesh(fh) of(f) her,(f) he(ef)  was(f) no(fhg) 0(e) de-(eg)fil-(f)ed:(f) all(fefe) the(df) nations(hhi)  (h) shall(i) Ta(hg) gather,(fe)  H(fe) RO(d) Glory(f) PR(ed) be(e) to(f) thee,(fghihgfgf) O(ef) Lord.(f) O(h)  (g) T(e) ey(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-061.png",
        nextFileName: "./pages/part-a-062.png",
    },
    {
        title: "part-a-062-0",
        gabc: "ho-(g)so-(gd)ev-(fg)er(g) shall(hg) call(h) on(f) the(h) Name(ji) of(hi) the(h) Lord(g)  shall(gfd) be(fg) saved.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png",
    },
    {
        title: "part-a-062-1",
        gabc: "H(c)  (cffe) 1ly(f) and(df) rev-(hhi)er-(h)end(h) is(ikj) his(ih) Name:(ijih) the(i) fear(hi) of(f) the(e)  Lord(f) is(d) e(e) be-(f)=(fh) ning(fe) of(edf) wisdom.(d)  (d) I(h) =(i)  (g) &amp;(h) o(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png",
    },
    {
        title: "part-a-062-2",
        gabc: "et(ed) I(g)  (hj) in(ij)  (k)  (ij) the(hji) Lord,(hg) I(g) will(de) joy(ghg) .(hg)  God(hgf) my(gf) e(e) Jesus.(e) et(j)  (ji) °(hi) &quot;-(h)w(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png",
    },
    {
        title: "part-a-062-3",
        gabc: "From(c)  (c) .(c) the(d) rising(dhi)  (h) of(h) the(h) sun(hghihgg) even(f)  (g) unto(h)  (g) the(f) go1ng(e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-062.png",
        nextFileName: "./pages/part-a-063.png",
    },
    {
        title: "part-a-063-0",
        gabc: "down(g) of(f) the(e) same,(ddc) the(ef) Lord’s(g) Name(f) be(fe) prais-(d)ed.(d)  SHORT(h)  (g)  (f)  (h)  (g)  O(f) help(f) standeth(g)  (f) in(f) the(f) Name(f) of(e) the(g) lord,(h) Al-(h)le(hg)  lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Our(f) help.(f) Who(f) hath(f) made(g) hea-(f) a(e) and(g) earth.(h) Al-(h)le-(hg)lu-(g)ia.(f) V.Glory(f)  (f) he.(f) RQur(f) help.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-063.png",
        nextFileName: "./pages/part-a-064.png",
    },
    {
        title: "part-a-063-1",
        gabc: "For(c)  (j) he(ji) that(hg) is(hi) mightyt(h)  (g) hath(g) mag-(g)ni-(eg)fi-(f)a(e) me,(f) and-(d) ](e) ly(f) is(gh) his(h) Name,(g) al(f) -(fg)lu-(g)ia.(g)  (j) .(h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-063.png",
        nextFileName: "./pages/part-a-064.png",
    },
    {
        title: "part-a-064-0",
        gabc: "Thy(c)  (d) Neme(dc) is(f) as(g) 01nmentTpour-(fh) (h) ed(hg)  (ih) forth,(g) there(h) ](g)  a(e) the(f) ](g) virgins(fe) love(d) thee.(d)  (h) ](g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png",
    },
    {
        title: "part-a-064-1",
        gabc: "ye(g)  (hj) that(j) the(h) LordThe(ji)  (h) is(hi) God:(g) his(ig) -(h)is(hi)  a(ik)  (g) er-(gf)last-(e)ing.(e) 1.(j) e(h) &amp;(j) R(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png",
    },
    {
        title: "part-a-064-2",
        gabc: "My(i)  (cefg) soul(ddc) thirsteth(df)  (e) a(g) thy(h) ___l(h) ly(gf) Name,(g) O(ghg) Lord.(e)   (ik)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png",
    },
    {
        title: "part-a-064-3",
        gabc: ".(c) lessed(d) .(fg) the(g) Name(i)  (hi) Tof(h) thy(gf) glo-(gh)ry,(g) and(h) ho-(h).(g) and(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-064.png",
        nextFileName: "./pages/part-a-065.png",
    },
    {
        title: "part-a-065-0",
        gabc: "worthy(g)  (f) to(g) be(gh) praised,(f)  (d) and(fg) mag-(h)ni-(g)fi-(ef)ed(gh) for(h) ev-(g)er.(g)   (g)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png",
    },
    {
        title: "part-a-065-1",
        gabc: "Ym_mg(dh) men(h) and(j) maidens,T(hg)  (h) old(hge) men(fg) and(f) children,(d)  (d) praise(fg)  (g)  the(g) Neme(h) of(g) the(f) Lord,(fghghih) for(h) his(gh) Name(jj) on-(h) (hg) ly(hg) 1is(ef)  .(g) cel-(fe)lent.(d)  (h)  (g)  (f)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png",
    },
    {
        title: "part-a-065-2",
        gabc: "Blessed(g)  (f) be(f) o(f) Name(f) a(e) the(g) Lord,(h) Al-(h)le-(hg)lu-(g)ia,(f)  al(d) le(fg) _lu—ia.(gf)  (f) Rlessed.(g)  (f) From(f) this(g) time(f) forth(f)  a(e) a(g) i(g) evermore.(h) &quot;(h) Alleluia.®.(hg)  (g)  (f) Glory(f)  (f) be.(f) Blessed.(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-065.png",
        nextFileName: "./pages/part-a-066.png",
    },
    {
        title: "part-a-066-0",
        gabc: "[](ig~)  (c)  (f) a(h) :(g)  (f) L(g)  (fe)  (f)  (f)  (h)  (i)  (j)  a(h)  (i) a(i)  (j)  (h)  (j) a(i)  (ji)  (h)  (i) .(hg) .(f)  a(hgi)  (c)  (f)  (h)  (g)  (f)  (g)  (fe)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-066.png",
        nextFileName: "./pages/part-a-067.png",
    },
    {
        title: "part-a-066-1",
        gabc: "H(gi) e(e) gave(eh) himself(fe)  (f) that(e) he(e) might(f) de-(ed)liv-(e)er(f) his(f) people,(de)  (d)  (d)  and(ig~)  (d) get(fh) him(hi) a(g) per-(g)pe-(ij)tu-(h)[(h) &amp;(e) T(fgh) le-(fgf)e(e) wf(e)  a(ghi)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-066.png",
        nextFileName: "./pages/part-a-067.png",
    },
    {
        title: "part-a-067-0",
        gabc: "Thou(c) a(c) shalt(d) call(dhi) his(h) |(jh) Je-(h)sus,(hghihgg) for(g) he(f) shall(g) save(h)  (g)  bis(gf) peo-(g)ple(deef) from(g) their(fe) sins,(dc) al(d) le(efe) lu-(d)ia.(d) RO(h)  (g) LN(fghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-067.png",
        nextFileName: "./pages/part-a-068.png",
    },
    {
        title: "part-a-067-1",
        gabc: "e-(df) (h) the(f) An-(h)gel(g) of(e) the(g) Lord(fed) T(e) appeareth(f)  (de) in(e) a(d)  dream(e) to(f) Jo-(h)seph,(j) saying:(h)  (h) A-(f)rise,(hi) and(g) take(i) the(h)  young(gh) Child(ef) and(f) his(ef) Mother,(d)  (d) and(f) flee(hgf) in-(i)to(g) E(h) gypt,(f)  and(h) be(i) thou(j) there(k) un-(ij)til(hg) I(fg) bring(hi) thee(i) word;(h) for(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-067.png",
        nextFileName: "./pages/part-a-068.png",
    },
    {
        title: "part-a-068-0",
        gabc: "it(i) shall(h) come(fgh) to(fe) pass,(f) that(de) He-(fg)rod(f) wil](e) seek(feffge) A(e)  young(gf) Child,(eg) to(hg) destroy(e)  (d) him.(d)  (h) I—h(i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-068.png",
        nextFileName: "./pages/part-a-069.png",
    },
    {
        title: "part-a-068-1",
        gabc: "ut(g) when(gj) Berod(h)  (g) was(hj) dead,T(j) -(j)bekold,(i) an(j) @(k) gel(ji) o(h) the(g)  (h)  B(jk)  Lord(h)  Lord(h) appeareth(g)  (h)  (i) in(j) a(h) dream(j) to(i) Jo-(ghig)sepk(h) in(ge) E-(fg)gynt,(gh)  say-(gfd)ing:(d) A-(g)rise,(gh) and(j) take(h) the(g) young(ij) Child(jk) and(ij) his(hg)  (h)  Mo-(hji)ther,(i) and(ji) zo(kj) in-(j)to(h) the(g) land(h) of(hi) Is-(ge)ra-(f)el;(ed) for(d)  (d)  t}Tey(dh) are(hj) dead(h) which(g) sought(g) the(d) young(ef) Child’s(ghg) life.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-068.png",
        nextFileName: "./pages/part-a-069.png",
    },
    {
        title: "part-a-069-0",
        gabc: "hen(dg) Jo-(fe)seph(fg) heard(gh) Tthat(h) Ar-(g)che-(h)la-(g)us(g) did(g) reign(gh) in(ge)  Ju-(g)dae-(fed)a(defghhg) in(g) the(gh) room(hgf) of(g) his(h) fa-(ij)ther(h) Herod,(g)  (g)  he(g) was(gj) a-(j)fraid(ji) to(hj) go(ji) thither;(hg)  (g) and(h) be-(h)ing(h) warn-(gh)ed(g)  in(f) a(g) dream,(gh) he(f) turned(hj)  (j) a-(k)side(ji) in-(h)to(i) the(h) parts(g) of(hi)  Ga-(h)li-(g)lee:(g) and(i) he(j) came(h) and(g) dwelt(hg) in(d) a(ef) ci-(g)ty(h)  (g)  which(g) was(f) called(gh)  (g) Na-(f)za-(ff)reth;(defedc) that(c) it(d) might(fd) be(f) ful-(e) (f)  filled(gf)  (g) which(g) [(e) spoken(f)  (g) by(h) the(gf) prophets,(gh)  (h) He(g) shall(h)  be(ji) call-(hg)ed(ghg) a(f) Na(hg) -(fg)za-(g)E(j) I(i)  (j)  (h) ||(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-069.png",
        nextFileName: "./pages/part-a-070.png",
    },
    {
        title: "part-a-070-0",
        gabc: "All(f) they(gh) from(f) Sheba(fe)  (dc) shall(fg) come,(i) Al-(hij)1le(ihgfe) -(h)ia,(f) [§]-(d) le(fgiihgfe) lu-(gg)ia.(f) All(f) they.(gh) ¥.(c) They(fg) shall(f) bring(gh) gold(fe) {ng(cd)  incense.(fg)  (i) Al-(hij) (i) le(ihgfe) lu-(gh)ia.(f) Glory(f)  (f) be.(g) RZALL(f) they.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-070.png",
        nextFileName: "./pages/part-a-071.png",
    },
    {
        title: "part-a-070-1",
        gabc: "An(c)  (f) they(g) from(f) Sheba(f) a2(e) shall(g) come,(h) Al(h) —le-(hg)lu-(g)ia,(f) al-(d) le-(fg)lu-(gf)ia.(f) All(f) they.(g) ¥.(c) They(f) shall(f) bring(g) gold(f) and(e)  (X(g) incense.(h) Al-(h)le-(hg)lu-(g)ia.(f) be.(f)  (f)  (f) B?&#39;All(f) ¢(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-070.png",
        nextFileName: "./pages/part-a-071.png",
    },
    {
        title: "part-a-071-0",
        gabc: "a(d)  (e)  (f) -(gh) (d) |(eg)  (fe) A(e) ](g) (B(hj)  (j) -(ji) ¢(hg) O(hi)  (i)  (i) e(h) S(hjk)  (j) S(ji) (B(hg)  (h) -(gf) (edfh)  O(d)  (e) This(f)  (fh) melody(gf) is(g) usad(f) at(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-071.png",
        nextFileName: "./pages/part-a-072.png",
    },
    {
        title: "part-a-071-1",
        gabc: "The(gd) wise(ffh) ](g) men,(gh) beholding(hgf)  (fh) the(h) star,(g) said(hj) one(h) to(g) an-(f)o-(gh) (g)  This(jj) is(k) the(j) sign(j) of(i) a(h) mighty(ji)  (hg) King;(g) forth(d) fare(fgh) we,(g)  and(g) let(hi) us(gh) seek(g) him:(f) and(h) let(f) us(hj) of-(j)fer(i) him(h) gifts,(ghg) ](e)  gold,(ef) incense(hg)  (h) and(h) myrrh,(gfd) al-(ef)le-(fg)lu-(g)ia.(g) M-(j)1(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-071.png",
        nextFileName: "./pages/part-a-072.png",
    },
    {
        title: "part-a-072-0",
        gabc: "Before(gi)  (f) -(fg)a(e) morning(fij)  (h) star(g) a(e) begot.ten,T(gh)  (f) and(ef) Lord(h) frop(ij) .(ji)  erlasting,(h)  (hgf)  (gf) our(f) Saviour(h)  (g) is(h) made(f) ](g) ni-(ef)fedt(fgeec) Un-(fe)tg(h)  the(ig~)  (g) world(e) to-(h)day.(f) ](h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png",
    },
    {
        title: "part-a-072-1",
        gabc: "Ty(f) light(ghg) is(hg) come,(fgf) _I-(g)Je-(fe)ru-(d)sa-(defede)lem,(ed) and(d) the(d) glo(dgfh) r(gf)  of(gh) the(h) Lord(ghg) is(f) ri-(ghg)sen(hg) up-(ghge)on(f)  (hg) thee:(hg) and(g) the(f) Gen(g)  tiles(fe) shall(d) .(fgf) to(fe) thy(de) light,(ddc) al(def) le(fed) _—I_I(de) ia.(d) T(h)  (g) adi](fg)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png",
    },
    {
        title: "part-a-072-2",
        gabc: "W(cc) hen(f) they(h) had(g) o-(h)L(g) @(g) @(f) @(g) e(d)  (hih) -(gh)men(jk)  presented(jkj)  (ij)  (g) un-(ji)to(i) the(i) Lord(h) gold,(h) frankincense,(g)  (h) [(e) and(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-072.png",
        nextFileName: "./pages/part-a-073.png",
    },
    {
        title: "part-a-073-0",
        gabc: "myrrh,(ghg) al(h) le(gf)  (fe) lu-(d)ia.(d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png",
    },
    {
        title: "part-a-073-1",
        gabc: "()(fd) ve(f) seas(g) and(f) floods,(efg)  (gf) bless(ef) ye(gh) the(h) Lord:(g) O(g) vye(g)  wells,(ij) sing(h) a(g) hymn(ge) un-(g)to(f) the(e) Lord,(d) al(f) —le~-(fg)lu-(e)ia.(e)  -(h) (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png",
    },
    {
        title: "part-a-073-2",
        gabc: "Like(c)  (g) a(h) flame(i) of(j)  (i) that(i) star(i) glittereth(j)  (h)  (i) yonder,(h)  (g)  revealing(h)  (ij)  (i) God,(hg) the(ef) King(hf) of(gf) kings:(e) the(e) wise(ghji) men,(hihg)  when(f) they(h) beheld(g) a(e) it,(f) a(e) M(d) ](ef) presents(h) o(e) un-(f)to(e) the(d)  mighty(ef)  (f) Ruler.(e)  (e)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-073.png",
        nextFileName: "./pages/part-a-074.png",
    },
    {
        title: "part-a-074-0",
        gabc: "——(f) kings(f) of(f) Tharsis(g)  (f) and(f) of(f) the(f) isles(f) shall(f) give(e) e(d)  presents,(g)  (h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ig,(f) The(f) kings,(f)  V.(c) The(f) kings(f) of(f) A-(f)ra-(g)bi-(f)a(f) and(f) Sa-(f)ba(f) shell(e) bring(g)  gifts.(h) Al-(h)le-(hg)lu-(g)ia.(f) i.Glory(c)  (f)  (f) be.(f) The(f) kings.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png",
    },
    {
        title: "part-a-074-1",
        gabc: "a4(g) s(g) a(f)  (e)  (d)  (fhg)  (fg)  (g)  (hjji)  (h)  (hg)  (h)  (@(ig) =(h) &amp;(g)  (f) e(g)  (g) g(f)  (g)  (h)  (j)  (g)  (hih)  ¥.(h)  (h) 5(ghg)  (e)  (f)  (hg)  (fg) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png",
    },
    {
        title: "part-a-074-2",
        gabc: "o-(f) (fg) the(hij) Church(ji) is(hg) joined(h)  (g) to(i) her(j) heavenly(h)  (gf) Bride-(gh) (ggh) ",
        groupIndex: 2,
        filename: "./pages/part-a-074.png",
        nextFileName: "./pages/part-a-075.png",
    },
    {
        title: "part-a-075-0",
        gabc: "groom;(g) because(f)  (g) 1n(jg~) Jordan(jjk)  (j) Christ(j) hath(j) washed(k)  (j) a-(j)way(ji) her(hj)  of-(jk) (ji) fences:(g) the(h) wise(ji) men(g) with(h) their(i) offerings(j)  (h)  (j) hasten(ih)  (g)  ‘to(g) the(g) roy-(h)al(ig) marriage;(hg)  (f) and(g) the(h) guests(g) are(f) re-(h)gal-(jj)ed(hih)  with(g) water(hj)  (g) made(ef) wine,(d) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-075.png",
        nextFileName: "./pages/part-a-076.png",
    },
    {
        title: "part-a-075-1",
        gabc: "Now(c)  (d) do(c) we(def) ce(fgfeded) le-(cd) (d) Tla(dc) ho-(f)ly(g) day(h) a-(g) (hg) dorned(f) by(gf) three(def)  mi(fgfeded) ra-(cd)cles:(d) to-(d)day(dh) a(h) star(hg) led(h) the(gf) wise(gh) men(fe)  (c) to(d) the(efe)  PV(d)  (d) I(d) day(dg) water(h) R(g) was(f) made(fe) wine(fg) at(e) the(fe) I(d) wedding(cd) feast;(d)  to-(d)day(dh) Christ(h) vouchsafed(g)  (h)  (f) to(f) be(g) baptized(gh)  (h) of(g)  (f) John(g) in(ef) Jor-(d) dan(dfddc) that(cd) he(fgfe) might(ghg) save(fe) us,(dc) al-(d)le-(efe)lu-(d)ia.(d) L(h)  (g)  (f)  (g) kY(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-075.png",
        nextFileName: "./pages/part-a-076.png",
    },
    {
        title: "part-a-076-0",
        gabc: "rom(d) the(de) FastT(efee) there(df) came(hfh) wise(hij) men(i) to(ij) Pethlehem,(h)  (gh)  (f) ¢,(i)  worship(gi)  (h)  (gh) the(fe) Lord:(fgfe) and(d) when(e) they(f) had(e) o-(f) (e) pened(e) their(d)  treasures,(ef)  (f) they(f) a(i) presented(h)  (gh) un-(f)to(e) him(efe) precious(dc)  (de) &quot;N(e)  as(d) to(e) a(f) mighty(hf)  (gf) King,(e) incense(i)  (h) as(i) to(f)  (k) the(j) true(ih) God,(i)  ¢(ig~) and(hi) myrrh(ihghf) to(f) -(i)foreshew(h) his(gh) bu-(f)ri-(e)al,(efe) .(d) le-(de)lu-(e)ia.(e) &quot;y(hghfefe) ",
        groupIndex: 0,
        filename: "./pages/part-a-076.png",
        nextFileName: "./pages/part-a-077.png",
    },
    {
        title: "part-a-076-1",
        gabc: "hen(c) I(c) wise(e) men(f) saw(gh) the(g) star&#39;(g) they(g) &quot;(f) rejoiced(hi)  (h) 3(h) ——(f)  ceeding(h)  (g) great(ih) joy:(g) and(g) when(h) they(g) were(g) come(hi) in-(j)to(j) the(i) house,(g)  they(g) presented(g)  (h) un-(g) (f) to(g) the(f) Lord(edd) gold,(c) frankincense(d)  (e)  (d) and(e)  .(cd)  (e) le-(d)lu-(c)ia.(c) 122(g)  (h) &#39;(g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-076.png",
        nextFileName: "./pages/part-a-077.png",
    },
    {
        title: "part-a-077-0",
        gabc: "Three(c)  (fd) are(e) the(f)  (ge) giftsTwhich(f) the(d) wise(ef) men(g) s(g) presented(g) .(f) un—(gh)  to(h) the(g) gold,(fg) frankincense,(d)  (e)  (f) and(h) myrrh,(gg) to(e) the(f) Son(gh) of(h)  God,(g) to(f) the(g) mighty(g)  (f) King,(fed) al-(f)le-(fg)lu-(e)ia.(e) ||(h) a1(g) 1(h)  (ih) [(gfe) a](e) ",
        groupIndex: 0,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png",
    },
    {
        title: "part-a-077-1",
        gabc: "|(c) ight(hg) of(fh) [(hge) &amp;4(d) C(ef) Christ,(hg) hast(f) a(e) appeared,(f) uw(e) un-(h)to(h)  whom(j) the(i) wise(j) men(i) present(h)  (i) their(hg) gifts,(f) al-(h)le-(e)lu-(f)ia,(e)  a(e) le-(ghi)lu-(h)ia,(f) al-(g)le-(f)lu-(e)ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png",
    },
    {
        title: "part-a-077-2",
        gabc: "W&#39;e(fe) have(d) seen(e) his(f) star?(ghg) in(g) the(e) East,(fed) and(f) are(e) come(d) with(f)  gifts(ghg) to(g) worship(h)  (f) the(g) Lord.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-077.png",
        nextFileName: "./pages/part-a-078.png",
    },
    {
        title: "part-a-078-0",
        gabc: "Y(gfd) rod(e) ——(f)  (gh) [(g) the(hgf)  (h) wise(ji) men,(g) What(jkji) .(h) haye(i) ve(j)  seen,(i)  (ih) concerning(j)  (ih)  (ghg) him(g) that(e) is(f) born(gh) King?(g) We(ji) have(h) .,(i)  a(j) star(ih) shining,(gi)  (h) the(g) brightness(gfd)  (ef) whereof(gh)  (g) enlighteng(hg~)  (hgf)  (h)  the(ji) world.(g) ](j)  (i)  (j) V.(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png",
    },
    {
        title: "part-a-078-1",
        gabc: "L](g)  (h) nationsTsllall(ij)  (i)  (ijhg) :(fh) from(h) a-(gf)](ef) bearing(h)  (i) their(gh)  s(f) al-(f)le-(gf)lu-(e)1a.(e) RN(j)  (i) ;—_I(h) BN(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png",
    },
    {
        title: "part-a-078-2",
        gabc: "N(def) they(e) from(d) She(fhhgfe) batshall(ed)  (de) 5(e) they(eiji) shall(i) bring(hgf)  gold(hg) and(f)  (f) incense,(e) al-(f)le-(hg)lu-(f)ia,(ed) al-(ef)le-(f)lu-(e)T(e) |(h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 2,
        filename: "./pages/part-a-078.png",
        nextFileName: "./pages/part-a-079.png",
    },
    {
        title: "part-a-079-0",
        gabc: "All(j) they(i) from(g) She-(j) (hg) ba(hg) come:(f) they(g) shall(g) bring(g)  gold(g) and(fh) incense,(j)  (i) al-(g)le-(j)lu-(h)ia,(h) al-(i)le-(h)lu-(g)ia.(g)  (j) 1(hj)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png",
    },
    {
        title: "part-a-079-1",
        gabc: "that(c)  (g)  (df) despised(e)  (f)  (fg) thee(g) tshall(g) come(hi) un-(ggh)to(g) thee,(f) and(f)  shall(jh) bow(j) themselves(jh)  (ih) at(h) the(f) soles(fh) of(h) thy(g) feet.(g)  a__.(ki~)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png",
    },
    {
        title: "part-a-079-2",
        gabc: "T(c) he(d) wise(d) men,(d) be-(f)ing(g) warned(fh)  (h) in(h) dreams(i) by(h) an(g) An-(fh) gel,(g) de-(g)part-(g)ed(e) in-(g)to(h) their(g) own(fg) country(ef) a(c) an-(d)oth-(dge)er(fe)  way,(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-079.png",
        nextFileName: "./pages/part-a-080.png",
    },
    {
        title: "part-a-080-0",
        gabc: "[(gi) he(e) Child(fg) Je-(h)sus(g) tar-(e)ri-(f)ed(f) a(e) behind(fg) in(h) Je-(hg)ru-(fg)sa-(fe)a(e)  and(ig~)  (h) Joseph(h)  (h) and(j) his(jk) mother(j)  (i) knew(h) not(hg) of(ef) it,(f) supposing(f)  (g)  (h)  B(ig~) him(i) to(i) have(ji) been(hgf) in(h) the(hg) compa-(fg)ny;(fe)  (e) [(c) they(ef) sought(hhi)  w(gi) him(h) -(h)among(h) their(h) -(h)e(gh) e(i) et(hg) acquaintance.(f) b(f) D(h)  (g) Th(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-080.png",
        nextFileName: "./pages/part-a-081.png",
    },
    {
        title: "part-a-081-0",
        gabc: "Son,(fg) why(h) hast(i) thou(h) thus(gf) dealt(gh) with(h) us?(g) behold(g)  (jh~) thy(ji)  father(h)  (g) and(h) I(g) have(g) sought(fed) thee(ef) sorrowing.(gh)  (h)  (g) How(jk) is(k) it(k)  that(k) ye(kj) sought(jk) me?(h) wist(hf) ye(hj) not(jkh) that(h) I(f) must(h) be(j) a-(i)bout(jk)  my(hg) Father’s(fh)  (h) same(g) business?(g) o(j)  (i) et(j)  (h) .(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-081.png",
        nextFileName: "./pages/part-a-082.png",
    },
    {
        title: "part-a-082-0",
        gabc: "A(cd) when(f) they(g) wanted(f)  (h)  (h) bade(h)  (h)  (hj) them(h) to(g) fil](h)  the(g) w-(ef)a-(g)ter—pot:s(f) with(fe) water;(d)  (d) and(hijihh) it(g) was(ef) turned(g)  (fe) in-(d) to(fe) wine,(dc) al-(d)le-(efe)lu-(d)ia.(d)  (h) THE(g)  (f) EPIPHANY(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-082.png",
        nextFileName: "./pages/part-a-083.png",
    },
    {
        title: "part-a-082-1",
        gabc: ".The(f) Ho-(fe)ly(d) Spirit(d) :(c) .(d) descended(f)  (gf) Tin(f)  (f) a(g) bo-(h)di-(g)ly(f) shape(f) like(f)  a(g) dove(h) up(gf) on(fgffg) him,(d) and(d) there(e) came(c) a(d) voice(f) from(g) hes-(fg) ven:(f) This(f) is(g) my(h) be-(e)lov-(f)ed(g) Son?’(defedc) héar(cd) ye(fg) him,(gf) al-(g)le-(ghg) lu-(f)1ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-082.png",
        nextFileName: "./pages/part-a-083.png",
    },
    {
        title: "part-a-083-0",
        gabc: "T(c) ord,(hh) if(g) thou(i) wilt,(ghge) thou(f) canst(g) make(e) me(fe) clean:(d) then(ff)  saith(ik)  (defec) Je-(f)sus,(ighghih) I(h) will;(gfe) be(fgf) thou(ef) clean.(d)  (h)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png",
    },
    {
        title: "part-a-083-1",
        gabc: "us,(f)  (gh)  (h) we(gf) perish:(gf)  (d) re-(d)buke(d) the(e) winds(f) and(e) the(f)  (d)  sea,(de) IO(dc)  (c) and(cd) a(ef)  (g) great(fe) calm.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png",
    },
    {
        title: "part-a-083-2",
        gabc: "ye(ik)  (f)  (dc~)  (d) to-(d)ge-(dhi)T(h) first(hj) the(h) tares,(hghihgg) and(f)  (gf) bind(h)  (hg~)  them(g) in(f) E==—(def) a(g) to(fe) burn(d) them:(d) but(cd) gather(ffg)  (f) the(f) wheat(ghg)  in-(gf)to(f) my(dfe) bhrn,(dc) saith(d) the(efe) Lord.(d)  (ffh)  (h)  (g)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-083.png",
        nextFileName: "./pages/part-a-084.png",
    },
    {
        title: "part-a-084-0",
        gabc: "he(d)  (f) of(c)  (d) hea-(dhi)ven(h) tis(h) like(hj) un-(h)to(h) lea-(h)ven,(hghihgg) Which}:(f)  a(g) wo-(h)man(g) took(fg) and(f) hid(f) in(f) three(ef) measures(g)  (fe) of(df) mea&#39;xl,(fc)  un-(cd)til(f) the(ef) whole(g) was(fe) leavened.(d)  (d)  (d) e(h)  (g) =](f) d(gh) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png",
    },
    {
        title: "part-a-084-1",
        gabc: "L](e)  (f) the(hi)  (i)  (i) bo-(hi)dy(jh) 1is,(i) there(fi) will(g) the(h) 0(fe) eacles(f)  be(e) gathered(d)  (e)  (f) together.(h)  (f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png",
    },
    {
        title: "part-a-084-2",
        gabc: "T(ki~)  (cc) he(d) Lord(fg) said(ghg) Tun-(g)to(fe) A-(fgf)dam,(g) Of(d) the(fg) tree(ghg) which(f) 1s(g)  in(hi) the(j) midst(ihij) of(h) the(gh) garden(i)  (j) thou(hg) shalt(f) not(fg)  in(j) the(jk) day(jih) that(j) thou(ji) ",
        groupIndex: 2,
        filename: "./pages/part-a-084.png",
        nextFileName: "./pages/part-a-085.png",
    },
    {
        title: "part-a-085-0",
        gabc: "sure-(h)ly(hih) die.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png",
    },
    {
        title: "part-a-085-1",
        gabc: "Let(g) us(g) bless(g) the(g) Lord,(h) al-(g)le-(f)lu-(hg)ia,(h) al-(h)le(gjihg) lu-(fgh)ia.(hg)  Thanks(g) be(g) to(g) God,(h) al-(g)le-(f)lu-(hg~)ia,(h) al-(h)le(gjihg) lu-(fgh)ia.(hg) ",
        groupIndex: 1,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png",
    },
    {
        title: "part-a-085-2",
        gabc: "And(cd) when(f) he(g) had(f)  (h) agreedfwith(hgg)  (f) the(g) labourers(h)  (g)  (f) for(f) a(f) pen-(fg) ny(fe) a(def) day,(fc) hé(cd) sent(fg) them(f) into(ef)  (g) his(fe) vineyard.(d)  (d)  (h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png",
    },
    {
        title: "part-a-085-3",
        gabc: "Goye(ji)  (hg) =](h) al-(gf)=(gh) to(i) the(h) vineyard,(g)  (g) and(g) what-(g)0(e) ev-(g)er(g)  18(fe) right(d) T(f) will(fh) give(g) you.(g) ](j)  (h)  (j)  (k)  (j) ",
        groupIndex: 3,
        filename: "./pages/part-a-085.png",
        nextFileName: "./pages/part-a-086.png",
    },
    {
        title: "part-a-086-0",
        gabc: "stand(cd)  (dh) ye(hi) herefall(hgg)  (h) the(gh) day(fe) 1i-(d)dle?(df) They(cd) answered(f)  (f)  (e)  him,(d) saying;(ffg)  (f) Because(f)  (ef) no(g) LR(e) hath(dfe) hired(d)  (d) us.(d)  (h) E——(g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png",
    },
    {
        title: "part-a-086-1",
        gabc: "C(ig) 211(eh) the(fed) la-(ef)bour-(fe)ers,(e) and(h) give(i) them(h) their(fhg) hire,(ef)  saith(gi)  (g) the(f) .-(e)Lord.(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png",
    },
    {
        title: "part-a-086-2",
        gabc: "Praise(h) be(h) to(h) thee,(h) O(h) Lord,(h) King(h) of(h) e-(h) (h) ternal(i) glory.(dhg)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png",
    },
    {
        title: "part-a-086-3",
        gabc: "—(c) bouseholder(dc~fe)  (fg)  (g) saith(gf) un-(d)to(f) the(e) labourers,(d)  (c)  (c) Wby(cfe)  stand(fghi) ye(i) here(fhih) all(g) the(f) day(hih) ](g) dle?(g) They(fgh) say(gf) un-(fd)to(e) ",
        groupIndex: 3,
        filename: "./pages/part-a-086.png",
        nextFileName: "./pages/part-a-087.png",
    },
    {
        title: "part-a-087-0",
        gabc: ".(c) Becdlse(d)  (c) e(d) man(f) hath(e) hi-(d)red(c) us.(c) Go(hij) ye(jhjihg)  al-(hi)80(gf) in-(h)the(h) vineyard,(g)  (g) a(e) what-(g)so-(hg)ev-(f)er(e) is(d)  oy(ef) I(gf) .(d) a(c) (D(c) -(h) (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png",
    },
    {
        title: "part-a-087-1",
        gabc: "Th:ase(ccc)  (dh) last(hj) have(hg)  (ef) but(g) one(fe) hour,(d) and(d) thou(fe) hast(d)  a(e) them(f) e—qual(g)  (ge) un-(f)a(e) .(d) which(f) have(cd) borne(ed) the(d)  bur-(fh)den(ghg) and(f) heat(df) of(g) the(fe) day.(d) &quot;(h) e(g) .(f) d(gh) &amp;g(gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png",
    },
    {
        title: "part-a-087-2",
        gabc: "T(cc)  (c) he(e) householder(eh)  (f)  (e) an-(f)swer-(ed)ed(ef) and(ef) said,(e) Friend,(cfigij)  (c) 1(i)  (c)  do(ji) thee(hij) no(hg) wrong:(e) didst(hg) notthou(f)  (g) a-(h)gree(ihj) with(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-087.png",
        nextFileName: "./pages/part-a-088.png",
    },
    {
        title: "part-a-088-0",
        gabc: "me(hf) for(g) a(f) penny?(e)  (e) Take(ec) that(e) thine(e) is,(dc) and(d) go(ef) thy(f) way.(e)  a(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png",
    },
    {
        title: "part-a-088-1",
        gabc: "Take(j) that(ji) thine(hg) ist(h) and(fg) go(gh) thy(h) way:(g) because(g)  (ge) I(g) am(fe)  (d)  good,(d) saith(f) the(h) Lord.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png",
    },
    {
        title: "part-a-088-2",
        gabc: "[s(e) it(eh) not(f) lawful(f)  (e) for(f) me(e) to(f) do(ed) what(ef) I(f) will?(e) Is(g)  thine(igj) eye(i) e-(hi)vil,(hghih) because(f)  (h) I(e) am(f) good,(ed) saith(ef) the(f)  Lord.(e)  (h)  (g)  (h)  (f) FRIDAY(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png",
    },
    {
        title: "part-a-088-3",
        gabc: "S(f) the(de) lastT(e) shall(f) be(d) -(ef)and(h) the(h) first(i) shall(f) be(h) ",
        groupIndex: 3,
        filename: "./pages/part-a-088.png",
        nextFileName: "./pages/part-a-089.png",
    },
    {
        title: "part-a-089-0",
        gabc: "last:(g) for(i) ma-(i)ny(g) are(h) call(iji) -(hghih)but(fe) few(fhf) are(gfj)  chosen.(e)  (e)  (h)  (g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png",
    },
    {
        title: "part-a-089-1",
        gabc: "he(g) LordT(ghgf) said(hj) un-(h)to(gf) No-(ghg)ah:(g) The(gj) end(jj) of(h) all(ij) flesh(k)  is(ji) come(h) be-(ij)fore(hg) me:(g) Make(g) thee(j) an(k) ark(h) of(hgf) go-(h)pher(hi)  wood,(g) that(h) therein(hg)  (fgh) the(h) seed(j) of(ih) all(ghgf) flesh(gh) may(i) be(h)  [(g) saved.(g) 0(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png",
    },
    {
        title: "part-a-089-2",
        gabc: "I(h) seedT(g) .(e) a(g) good(i) _(h) and(g) N(e)  forth(f) fruit(h) with(g) a(e) ar(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-089.png",
        nextFileName: "./pages/part-a-090.png",
    },
    {
        title: "part-a-090-0",
        gabc: "T(c)  (c) hey(d) keep(dc)  (f) the(g) word(f) of(gh) God(h) with(h) an(g) honest(h)  (g) and(f)  =(h) perfect(fe) heart(d) bring(g) forth(ef) fruit(g) with(fe) patience.(d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png",
    },
    {
        title: "part-a-090-1",
        gabc: "ome(h) a(g) fell(e) on(g) good(i) ground,(h) and(f) broucht(ef) forth(gf) frujt;(e)  same(g) an(h)  (i) hundredfold,(h) ](g) and(f) some(hg) sixtyfold.(e)  (e)  (e) |(h) B(f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png",
    },
    {
        title: "part-a-090-2",
        gabc: "£(ig) then,(j) brethren,Tye(i)  (i) n(i) would(i) be(gh) truly(ih)  (f) rich,(e) set(h) your(h)  af-(f)fec-(h)tion(gf) on(e) the(f) true(gf) riches.(e)  (e) —(i) ¢(j)  (i)  (h) |(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png",
    },
    {
        title: "part-a-090-3",
        gabc: "Unr-(f)to(h) you(f) it(f) is(e) s(d) givenT(d) to(e) know(c) the(d) mys-(f)te-(f)ries(f) of(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-090.png",
        nextFileName: "./pages/part-a-091.png",
    },
    {
        title: "part-a-091-0",
        gabc: "the(e) kingdom(c)  (d) of(f) hea—-(ffgf)ven:(f) but(fh) to(hg) o(hih) thers(gf) in(gghg)  parables,(f)  (ef)  (f) said(f) Je-(gh)sus(f) to(f) his(dc) disciples.(df)  (f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png",
    },
    {
        title: "part-a-091-1",
        gabc: "[f(cig) ye(hij) seek(i) the(i) summit(j)  (i) of(gh) true(ihf) [](e) honour,(e) hasten(h)  (h) to(h)  yon(h) heavenly(h)  (h)  (f) country(h)  (g) with(f) what(ef) speed(g) ye(f) may.(e)  (j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png",
    },
    {
        title: "part-a-091-2",
        gabc: "The(g) seed(hj) is(ji) the(hg) word(hiji) of(h) God,(g) but(g) Christ(hi) is(h) the(g)  Sow-(effg)er:(g) every(i)  (h) one(j) that(hg) hear-(h) (iji) eth(h) him(g) shall(h) a-(gf)bide(g)  for(gf) ev-(e)er.(e)  (j)  (h) ESDAY(j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png",
    },
    {
        title: "part-a-091-3",
        gabc: "thatT(idhi)  (h) which(h) fell(h) on(h) the(h) good(h) ground(ihghihgg) are(h)  (fg) they(h) ",
        groupIndex: 3,
        filename: "./pages/part-a-091.png",
        nextFileName: "./pages/part-a-092.png",
    },
    {
        title: "part-a-092-0",
        gabc: "which(g) in(h) an(g) honest(h)  (g) and(f) 4(ghfe) -(d)receive(g)  (h) the(g) word;(f)  and(f) bring(f) forth(ef) fruit(g) with(fe) U(d)  (d) E——(h)  (g) {‘I(f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png",
    },
    {
        title: "part-a-092-1",
        gabc: "Some(h) a(g) 0(e) ](g) good(i) ground,(h) and(f) i(ef) forth(gf) fruit;(e)  some(gi)  (g) an(h) *(i) hundredfold,(h) :(g) and(f) some(hg) sixtyfold.(e)  (e) e(e) e(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png",
    },
    {
        title: "part-a-092-2",
        gabc: "T(c) hey(d) ;]Eo(dc) keep(f) the(g) word(f) of(gh) God(h) twith(h) an(g) honest(h)  (g) and(f) per-(h) fect(fe) heart(d) bring(g) forth(ef) fruit(g) with(fe) patience.(d)  (d) |(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png",
    },
    {
        title: "part-a-092-3",
        gabc: "-(ik) (c)  (cffddcf) ty(f) A-(gh)bra-(gf)ham,(f) the(hj) fa-(ih)ther(gf) of(g) our(gh) faith,(f)  of(ffdd) -(fcgh)fer-(gf)ed(f) a(g) burnt(ghg) offering(f)  (ef)  (f) up-(f)on(gh) the(ghg) al-(f)tar,(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-092.png",
        nextFileName: "./pages/part-a-093.png",
    },
    {
        title: "part-a-093-0",
        gabc: "in-(f)stead(fdd)  (fc) of(g) his(ghg) son.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png",
    },
    {
        title: "part-a-093-1",
        gabc: "As(cd)  (d) made(dc)  (d)  (fd) _——————————————————(ed)  (c) when(d) ia(dc) was(f) come(g) nigh(h)  un-(g)to(f) Je-(fe)ri-(fgf)cho,(g)  (g) la(dc) blind(f) man(g) cri-(h)ed(g) un—to(f)  (gh) him,that(h)  (fg)  he(ihih) might(g) n(e) worthy(g) a(fe) to(d) -(c)receive(ef) light.(d) &quot;=(h) [(g)  (f) Te(g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png",
    },
    {
        title: "part-a-093-2",
        gabc: "As(d) the(dc) Lord(f) was(g) passing(f)  (gh) by,t(h) a(hg) blind(i) man(h) cri-(g)ed(g) un-(f) to(gh) him,(g) Have(g) mer-(e)cy(g) on(hg) me,(fg) thou(ec) Son(eg) of(f) Da-(d)vid.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-093.png",
        nextFileName: "./pages/part-a-094.png",
    },
    {
        title: "part-a-094-0",
        gabc: "a(e) they(g) which(h) went(ihj) before(hi)  (i) rebuked(i)  (i)  (i) him(i) that(h) he(ij)  should(i) hold(h) his(hg) peace:(e) but(h) he(h) cri-(hih)ed(hg) so(hf) much(gh) the(g) more,(e)  ave(dde) a(e) mercy(f) on(h) hong(gh) thou(f) Son(h) .(g) A(e) 8.(e) “(i)  (j)  (i) ﬂ(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png",
    },
    {
        title: "part-a-094-1",
        gabc: "he(d) bl;nd(ef) man(g)  (g) out(g)  (gh) more(ge) and(f) more,(d) that(fh) tle(h)  Lord(ghg) would(ef) give(g) him(fe) light.(d)  (f)  (h) I(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png",
    },
    {
        title: "part-a-094-2",
        gabc: "And(c)  (c)  (cd)  (d) Tand(dfdcdc)  (f) ](g) commanded(hhi)  (h) him(h) [](g) be(f) ](g)  un-(fhi)to(gh) him,(h) and(hgh) asked(f)  (fe) him,(fgfe) saying:(d)  (d) What(ef)  (d) wilt(cd) thou(d)  that(d) I(d) shall(cd) do(f) un-(g)to(g) thee?(f)  (f) Lord,(fh) that(g) I(f) may(f) a(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-094.png",
        nextFileName: "./pages/part-a-095.png",
    },
    {
        title: "part-a-095-0",
        gabc: "ceive(fg) my(fe) sight.(d) And(c) Je-(df)sus(f) said(f) un-(f)to(de) him,(dc) Beceive(d)  (e)  e(i) thy(cd) sight,(d) thy(ccd) faith(f) hath(g) saved(g)  (f) thee.(f) And(f) straightway(fh)  (g)  he(f)  (fe) received(f)  (g) his(fe) sight,(d) and(c) followed(df)  (fe) him,(de)  (dc) glo-(cd)ri-(ef)fy-(fgh) ing(ik)  (fe) God.(d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png",
    },
    {
        title: "part-a-095-1",
        gabc: "nd(e) they(g) which(h) went(ihj) before(hi)  (i) trebuked(i)  (i)  (i) him(i) that(h) he(ij)  should(i) hold(h) his(hg) peace:(e) but(h) he(h) cri-(hih)ed(h)  (hg) so(hf) much(gh) the(g) more,(e)  Have(g)  (de) .(e) mercy(f) on(h) -(gh)thou(f) Son(h) of(g) a.(e) David.(e) @-(j) (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png",
    },
    {
        title: "part-a-095-2",
        gabc: "Have(c)  (e) mercy(f)  (f) on(e) me,l(e) thou(f) Son(h) of(hg) Da-(fgfe)vid.(e) What(h) wilt(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-095.png",
        nextFileName: "./pages/part-a-096.png",
    },
    {
        title: "part-a-096-0",
        gabc: "thou(f) that(g) I(f) shall(fi) do(i) un-(h)to(hg) thee?(hihgf) Lord,(de) that(f) I(hf)  may(g) receive(f) a(e) my(de) [(e) sight.(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png",
    },
    {
        title: "part-a-096-1",
        gabc: "Lay(f) up(h) for(h) yourselves(hj)  (i) t(h) treasures(i) .(hj) heaven,(i)  (i) where(fi)  neither(g)  (h) moth(f) nor(e) rust(fe) doth(de) corrupt.(fh)  (f) &amp;(i) v(h)  (i)  (j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png",
    },
    {
        title: "part-a-096-2",
        gabc: "Lord,(f) T(gh) e(h) not(g) TR(h) e(ghg) TawT(e) thou(f) B(g) shouldest(f) e(g) ter(e)  un-(g)der(h) my(fe) roof:(d) but(d) speak(dgfgh) the(g) word(gf) on-(fg)1ly(f) and(f)  my(f)  my(f) -(f)servant(ef) shall(g) be(fe) healed.(d)  (d) e(h) %(g)  (f) &amp;(g) on(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png",
    },
    {
        title: "part-a-096-3",
        gabc: "But(c)  (c)  (d) »(dc) when(f) thou(g)  (fh) prayest,enter(h) t(i) -(h)a(g) to(h) -(fe)loset(d) ;(d) ",
        groupIndex: 3,
        filename: "./pages/part-a-096.png",
        nextFileName: "./pages/part-a-097.png",
    },
    {
        title: "part-a-097-0",
        gabc: "and(g) when(g) thou(e) hast(g) shut(h) thy(g) door,(f) pray(fg) to(e) thy(fe) Father.(d)  (d)  .(h)  (g)  (f) I(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png",
    },
    {
        title: "part-a-097-1",
        gabc: "He(c)  (cf) sball(f) de-(f)fend(gh) thee(hg) Un-(g)der(fd) his(fg) wings.(gf) He(f) shall.(f)  defend.(f)  (gh) And(h) thou(h)  (hi) shalt(h) be(gh) safe(g) un-(g)der(g) his(f) fea-(gh) thers.(hg) Un-(g)der(fd) his(fg) wings.(gf) Glory(h)  (h) be.(h) He(f) shall(f) defend.(f)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png",
    },
    {
        title: "part-a-097-2",
        gabc: "o(fe) |(f)  (hg) &quot;(h)  (fg) T(gf) W&amp;(ef) &quot;(f) &quot;(hg) R(hi) T(ihg) R(f) &quot;(hg)  (fg) P(fe) af(e)  .,(gi)  (e)  (f) a(g) o(dhg)  (f) fi(hg) R(hi) a.(i) &amp;(ef)  (hi)  (g) fa(hg) ](f) _a(gf) ](ef)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-097.png",
        nextFileName: "./pages/part-a-098.png",
    },
    {
        title: "part-a-098-0",
        gabc: "hen(e) shalt(g) thou(h) call,T(ihji) and(g) the(h) Lord(ih) shall(f) a(e) a(e)  thou(h) shalt(hhi) cry,(hggh) and(hi) he(h) shall(gh) say,(f) Here(gh) am(g) I.(e)  (ijihgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png",
    },
    {
        title: "part-a-098-1",
        gabc: "J(g)  (g)  (dfe)  (f)  (g)  (h)  (f) [](f)  (f)  (f)  (h)  (g)  (e) !(f)  (h) |(g)  L(gi)  (h) J(i)  (h) T(g)  (f) I(h)  (f) SUNDAY(f) IN(g) LENT(g)  (fe) Y(f)  (g) T(h)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png",
    },
    {
        title: "part-a-098-2",
        gabc: "o(gi) R(g)  (i) o(ij)  (j) P(ih)  (i) sG](i) |(j) s(i) GRS(g)  (h) -(i)IR(hg) N(f) e(eg) e(g)  [(g) .(i) N(ij)  (ji) A(gf)  (h) o(gf) L(fg) A(e) A(hg) A(hi) R(hg)  (e) B(gh) .(f)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png",
    },
    {
        title: "part-a-098-3",
        gabc: "nd(d) when(f)  (dc) had(f)  (g) fast-(fgh)ed(hgg)  (j)  (f) days(fg)  (h) and(g)  (h)  (fe)  .(d) he(e) was(f) &amp;(g) afterward(f)  (g) &#39;an(fe) hungred.(d)  (d) I(fh)  (h) *5—§(g)  (f)  (gh) |(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-098.png",
        nextFileName: "./pages/part-a-099.png",
    },
    {
        title: "part-a-099-0",
        gabc: "the(h)  (h) devil(fg)  (f) T(f) a(e) him(f) up(h) in-(h)to(g) a(e) ho-(f)ly(efec) ci-(eg)ty,(f)  and(efh) setteth(h)  (hg) him(f) on(g) a(f) pinnacle(f)  (e)  (fh) of(hg) the(f) temple,(hi)  (h) and(h)  (ji)  saith(g)  (hg) un-(h)to(ih) him,(f) &#39;Tf(fe) thou(hi) be(j) the(ji) Son(h) of(i) God,(h) cast(hi) thy-(g) self(h) down.(f) I(f) =(h)  (g) I(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png",
    },
    {
        title: "part-a-099-1",
        gabc: "an(h) shall(df) not(hijh) live(hghih) 1(j) Tea(fe) bread(f) a-(e)lone,(d) but(d) by(f) ‘every(fe)  (d)  word(ef) that(f)  (h) proceedeth(f)  (e) out(f) of(e) the(d) mouth(ef) of(e) God.(d) o(h) &amp;(i)  (g) _(h) 1(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png",
    },
    {
        title: "part-a-099-2",
        gabc: "hou(f) shalt(g)  (h)  (g) Lord(fgf)  (gfhg) thy(fg)  (gf) God,(fgfd) ahd(f)  (d) him(fg) on-(h)ly(defgf)  shalt(gh)  (fgf) serve,(f)  (dfgh)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-099.png",
        nextFileName: "./pages/part-a-100.png",
    },
    {
        title: "part-a-100-0",
        gabc: ".(c)  (de) —o————(eed) -(fh)the(g) ac-(h)2(f)  (de) =(efe) .3(d) behold,(de) S|(e)  (e)  5(e) day(ed) of(f)  (fgf) e(e)  (e) let(df) us(hj) therefore(hg)  (f) in(i) al](h) things(e)  approve(ig~)  (f)  (hf) ourselves(hi)  (f) as(d) the(fh) v(h) ministers(f)  (g) of(f) God,(e) in(fd~) much(hij)  |(gi)  (hg) 8(e) in(fg) T(hi) watchings,(h) in(f) e(fe) fastings,(d) e(e) by(fg) Y(gfghgfe)  unfeigned.(gi)  (fgf)  (e)  (e) a(j)  (i)  (j) L)(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-100.png",
        nextFileName: "./pages/part-a-101.png",
    },
    {
        title: "part-a-100-1",
        gabc: "As(j) I(h) live,(ghjj) saith(j) the(j) Lord,(j)  (f) I(j) have(ih) no(gh) pleasure(j)  (i) 1n(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-100.png",
        nextFileName: "./pages/part-a-101.png",
    },
    {
        title: "part-a-101-0",
        gabc: "the(g) death(h) of(h) a(g) 4(df) &#39;.(ed) but(e) ra—-(gi)ther(h) that(h) he(g) turn(h)  from(g) his(f) way(ef) and(fg) live.(e)  (j)  (h)  (j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png",
    },
    {
        title: "part-a-101-1",
        gabc: "T(ik) he(g) days(g) of(h)  (h) a(g) a(g) come(hih) to(gf) us,(f) for(h) the(f) redemp-(h) (j)  tion(ik)  (k) of(i) our(j) sins,(hg) and(g) the(g) saving(e)  (f) of(gh) our(h) souls.(g) ||(j)  (i) &quot;](j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png",
    },
    {
        title: "part-a-101-2",
        gabc: "L(ig~) et(f) us(e) @(f) approve(h) ourselves(ij)  (i) Tin(ih~) much(jh) a(i) patience,(i) in(if) ma-(g)ny(h)  astings,(fe)  (fe) by(d) the(e) armour(gfg)  (h) of(h)  (f) righteousness.(f) v(f) |(i) e(h)  (i)  (j)  (h) |(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png",
    },
    {
        title: "part-a-101-3",
        gabc: "By(d) the(f)  (d) of(dc)  (f) the(g)  (f) righteousness(gh) T(h) of(h) the(h) power(hj) of(h) God,(hghih)  let(h) us(g)  (fe) approve(g) ourselves(fe)  (def) in(fd~) much(gf) patience.(d)  (d) &quot;8(h)  (g) o(f) d(gh) p(gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-101.png",
        nextFileName: "./pages/part-a-102.png",
    },
    {
        title: "part-a-102-0",
        gabc: "hat(d) which(ef) ye(g) have(g) donet(gh) un-(g)to(g) one(g) of(g) the(e) least(f) of(e) mine,(d)  ye(f) have(gh) done(hg) un-(f)to(fg) me,(fe) saith(g) the(fe) Lord,(d) e(e)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png",
    },
    {
        title: "part-a-102-1",
        gabc: "it(c)  (c)  (fgh)  (g)  (g) is(g) written,(fef)  (df) Mine(f) house(h) shall(j) be(jih) call-(jk)eg(ji)  an(h) house(h) of(g) pray-(h)er(g) for(gh) all(ih) nations:(g)  (g) but(jk) ye(ji) have(h) made(h)  it(g) a(ef) den(g) of(f) -(edc)’)bers.(c) 2(c) he(dcgfgh) Q(g) daily(gh)  (h) with(ghgfg) N(gf)  teach-(ghih) teach-(jk) (ghihij) ing(hg) in(f) e(gh) T(g) temple.(g) I(j) e(i)  (j) P(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png",
    },
    {
        title: "part-a-102-2",
        gabc: "For(c)  (c)  (e) as(f) Jo-(h) (h) was(h) three(ij) \\—_T__(i) and(i) three(hi) nights(j) in(i) the(h)  whale’s(ij) belly,(i)  (i) =(fi) shall(g) )(h) Son(f) ](e) man(fe) be(de) in(f) the(gg) ",
        groupIndex: 2,
        filename: "./pages/part-a-102.png",
        nextFileName: "./pages/part-a-103.png",
    },
    {
        title: "part-a-103-0",
        gabc: "heart(g)  (hg) of(hi) the(hg) earth.(f) ™(i)  (h)  (i) &quot;(j)  (h) 4(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png",
    },
    {
        title: "part-a-103-1",
        gabc: "-(ef) (hi) woman,(i) is(h)  (i) thy(jh) faith:(i) be(gi) it(hg) un-(f)to(e) thee(fe) €-(d) ven(e) as(f) thou(fh) wilt.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png",
    },
    {
        title: "part-a-103-2",
        gabc: "e(d)  (dc) made(f) me(gh) whole,(hgg) the(fg) same(h) commanded(g)  (h)  (fe) me:(d) Take(g)  up(h) thy(g) bed,(f) and(def) walk(g) in(f) peace.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png",
    },
    {
        title: "part-a-103-3",
        gabc: "Tell(d) the(ef) vision(g)  (e) twhich(gh) ye(f) have(ed) &#39;seen(dfddc) to(fh) no(gf) man,(f) un-(df)til-(f) the(g) Son(h) of(g) Man(f) be(e) risen(fg)  (g) a-(f)gain(ef) from(g) the(fe) dead.(d)  (h)  (g)  (fgh)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-103.png",
        nextFileName: "./pages/part-a-104.png",
    },
    {
        title: "part-a-104-0",
        gabc: "it(f)  (ghg)  (h) is(g) good(h) ](g) us(ef) [(g) Je(fe) here:(d) if(dgf) thoy(gh) -(g) let(f) us(g) make(hg) here(f) three(gfe) ta-(d)ber-(fe)a-(dc)[(c) one(c) for(d) thes,(f)  and(f) one(f) for(f) Mo-(fg)ses,(f) and(f) one(ef) a(g) a(fe) li-(d)—as.(d)  (h)  (g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png",
    },
    {
        title: "part-a-104-1",
        gabc: "The(d)  (dc)  (f) of(g)  (f) Je-(gh)sus(hgg) came(fg) un-(h)to(g) him,(fgffd) beseeching(g)  (h)  (g)  him(jk)  him(fe) and(df)  (fe) Send(c)  (d) her(c) a-(d)way,(ffgf) for(h) she(g) ](e)  (f) af.(g)  ter(fe) us.(d)  (h) AT(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png",
    },
    {
        title: "part-a-104-2",
        gabc: "I(e) am(gh) not(ij) sent?(i) but(i) un-(ih)e(ij) the(i) lost(hi) sheep(if) of(h) the(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-104.png",
        nextFileName: "./pages/part-a-105.png",
    },
    {
        title: "part-a-105-0",
        gabc: "house(i) of(i) Is-(h)ra-(f)el,(gh) saith(f) the(f) Lord.(e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png",
    },
    {
        title: "part-a-105-1",
        gabc: "et(e) us(f) make(hi) 00O(i) three(hi) ta-(j)ber-(ih)na-(i)one(f) for(i) thee,(g)  and(h) one(f) for(f) Mo-(fe)ses,(f) and(e) one(de) for(f) E-(h)li-(f)as.(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png",
    },
    {
        title: "part-a-105-2",
        gabc: "0(ef)  (hi) a(i) great(h) is(i) thy(jh) faith;(i) be(gi) it(hg) un-(f)to(e) thee(fe)  e(d) -(e)as(f) thou(fh) wilt.(f) NONE(i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png",
    },
    {
        title: "part-a-105-3",
        gabc: "Tell(c)  (d) the(ef) vision(g)  (e) Twhich(gh) ye(f) have(ed) seén(dfddc) to(fh) no(f) man,(f)  lin—til(df)  (f) the(g) Son(h) of(g) Man(f) be(e) risen(fg)  (g) a-(f)gain(ef) from(g) the(fe) dead.(d)  .(h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-a-105.png",
        nextFileName: "./pages/part-a-106.png",
    },
    {
        title: "part-a-106-0",
        gabc: "(O(f) a(e) man,(f) go(h) thy(hij) way;(i) Talready(i)  (h)  (i) have(j) I(hih) told(i) thee(i)  If(i) thou(fi) wilt(g)  (h) believe,(fe) thou(f) shalt(e) see(de) mighty(f)  (h) wonders,(f)  (f)  AT(i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-106.png",
        nextFileName: "./pages/part-a-107.png",
    },
    {
        title: "part-a-106-1",
        gabc: "J(c) e-(d)sus(ef) said(g) Tun-(g)to(g) the(f) wo-(gh)man(h) of(h) Ca-(g)na-(fg)an,(g) It(cd) is(f) not(fd)  meet(f) to(ghg) take(h) the(g) 5(fe) 2(defgefe) .(d) and(c) to(d) cast(f) it(f)  to(gh) dogs.(g) Truth,(fg) Lord;(g) yet(g) the(g) dogs(hg) eat(f) of(h) the(g) crumbs(f)  which(fh) fall(jk) from(kji) their(hg) master&#39;s(f)  (fgh) table.(g)  (g) Then(j) Je-(j)sus(hg) en-(f) swer-(gh)ed,(g) O(df) [(fgh) man,(g) great(h) is.(dgf) thy(fgh) faith;(f) be(h) it(dgf) un-(g)to(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-a-106.png",
        nextFileName: "./pages/part-a-107.png",
    },
    {
        title: "part-a-107-0",
        gabc: "thee(h)  (j) e-(hj)ven(h) as(i) thou(h) wilt,(g)  (h)  (j)  (i)  (j)  (h)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png",
    },
    {
        title: "part-a-107-1",
        gabc: "He(cd) that(ef) sent(g) meT(g) is(e) with(fe) me;(d) the(d) Fa-(d)ther(dc) hath(f) not(g)  left(h) me(g) a-(fg)lone;(f)  (f) I(fd)  (f) do(g) al-(ih)ways(g) those(fg) .(e)  please(dfe)  (d) him.(d)  (fh)  (h)  (g) I(f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png",
    },
    {
        title: "part-a-107-2",
        gabc: "ut(cdef) all(dfge) ye(f) are(d)  (e) 1&#39;a.nd(c)  (c) call(df) no(f) man(f) your(f)  (fe)  (d)  ther(d)  (c) on(df) earth;(de)  (h) for(g) one(hi) is(h) your(fg) Father,(g)  (e) which(g) is(fe)  in(de) heaven:(e)  (e)  (df)  (c) be(df)  (f) ye(f) call-(fe)ed(d) masters;(f)  (c) for(f)  (f) one(fed)  (fe~)  0(e) your(f) Master,(gh)  (g) e-(dghgf)ven(fgf) Christ.(e) I—-(h)-(g) (h)  (fji) —l(dhg)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-107.png",
        nextFileName: "./pages/part-a-108.png",
    },
    {
        title: "part-a-108-0",
        gabc: "For(d) he(d) all(dc) &#39;(f) a(g) liv-(f) (gh) —T(h) Tun-(i)to(h) the(g) 4(fh)  (g) 0(g)  mock,(gg) and(e) .(g) ®(hg) and(f) to(f) e(g)  (e) fy(fe) |(d)  (h)  (g)  (f) —(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png",
    },
    {
        title: "part-a-108-1",
        gabc: "H\\’\\.-(gh) (ij)  (i) .(j)  (k)  (j)  (i) ‘(h)  (ij)  (j)  (i)  (g) vij(ij)  of(i) bread,(hg) de-(ef)sir-(g)ed(h) a(f) drop(g) M__(f) water,(e)  (e) [—_:-(j) (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png",
    },
    {
        title: "part-a-108-2",
        gabc: "m(g)  (h)  (j)  (j)  (h)  (j)  (i)  (i)  (g)  (h)  (h)  (h)  [(i) multitude,(hg)  (g) R(ih) because(ji) they(h) took(ghihg) him(ef) for(g) a(ghg) prophet.(e)  (e) |(j) I(h)  (j) ](ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png",
    },
    {
        title: "part-a-108-3",
        gabc: "ut(eh) the(f) fatherT(f)  (e) said(f) to(f) His(ed) servants,(ef)  (e) Bring(igij) forth(ij) ",
        groupIndex: 3,
        filename: "./pages/part-a-108.png",
        nextFileName: "./pages/part-a-109.png",
    },
    {
        title: "part-a-109-0",
        gabc: "the(i) best(hih) robe(he) and(f) put(h) it(gf) on(h) him;(e) and(hg) put(i) a(h) ring(g) on(f)  Lis(fh) hand,(gh) and(ih~) shoes(iie) on(fhf) his(gf) feet.(e) I(h)  (g)  (h) _l(f) N(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png",
    },
    {
        title: "part-a-109-1",
        gabc: "A.nd(c) when(d) Je(idhi) sus(h) had(h) cast(h) out(h) the(h) de-(h)vil,(ihghihgg) the(gf) dumb(g)  (d)  spake,(def) and(e) the(f) [(g) people(fe) wondered.(d)  (d)  (d) a(h)  (g) 1~(f) d(gh) &amp;«(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png",
    },
    {
        title: "part-a-109-2",
        gabc: "If(g) I(gj) with(h) the(g) fin-(hjh)ger(i) of(j) God(k) cast(jh) out(ji) de-(hg)vils,(g) no(gh)  doubt(j) the(i) king-(ghig)dom(h) of(g) God(e) 1is(f) come(g) 3(gf) on(e) you.(e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-109.png",
        nextFileName: "./pages/part-a-110.png",
    },
    {
        title: "part-a-110-0",
        gabc: "He(cd) that(ef) gathereth(g)  (g)  (g) not(g) Twith(g) me(ge) scattereth:(f)  (e) o(d) ang(d) he(f)  that(g) is(h) not(g) with(ffg) me(f) -(fg)A(e) gainst(f) 8(d) me.(h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png",
    },
    {
        title: "part-a-110-1",
        gabc: "hen(d)  (dc) unclean(f)  (g) spiritT(fh)  (h) is(h)  (i) gone(ih) out(g) of(f) a(h) man,(g)  he(g) walketh(g) O(e) through(g) dry(hg) places,(fg) 0(fec) seeking(c)  (d) rest,(f) -(ef) findeth(g)  (fe) none.(d)  (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png",
    },
    {
        title: "part-a-110-2",
        gabc: "A(e) certain(eh)  (f) woman(f)  (e) of(f)  (ed) company(ef)  (e)  (e) lifted(f)  (e) up(e) her(d) voice(f)  and(ffg) 2(e) a.(e) Blessed(ghi)  (i) is(j) the(i) womb(h) that(hf) bare(hi) thee,(g) and(g)  the(h) paps(i) which(fgh) thou(ih) hast(f) sucked.(e)  (e) But(d) Je-(fh)sus(hf) ansvered:(g)  (fg)  (e)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-110.png",
        nextFileName: "./pages/part-a-111.png",
    },
    {
        title: "part-a-111-0",
        gabc: ".(gi) Yea,(e) ra-(ghi)ther,(i)  (j) blessed(j)  (i) are(h) they(i) that(h) hear(h) the(gh) word(ih)  of(gi)  (f) God,(e) and(f)  (hg)  (gf) keep(e) it.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png",
    },
    {
        title: "part-a-111-1",
        gabc: "Blut(ik)  (dc) Je-(f)sus,(g)  (fh)  (h) M(h) the(g) midst(h) of(g) them,(ef) went(g)  his(ki~)  (fe) way.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png",
    },
    {
        title: "part-a-111-2",
        gabc: "Where(f) two(h) or(hj) three(i) Tare(i) gathered(h)  (i)  (j) together(h)  (i)  (i) in(gihg) a(fe)  Name,(fe) there(d) am(e) I(g)  (fg) in(h) the(hg) midst(hi) of(fghg) &#39;8(fg) them,saith(h) the(hg) Lord.(f)  Non(i)  (h) lotis(i)  (j) manibus(h)  (i)  (h)  5(e) eat(ehg) with(h)  (i) unwashen(hij)  (h) hands(fhh) Tdefileth(g)  (i) o(hg) not(fh) a(g) ](e) T™e(ji)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-111.png",
        nextFileName: "./pages/part-a-112.png",
    },
    {
        title: "part-a-112-0",
        gabc: "so-(d)ev-(ef) (g) er(g) had(ge) a-(f)ny(e) .(d) they(dc) brought(f) them(g) up-(h) to(g) Je-(fg)sus;(f) and(gf) they(e) were(f) healed.(d)  (d) .(h)  (g) L(f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png",
    },
    {
        title: "part-a-112-1",
        gabc: "[(g) I(h)  (j) perceiveT(j) that(jk) thou(jh) art(i) a(h) prophet.(g)  (g) Our(gh) fathers(j)  (i)  worshipped(h)  (g)  (h) in(gf) this(ghg) &amp;(e) mountain.(e) [(j) I__I(h)  (j) T(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png",
    },
    {
        title: "part-a-112-2",
        gabc: "a(e)  (fh) hath(h) no(h) man(hg) con-(f)dem-(fghg)ned(fg) thee?(ge) No(hg) man,(fg)  Lord.(g) Neither(i)  (j) do(i) I(h) condemn(fg)  (f)  (ghgf) thee;(gf) go(ghi) and(gh) sin(fe)  &quot;(gf) &amp;(e) [(h) &quot;(g)  (h)  (f) =(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-112.png",
        nextFileName: "./pages/part-a-113.png",
    },
    {
        title: "part-a-113-0",
        gabc: "Je-(d) (f) sus(g) took(f) the(fgh) loaves,and(hg)  (fg) when(h) he(g) had(f) given(f)  (fg) thanks,(f)  he(f)  (f) distributed(f)  (f) a(e) to(f) them(g) that(fe) were(d) set(cd) down.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png",
    },
    {
        title: "part-a-113-1",
        gabc: "W&#39;ith(ik)  (cd) five(fg) loaves(fgh) Tand(i) two(h) small(g) fishes,(fh)  (g) the(g) Lord(eg) sat-(h) is—fi-(ik) (g) ed(f)  (g) five(ec) thousand(eg)  (f) men.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png",
    },
    {
        title: "part-a-113-2",
        gabc: "T(c) he(f) Lord(ef) sat-(h)is—fi-(h)ed(hj)  (i) five(hi) thousand(j)  (hi) men(i) with(i) five(gihg)  loaves(fe) and(ef) two(de) small(fh) e(f) fishes.(f) S(i)  (h)  (i) R(j)  (h) )(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png",
    },
    {
        title: "part-a-113-3",
        gabc: "hen(dh) those(hi) men,!(h) when(h) they(h) had(h) seen(h) the(h) mi-(h)ra-(h)cle(hghihgg) that(fg) ",
        groupIndex: 3,
        filename: "./pages/part-a-113.png",
        nextFileName: "./pages/part-a-114.png",
    },
    {
        title: "part-a-114-0",
        gabc: "Je-(h)sus(gf) did,(gfd) said(d) un—to(d)  (c) each(d) o-(ffg)ther:(f) This(h) is(g) of(f) J(e)  truth(g) that(fe) pro-(defe)phet(ddc) that(c) should(d) come(f) in-(ef)to(gh) the(fe) worlq(d)  AT(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png",
    },
    {
        title: "part-a-114-1",
        gabc: "A(ik) B(dc~) Je-(dhi)sus(h) Twent(h) up(hj) into(h)  (h) a(h)  (h) mountain,(hghihgg) and(f) there(gh) e(fe)  sat(ik)  (def) with(ef) his(g)  (fe) disciples.(d)  (d) &quot;=(h)  (g) ¥(f)  (gh) &amp;(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png",
    },
    {
        title: "part-a-114-2",
        gabc: "e(f) estroy(d) this(f) el(hi)  (h) S(h) ey(ij) Lord,(jih) and(h) in(ij) three(jih)  days(h) I(hg) will(f) raise(hi) it(hi) up:(f) )(hf) he(hi) spake(h) of(f) the(f)  temple(d)  (f) of(h) his(e) bo-(f)dy.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-114.png",
        nextFileName: "./pages/part-a-115.png",
    },
    {
        title: "part-a-115-0",
        gabc: "But(ff) no(e) T(f) 1aid(gh) hands(i) on(hg) him,(fe) because(h)  (ij) his(j) hour(ji) was(gh)  not(gi)  (i) yet(hg) come.(f) A(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png",
    },
    {
        title: "part-a-115-1",
        gabc: "-(j)nanT(hj) that(i) is(g) called(h)  (i) Je-(h)sus(g) made(i) clay(i) out(h) of(i) spittle(g)  (e)  and(e) _n(f) anointed(gh)  (g) mine(g) =(gh) and(fg) now(g) I(f) see.(e) |(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png",
    },
    {
        title: "part-a-115-2",
        gabc: "A(f) great(f) prophet(hi)  (i) Tis(i) ri-(h)sen(i) up(j) among(h)  (i) us,(i) and(gihg) God(fe)  hath(fe) vis-(d)it-(e)ed(f) his(h) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png",
    },
    {
        title: "part-a-115-3",
        gabc: "s(f) if(gh) thou(h) hadst(g) been(h) &amp;(ghg) La-(e)za-(f)rus(g) would(e) not(gh) ",
        groupIndex: 3,
        filename: "./pages/part-a-115.png",
        nextFileName: "./pages/part-a-116.png",
    },
    {
        title: "part-a-116-0",
        gabc: "have(fe) di-(ded)ed:(d) lo,(g) by(e) this(fgh) time(f) he(e) stinketh;(def)  (fcd) for(d) He(dc) hath(f)  lain(gh) in(h) the(g) grave(ghg) four(ef) days(g) al-(fe)rea-(d)dy.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-116.png",
        nextFileName: "./pages/part-a-117.png",
    },
    {
        title: "part-a-116-1",
        gabc: "Save(f) me,(f) O(fgh) Lord,(hg) From(f) the(gh) li-(gfd)on’s(fg) mouth.(gf) Save(f) me.(f)  Thou(h) hast(h) heard(hi) me(h) al-(gh)so(g) from(g) among(g)  (g) the(g) horns(h) of(g)  the(f) u-(g)y(gh) ni~corns.(hg) From(f) the(gh) li-(gfd)on’s(fg) mouth.(gf) Save(f) me,(f)  0(gh) Lord,*(hg) From(f) the(gh) li-(gfd)on’s(fg) mouth.(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-116.png",
        nextFileName: "./pages/part-a-117.png",
    },
    {
        title: "part-a-117-0",
        gabc: " (f)  (gi)  (i)  (hgf)  (g)  (ghg)  (f)  (ed)  (g)  (g)  (h)  (fed)  i.(f)  (edf)  (dc)  (cd)  (d)  (d)  (f)  (dc)  (f)  (fgh)  (g)  (gf)  ?.(f) Deliver(fhihg) me,(h) 0(fe) Lord,(d)  (f) from(f) i.(dc) evil(cd) ",
        groupIndex: 0,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png",
    },
    {
        title: "part-a-117-1",
        gabc: "I(e) am(hf~) one(h) that(h) bear(hgfg) witnéss(g)  (fe) of(ghih) myself,(ih)  (g) and(gh) the(h)  Father(ij)  (i) that(hf) sent(fg) me(e) beareth(e) PR(fh) witness(hgf) R(g) of(f) me.(e) el(hghf) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png",
    },
    {
        title: "part-a-117-2",
        gabc: "I(hg) have(f) not(g) a(gh) devil,f(fe)  (e) but(f) I(df) honour(h)  (g) my(f) Father,(hi)  (f) saith(fd)  the(f) .-(e) (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-117.png",
        nextFileName: "./pages/part-a-118.png",
    },
    {
        title: "part-a-118-0",
        gabc: "I(g) seek(hj) not(j) Tmine(h) own(j) htacue(ih)  (g) ahws(g) da(g) e(h) oy(g) TR(ef)  eth(g) and(gh) A(e) 8-(e)AT(j)  (h) SEXT(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png",
    },
    {
        title: "part-a-118-1",
        gabc: "N(dc)  (f)  (g) ve-(f)ri-(gh)ly,T(h) I(h) say(j) un-(h)to(g) you,(h) If(h) a(g) man(fg) keep(ghi)  my(h) A(gf) saying,(f) he(gh) shall(g) never(fe)  (dc) taste(d) of(efe) death.(d) N(h)  (g)  (f) I(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png",
    },
    {
        title: "part-a-118-2",
        gabc: "T(c) he(d) Jews(cd) took(f) up(fe) stones(dc) Tto(ef) cast(g) at(fe) him:(d) but(ifghghih) Je(hg) sus(fe)  hid(gh) o(fe) himself,(d) and(fe) went(ge) out(gh) of(f) the(e) -(d)temple.(d) B(h)  (g)  (f) s(gh) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png",
    },
    {
        title: "part-a-118-3",
        gabc: "o(gi) Your(e) fa-(fgh)ther(h) A-(ij)bra-(hg)ham(fhffe) re(hiji) joic-(i)ed(g) to(i) see(ij) my(hg) day:(f)  and(f) he(ec) saw(e) it(f) and(h) was(g) glad.(f) Sl(h) i(g)  (e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-118.png",
        nextFileName: "./pages/part-a-119.png",
    },
    {
        title: "part-a-119-0",
        gabc: "me,(d)  (dh)  (h)  (hj) O(hg)  (h) set(h)  (hg) me(ef) beside(g)  (fe) thee:(d) and(d) I(e)  care(fe) mot(d) who(ef) lifteth(gh)  (ghg) his(ef) hand(g) &#39;a-(fe)ginst(d) me.(d)  (h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png",
    },
    {
        title: "part-a-119-1",
        gabc: "O(f) Lord,(e) thou(f) hast(h)  (hj)  (i) -(i)causes(h)  (i) of(j) my(ih) soul:(i)  thou(i) hast(f) defended(i)  (g) my(h)  (fe) life,(f) O(e) Lord(de) my(fh) God.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png",
    },
    {
        title: "part-a-119-2",
        gabc: "O(f) my(h) people,1(hi)  (i) what(i) have(h) I(i) dome(j) unto(i)  (h) thee?(i) and(i) where-(f) in(i) have(g) I(h) wea-(f)ri-(f)ed(e) ¢(fe) tes-(d).(e) fy(f) a-(h).(f) me.(f)  165(i)  (h)  (i)  (j)  (h)  (i) ",
        groupIndex: 2,
        filename: "./pages/part-a-119.png",
        nextFileName: "./pages/part-a-120.png",
    },
    {
        title: "part-a-120-0",
        gabc: "e-(hi)vil(i) The(i) ](i) recompensed(h)  (j) for(h)  (hj) good?(i) for(f) a(g)  have(g) dig-(fe)ged(f) w(e) pit(ed~) for(f) &quot;(fh) soul.(f) §|(i)  (h)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png",
    },
    {
        title: "part-a-120-1",
        gabc: "[f(f) a-(e)ny(f) man(h) thirst,(i) let(h) him(i) come(j) e(i) to(h) TR(ij) and(j) drink:(i)  and(i) out(fi) of(g) his(h) bel-(fe)ly(f) shall(e) flow(ed) living(f)  (g) wa-(h)ter,(gg) saith(hi)  the(hhg) Lord.(f) R(i)  (h)  (i) S(h) PR(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png",
    },
    {
        title: "part-a-120-2",
        gabc: "—(c) (Govye(d) u(f) Tun-(f)to(e) this(gfe) -(d)&#39;I(ffdefec) go(f) not(f) up(hih) yet,(gg)  for(f) my(f) time(gf~) is(f) not(ef) yet(g) full(fe) come.(d) &amp;+(h)  (g) 5T(f)  (g)  (gfedf) ",
        groupIndex: 2,
        filename: "./pages/part-a-120.png",
        nextFileName: "./pages/part-a-121.png",
    },
    {
        title: "part-a-121-0",
        gabc: "ny(f) good(h) 5(i) have(h) I(i) wrought(j) among(h)  (i) you.(i) for(f) which(g)  (h)  of(h) those(f) works(fe) do(d) wish(f) to(h) kill(f) me?(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png",
    },
    {
        title: "part-a-121-1",
        gabc: "ith(e) desire(f)  (hi) T(i) have(j) de-(ih)sir-(i)ed(i) to(fi) eat(g) this(h) Pass-(f)o-(fe)ver(f)  before(e)  (f) I(h)  with(e) you(c) before(f) I(h) suffer.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png",
    },
    {
        title: "part-a-121-2",
        gabc: "The(c)  (c) r(dc~)  (dfddc) o(d) onsulted(f)  (gh) how(hih) they(g) might(ig) take(hh)  Je-(g)sus(f) [](e) kill(c) 5(d) they(f) salid,(dfddc) Not(f) on(hh) the(g)  feast(ig) day,(h) lest(h) there(g) be(f) ](e) up-(f)roar(gh)  (hg) the(f)  (gf)  people.(d)  (d) ](h)  (g)  (f)  (g) =(gfed) ",
        groupIndex: 2,
        filename: "./pages/part-a-121.png",
        nextFileName: "./pages/part-a-122.png",
    },
    {
        title: "part-a-122-0",
        gabc: "R(f) N(ed)  (f) LS(fed) the(ef) w(ggf) hath(ggh) not(gf) T(e) T(e)  have(ki~)  (fg) known(hgf) thee,(eed) T(cd) because(df) thou(gh) m(fg) T(e) me.(e) }E&#39;ggl(h)  (g)  (h)  (ih) I(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png",
    },
    {
        title: "part-a-122-1",
        gabc: "chil(ik)  (d)  (d) of(dc)  (f) the(g) Hebrews,t(fh)  (h) carrying(h)  (j)  (h) palms(h) and(g) o-(hg)live(f)  branches,(ki~)  (gh)  (h) went(f) forth(h) to(gf) meet(g) the(fe) Lord,(d) crying(f)  (fe) and(dc)  (df)  g(ik) i(ffg) saying;(f) Ho-(f)san-(hg)na(hge) in(f) the(e) highest.(d)  (d) |(h) N(g)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png",
    },
    {
        title: "part-a-122-2",
        gabc: "The(cc)  (d)  (d) of(dc)  (f) the(g) Hebrews(fh)  (h) spread(hj) their(h) garments(h)  (g) in(h) the(gf)  way,(fg) end(h) cri-(g)ed,(ef) e(ed) saying:(d) Hosanna(d)  (f) e(d) to(e) the(f) Son(g) of(ef) David;(f)  (g)  blessed(f) a(e) is(f) he(fgh) that(g) cometh(fg)  (f) the(f) Name(g) of(e) the(fe) Lord.(d) I(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-122.png",
        nextFileName: "./pages/part-a-123.png",
    },
    {
        title: "part-a-123-0",
        gabc: "[n-(e)to(f) thee,(h) O(hj) Lord,(i) have(i) I(h) 0(i) revealed(j) a(i) my(h) cause:(i) thou(i)  hast(f) defended(i)  (g)  (h) my(fe) life,(f) O(e) Lord(de) my(fh) God.(f)  (i) RS(h) &quot;(i)  (j)  (h) B(fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png",
    },
    {
        title: "part-a-123-1",
        gabc: "I(h) will(hi) call!(i) up-(i)on(h) thy(i) Name,(j) O(ih) Lord:(i) turn(fi) not(g) a-(h)way(f)  (e)  thy(e) face(fe) from(de) my(fh) calling.(f) T(f) T—(i)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png",
    },
    {
        title: "part-a-123-2",
        gabc: "For(f) it(fg) is(g)  (fghihg) I(hg)  (gh) will(fg) smite(g) the(fgh) shepherd,(f)  (f) and(f)  (h)  the(h) sheep(j) shall(hi) ‘&#39;be(jk) &quot;(h) scattered.(g) e(g) But(h) after(f)  (h) I(j) am(k) ri-(ji)sen(hj)  a-(j) (jjk) gain,(kj) I(k) will(k) go(j) be-(ij)fore(h) you(gf) in-(h)to(gh) Galilee:(f)  (f)  (f) there(g)  A(e) ye(g) LI(fe) me,(d) saith(fh) the(fg) Lord.(g) ST(j) TN(i)  (j) ST(h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-123.png",
        nextFileName: "./pages/part-a-124.png",
    },
    {
        title: "part-a-124-0",
        gabc: "»(e) hid(hg)  (h) face(hi)  (g) from(ef) shame(g) and(fg) spitting.(e)  (e) INI(h)  (h)  (h) L(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png",
    },
    {
        title: "part-a-124-1",
        gabc: "wake,(h) O(hgf) sword,(fh) a(d) gainst(gf) them(fh) that(g) scatter(hi)  (g) my(ef)  flock.(g)  (f)  (h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png",
    },
    {
        title: "part-a-124-2",
        gabc: "S(ki~) o(d) they(df) weighed(g)  (e) for(gh) my(e) price(d) thirty(f)  (fe) pieces(d)  (e) of(f) sil-(g) ver,(d) the(f) price(fe) that(d) was(f) prised(g)  (f) at(gh) of(ff) them.(d)  (h) a(g)  (f) [(h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png",
    },
    {
        title: "part-a-124-3",
        gabc: "Be-(g)hold,(h) O(g) Lord,(f) the(f) lips(g) of(h) them(j) that(i) rise(hj) up(i) &amp;(g)  gainst(g) me,(h) and(h) their(i) devices.(h) &amp;R(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 3,
        filename: "./pages/part-a-124.png",
        nextFileName: "./pages/part-a-125.png",
    },
    {
        title: "part-a-125-0",
        gabc: "couldest(f)  (e)  (f) have(h) no(ij) power(i)  (i) at(h) all(j) a-(ih)gainst(i) me,(i) e€X-(i) =(fi) it(g) were(h) given(f)  (e) thee(fe) from(de) a-(fh)bove.(f)  (i)  (h) &quot;1(i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png",
    },
    {
        title: "part-a-125-1",
        gabc: "See,(g) O(h) Lord,T(i) and(j)  (i) consider,(hh)  (g) for(g) I(f) am(e) in(f) trouble:(h) O(f)  (e)  haste(e) thee(g) and(h) hear(f) me.(e) TERCE(j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png",
    },
    {
        title: "part-a-125-2",
        gabc: "[}(g) IE(iij) thou(i) my(j) cause,(k) O(j) Lord:(ij) O(i) de-(g)liv-(h) (h) er(fe) me(e) from(f) i(e)  a(jk)  a(e) .(f) deceitful(hhg)  (f) and(hihi) wicked(gg)  (hf)  (df) man.(ee) 1(j) &quot;(i)  (h) a(g)  (fhfh) ",
        groupIndex: 2,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png",
    },
    {
        title: "part-a-125-3",
        gabc: "&amp;(e) o(e) was(g) in(h) troublet(i) &quot;(hih) I(f) cried(h) 000000000(g) un-(f)to(e) Lord(e) out(f)  R(e) the(d) @(e) belly(e) of(fe) :(f) and(h) .(fe) A(fgf) me.(e) [(i) A(h)  (gf) ](i) ",
        groupIndex: 3,
        filename: "./pages/part-a-125.png",
        nextFileName: "./pages/part-a-126.png",
    },
    {
        title: "part-a-126-0",
        gabc: "T&#39;he(c)  (g) ungodly(g)  (g)  (fe) séid,?(dc) Let(g) us(f) oppress(g)  (h) the(gf) righteous(g)  (gh) man,(f)  a(g) because(f) he(g) is(h) clean(jk) :(i) contrary(ji) to(hg)  (fe) our(fg) doings.(g)  (g) |(j)  (i) )(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png",
    },
    {
        title: "part-a-126-1",
        gabc: "&quot;(e) have(f) ~(hi) a(i) a(i) lay(hi) down(j) my(h) life,(i) and(i) T(gi) have(hg)  pow-(fe)er(f) to(e) take(de) it(f) a-(h)gain.(f)  (i)  (h)  (i)  (j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png",
    },
    {
        title: "part-a-126-2",
        gabc: "D(c)  (h) liv-(f)er(h) me(gf) tfrom(h) blood-(j)guiltiness,(jk)  (ji)  (j) O(j)  (jh) God(ij) my(i) God:(gh) and(f)  my(gh) tongue(i) shall(j) sing(h) of(g) =(gh) PR(i) righteousness.(hg) LI(g) 1(j) N(i)  (j) 1(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png",
    },
    {
        title: "part-a-126-3",
        gabc: ",(h) eproaches(hg) O(e) Tand(f) R(hih) oY(hg) have(hg) I(f) suffered(g)  (h)  (f) a(e) them:(e) ",
        groupIndex: 3,
        filename: "./pages/part-a-126.png",
        nextFileName: "./pages/part-a-127.png",
    },
    {
        title: "part-a-127-0",
        gabc: "and(e) the(d) Lord(ef) is(hi) withme(hg)  (hih) as(h) a(h) mighty(hg)  (f) terrible(gh)  (f)  (gf) one.(e)  AT(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png",
    },
    {
        title: "part-a-127-1",
        gabc: "These(ef) al-(hi)so(i) Tthat(hi) seek(jk) the(i) hurt(hi) of(g) my(hg) soul,(f) they(e) shall(f)  go(ig~)  (hi) un-(gh)der(e) the(gh) earth.(f) 1w(h)  (g) a1(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png",
    },
    {
        title: "part-a-127-2",
        gabc: "ind(f) the(hi) nations(hg)  (h) Tof(g) the(ig) heathen(h)  (g) with(ef) chains,(g) O(fe) Lord;(d)  and(e) their(f) 8(ge) princes(f) with(e) fetters.(d)  (d) &amp;(h)  (g) _(f) a(g) am(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png",
    },
    {
        title: "part-a-127-3",
        gabc: "&amp;(ig~) A(ff) nmaid(e) said(f) un-(h)e(g)  (f) -(fe)Surely(h)  (i) thou-(j)art(i) one(j) of(gh)  ‘(gi) them,(fhffe) for(e) thy(f) speech(h) B(gh) bewrayeth(i) C(gh) thee.(f) o(h) ~(g) R(e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-127.png",
        nextFileName: "./pages/part-a-128.png",
    },
    {
        title: "part-a-128-0",
        gabc: "A(f)  (g)  (h) al-(f) (gh) le-(g)lu-(f)ia,(dc) al-(f)le-(gh)lu-(dfg)ia.(f) |(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png",
    },
    {
        title: "part-a-128-1",
        gabc: "n(e) the(e) end(eh) &#39;of(fe) the(d) sabbath,T(ef)  (e) as(h) it(g) be-(h)gan(ij) to(i) dawn(i)  toward(i) the(j) 3(h) day(f) of(h) the(h) week,(g) came(h) Ma-(h)ry(h) Mag-(f)T(h)  le-(gf).-(e)a(e) a(e) o-(f)ther(g) Ma-(f)ry(f) to(f) see(h) the(f) se-(f)pul-(dfe)N(d)  al(fe~) -(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png",
    },
    {
        title: "part-a-128-2",
        gabc: "s(g) De(g) &quot;(g) .(g) peace,(h) a(g) le-(f):(hg)  (h) 2(gji) 0(g) .(f)  (gh) 1l(hg) ",
        groupIndex: 2,
        filename: "./pages/part-a-128.png",
        nextFileName: "./pages/part-a-129.png",
    },
    {
        title: "part-a-129-0",
        gabc: "a(c)  (e) An-(eh)gel(f) of(efe) the(de) Lord(e) T(g) descended(h)  (i) from(hf) heaven,(h)  (g) and(hih)  came(gh)  (hgfh) and(h) rolled(hg)  (f) back(g) the(gh) stone(fe) from(e) the(e) door,(f) and(e) sat(d)  up-(f)on(h) it,(g) al(f) -(gh)lu-(f)1a,(ed) al-(def)le-(f)lu-(e)ia.(e) ||(h)  (g) al](h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-129.png",
        nextFileName: "./pages/part-a-130.png",
    },
    {
        title: "part-a-129-1",
        gabc: "nd(gi) i(j) behold,(i) there(i) z(gh) a(i) great(hg) &amp;(e) earthquake:(e) for(h) the(h)  A(h) Angel(h) of(f) the(h) Lord(g) descended(f)  (e) .(f) from(f) heaven,(f)  (f) al(g) -(f) 175(e)  (e)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-129.png",
        nextFileName: "./pages/part-a-130.png",
    },
    {
        title: "part-a-130-0",
        gabc: "is(h) a(hihh)  (e) a(e) t(j) was(g) like(ih) lightning,(hih)  (h)  (hg) and(h) his(h) raimen(gf) ;(e)  white(g) as(e) snow,(f) al-(f)le-(e)lu-(c)ia,(d) al-(ef)le-(f)lu-(e)ia.(e)  (hf)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png",
    },
    {
        title: "part-a-130-1",
        gabc: "nd(g) for(h) fear(i) of(gh) him(i) tthe(i) keepers(j)  (i) did(g) shake,(hi) and(f) ](e)  came(h) as(h) dead(fh) men,(gfe) al(fg) le(f) lu-(e)ia.(e) J(j) T(i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png",
    },
    {
        title: "part-a-130-2",
        gabc: "a(e) a(e) An-(eh)gel(f) an-(f)swer-(ed)ed(efe) and(de) a-(e)un-(gh)to(i) the(hf) women,(h)  (g)  Fear(h) not(gf) ye,(e) for(g) &#39;I(fe) know(fgf) that(g) ye(h) seek(ij) Je(ih) sus,(gh)  al(hgi)  (ih) le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png",
    },
    {
        title: "part-a-130-3",
        gabc: "T(jik)  (c) he(f) Lord(g) is(f) ri-(f)a(e) from(g) the(g) tomb,(h) Al-(h)le-(hg)lu-(g)is,(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-130.png",
        nextFileName: "./pages/part-a-131.png",
    },
    {
        title: "part-a-131-0",
        gabc: "al-(d)le-(fg)lu-(gf)ia.(f) The(f) Lord.(g) ¥.(c) Who(f) for(f) our(g) sakes(f) hung(f)  up-(e)on(g) the(g) tree.(h) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f) the(e)  Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Holy(h)  (g) Ghost.(cgf) The(cf) Lord.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png",
    },
    {
        title: "part-a-131-1",
        gabc: "[](e) a(e)  (f)  (g)  (h) a-(g) (f)  (e) i(h)  (h) [](h)  (g)  (e)  (f)  (h)  (hihg)  This(f)  (g) is(h) the(i) day(g)  (h) which(g) :(f) Lord(f)  (g) hath(h) made,(g)  (f) alleluia.(g)  (f) ™(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png",
    },
    {
        title: "part-a-131-2",
        gabc: "Ang(e) ve-(eh)ry(f) early(f)  (ed) in(ef) the(f) a(e) morningT(e) the(gh) first(i) day(f) of(fi)  the(h) week,(g) they(i) came(i) un-(h)to(h) the(h) sepulchre(ij)  (i)  (hghih) at(h) the(f) ris-(h) Ing(e) of(f) the(e) sun,(ed) al(ef) le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-131.png",
        nextFileName: "./pages/part-a-132.png",
    },
    {
        title: "part-a-132-0",
        gabc: "Lord(ik)  (f)  (gh) is(f)  (fe) in-(dc) (fg) deed,(ii) Al(hij) —le(ihgfe) lu-(gh)ia,(f)  1(ik)  (cd) le(fgiihgfe) lu-(gg)ia.(f) The(f) Lord.(gh) And(f) hath(gh) ap(fe)  ear—;d(ik)  (dc)  (c) to(f) Simon.(fg)  (i)  (i) Al(hihij) le(ihgfe) lu-(h)ia.(f) ¥.(c) Glory(f)  (f)  be(ik)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) he(dc) Son,(c) and(c) to(df) the(f) Ho-(ghih)ly(gf)  Ghost.(f) The(f) Lord.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-132.png",
        nextFileName: "./pages/part-a-133.png",
    },
    {
        title: "part-a-132-1",
        gabc: "The(ik)  (cc)  (f) Lord(g) is(f) risen(f) a(e) indeed,*(g)  (h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  The(f) Lord.(g) ¥.(c) And(f) hath(f) appeared(f)  (g)  (f) to(e) Simon.(g)  (h) Al-(h)le-(hg) lu-(g)ia.(f) Glory(f)  (f) be.(f) The(f) Lord.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-132.png",
        nextFileName: "./pages/part-a-133.png",
    },
    {
        title: "part-a-133-0",
        gabc: "[(g)  (j)  (hg)  (ji)  (jk) .(j)  (i)  (h)  (h)  (hg)  (ef) 5(g)  M(eg)  (f) a(e) -(d)[(e) 2(e) .(dc)  (g)  (gh)  (j)  (j)  (i)  §.(jk) This(ji) the(hg) day(i) N(hij) O(h) L(g) Lord(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-133.png",
        nextFileName: "./pages/part-a-134.png",
    },
    {
        title: "part-a-133-1",
        gabc: "nd(e) when(eh) they(f) 0y(efhf) ed,(ghg) they(gh) saw(i) that(j) the(i) stone(h)  was(g) rolled(f)  (f) a-(g)way:(e) for(e) it(g) was(ef) ve(f) ry(e) gréat,(cd) al-(e)le-(ed) lu-(c)ia.(c)  (h)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-133.png",
        nextFileName: "./pages/part-a-134.png",
    },
    {
        title: "part-a-134-0",
        gabc: "-(ggfd) (f) himself(gh)  (g) drew(g) near(h) to(g) his(g) .(g) disciplesg(h)  (g) in(g)  way,(df) and(d) went(fe) with(gh) them:(g) but(gj) their(j) eyes(k) were(i)  (j)  (h)  that(gh)  (g) should(f) not(gijkjihih) know(g) him:(g) and(g) he(h) rebukeq(g)  (h)  (g)  them,(g) say-(fe)ing,(d) O(defg) fools(gh) and(hg) slow(j) of(i) heart(j) to(h) believe(gh)  (gf)  all(dfg) that(fg) the(g) —(gh) .(g) have(gh) =(fe) spoken,(d) e(f) le-(gh)lu-(g)ia.(g) I(jijh) 1)(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-134.png",
        nextFileName: "./pages/part-a-135.png",
    },
    {
        title: "part-a-134-1",
        gabc: "menner(fg)  (gh)  (h) of(h) commu-(g) (f) e(gh) ni-(h) (g) are(g) these(g) that(h)  Ye(fg) have(hi) one(g) to(h) another?(g)  (hg)  (f) as(f) ye(hj) walk,(ji) and(j) are(h)  sad?(ghg) al-(f)le-(g)lu-(fe)ia,(d) al(f) -(fgh)lu-(g)ia.(g) |(j) T(i)  (j) e(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-134.png",
        nextFileName: "./pages/part-a-135.png",
    },
    {
        title: "part-a-135-0",
        gabc: "5(g) stood(h)  (gf~) :(h) the(j) =(ji) of(g) his(hj) .(hg) disciples(hg)  (f) and(g)  (g)  said(g) un-(f)to(g) them,(h) Peace(jj) be(h) un-(j)to(j) you,(i) al-(g)le-(ij)lu-(h)ia,(gf)  al(gfh) le-(h)lu-(g)ia.(g)  (j) I(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png",
    },
    {
        title: "part-a-135-1",
        gabc: "e-(g)hold(j) m);(ig) hands(hij) Tand(h) my(hg) feet,(f) that(g) it(f) is(h) I(j) |(j)  my-(j)self,(ig) al-(i)le-(j)lu-(h)ia,(gf) al(gh) le(h) lu-(g)1ia.(g) |(j) T(i)  (j)  (h) a(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png",
    },
    {
        title: "part-a-135-2",
        gabc: "C(ighij) the(i) net(i) Ton(ij) the(i) right(h) side(fhi) of(h) the(g) [N(e) and(f)  ve(hi) shall(ih) find,(gh) al-(hi)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-135.png",
        nextFileName: "./pages/part-a-136.png",
    },
    {
        title: "part-a-136-0",
        gabc: "a-(eh)sus(f) saith(f) a(e) to(d) his(ef)  (fgf) disciples,(e) a(e) Bring(igj) of(ji) the(i)  fish(ig~)  (hghih) which(h) ye(h) have(f) now(ghg) caught.(e) Si-(e)mon(fh) Pe-(h)ter(f) went(hg)  up,(e) and(g) drew(i) the(h) net(i) to(h) land,(fh) full(h) of(hg) great(fe) fis(f) es,(ed)  al-(ef)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png",
    },
    {
        title: "part-a-136-1",
        gabc: "a(e) ry(h) stood(i) Tat(j) the(h) sepulchre(h)  (fh)  (gf) [(e) &amp;(e) and(e) seeth(d)  (f)  (h)  two(h) An-(h)gels(f) in(h) white,(gf) sitting,(hh)  (g) and(g) the(h) napkin(iji)  (h) that(f)  (h)  was(ig~)  (h) a-(ih)bout(f) the(ed) head(ef) of(h) Je-(f)sus,(gh) al-(ih)le-(f)lu-(e)ia.(e)  (j) I(i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png",
    },
    {
        title: "part-a-136-2",
        gabc: "hey(g) have(g) ta(igij) ken(i) &#39;(i) way(jk) A(ji) Lord,(ji) and(h) I(j) know(kj) not(ih) B(f) ",
        groupIndex: 2,
        filename: "./pages/part-a-136.png",
        nextFileName: "./pages/part-a-137.png",
    },
    {
        title: "part-a-137-0",
        gabc: "where(fi) they(h) ha:&#39;e(g) laid(e) him.(e) If(e) thou(g) have(h) borne(i) him(j)  hence,(ih) tell(jkji) me,(jh) al-(ij)le-(j)lu-(i)ia:(i) and(i) I(j) will(i) take(h)  him(f) a-(h)way,(gh) al(hi) -(f)lu-(e)ia.(e) a(i)  (j) [](i)  (h)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png",
    },
    {
        title: "part-a-137-1",
        gabc: "he(i) e(h) lev-(h)en(g) disciples,(h)  (ij)  (i) when(hg) they(hi) saw(ii) the(ef) Lord(i)  in(h) li-(f)lee,(e) M(e) worshipped(e) Fim,(dc) al(d) -(ef)lu-(e)ia.(e)   (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png",
    },
    {
        title: "part-a-137-2",
        gabc: "A1l(g) pow-(j)er!(i) is(g) giv-(ij)en(hg) un-(h)to(g) me(f) in(g) heaven(f)  (h) and(j) in(j)  earth,(ki~)  (ig) al(ij) le(h) -(g)lu~—ia.(g) P(j)  (i) DI(j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-137.png",
        nextFileName: "./pages/part-a-138.png",
    },
    {
        title: "part-a-138-0",
        gabc: "hey(d) 2n(dc) both(f) to-(g) (fh) gether,(h) and(h) the(h) other(hj)  (h) isciple(gf)  (igih)  (gf)  did(gh) outrun(g)  (fe) Peter,(df)  (fc) and(cd) came(ffd) first(fhg) to(f) the(g)  (f) sepulclire,(fe)  (dc)  al(ik)  (d) le(efe) lu(d) 1ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png",
    },
    {
        title: "part-a-138-1",
        gabc: "A(f) 1-(g)le-(h)lu-(f)al(hg) —le-(g)lu-(ef)ila,(dc) al-(f)le(gh) -(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png",
    },
    {
        title: "part-a-138-2",
        gabc: "The(ik)  (c) sdne(cd) day(d) tat(d) S(f) evening,(d)  (dc) bé-(c)ing(d) the(d)  (fdfgh) ay(fe) of(d)  the(cd) week,(d) when(cd) the(fg) doors(hg) were(fg) shut(gfed) wHere(dc) the(f) dis-(g) ci-(f)ples(gh) were(h) as-(g) (g)  (gf) sembled,(d) came(d) Je(dg) sus(g) and(gh) stood(g) in(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-138.png",
        nextFileName: "./pages/part-a-139.png",
    },
    {
        title: "part-a-139-0",
        gabc: "the(g) midst,(fgf) and(f) saith(fg) un-(f)to(f) them,(ef) Peace(g) be(f) un-(fg)to(fe)  ’75;_:1(dc) -(d) (efe) 1lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png",
    },
    {
        title: "part-a-139-1",
        gabc: "Al-(eh)le-(f)lu-(f)a(e) ia,Tal(d) en(efe) 1lu(ed) [(e) B(j) al(g) -(h)1lu-(i)ia;(f)  Al-(h)le-(h)1u-(hih)ia,(gh) al(f) le(gh) -(f)a.Ja(e) al(e) &amp;(e) &amp;(e) ](d)  Al-(d)le-(f)lu-(h)ia,(g) al-(e)le(gh) -(f)1ia,(ed) al(ef) -(f)&quot;(e) @(e) .(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png",
    },
    {
        title: "part-a-139-2",
        gabc: "is(f)  (g) ri-(h)sent(g) from(g) the(h) grave,(fgf) who(fh) de-(g)liv-(h)er-(g)ed(fgh)  the(hg) three(f) children(gf)  (def) from(c) the(d) burning(f)  (f) fiery(g)  (f) furnace,(fe)  (dc)  al(f) le(g) 1y(fg) ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-139.png",
        nextFileName: "./pages/part-a-140.png",
    },
    {
        title: "part-a-140-0",
        gabc: "A(f) 1le-(ghg)1lu-(h)ia,T(gf) al(gh) le-(g)lu(fe) ia,(d) al-(f)le-(g)lu-(g)ia,(f) —1(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png",
    },
    {
        title: "part-a-140-1",
        gabc: "-(g) (gj)  (h)  (hg)  (h)  (g) lu-(h)ia,(g) al-(g)le-(f)lu-(g)ia,(h)  al(i) -(hg)1lu-(h)ia.(g) ||(j) &quot;(i)  (j)  (h) =(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png",
    },
    {
        title: "part-a-140-2",
        gabc: "A(c) IR(f) l—le—lu—ia,f(h)  (h) T,(g) al(f) -(g)lu-(h)ia,(f) al(f) -(e)lu-(f)ia,(f)  al(g) le(f) [(e) ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png",
    },
    {
        title: "part-a-140-3",
        gabc: "Al-(h)le-(h)lu-(i)ia,(hg) Tal-(fh)le-(gf)lu-(e)ia,(e) al-(e)le-(e)lu-(f)ia(ed)  al-(ef)le-(f)1lu-(e)ia.(e) I(h)  (f) ](h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-140.png",
        nextFileName: "./pages/part-a-141.png",
    },
    {
        title: "part-a-141-0",
        gabc: "AL-(hd)le-(hi)lu-(h)ie,(gh) Tal(f) -(h)11(fe) :(df)  (f) e(f)  (f)  (ef)  (g)  al(g) le(fe) -(d)1ia,(d)  (h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png",
    },
    {
        title: "part-a-141-1",
        gabc: "A(ig~) 1-(g) (h) lu-(i)ia,T(i) al(ih) -(fh)lu-(fg)ia,(e) al(f) le(fhg) lu-(e)a(e)   (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png",
    },
    {
        title: "part-a-141-2",
        gabc: "A(h) frer(h)  (hih) when(hg)  (h) the(g) doors(fh) were(gf) shut,(e) the(ef)  (d)  Lord(ig~)  (df) en-(h)ter-(g)and(e) said(ef) un-(d)to(f) them,(h) Peace(g) a(e) un-(g) (g)  to(g) you,(h) al(f) —-(d)lu-(f)ia,(g) al-(f) (d)  (fe)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-141.png",
        nextFileName: "./pages/part-a-142.png",
    },
    {
        title: "part-a-142-0",
        gabc: "A(g) le-(h)lu-(ij)ia,(i) Tal(ih) le-(fh)lu-(fg)ia,(e) al-(f)le-(fhg)lu-(e)ia.(e)  (i)  (j) T(i)  (hih) ",
        groupIndex: 0,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png",
    },
    {
        title: "part-a-142-1",
        gabc: "A(f) le-(f)lu-(hg~)ia,(h) tal-(h)le-(g)lu-(gh)ia,(ef) al-(g)le(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png",
    },
    {
        title: "part-a-142-2",
        gabc: "Al-(h)le-(g)lu-(h)ia,(f) al-(e)le-(d)lu-(e)ia,(f) e(g) lu-(fe) (f) ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png",
    },
    {
        title: "part-a-142-3",
        gabc: "A(ki~)  (c) I-(g)le-(h)lu-(hj)ia,T(j) al(ji) le(hg) lu-(h)ia,(g) al(gf) le-(gh)lu-(gfe)ia.(e)  (j)  (hji)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-142.png",
        nextFileName: "./pages/part-a-143.png",
    },
    {
        title: "part-a-143-0",
        gabc: "g(g)  (hj) al-(j) (g)  (h) le-(g)lu-(e)ia,(f) al-(hg)le-(gf)lu-(e)ia.(e)  (j) T(h)  (j) ](ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png",
    },
    {
        title: "part-a-143-1",
        gabc: "A(h) le-(gh)lu-(f) (e) al-(g)le-(f)lu-(g)ia,(h) al-(f)le-(e)lu-(f)ia.(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png",
    },
    {
        title: "part-a-143-2",
        gabc: "Al-(f)le-(g)lu-(h)ia,(f) al-(gh)le-(g)lu-(f)ia,(dc) al-(f)le-(gh)lu-(fg)ia.(f) 178.(h)  (f)  (gh) |(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png",
    },
    {
        title: "part-a-143-3",
        gabc: "He(c)  (c)  (e) the(ef) ho-(f)ly(h) Cross(hg) endured,(fg)  (g) Burst(gi) the(g) gates(hg) of(f) hell(gf)  in(ef) twain:(f) Begirt(f)  (fe) might(c)  (e) and(hf~) ma-(hg)jes-(fg)ty,(g) On(i)  Eas-(iji)ter(g) morn(hg) he(f) rose(gf) a-(ef)gain,(f) al(eg) le(gfhhfgf) lu(ef) ia.(f) ",
        groupIndex: 3,
        filename: "./pages/part-a-143.png",
        nextFileName: "./pages/part-a-144.png",
    },
    {
        title: "part-a-144-0",
        gabc: "—(c) Peace(f) be(f) .(f) s(f) a(e) it(g) is(g) I,(h) a(e)  (f)  (d) o(c)  (fe)  not(g) afraid,(g)  (h) al(h) -(hg)le-(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png",
    },
    {
        title: "part-a-144-1",
        gabc: "Reach(eg) «(g) _—-(h)thy(g) finger,T(h)  (g) and(f) ex-(hj)am-(ji)——ﬁ(g) the(g) a(g)  of(i)  (g) the(g) nails,(gh) al-(g)le-(f)lu-(gh)ia:(h) and(h) be(j) not(g) faithless(h)  (g)  but(g) believing,(fe)  (f)  (d) al-(g)le-(h)lu-(i)ia,(j) al-(h)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png",
    },
    {
        title: "part-a-144-2",
        gabc: "B(g) cause(g) thou(f) hast(h) seen(j) me,T(i) a(g) Thomas,(i) thou(j) hast(h) be-(g) lieved:(hg)  (f) &quot;(g) s(g) are(g) they(g) that(f) have(h) not(j) seen,(i) and(g)  yet(ik)  (j) have(h) believed,(g)  (h)  (gf) al-(gh)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-144.png",
        nextFileName: "./pages/part-a-145.png",
    },
    {
        title: "part-a-145-0",
        gabc: "[(fg) did(g) put(hj) my(i)  (j) finger(h) in-(g)to(g) the(hi) print(g) of(h) the(g) nails,(f)  (fe)  and(d) thrust(e) my(fg) hand(g) in-(jh)to(i) his(j) side,(h) and(hijg) said,(g) My(eg)  Lord(f)  (fe) and(d) my(ef) God,(gf) al-(gh)le-(h)lu-(g)ia.(g)  (j) I(i)  (j) 1(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-145.png",
        nextFileName: "./pages/part-a-146.png",
    },
    {
        title: "part-a-145-1",
        gabc: "[(f) amTthe(ggf)  (h) Shepherd(j)  (ij) of(hg) the(fg) sheep:(g) I(ji) am(jkji) the(h) way,(ji)  the(hg) truth,(hi) and(h) the(g) life:(ghg) I(fg) am(g) the(f) Good(gh) Shepherd;(f)  (f)  and(f) I(hj) know(ji) my(hg) sheep,(g) -(e)am(f) known(g) of(f) (D(edc) .(c) le(d)  Q(e) ia,(f) al-(gh)le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-145.png",
        nextFileName: "./pages/part-a-146.png",
    },
    {
        title: "part-a-146-0",
        gabc: "—(ik) I(g) am(hj) the(i) Good(hj) Shepherd,(ji)  (g) who(g) feed(hi) my(hg) sheep:(eg) and(g)  I(hj) lay(h) down(j) my(j) life(ihg) for(gh) my(g) sheep,(ef) al-(g)le-(gf)lu-(e)ia,(e)  &gt;(j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png",
    },
    {
        title: "part-a-146-1",
        gabc: ".(e) Good(fh) =(gh) Shepherd(h) Tlay(g)  (hiji) eth(h) down(fh) his(gf) life(e) for(f)  (hgf)  the(gi)  (gf) sheep,(ed) al(e) le(ed) lu-(c)1ia.(c)  (h)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png",
    },
    {
        title: "part-a-146-2",
        gabc: "St(j)  e(g) that(g) is(gj) an(h) hireling,(gi)  (i) whose(ij) own(k) the(kj) sheep(i) are(kj)  not,(k) se-(i)eth(k) the(j) wolf(ji) coming,(gh)  (g) and(hg) leaveth(j)  (i) the(h)  sheep,(ghihg) and(gh) fle-(f)kth:(ed) and(g) the(h) wolf(ji) catch-(gihg)eth(hg) them(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-146.png",
        nextFileName: "./pages/part-a-147.png",
    },
    {
        title: "part-a-147-0",
        gabc: "and(g) —(e) scattereth(f)  (g) the(h) sheep,(gf) al-(g) (gf) lu-(e)ia.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png",
    },
    {
        title: "part-a-147-1",
        gabc: "A(c)  (d) the(fh) Fa-(hg)ther(fe) knoweth(h)  (ih) me,(h) e-(h)ven(i) so(j) know(kj) I(i) the(h)  (h)  Fa-(hi)ther:(f) and(f) I(gg) &lt;lay(hi) down(h) my(g) life(hh) for(d) the(e) sheep,(fg)  (h)  al(h) le(e) lu-(d)1ia.(d) M(h)  (i)  (g) ](h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png",
    },
    {
        title: "part-a-147-2",
        gabc: "OI(ffe)  (dc) I(c)  (d) have,(ffgf) which(gi) are(ih) not(g) of(ih)  (gf) fold:(gf)  them(hi) al-(j)so(hih) must(gf)  (dedcd)  (dc) and(f) they(f) shall(fg) hear(h) my(gf)  voice;(f) and(hjihgf) there(gh) ja]l(fg) be(f) one(df)  (edcd) and(fghgi) one(hg)  Shepherd,(f)  (fg) al(h) le(g) lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-147.png",
        nextFileName: "./pages/part-a-148.png",
    },
    {
        title: "part-a-148-0",
        gabc: "A(cf) little(f)  (ef)  (d) shall(de)  (c)  (d) not(fg) see(fg) me,(f) saith(f)  the(gh) Lord:(hgf) and(f) again,(fgh)  (h) a(h) lit-(h)tle(gfgf) while,(d) and(ed) ye(cd)  shall(fg) see(fg) me,(f) because(d)  (f) I(g) go(h) to(g) the(f) Fa-(g)ther?(dfedc)  *1-(c)le-(d)lu-(ffg)ia,(gf) al-(g)le-(gh)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-148.png",
        nextFileName: "./pages/part-a-149.png",
    },
    {
        title: "part-a-148-1",
        gabc: "ly,(g)  (fgh)  (h) I(h) say(hg) un-(h)to(hi) S(g) that(f) ye(g) shall(g) weep(hf)  and(ik)  (g) lament,(h)  (f) the(g) world(fg) shall(g) rejoice:(h)  (jijkj) and(j) ye(jk)  shall(j) be(h) sorrowful,(ji)  (hg)  (g) but(g) your(eg) ](fe) sorrow(f) shall(d) be(e) turned(f)  (gh)  (g)  in-(g)to(fg) joy,(gfd) al-(ef)le-(fg)lu-(g)ia.(g) |(j) v(i)  (j)  (h) a(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-148.png",
        nextFileName: "./pages/part-a-149.png",
    },
    {
        title: "part-a-149-0",
        gabc: "be(g)  (gj)  (h)  (h)  (g) turned(hg)  (f) in-(hg)to(h) joy,(g) al(ij) -(kh) lu-(j)ia:(i) and(jk) your(k)  (k) joy(jijkj) no(h) man(j) taketh(g)  (hg) [(fe) -(dc) (j)  .(c) -(d)L(e) 1ia,(f) al-(fh)le-(h)lu-(g)ia.(g) I(j) 1(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png",
    },
    {
        title: "part-a-149-1",
        gabc: "Sorrowlhath(fg)  (g)  (hj) filled(j)  (ji) your(hg) heart:(hg) and(hjij) your(hg) joy(hig) [](e)  man(f) .(g) taketh(f) from(edc) you,(c) al(c) -(d)1lu-(e)ia,(f) al(gh) -(h)lu-(g)ia.(g)  an(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png",
    },
    {
        title: "part-a-149-2",
        gabc: "Y&#39;our(fe)  (g) .(h)  (e) -(f)lu-(d)i;&#39;,(c) shall(f) be(f) turned(f) [(e) in-(g) to(g) joy,(h) al-(h)le-(hg)lu-(fg)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-149.png",
        nextFileName: "./pages/part-a-150.png",
    },
    {
        title: "part-a-150-0",
        gabc: "ve-(d) (d)  (f)  (d) ri-(d)lly,(dc) I(f) say(g) un-(f)to(gh) w,&#39;ou,&#39;r(h) I(hghih) will(gf) see(fgh)  you(ik)  (f) again,(e)  (d) and(cd) your(f) heart(fg) shall(h) re-(gf)joice:(f) and(f)  your(g) joy(hgf) no(g) man(f) taketh(g)  (f) from(fe) you,(dc) al(d) le(efe) lu-(d)ia,(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png",
    },
    {
        title: "part-a-150-1",
        gabc: "Now(dh) I(j) go(h) my(g) way!(h) to(f) him(gh) that(fe) sent(d) me;(d) and(fc) none(fe)  of(d) you(fg) askéth(f)  (ed) n(c) -(ifhi):(h) go-(h)est(g) thou?(ghg) al(f) -(f) lu-(e)ia,(f) al(g) le-(fe)lu-(d)ia.(d) &quot;(h) =(g) _dd(f)  (gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png",
    },
    {
        title: "part-a-150-2",
        gabc: "Now(c)  (ff) I(e) go(f) my(g) wayl(h) to(i) him(hg) that(fg) sent(f) me:(e) but(h) because(j)  (jji)  (kji) ",
        groupIndex: 2,
        filename: "./pages/part-a-150.png",
        nextFileName: "./pages/part-a-151.png",
    },
    {
        title: "part-a-151-0",
        gabc: "I(ig~)  (h) have(i) said(j) these(i) things(hi) un-(i)to(hg) you,(f) sorrow(ih)  (hg) hath(fe)  (f)  filled(gi)  (ff)  (e) your(f) heart,(hg) al-(i)le-(hg)1lu-(f)ia.(f) a1(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png",
    },
    {
        title: "part-a-151-1",
        gabc: "I(ec) tell(fh) you(g) the(hi) truth;(i) Tit(hg) is(g) ex-(fg)pe-(ef)di-(fe)ent(e) for(fgf) you(gfefhfgh)  that(i) I(h) go(j) a-(ih)way:(h) for(g) if(hi) I(hg) go(fe) =(fg) a-(f)..(e) the(f) Com-(f) orter(ed)  (d) s(c) not(d) ](e) a(e) to(f) you,(ed) al-(e)le-(ed)lu-(c)ia.(c)  (hg)  (fg)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png",
    },
    {
        title: "part-a-151-2",
        gabc: "1(e) A(e) you(g) the(h)  (i) it(i) is(hg) ex-(fg)pe-(e)di-(ef)ent(e) O(c) you(egh)  that(g) I(h) go(i) a(iji) a-(g)for(g) if(i) I(hg) go(f) L(gh) :(g) 5(e) the(f) Com-(f) a(e) forter(f) T(c) a(c) 0(e) [(e) to(f) -(ef)al-(g)le-(fg)lu-(e)ia.(e) af](i)  (ji) ](h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-151.png",
        nextFileName: "./pages/part-a-152.png",
    },
    {
        title: "part-a-152-0",
        gabc: "hen(fhh) the(f)  (fgf) T(ef)  (f) the(h) Spirit(j)  (i) of(j) truth,(ih) ig(ij) come,(jii)  he(ig~)  (j) will(i) g(h) convince(hih) the(f) world(i) of(hg) sin,(f) and(e) of(f) right(h)  I(gi)  (h) eousness,(gh) and(i) of(hg) judgment,(dfe)  (gh) al-(i)le-(hg)lu-(f)ia.(f) I-(h)-(g) (e) I(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png",
    },
    {
        title: "part-a-152-1",
        gabc: "-(d)have(f) yetT(hh) ma-(h)ny(h) things(ih) to(g) say(ij) un-(h)to(gh) you,(h) but(i) e(h)  bear(gh)  (fe)  (f) them(ef) now:(d) how-(f) (d) be(f) when(hf) he,(hi) the(h)  Spirit(i)  (h) of(fg) e(hi) is(i) come,(h) he(i) T(i) guide(h) you(h) in-(f) to(fe) all(ef) truth,(de) al-(f)le-(e)lu-(d)ia.(d) |(h) =(h) &amp;«(i)  (g) &quot;(h) 1(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png",
    },
    {
        title: "part-a-152-2",
        gabc: "F(gi)  (cf) he(e) shall(gfh) not(gh) speak(i) of(hg) himself;(fg)  (fe) T(c) but(f) what-(h)so-(i)",
        groupIndex: 2,
        filename: "./pages/part-a-152.png",
        nextFileName: "./pages/part-a-153.png",
    },
    {
        title: "part-a-153-0",
        gabc: "ev-(gi) (j) er(i) he(g) shall(h) hear,(i) That(h) shall(gh) he(f) speak:(gf) and(f) he(g)  will(gi)  (h) shew(ijijkj) you(hh) things(iji) to(hg) come,(fe) al-(f) (ghg) lu-(f)ia.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png",
    },
    {
        title: "part-a-153-1",
        gabc: "H(gi) ith-(f) (ef) er-(f)to(f) ye(gh) ask-(i)ed(i) nothing(j)  (i) in(g) my(hg) Name:(f) ask,(g)  and(ig~)  (ef) ye(f) shall(e) receive,(fh)  (gh) al-(i)le-(hg)lu-(f)ia.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png",
    },
    {
        title: "part-a-153-2",
        gabc: "sk,T(df) and(e) ye(e) shall(h) receive,(g)  (fge) that(d) your(f) joy(hiih) may(j) be(hg)  full:(f) for(h) the(g) Fa-(h)ther(f) himself(hg)  (f) loveth(fg)  (f) you,(e) because(e)  (e)  e(ec) e(e) lov-(d)ed(c) -(d)and(c) have(c)  (d) believed,(e) 3(d) al-(ef)le-(f)lu-(e)ia.(e)  al(gi)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 2,
        filename: "./pages/part-a-153.png",
        nextFileName: "./pages/part-a-154.png",
    },
    {
        title: "part-a-154-0",
        gabc: "or(def) the(e) Father(def)  (e) T(f) himself(de) loveth(f)  (gh) you,(e) because(df) you(hi) haye(j)  lov-(h)ed(hg) me,(f) and(f) have(h) believed,(e)  (fe)  (d) al-(ef)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 0,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png",
    },
    {
        title: "part-a-154-1",
        gabc: "[(ki~)  (cg) came(gj) forth(hg) from(h) the(gf) Father,T(gh)  (g) and(g) am(g) come(hij) in-(j)to(h)  the(j) world:(j) again(j)  (j) I(h) leave(j) the(g) world,(ghg) and(fe) go(g) to(f)  the(e) Father,(f)  (efd) al-(f)le-(fgh)lu-(g)ia.(g) S(j)  (i)  (j) R(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png",
    },
    {
        title: "part-a-154-2",
        gabc: "When(f) Christ(gh) ascended(f)  (fe) LI(dc) up(f) on(fg) high,(i) Al-(hij)le(ihgfe) lu-(fh)i#(f)  (d)  al-(d)le(fgiihgfe) lu-(gg)ia.(f) When(f) Christ.(gh) He(f) led(gh) cap-(f)ti-(fe)",
        groupIndex: 2,
        filename: "./pages/part-a-154.png",
        nextFileName: "./pages/part-a-155.png",
    },
    {
        title: "part-a-155-0",
        gabc: "bi-(dc)=(c) captive.(fg)  (i) B(h) Al(hj) le(ihgfe) lu-(gh)ia.(f) Glory(f)  (f) be(g)  vo(f) the(f) Father(gh)  (f) and(g) to(fe) the(dc) Son,(c) and(c) to(df) the(f) Ho(ghih) ly(gf)  Ghost.(f) When(f) Christ.(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-155.png",
        nextFileName: "./pages/part-a-156.png",
    },
    {
        title: "part-a-155-1",
        gabc: "hen(f) Christ(g) ascended(f)  (f) a(e) up(g) on(g) high,*(h) Al-(h)le-(hg)lu-(g)ia,(f)  ol-(d)le-(fg)lu-(gf)ia.(f) When(f) Christ.(g) V.(c) He(f) led(g) capti-(f)vi-(f)ty(f)  (e)  captive.(g)  (h) Al(h) le(hg) -(g)ia.(f) Glory(f)  (f) be(f) to(f) the(e)  Father(g)  (h) and(h) to(ihi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Chost.(gf)  When(f) Christ.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-155.png",
        nextFileName: "./pages/part-a-156.png",
    },
    {
        title: "part-a-156-0",
        gabc: "Fa(ff)  (def) I(fd) have(gf~) ma-(hi)ni-(hi)fest-(g)ed(f) thy(ghg) Name(f) un-(gh)to(f)  the(e) men(ed~) which(d) thou(cd) ga-(f)vest(fgf) me:(f) and(hihgf) now(ghg) I(h) pray(jk)  for(ji) them,(hg) not(h) for(j) the(i) world,(hih) because(fh)  (gh) I(eg) come(hg) to(fe)  (dc)  al(f) le(gh) lu-(g)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-156.png",
        nextFileName: "./pages/part-a-157.png",
    },
    {
        title: "part-a-156-1",
        gabc: "Ye(e) men(g) of(h) Ga(ihji) li-(hi)lee,(i) why(i) stand(i) ye(g) gazing(ij)  (i) up(h)  in-(h)to(i) heaven?(hg)  (e) This(d) same(fh) Je-(hi)sus,(h) which(hg) is(f) ta-(g)ken(h)  up(f) from(e) you(f) in-(e)to(f) heaven,(e)  (d) shall(h) so(hgf) come,(gh) al(hi) -(f) lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-156.png",
        nextFileName: "./pages/part-a-157.png",
    },
    {
        title: "part-a-157-0",
        gabc: "nd(gf~) while(g) they(g) look-(g)ed(g) 1&#39;st&#39;.edfast:ly(g)  (h) toward(i)  (gh) heaven(g)  (f) as(hj)  he(i) went(jk) up,(h) they(g) said,(hg) al(f) -(gh)1lu-(g)ia.(g)  (j)  (i) 1(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png",
    },
    {
        title: "part-a-157-1",
        gabc: "He(f) lifted(e)  (f) up(h) his(hij) hands(i) tand(ih~) blessed(j)  (ih) them,(i) and(f) was(i)  .(jk)  (jk)  carried(g)  (h) up(f) in-(f)to(e) heav’n,(fe) al-(ed)le-(fh)lu-(f)ia.(f) 1(i)  (h)  (i) 1(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png",
    },
    {
        title: "part-a-157-2",
        gabc: "x-(fg)alt(g) ye(gf) Tthe(h) King(j) of(jkj) kings,(hih) and(g) sing(hj) a(g) hymn(h) un-(g)to(g)  d,(fed) al-(f)le-(gh)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png",
    },
    {
        title: "part-a-157-3",
        gabc: "hile(h) they(g) a(e) -(gh)he(f) ](e) taken(f) a(e) B(d) and(d) a(e) cloud(e)  ](e) ](e)  (d) him(f) out(h) of(g) [(e) -(gh)al-(f)le-(f)lu-(e)ia.(e)  (h)  (fh)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-157.png",
        nextFileName: "./pages/part-a-158.png",
    },
    {
        title: "part-a-158-0",
        gabc: "God(f) is(f) gone(f) up(g) with(f) a(e) merry(g)  (g) noise,*(h) Al(h) le-(hg)lu-(g)j,(f)  al-(d)le-(fg)lu-(gf)ia.(f) God(f) is(f) gone(f) up.(g) And(f) the(f) Lord(g)  with(f) the(f) sound(f) a(e) the(g) trump.(h) Al(h) -(hg)lu-(g)ia,(f)  Glory(f)  (f) be.(f) God(f) is(f) gone(f) up.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-158.png",
        nextFileName: "./pages/part-a-159.png",
    },
    {
        title: "part-a-158-1",
        gabc: "Se—m(ik)  (f)  (efgh)  (g)  (fd)  (f)  (efg) et(f)  (e)  (g)  (hj)  (h)  (gf)  (g)  .(g) ‘(f)  (ed)  (cd) a(d)  (dc)  (d) (](fe) a(de)  (e) a.(e)  (g)   (ki~)  (gh)  (g)  (fd)  (f)  (efg)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-158.png",
        nextFileName: "./pages/part-a-159.png",
    },
    {
        title: "part-a-159-0",
        gabc: "I.(c) ascend(ef)  (g) Tun-(g)to(h) my(jg) Father,(h)  (gg) and(fe) your(gfd) Father:(c)  (c) and(ef)  to(d) my(fg) God,(g) and(g) your(hg) God,(fe) al-(dc~)le(ed) lu-(cd)1a.(c) l(ghgf)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-159.png",
        nextFileName: "./pages/part-a-160.png",
    },
    {
        title: "part-a-159-1",
        gabc: "0(gi)  (fhhg) King(hf) of(gf) o(ef) —(f) thou(f) Lord(g) of(hf) Sa-(g)ba-(f).-(e)who(f)  triumphing(gi)  (cf)  (f)  (f) to-(f)day(g) hast(f) ascended(f)  (g)  (f) above(f)  (g) all(h) heav’ns,(kijijkj)  leave(ji) us(hg) not(fh) comfortless;(h)  (fgfe)  (e) but(fe) send(he) on(h) us(h) the(g)  promise(h)  (g) of(f) the(g) Fa(gfef) ther,(fec) e-(f)ven(e) the(f) Spirit(h)  (g) of(e)  truth,(gi)  (fe) al(f) le(ghg) lu-(f)ia.(f) R(h)  (gf) o(hg)  (e) 1(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-159.png",
        nextFileName: "./pages/part-a-160.png",
    },
    {
        title: "part-a-160-0",
        gabc: "(O(fhhg) King(hf) of(gf) glory,(ef)  (f) thou(e) Lord(fh) of(hg) Sa-(fg)ba-(f)oth,(e) who(f)  triumphing(gi)  (cf)  (f)  (f) to-(f)day(gf) hast(e) ascended(fh)  (h)  (f) above(e)  (gh) all(f) hea(khjkji) veng(ji)  leave(ig~)  (ij) us(i) not(hf)  (g) comfortless;(ef)  (f) but(fe) send(f) on(f) us(f) the(f) pro-(hg) mise(gi)  (hih) of(h) the(e) Fa(fefe) ther,(c) e-(f)ven(e) the(f) Spirit(h)  (i) of(hg) truth,(fe)  =(hgi) al(f) le(ghg) -(f)ia.(f) 1&quot;(h) p(gf) 1(hg) s(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-160.png",
        nextFileName: "./pages/part-a-161.png",
    },
    {
        title: "part-a-160-1",
        gabc: "hen(c) the(d) Comforter(f)  (e) is(f)  (g) come,(g) whom(fh) I(hg) will(gf) send(gh) un-(j)to(i)  you(j) from(i) the(h) Father,(j)  (g) e-(g)ven(h) the(f) Spirit(g)  (f) of(ed) truth,(df) ",
        groupIndex: 1,
        filename: "./pages/part-a-160.png",
        nextFileName: "./pages/part-a-161.png",
    },
    {
        title: "part-a-161-0",
        gabc: "which(c) proceedeth(d)  (f)  (fe) from(d) the(f) Father,(fg)  (g) he(hj) shall(j) testify(ji)  (hg) .(hi)  of(ik)  (gh) me,(g) al(ef) le(fg) lu(g) -(g)0O(g)  (f)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-161.png",
        nextFileName: "./pages/part-a-162.png",
    },
    {
        title: "part-a-161-1",
        gabc: "hese(d)  (dc) have(f) I(g) told(fgh) e(h) that(f) when(h) the(j) time(h)  shall(fg) come,(ghg) ye(g) may(h) ](g) remember(gf~) E(f) that(e) I(f) told(g) you(f) of(fe)  them,(dc) al(d) le(efe) lu-(d)ia.(d) 8(h)  (g)  (f) &amp;(gh) p(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-161.png",
        nextFileName: "./pages/part-a-162.png",
    },
    {
        title: "part-a-162-0",
        gabc: "he(f) Ho(fg) 1y(f) Ghost,(fe)  (dc) Comforter,*(f)  (fg)  (i) Al(hij) le(ihgfe) lu-(gh)ia,(f)  al(dc) le(ifgiihgfe) lu-(gg)ia.(f) The(f) Ho-(fg)ly(f) Ghost.(fe) ¥.(c) Shall(fg)  teach(fe) you(dc) all(fg) things.(i) Al(hij) le(ihgfe) lu-(gh)ia.(f) ¥.(c) Glory(f)  (f)  be(ijk)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) e(dc)  (c) and(c) to(df) the(f) Ho-(ghih) Ghost.(gf)  (f) The(f) Ho(fg) 1y(f) Ghost.(fe) ",
        groupIndex: 0,
        filename: "./pages/part-a-162.png",
        nextFileName: "./pages/part-a-163.png",
    },
    {
        title: "part-a-162-1",
        gabc: "T(c) he(f) Ho-(g)1y(f) Ghost,(f) the(e)  (g) Comforter,*(g)  (h) Al-(h)le(hg) -(g)ia,(f)  al(d) -(fg)lu-(gf)ia.(f) The(f) Ho-(g)1ly(f) Ghost.(f) Shall(f) teach(f)  a(e) all(g) things.(h) R.Al(h) -(hg)lu-(g)ia.(f) ¥.(c) Glory(f)  (f) be(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-162.png",
        nextFileName: "./pages/part-a-163.png",
    },
    {
        title: "part-a-163-0",
        gabc: "to(f) the(e) Father(g)  (h) and(h) to(ihi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)1ly(g) e(g)  Ghost.(gf) The(f) Ho(g) 1y(f) Ghost.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png",
    },
    {
        title: "part-a-163-1",
        gabc: " (e)  (f)  (ed)  (e)  (fe)  (h)  (ih)  (h)  (h)  (e)  (f)  (h)  [l(ih)  (ij)  (ih)  (i)  (h)  (ij)  (hg)  (fe) .(hi)  (e)  (f)  (h)  V.(gh) They(ffe~d) were(f) all(fgf) filled(e) with(d)  (e) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png",
    },
    {
        title: "part-a-163-2",
        gabc: "I(cd) will(d) not(d) leave(de)  (d)  (cd) al(df)  (fe)  (d)  (cd)  (de)  (dc)  (f)  I(fgh) go;(ghg) but(f) I(gh) will(f) come(ef) to(cd) you,(def) al-(f)le-(cd)lu=(de)  (dc)  and(cd) your(de) hdart(dc) shall(cd) rejoice,(f)  (ef) al-(g)le(fe) lu-(d)ia.(d) &quot;o(h)  (g) &quot;(f) en,(g) [(gfed) ",
        groupIndex: 2,
        filename: "./pages/part-a-163.png",
        nextFileName: "./pages/part-a-164.png",
    },
    {
        title: "part-a-164-0",
        gabc: "W(c) hen(e) t;le(ed) day(g) of(hj)  (ji) Pentecost(j)  (j) twas(h) fully(i)  (h) come,(g) they(g)  were(hi) all(h) with(g) one(e) !(fg) accord(g) in(g) one(h) place,(gf) al-(g)le(gf)  -(ki~) (e) ia.(e)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png",
    },
    {
        title: "part-a-164-1",
        gabc: "T(ki~) he(d) Spirit(fhg)  (gh) of(h) the(g) Lord(fe) Thath(d) filled(fg) Il(gd) the(fg) whole(hgf) world,(gh)  al(ik)  (gfd) -(ef)1lu-(gh)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png",
    },
    {
        title: "part-a-164-2",
        gabc: "hey(gj) were(h) all(fg) filledT(gh)  (g) with(h) the(gf) Ho-(g)ly(gh) Ghost,(h) and(ij) be-(h) gan(j) to(k) speak,(ghg) al-(f)le-(fg)lu-(hg~)1a,(gf) al-(hg~)le-(h)lu-(g)ia.(g)  (j)  (i)  (jh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-164.png",
        nextFileName: "./pages/part-a-165.png",
    },
    {
        title: "part-a-165-0",
        gabc: "(O~(dh) ve(hj) wells,Tand(h)  (g) all(h) that(g) move(ef) in(g) the(fe) waters,(d)  (d) sing(fd)  a(ef) hymn(ghg) un-(f) a(ef) hymn(gh) un-(f)to(fe) God,(dc) al(d) le-(efe)lu-(d)ia,(d) |(h) e,(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png",
    },
    {
        title: "part-a-165-1",
        gabc: "he(hg)  (f) A-(hi) (i) did(ijhg) speak(fh) with(ef) o-(f) (ef) ther(ede) tongues(ed) the(fh)  wonderful(h)  (hg) LI(fe) works(f) of(gf) God,(e) al(h) le-(f)lu-(ih~)ia,(i) al-(fe)1le-(fed) W(fe) ia,(f) al-(h)1le(fhfd) lu-(ff)ia.(e) &amp;«(i) ™(j) ®(i) &quot;m(h)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png",
    },
    {
        title: "part-a-165-2",
        gabc: "he(f) Spirit(f)  (f) of(f) the(f) Lord(g) hath(f) L(f) e(f) the(e) T(g) .(h)  Al-(h)le-(hg)lu-(g)ia,(f) al(d) -(fg)lu-(gf)ia.(f) The(f) Spirit.(f)  (f)  %.(c) And(f) that(f) which(f) containeth(f)  (f)  (f) all(g) things(f) hath(f) knowledge(f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-165.png",
        nextFileName: "./pages/part-a-166.png",
    },
    {
        title: "part-a-166-0",
        gabc: "of(g) the(g) voice.(h) Al(h) -(hg)1lu-(g)ia.(f) ¥.(c) Glory(f)  (f) be.(f)  The(f) Spirit.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png",
    },
    {
        title: "part-a-166-1",
        gabc: "N(gi)  (ef) SEE==s—s(fjk)  (j)  (j)  (ji) a(ij)  (i) -(ih) (j) ==(j)  (i)  (hg) .(f)  4(gh) .(fe)  (ef)  (c)  (ef)  (f)  (fh) -(hf) (g)  (f)  (e)  %.(ig~)  (i) They(i) were(h) all(iji) filled(gf) with(gh) the(fe)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png",
    },
    {
        title: "part-a-166-2",
        gabc: "R(c) e(c) ceive(cfefg) =1(defedcd) the(dc) Ho—1ly(fe)  (fg) Ghost:(g) whose-(g)so-(f)ev-(hj)er(j)  sins(ji) ye(h) re-(g)mit,(h) they(g) are(gg) a(e) mitted(gh)  (g) un-(f)to(fe) thém,(cd)  .(e) le-(d)1u-(c)ia.(c)  (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-a-166.png",
        nextFileName: "./pages/part-a-167.png",
    },
    {
        title: "part-a-167-0",
        gabc: "[(d)  (d)  (f)  (d)  (dc) ](f) D(g)  (h)  (hg)  (j)  (jk)  (j)  —4(ji)  (h)  (g)  (h)  (h)  (h)  (hjih)  (gf)  (ed)  (f)  (ed)  (de)  ](c)  (ed) ](g) a(ghg)  (fe) a(d)  (c)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-167.png",
        nextFileName: "./pages/part-a-168.png",
    },
    {
        title: "part-a-167-1",
        gabc: "T(c)  (cd) are(f)  (f) the(de)  (dc)  (fh) days(gh) of(fg)  (hg)  (fe) al(dc)  (d)  le(efe) lu-(d)ia:(d) to-(cd)day(dhi) the(h) Ho-(hhg)1ly(gf) Spi-(gig)rit(h) appeared(d)  (f)  (d) in(d)  fire(dg) to(f) the(fe) discipl(d) .(fe) 8,(dc) and(c) bestowed(d)  (d) [](e) up-(f)bn(cd) them(c) ||(e) ma-(g) ni-(ed)fold(f) graces:(d)  (d) sending(idhi)  (hg) them(gh) in-(h)to(g) all(h) the(iji) world,(h)  to(h) preach(h) the(g) gospel,(h)  (g) [](e) to(f) tes-(gh)ti-(fe)fy:(d) He(f) that(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-167.png",
        nextFileName: "./pages/part-a-168.png",
    },
    {
        title: "part-a-168-0",
        gabc: "believeth(d)  (ef)  (ghhg) and(fhh) is(ed)  (fe) baptizid&#39;(de) shall(dc)  (cd) be(gfe)  (gh)  (fe)  (gd)  lu-(d)ia.(d) WITHIN(h)  (g)  (f) THE(g) OCTAVE(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png",
    },
    {
        title: "part-a-168-1",
        gabc: "od(gfd) so(ef) loved(g)  (h) the(h) world,T(g) that(g) he(g) gave(fh) his(g) only-(h) (g) begot-(f) (g)  ten(gh) Son,(f) that(fh) who-(j)so-(i)ev-(j)er(i) believeth(h)  (j) in(g)  (gh) him(g) should(ge)  not(fgh) perish,(fed) 1(d) have(fgh) ev-(hg) (f) er-(gh)lasting(h) life,(gfd) al-(ef)le-(fg)lu-(g)ia.(g)  On(ik) this(j)  (i) Monday(j)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png",
    },
    {
        title: "part-a-168-2",
        gabc: "If(cehg) a(h) man(ij) love(g)  (ih) me,(i) he(i) will(jk) keep(j) my(ij) saying,(ghi)  (i) and(ii)  my(ef) Fa-(hiji)ther(hg) will(f) love(fgf) him:(e) and(ef) we(g) will(h) come(i) un-(j)to(hi) ",
        groupIndex: 2,
        filename: "./pages/part-a-168.png",
        nextFileName: "./pages/part-a-169.png",
    },
    {
        title: "part-a-169-0",
        gabc: "him,(ihf) and(hj) make(i) our(h) a-(g)bode(f) with(gh) him,(fed) al(hf) le(hfefgf) lu-(e)ia.(e)  [(i)  (j) TUESDAY(i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png",
    },
    {
        title: "part-a-169-1",
        gabc: "[(eh) @am(fe) the(f) door,(ed) saith(efe) the(de) Lord:(e) by(e) me(e) if(e) a-(fh)ny(i)  man(i) enter(ji)  (i) in,(i) he(if) shall(h) be(i) sa-(g)ved,(g) and(g) shall(h) find(fe)  -(fe)pasture,(d) al-(ef)le-(f)lu-(e)ia.(e) &quot;(h) e«(g) —(h)  (f) 1(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png",
    },
    {
        title: "part-a-169-2",
        gabc: "P(c)  (c)  (ff) TI(def)  (c) with(df) you,(fgf) my(f) peace(ggf~) I(g) give(h) un-(g)to(f)  you:(ghghih) not(fg) as(i) the(hg) world(fg) giveth,(fe)  (d) give(gf) I(gh) un-(g)to(fe) you,(dc)  al(g) le(gh) lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-169.png",
        nextFileName: "./pages/part-a-170.png",
    },
    {
        title: "part-a-170-0",
        gabc: "I(eh) am(f)  (ed) living(ef)  (f) bread,(e) saith(gh) the(if) Lord,(hhg) which(i) came(i) dow(h)  from(h) hea-(iji)ven,(hghih) al-(f)le-(e)lu-(f)ia,(f) al-(h)le-(g)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png",
    },
    {
        title: "part-a-170-1",
        gabc: "Il(dc) am(f) the(g) living(f)  (gh) bread(h) which(hg) came(def) down(g) from(fe) heaven:(d)  (d)  if(dhi) a-(h)ny(g) man(hg) eat(f) of(h) this(hj) bread,(h) he(hg) shall(ef) live(g) for(fe)  ev—er:(d)  (d) and(ff) the(dedcd) bread(dc) that(d) Y(c) will(df) give(fgf) is(h) my(gf) flesh,(e)  which(c) I(e) will(d) give(f) for(d) the(d) life(fh) of(h) the(f) world,(ef) al(g) -(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png",
    },
    {
        title: "part-a-170-2",
        gabc: "](cf) sus(d) called(f) ](e) un-(d)to(d) a(e) him1his(fg) twelve(ghg) disciples,(fe)  (de)  (e) and(c) ",
        groupIndex: 2,
        filename: "./pages/part-a-170.png",
        nextFileName: "./pages/part-a-171.png",
    },
    {
        title: "part-a-171-0",
        gabc: "gave(dhi) them(h) pow-(g)er(h) and(gf) au-(g)thor-(ghg)i-(ef)ty(g) o-(g)ver(g) all(fe) devils,(de) ar(e)  and(efedd) to(cd) cure(ef) diseases:(gf)  (de)  (e) and(f) lle(dc) sent(de) them(e) to(ef) preach(gh)  the(g) .(f) a(e) of(de) God,(e) e(c) a(e) heal(fe) the(d) -(ef)al(gf) le(de)  lu(ik)  (e) ia.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png",
    },
    {
        title: "part-a-171-1",
        gabc: "he(f) Spirit(de) ](e) twhich(e) ](e) proceedeth(e) .(d) from(f) the(e) Father,(eh)  (h) al-(g)le-(h) v(jk)  lu-(ij)ia:(i) he(j) shall(i) glo-(hg)ri-(fi)fy(hg) me,(e) al-(e)le(e) u-(dc):(d) le-(ef) lu-(e)ia.(e)  (h)  (g) EMBER(h)  (f)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png",
    },
    {
        title: "part-a-171-2",
        gabc: "J(cd) -(fgfe)said:(cd) But(f) that(g) ye(hg) may(if)  (ghi) know(h) that(hij) the(ihg) Son(fg) ",
        groupIndex: 2,
        filename: "./pages/part-a-171.png",
        nextFileName: "./pages/part-a-172.png",
    },
    {
        title: "part-a-172-0",
        gabc: "of(f) man(fe) hath(cd) power(ffe) on(c) earth(ffgf) to(f) forgive(f)  (defe) jiﬁs(dc)  (he(c) saith(d) un-(f)to(fg) the(f) sick(f) of(f) the(e) palsy)(cd)  (d) I(f) say(f) un-(f)t,(d)  thee,(dedc)  (c) take(d)  (d) thy(c)  (df) bed,(ffgf) and(fg) go(h)  (gf) way(fe) iin-(c)éo(d)  thine(f) house,(ef) al(g) -(fe)lu-(d)ia.(d) i(h) e(g)  (f) ——(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-a-172.png",
        nextFileName: "./pages/part-a-173.png",
    },
    {
        title: "part-a-172-1",
        gabc: "B&#39;ut(gd) the(fg) Comforter,(gh)  (g)  (g) which(g) is(h) the(gf) Ho-(g)ly(g) Ghost,(h) whom(i)  the(g) Father(h)  (g) will(hg~) send(hgf) in(g) my(hg) Name,(f) he(f) will(jh) teach(j) you(ij)  all(h) things,(h) and(g) bring(h) all(h) things(g) to(gd) your(hf) re-(h)mem-(g) brance,(g) what-(g)so-(g)ev-(h)er(g) I(h) have(g) said(g) un-(g)to(fe) you,(de) al-(f) le-(fgh)1lu-(g)ia.(g) T(j)  (i)  (j) Y(h) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-172.png",
        nextFileName: "./pages/part-a-173.png",
    },
    {
        title: "part-a-173-0",
        gabc: "T(c) %(dc) love(f) of(g) God(f) is(h) shed(h) Ta-(g)broad(f) in(g) our(fe) hearts(d) by(d)  his(f) Spirit(gf)  (d) which(fg) dwelleth(h)  (g) &#39;in(fe) ks,(dc) al(d) le(efe) lu-(d)ia.(d)  L](h)  (g)  (f) l(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-173.png",
        nextFileName: "./pages/part-a-174.png",
    },
    {
        title: "part-a-173-1",
        gabc: "Let(i)  (f) us(f) bless(f) the(f) Father,(g)  (f) and(f) the(gh) Son,(hg) And(f)  Ho-(g) (fd) =(fg) Ghost.(gf) Let(ff) —(f) bless.(f) V.(c) Praise(hi) him,(h) and(h)  mag-(hg~)fy(g) him(g) for(f) ev(gh) er.(hg) And(f) the(gh) Bo-(gfd)ly(gf~) Ghost.(gf)  be(h) to(h) the(h) Father(hi)  (h) and(h) to(h) Son,(g) and(g) to(h) the(g) Fo-(f)ly(g)  Ghost,(gh) Let(f) us(f) bless.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-173.png",
        nextFileName: "./pages/part-a-174.png",
    },
    {
        title: "part-a-174-0",
        gabc: " (gh)  (gfef)  (d)  (e)  (f)  (gh)  (hg)  (g)  (gh)  (gfef)  (d)  (e)  (f)  k(f)  (gh)  (hg)  (g) |(gh)  (j)  (j)  (h)  (gf)  (h) .(gfe)  (e)  B.(fg) (¢~(gfef) ,(d) &amp;(e) =(f) Lord,(fh) o(hg) T(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png",
    },
    {
        title: "part-a-174-1",
        gabc: "Th;nks,(c)  (cd) God,(dc) The(ed) &#39;un-(fe)to(cd) thee,(d) thanks(fgf) be(gh) un-(h)to(gf) thee(gh)  one(f) =(de) [(dgfghgfgfe) o(d) Tri(d) L(dcffd) o(cd) ty,(d) ](h) I(hgjji) and(h) supreme(f) o,(ghgf)  De(gfe) i-(d)ty,(d) ho(dgfedd) [(c) and(efgfg) one-(de)ly(efe) U-(d)ni-(cd)ty.(d)  For(h) O(g)  (f) n(g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png",
    },
    {
        title: "part-a-174-2",
        gabc: "¥.(dcef) Lo;E[d,(gfddc) for(ffhg) thy(fe) servant(fg)  (fe) heareth.(d)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-a-174.png",
        nextFileName: "./pages/part-a-175.png",
    },
    {
        title: "part-a-175-0",
        gabc: "G(df) to(d)  (d)  (dc) 0(fg) Tri-(f)ni-(gh)ty(h) co-(h)e(hj) -(h)onely(h)  (gf)  De-(g)i-(gh)ty,(h) ere(h) yet(hjkjhi) the(h) worlds(h) be-(hg)gan(h) to(gf) be,(gh) and(f)  now,(ghg) and(f) through(f) e(fgf) ter-(d)ni(cd) ty.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png",
    },
    {
        title: "part-a-175-1",
        gabc: "P(ig~) raise(ff) and(e) un-(f)end-(h)ing(hihg) gloryt(f)  (f) to(f) God(fg) the(f) Father,(fe)  (f) and(dh)  to(fg) the(fe) Son,(e) and(ef) to(f) Ho-(fe) (f) ly(h) Pa-(hi) (h) ra—clete,(h) through(h)  a(gf) ges.(gh) ev-(i) (hg) er-(f)lasting.(f) &quot;(h) w7(g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png",
    },
    {
        title: "part-a-175-2",
        gabc: "L&#39;t(de) praise(g) and(jh) !(ij)  (j) glory(ji) resound(h) from(i) the(j) lips(k) of(ji) all(hihg)  men(g) to(g) the(g) ~(gh) &amp;(g) a(e) j(ed) Sole-(g)be-(hj)got-(ij)ten;(j) and(j) ",
        groupIndex: 2,
        filename: "./pages/part-a-175.png",
        nextFileName: "./pages/part-a-176.png",
    },
    {
        title: "part-a-176-0",
        gabc: "e(h) qual(hj) praise(k) be(ji) gi(hihg) ven(g) for(g) ev-(hi)er(h) to(g) the(gf)  Ho(g) 1y(ghg) e(e) A(e)  (ji)  (hi)  (h)  (gh)  &#39;et(ed) praise(df) to(d) God(dc) the(de) Father,(e)  (e) to(e) the(d) co-(c)equal(d)  (de) Son,(e)  [(ik)  (e) to(g) thee,(g) O(fh) Ho-(hi)ly(h) Spirit,(hg)  (h) resound(ih)  (gg) unceasingly(ef)  (gf)  (de) n.(e)  (c)  n(c) the(df) lips(fe) of(d) all(e) cre-(fg)a-(gh)tion,(g) for(g) ev-(gh)er(f) and(fg)  ev-(e)er.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e)  £(fee) whom(d) are(fh) all(h)  (ih)  (h) through(hik) whom(kj) are(ij) all(hi) things,(h)  in(ih) whom(ihg) are(hg) all(e) things:(fghgefeed) to(df) him(hi) T(hg) glo-(hg)4(eg) for(fhge)  ev(fe) —er.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-176.png",
        nextFileName: "./pages/part-a-177.png",
    },
    {
        title: "part-a-177-0",
        gabc: "art(c)  (f)  (f)  (f) thou,(g) O(gh) Lord,(hg) In(g) the(f) fir-(fgh)ma-(g)mint(fd) of(fg)  heaven.(g)  (f) Blessed.(f)  (f) V.(c) And(h) to(h) be(h) praised,(hi)  (h) and(h) glo-(gh)ri-(g) fied,(g) and(g) mag-(h)ni-(g)fied(g) for(f) ev-(gh)er.(hg) In(g) the(f) fir-(gh) ma-(g)ment.(fd) Glory(h)  (h) be.(h) Blessed.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-177.png",
        nextFileName: "./pages/part-a-178.png",
    },
    {
        title: "part-a-177-1",
        gabc: "Blessed(ff)  (g) be(fhih) Tthe(h) ho-(h)ly(h) Cre-(i)a-(ih)tor(g) and(h)  (g) Governor(gf)  (g) of(ghg)  all(f) things,(f)  (f) the(f) ho(fhi) ly(i) and(hi) un-(j)di-(jh)vid-(ij)ed(ihgf) Tri-(ghih)ni(gf)  ty,(f) both(fg) now(f) and(gi) ev-(hi)er,(i) and(hij) to(ih) endless(gf)  (f) a(gi) ges(hihg)  of(hg) a-(f)ges.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-177.png",
        nextFileName: "./pages/part-a-178.png",
    },
    {
        title: "part-a-178-0",
        gabc: "B(c) e(df) ye(d) therefore(de)  (d) Ther-(fe)ci-(de)ful,(dc) as(f) your(g) Father(h)  (gf) &quot;(g) Wl(d)  is(g) a(g) is(fe) King,(dc) saith(d) the(efe) Lord.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-178.png",
        nextFileName: "./pages/part-a-179.png",
    },
    {
        title: "part-a-178-1",
        gabc: "hee,(efgfe) 0(de) God,(e) the(e) -(g)Father(gh) un-(h)be-(hg)got-(fe)ten;(e) thee,(e) O(gh)  on-(gh)1ly-(hih)be-(gf)got-(ghg)ten(f) Son;(e) thee,(g) 0(hj) Ho-(ji)ly(hg) Spirit,(h)  (g) the(h)  Pa(ik)  (hiji) ra-(hg)clete;(g) ho(hih) ly(h) and(h) di(h) -(gf)-(fhgf)ded(ef) Tri-(gf)ni-(de)v(e)  with(ki~)  (fe) our(fg) whole(gfe) heart(fe) and(ffg)  (edd) confess(c)  (df)  (efee) thee,(d) we(dh) ",
        groupIndex: 1,
        filename: "./pages/part-a-178.png",
        nextFileName: "./pages/part-a-179.png",
    },
    {
        title: "part-a-179-0",
        gabc: "raise(fhgfg) thee(fe) and(idhi) bless(hgfgfe) thee:(e) to(f) thee(fe) be(de) glo-(edc)ry(c)  for(gf) ev-(gh)er(g) and(ffg) ev-(e)er.(e) Sunday(h) after(g)  (h) 1(ih) Pentecost(gfe) =(e) ",
        groupIndex: 0,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png",
    },
    {
        title: "part-a-179-1",
        gabc: "udge(ghj)  (hg) that(i) ye(j) be(k) not(h) judged:(j)  (j) for(k) with(k) what(i) judg-(kk) ment(jijkj) ye(hji) judge,(g) ye(ge) shall(g) be(g) judged,(fe)  (d) saith(f) the(gh) Lord.(g)  (f)  (ji)  (jhg) ",
        groupIndex: 1,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png",
    },
    {
        title: "part-a-179-2",
        gabc: "Christ(f) the(gh) Lord,(h) a(hj) Priest(h) for(gf) ev—er(gh)  (h) af(hjkjhi) ter(h) the(h)  order(h)  (h) of(hg)  (h) Melchisedech,(g)  (f)  (gh) offered(f)  (gh)  (g) bread(fe) and(fgfe) wine.(d) 1(h) —(g)  (ffghgf) ",
        groupIndex: 2,
        filename: "./pages/part-a-179.png",
        nextFileName: "./pages/part-a-180.png",
    },
    {
        title: "part-a-180-0",
        gabc: "he(c) mer—ci-(e) (ef) ful(f) and(f) gra-(fghf)cious(ef) Lord(f) hath(fj) given(ih)  (gf) meat(g)  un-(h)to(i) them(g) that(h) 1](gf) fear(e) him,(f) in(j) re-(i)U](jjihii) brance(j) cf(fh)  I(gi) his(ge) T(c) mervellous(e) W(fg) do-(hf)ings.(f) B(h)  (g) W(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png",
    },
    {
        title: "part-a-180-1",
        gabc: "I(e) vin(e) receive(g)  (hj) the(j) cup(k) of(ji)  (jh) salvation,(ji)  (g) and(h) of-(efg)fer(g)  the(g) sacrifice(h)  (g)  (f) of(g) p(gf) thanksgiving.(e) @(e) &quot;(ji) _-(hi)](h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png",
    },
    {
        title: "part-a-180-2",
        gabc: "the(c)  (cfe)  (df) children(gh)  (gf) Tof(gh) the(gf) Church(e) be(e) like(ghi) the(h) o(h) -(gf) branches,(gh)  (gfe) o(fe) a-(de)7(e) TOCN(dc) ta(gf) ble(ghg) |(fe) the(de) Lord.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-180.png",
        nextFileName: "./pages/part-a-181.png",
    },
    {
        title: "part-a-181-0",
        gabc: "e(d) that(fh) ma-(h)keth(fhiih) Peace(hik) in(j) the(i) Church’s(i)  (hg) bor(hihh)  ders(f) )(f) the(g) Lord,(hge) who(fe) fill-(dfhhi)eth(h) us(h)  (hg) with(d) a(e)  flour(ef) of(e) wheat.(d)  (h)  (i)  (h)  (g)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-a-181.png",
        nextFileName: "./pages/part-a-182.png",
    },
    {
        title: "part-a-181-1",
        gabc: "He(f) fed(gh) them(f) with(g) the(f) fin-(fe)ést(dc) wheat(fg) flour,(i) Al(hij) le(ihgfe)  lu-(fgh)ia,(f) &#39;al(dc) le(hifgiihgfe) lu-(gg)ia.(f) He(f) fed(gh) them.(f) And(f)  with(f) ho-(gh)ney(f) out(f) of(f) the(f) sto-(f)ny(f) rock(g) did(f) he(f) sa(fe) -(dc) fy(fg) them.(i)  (i) R.Al(hij) le(ihgfe) lu-(gh)ia.(f) 7.(c) Glory(f)  (f) be(g) to(f) the(f)  Father(gh)  (f) and(g) to(fe) the(dc) and(c)  (c) to(df) the(f) Ho(ighih) ly(gf) Ghost.(f)  He(f) fed(gh) them.(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-181.png",
        nextFileName: "./pages/part-a-182.png",
    },
    {
        title: "part-a-182-0",
        gabc: "He(f) fed(g) them(f) with(f) the(f) finest(f)  (e) wheat(g) flour,(h) A]-(h)1a.(hg)  lu-(g)ia,(f) a-(d)le-(fg)1lu-(gf)ia.(f) He(f) fed(g) them.(f) ¥.(c) And(f) with(f)  ho-(g)ney(f) out(f) of(f) the(f) sto-(f)ny(f) rock(g) did(f) he(f) sa-(f) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be.(f) He(f) fed(g) them.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png",
    },
    {
        title: "part-a-182-1",
        gabc: "[(d)  (d)  (d)  (c) ](f)  (f)  (gi)  (i) [(ij)  (i)  (i)  (i) )(g)  (i)  (hgf)  (f)  [(f)  (g) L(i) a(h)  (g)  (f) a(g) a(g) a(g)  (h) =(f)  (e)  (d) [](g) B(gc)  .(f) Thou(f)  (f) gavest(d)  (f) them(g) bread(g)  (f) from(g)  (h) heaven,(f)  (gf) LJ(e)  (c)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png",
    },
    {
        title: "part-a-182-2",
        gabc: "0(fghfggf) how(fe) sveet(dc) is(f) thy(gh) Spi(hjhhgf) rit,(gf) O(fhjij) Lord,(ih) who(jiih) ",
        groupIndex: 2,
        filename: "./pages/part-a-182.png",
        nextFileName: "./pages/part-a-183.png",
    },
    {
        title: "part-a-183-0",
        gabc: "that(g) thou(f) mightest(gh)  (f) shew(fe) thy(dc) kindness(fghi)  (h) un-(h)to(gf) thy(hj)  chil-(jhgj)dren,(j) giv-(jk)est(kji) them(j) that(ih) sweetest(jih)  (gf) bread(efddc)  fron(fghjhhgf) heaven,(gf)  (f) fillest(f)  (hj) the(j) hun(jhgj) gry(j) with(kj) good(kjij)  things,(ih) and(hgg) send-(fhjjk)est(j) the(j) rich&#39;(jkjhih) and(hg~) scornful(gf) &#39;(efddc)  emp(fghjh) ty(hg) a(f) —way.(gf) e(h)  (f) |(h) s(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-183.png",
        nextFileName: "./pages/part-a-184.png",
    },
    {
        title: "part-a-183-1",
        gabc: "is-(dhi)dom(h) Thath(ghg) build-(fe)ed(fg) her(fe) house,(d) she(f) hath(e)  mingled(d) [](e) her(f) wine,(ghg) and(g) a(f)  (e)  (d) her(g) ta-(fe)ble,(dc)  al-(d)le(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (gf)  (fgh) ",
        groupIndex: 1,
        filename: "./pages/part-a-183.png",
        nextFileName: "./pages/part-a-184.png",
    },
    {
        title: "part-a-184-0",
        gabc: "T(gi) hou(fc) feddest(ef)  (f) thine(gf) own(ef) peo(hijk) ple(j) with(iji) an(hg) gels’(fe) Foog(f)  N(jk)  and(c) didst(ef) send(f) them(fh) bread(hi) from(h) heaven,(hg)  (f) al-(e)le-(eg)lu-(f)ia,(f)  (h) I(ge)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png",
    },
    {
        title: "part-a-184-1",
        gabc: "Rich(ghjj) is(ijk) the(j) bread(ji) of(hi) Christ,t(hg) and(gh)  (ed) shall(ghj) yield(jj)  roy(i)  (j) al(k) dainties,(j)  (hg) al(ghij) le(hgf) lu(ghgg) ia.(e)  (j)  (h) &#39;(j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png",
    },
    {
        title: "part-a-184-2",
        gabc: "C(fede) -(d)se(dfe) crat—ed(fg) priests(gff) Thf-(dc)fer(de) bread(efe) and(dhi) in-(hgfgfe)cense(e)  un(efgfe) to(de) God,(cd) al(dfgh) le(gfe) 8(de) e(e) e(h)  (g) T(h) T(ji) T(hg) w](e) ",
        groupIndex: 2,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png",
    },
    {
        title: "part-a-184-3",
        gabc: "o(f) him(d) that(fh) o(hg) ver-(fe)com-(hi)etht(h) will(h) I(ik) give(kj) the(ih) hidden(i)  (ij)  manna,(ih)  (h) and(d) a(e) new(efe)  (de) al-(f)le-(e)lu-(d)ia.(d)  (d)  (h)  (i)  (h)  (g)  (h)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-a-184.png",
        nextFileName: "./pages/part-a-185.png",
    },
    {
        title: "part-a-185-0",
        gabc: "He(f) gave(g) them(f) bread(f) from(e) heaven,(g)  (h) Al(h) le(hg) 1lu-(g)ia,(f)  (d)  al(d) -(fg)lu-(gf)ia.(f) He(f) gave(g) them.(f) So(f) man(g) did(f) a(e)  angels’(g)  (g) food.(h) Al-(h)le-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f)  the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho(h) 1y(g) Ghost.(gf)  Fe(f) gave(g) thenm.(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-185.png",
        nextFileName: "./pages/part-a-186.png",
    },
    {
        title: "part-a-185-1",
        gabc: "[~(ik)  (g)  (ghijh) o(gf) Ja(hg) &quot;[e(hijihg) Jmu(hg) §(fg) s(g) @(g)  (gji)  (jk)  (k)   (ik)  (ji)  (hg)  (hj)  (j)  (j)  (h)  (j)  (g)  (gh)  (hg)  (fg)  (g)  k.(f)  (hg)  (hj)  (ji)  (hg)  (hg)  (fg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-185.png",
        nextFileName: "./pages/part-a-186.png",
    },
    {
        title: "part-a-186-0",
        gabc: "I(dh) &#39;am(g)  (gfhih) the(h) liv(hgf) ing(gf) bread,(dfgf) which(hgf) came(g)  (hf) down(h)  from(hdffdfggf)  (hhgf) hea-(gf)ven:(f) if(d) a(f) ny(g) nan(dc) eat(f) of(gh)  this(fh) bread,(h) he(hjigjjh) shall(jk) live(kh) for(kj) ..(igjhhhgfhg)  al(d) lle(dcdffghjihjijh) -(kjigjhhhgfhefgd)g(c) -(gge) (ghddcef) lu-(ed)i,,(d)  the(h)  (g) Hours(f)  (gh) the(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-186.png",
        nextFileName: "./pages/part-a-187.png",
    },
    {
        title: "part-a-186-1",
        gabc: "oy(fee) sa(dfhhih) cred(hj) ban(kjih) quet,T(h) where-(hh)in(f)  (fe) Christ(fh) 1(gfef)  re(f) [~(defgf) e(ed) the(f) me(hij) mo(ih) ry(h) of(f) his(gdfgh) Pas-(ihg) (gf) sim(h)  is(h) re(jk) new(kjijii) ed;(h) the(i) soul(ghi) s(h) grace(hgf) is(ef) fill-(ghgfed)",
        groupIndex: 1,
        filename: "./pages/part-a-186.png",
        nextFileName: "./pages/part-a-187.png",
    },
    {
        title: "part-a-187-0",
        gabc: "is(j)  ed,(ef) and(fg) a(def) pledge(hihfgh) of(gfe) fu(defe) ture(h) glo-(hij)ry(j) is(jk)  be(jjih) stow-(ijii)ed,(h) al-(k)le(kjih) [(ihggfhhfged) &quot;o(fgfe) i(hih) N(f)  (fe)  lu(g)  (defgfe) -(dde)ia.(d) e(h)  (i)  (g) ](h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-187.png",
        nextFileName: "./pages/part-a-188.png",
    },
    {
        title: "part-a-187-1",
        gabc: "cjild(cd)  (ef) Sa-(f) (fg)  (hg) mi-(f)nis-(g)ter-(h)ed(i) un-(j)to(k) the(j) Lord(i)  (j)  (i)  before(i)  (dhg) E-(fg)1i,(g) and(g) the(i) word(i) of(h) the(g) Lord(hihg) was(g)  precious(dfe) .(cd) .(e) his(d) ...(c) sight.(e)  (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-a-187.png",
        nextFileName: "./pages/part-a-188.png",
    },
    {
        title: "part-a-188-0",
        gabc: "A(g) certain(h)  (hi) T(i) made(j) a(hg) great(hi) wedwne(g) supper,(g) and(gh) bade(iih~) ma-(h)ny;(g)  and(g) sent(gij) his(i) servants(k)  (j) at(hj) supper(i)  (hg) time(g) to(g) say(h) to(ij)  them(h) that(h) were(i) bidden,(g)  (g) Come;(ghiji) for(hg) all(hhj) things(h) are(g)  now(hi) ready,(h) .(gf) al-(g)le-(gf)lu-(e)ia.(e) BENEDICTUS(j) T(ji) 1(hih) T¢(gfe) a](e) ",
        groupIndex: 0,
        filename: "./pages/part-a-188.png",
        nextFileName: "./pages/part-a-189.png",
    },
    {
        title: "part-a-188-1",
        gabc: "F(fg) ather(g) Abraham,(h)  (gf) e(g) have(g) mercy(hgf)  (g) on(gh) me,(f) and(g) send(hj) La-(jk)~za-(ji) rus,(j) that(j) he(j) may(j) dip(jig) the(j) tip(kj~) of(j) his(j) finger(ji)  (h) 11(ij) ",
        groupIndex: 1,
        filename: "./pages/part-a-188.png",
        nextFileName: "./pages/part-a-189.png",
    },
    {
        title: "part-a-189-0",
        gabc: "va(hh) ter,(g) and(dg) cool(f) my(gh) tongue.(g) am(j) the(i)  (j) living(h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-189.png",
        nextFileName: "./pages/part-a-190.png",
    },
    {
        title: "part-a-189-1",
        gabc: "Go(h) out(g) quicklyT(h)  (g) in-(ef)to(fg) the(ef) streets(d) and(c) lanes(ef) of(g) the(fe)  (d)  ci-(d)ty,(d) and(hihh) compel(hg)  (j) them(k) to(j) come(ih) in;(h) the(k) and(j) the(j)  naimed,(ji)  (g) the(h) halt(jk) and(i) the(ji) blind,(h) that(hgg) my(f) house(ghg) may(ef)  be(gf) filled,(df)  (ef) al-(g)le-(fe)lu-(d)ia.(d) &quot;(h) ml—l(g)  (f) &amp;(g) =(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-189.png",
        nextFileName: "./pages/part-a-190.png",
    },
    {
        title: "part-a-190-0",
        gabc: "[(eh) re-(fd)e(e) ber(e) Tthat(e) thou(e) in(g) e(h) lifetime(i)  (i) re~Ceiv_(i) ](i)  edst(h) thy(f) good(h) things,(h) and(hg) likewise(hi)  (h) La-(f)za(h) ryg(g)  e(e) vil(de) things.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-190.png",
        nextFileName: "./pages/part-a-191.png",
    },
    {
        title: "part-a-190-1",
        gabc: "nd(d) all(ef) Is-(g)ra-(g)el(f) knew(d) Tfrom(fh) Dan(hghih) e-(h)ven(g) to(f) Beer-(f) she-(f)ba,(fgfefeded) that(cd) Sa(f) -(f)—el(fd) was(f) es-(gh)tab-(g)lished(fg)  (g)  to(g) be(g) a(e) prophet(gh)  (fe) of(d) the(cd) Lord.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-190.png",
        nextFileName: "./pages/part-a-191.png",
    },
    {
        title: "part-a-191-0",
        gabc: "So(e) Da-(eh)vid(f) prevailedto-(e) (f) v(e) ver(f)  (e) the(d) )(ef) Philistine(f) e(e) with(g) a(h)  sling(i) and(h) a(f) stone,(h) in(g) the(e) Name(gh) of(f) the(f) Lord.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-191.png",
        nextFileName: "./pages/part-a-192.png",
    },
    {
        title: "part-a-191-1",
        gabc: "e(d) mbuntains(d) M(dfddc) of(fg) Gil(f) -(gh)a,(hfgfd) let(d) .(c) be(d) .(dg) neither(gh)  dew(f)  (ed) rain(f)  (ed) you;(cd)  (d) there(d)  (d)  (efd) the(dg) shield(fg) of(h)  the(g) mighty(f)  (fe) is(d) vilely(e)  (cd) cast(f) a-(gf)way,(f) the(f) shield(f)  (dc)  Saul,(efd) d5(dc) though(cd) he(d) had(f) not(g) been(f) a-(d) (fe) nointed(d) with(cd) oil.(d)  How(hghfefd) are(c) the(d) mighty(d)  (cd) fallen(fg)  (f) in(f) tEe(fe) ildst(cd) of(df) the(efe)  battle!(d)  (d) Jon-(fgf)a-(gh)than(hfgfd) was(cd) slain(f) up-(g)on(f) h.y(dc) high(ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-191.png",
        nextFileName: "./pages/part-a-192.png",
    },
    {
        title: "part-a-192-0",
        gabc: "places!(d)  (d) Saul(hjih) and(hg) Jon-(j)a-(k)than(jih) were(h) love(jig) ly(h)  (fgfd)  .(c)  (d) exceeding(f)  (g) pleasant(f)  (d) &#39;in(de) their(cd) .(d) and(dde) in(c)  their(d) death(ffgf) they(fghg) were(fedc) not(d) di(efe) vided.(d)  (d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png",
    },
    {
        title: "part-a-192-1",
        gabc: "0(d) ord,(dc) I(e) beseech(f)  (gff) thee,(dc) Tdo(f) a(gh) way(hghih) the(h) in-(g)i-(f) qui-(fg)ty(fe) of(g) thy(fe) ser-(df).(fc) for(d) a(c) have(d) done(ef) ve-(gh)ry(fe)  foolishly.(ik)  (d)  (d)  (d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png",
    },
    {
        title: "part-a-192-2",
        gabc: "a(ghggf) dok(gh) the(hji) priestf(g) and(g) Na(ghgf) than(g) the(h) prophet(jk)  (kj) anoin-(jk) (k)  ted(i) So-(j)lo-(ji)mon(hg) king(h) in(f) Gi-(hji)hon:(g) and(g) the(g) people(g)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-192.png",
        nextFileName: "./pages/part-a-193.png",
    },
    {
        title: "part-a-193-0",
        gabc: "came(gh) up(g) re-(g)joic-(ghgf)ing(gh) and(gf) said,(f) Let(fg) the(gh) king(ji) live(hg) for(hih)  ev-(g)er.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png",
    },
    {
        title: "part-a-193-1",
        gabc: "T(c) hou(ehg) hast(hi) heard,(iji) 0(hg) Lord,(hi) the(j) I(i) supplication(h)  (i) of(hg)  (f) thy(gf)  &quot;(e) servant,(e) that(e) I(f) might(ed) build(ef) a(f) temple(hi)  (hghih) to(f) thy(hg) Name.(e)  [(i)  (j) BEFORE(i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png",
    },
    {
        title: "part-a-193-2",
        gabc: "hen(g) the(g) Lord(gfd) took(e) up(f) E-(gh)li-(g)jaht(g) by(g) a(g) whirlwind(h)  (f) in-(h)to(ji)  CHN(g) heaven,(g) E-(f)li-(hj)sha(ji) cri-(jh)ed,(ih) saying:(g)  (g) My(fh) fa-(fe)ther,(d) the(d)  chariot(d) 5(c) of(d) Is-(fh)ra-(h)el(g) and(h) the(g) horses(hj)  (ih) thereof.(gh)  (g) S(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-193.png",
        nextFileName: "./pages/part-a-194.png",
    },
    {
        title: "part-a-194-0",
        gabc: "e(f) ho(gh) ash(g) Tdid(f) that(f) which(d) |f(dc) ¥(c) W(c) the(d) sight(f) e(fg)  the(f) Lord(f) a1l(fd) his(ffh) days,(ghg) wherein(de)  (f) Je(e) ho(d) ia(dedc) da(c) the(fg)  priest(h) in-(g)struc-(hig)ted(gf) him.(f) I(h) B(f)  (gh)  (g) R(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png",
    },
    {
        title: "part-a-194-1",
        gabc: "—(gi) I(d) beseech(d)  (fh) thee,(hhi) G(h)  (h) re-(h) (h) member(ik) now(jih) how(h) I(f) have(h)  walked(i)  (h) before(g)  (h) thee(fe) 1in(fe) truth(de) and(d) with(e) a(g) per-(gfe)fect(fe)  P(d) and(d) have(fg)  (ge) done(g) that(fe) which(fg) is(h) good(gf) in(fe~) thy(ed) sight(d)  a(h)  (i)  (g) BEFORE(h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png",
    },
    {
        title: "part-a-194-2",
        gabc: "W(gi) TR(e) isdom(f) hath(hi) N(i) builded(h) her(hj) RS,(i) she(i) hath(f) hewn(fi) out(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-194.png",
        nextFileName: "./pages/part-a-195.png",
    },
    {
        title: "part-a-195-0",
        gabc: "her(h) se-(f)ven(e) pil-(fgh)lars:(e) she(f) hath(e) sub-(f)du-(h)ed(h) the(h) nations,(hj)  (i)  and(h) in(i) her(j) own(jk) might(i) hath(g) she(i) trodden(j)  (ih) un(fh) der(e)  (j)  the(f) necks(g) of(ef) the(gh) proud(ihf) and(fg) lofty.(e)  (e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png",
    },
    {
        title: "part-a-195-1",
        gabc: "I(h) dwell(hghih) in(h) high(fh) places,(hg)  (e) and(e) my(g) throne(ef) is(f) in(f) a(i)  cloudy(jk)  cloudy(hg)  (e) pillar.(f)  (e) I“I_I(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png",
    },
    {
        title: "part-a-195-2",
        gabc: "wis-(c) (dg)  (fh) dom(g)  (fe) from(d)  (f) the(fgh) Lord,(ihghih) and(f) is(h) with(j) him(g)  for(hg) ev(ffg) er;(fgfed) and(d) is(e) before(f)  (gh) the(h) ages.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-a-195.png",
        nextFileName: "./pages/part-a-196.png",
    },
    {
        title: "part-a-196-0",
        gabc: "W(ik) .(c) dom(d) .(fg) [(g) a(g) aloud(h) .(h) the(j) broad(hg~) places:(gf) N(f) Who-(f)so_(h)  -(jk)ev—er(jih) lov-(kji)eth(hg) wisdom,(hi)  (hg) let(g) him(gh) turn(fe) in(df) &quot;(fe) -(dc) and(dc) he(e) shall(f) find(gh) her;(g) and(g) when(h) he(g) hath(fd) found(f) hel(efddc)  hap-(cd)|(e) is(d) he(c) if(d) he(f) hold(gh) her(h) fast.(g)  (g)  (f)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png",
    },
    {
        title: "part-a-196-1",
        gabc: "](efddc) son,(fg) .(g) thy(f) ](g) father’s(gh) a(g) commandment,(f) .(f) for(f)  sake(fhihg) not(hg) the(i) law(ihf) of(g) thy(ghg) mother:(f)  (f) bind(g) them(f) contin-(f) (d)  up(de)  (c)  (j)  (gf) on(g) thine(ghg) heart.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png",
    },
    {
        title: "part-a-196-2",
        gabc: "ow(d) when(cd) Job(f) had(hg~) heard(h) the(h) words(hj) of(h) the(h) messengers:(h)  (g)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-196.png",
        nextFileName: "./pages/part-a-197.png",
    },
    {
        title: "part-a-197-0",
        gabc: "he(h) en-(g)dur-(h)ed(g) with(ef) patience,(g)  (fe) saying,(d)  (d) Shall(d) we(fg) re-(g) ceive(gh) good(g) at(g) the(gf) Lord&#39;s(gh) hand,(ffg) and(fh) shall(i) we(h) not(hi) re-(h) ceive(gf) e-(g)vil(ghg) al-(f)so?(f) In(d) all(gf) this(g) Job(g) sinned(h)  (g) not(g)  with(gf) his(ghg) lips,(f) nei(ifhi) ther(h) charged(h)  (g) God(ef) foolishly.(g)  (fe)  (d)  BEFORE(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png",
    },
    {
        title: "part-a-197-1",
        gabc: "I™(cd) all(dhi) this(hhj) Job(hg) sinned(h)  (g) not(ef) with(g)  (fe) lips,(d) nei-(fed) ther(i)  (ef) charged(gh)  (ghg) God(ef) foolishly.(g)  (fe)  (d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png",
    },
    {
        title: "part-a-197-2",
        gabc: "Re—mem-(d) (cdef) ber(f)  (f) Lord,(fe) dur(dc) of(ded) fences,(c)  (c) nor(c) the(d) of-(e)fen-(ef)",
        groupIndex: 2,
        filename: "./pages/part-a-197.png",
        nextFileName: "./pages/part-a-198.png",
    },
    {
        title: "part-a-198-0",
        gabc: "ces(ed) a(e) our(f) fore(ghgf) ](e) [(e) neither(e)  (gh) take(h) tho,(gf) Ve(fg)  geance(efggf) of(dc) our(de) sins.(e) l_-(h)o(g)  (h)  (ji) I(hg)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png",
    },
    {
        title: "part-a-198-1",
        gabc: "A(e) -(f)na-(g)1i,(gf) Lord(ed) God(g) Almighty,(jh)  (j)  (j) great(ijk) and(j) won~der-(hj) (hig)  ful,(g) who(g) hast(h) gi-(i)ven(j) salvation(hg)  (hi)  (i) by(e) the(f) hand(g) of(ge) %(fe)  woman;(d)  (d) we(de)  (g) beseech(ge)  (gi) thee,(h) the(g) pra_yers(ef) of(g) thy(ghg)  servants.(e)  (e)  (ji)  (hi)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png",
    },
    {
        title: "part-a-198-2",
        gabc: "A(cg) -(gj)na-(hg)i,(h) Lord(gf) Ged(g) =(h) Almighty,(hk)  (jkj) great(j) and(jk) won-(h)der-(fg) ven(j)  ful,(g) who(gji) hast(j) gi-(k)ven(k) salvation(k)  (ji)  (h) by(k) the(ji) hand(gh) of(hi) &amp;(h) ",
        groupIndex: 2,
        filename: "./pages/part-a-198.png",
        nextFileName: "./pages/part-a-199.png",
    },
    {
        title: "part-a-199-0",
        gabc: "woman;(g)  (g) hear,(g) we(h)  (g) beseech(eg) thee,(gfed) the(d) prayers(ef) of(gh) thy(h)  servants.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png",
    },
    {
        title: "part-a-199-1",
        gabc: "Lord,(dc)  (d) the(f) King(fg)  (d)  (ef)  (d) tée(d)  (dc) whole(fhg) world(fgf) 1is(ef)  in(g) thy(fe) power,(d)  (d) and(d) there(d) is(c) no(dgfgf) man(d) that(ef) can(hg)  gain-(fe)say(d) thee.(d)  (h) T(h)  (g)  (f) g(gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png",
    },
    {
        title: "part-a-199-2",
        gabc: "he(e) Lord:(eh)  (f) your(ed)  (f) hearts(e) Tin(e) his(e) law(f) and(e) com-(d) mandments;(ef)  (d) and(e) may(d) the(f) Lord(h) our(i) God(hghih) send(hf) you(g)  o(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-199.png",
        nextFileName: "./pages/part-a-200.png",
    },
    {
        title: "part-a-200-0",
        gabc: "he(gd) sun(fgh)  (g) the(g)  (hg)  (gd) shields(fgh) of(fe) gold,(def) and(f) the(h)  mountains(kj)  (j) glistered(ji)  (h)  (ji) therewith:(hg) ](g) and(ggh) yet(f) the(hij) forceg(j)  (ih)  of(jk) the(hg) heathen(fg)  (g) were(g) discom-(h)fi-(ji) (hg) ted.(g) —I—|(j)  (i)  (j) =(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png",
    },
    {
        title: "part-a-200-1",
        gabc: "Bl:t(c)  (cd)  (d) mourned(cd)  (f)  (f) Ju—d!g,(de)  (dc) and(f) made(gh) great(h) la-(i)men-(h) ta-(h)tion(gf) for(g) him,(ghg) saying:(f)  (f) How(f)  (hghi) art(h) thou(gf) fallen,(gf)  (d)  valiant(fg)  (h) in(dfg) battle,(ghi) e(h) that(d) didst(e) de(f) liv(gfghg) er(g) the(g)  peo-(fec)ple(d) of(c) the(ef) Lord.(d) s(h)  (g) e(f)  (g) &amp;(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png",
    },
    {
        title: "part-a-200-2",
        gabc: "God(d) .(dc) gracious(f) L](g) un-(f)to(gh) you,(ih~gg) T(j) and(ef) D(g) your(fe) prayers,(d) ",
        groupIndex: 2,
        filename: "./pages/part-a-200.png",
        nextFileName: "./pages/part-a-201.png",
    },
    {
        title: "part-a-201-0",
        gabc: "and(d)  (fe) at(de) one(d) a,(c) .(c) and(f) the(g) Lord(h) our(hi) God(h)  never(h)  (g) forsake(fg)  (gf) you(d) 1in(fe) time(g) of(fe) trouble.(d)  (d) R(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png",
    },
    {
        title: "part-a-201-1",
        gabc: "T(hig~) hine(fhghg) is(h) the(f) power,(gf) O(ef) Lord,T(f) and(ef) thine(gij) is(hg) the(f) king-(hg) dom;(hgi)  (e) thou(h) art(j) high(i) a-(ji)bove(i) all(ih) nations:(f)  (f) give(h) peace(hhg)  in(hig~)  (f) our(gfef) time,(fec) O(ef) Lord(hg) our(eg) God.(f) |(h)  (gf)  (hg) &amp;(e) =(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png",
    },
    {
        title: "part-a-201-2",
        gabc: "Hine(dc) is(f) the(g) power,(f) O(gh) Lord,(h) Tand(g) thine(fe) is(fg) the(f) king-(d) dom:(d) thou(hh) art(h) high(h) a-(g)bove(h) all(ji) nations:(hi)  (h) give(hgg) peace(ef)  in(g) our(fe) time,(dc) O(ef) s(g) our(fe) 9w(d) &quot;~(h) -(g)=(f) d(gh) 1(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-201.png",
        nextFileName: "./pages/part-a-202.png",
    },
    {
        title: "part-a-202-0",
        gabc: "I(ch) saw(h) the(g) Lord(hj)  (hi)  (h) a(h)  (g) up(ef) on(g) .(fe) ;(d)  high(hihh) and(g) lifted(hj)  (ji) up,(hhg) and(hk) his(ji) train(hhg) filled(hk)  (i) the(ji)  temple:(h)  (h) the(hgg) whole(f)  (ghg) earth(ghg) was(ffe) full(d) of(e) the(f) ma(gi) jes-(hg) ty(hg) of(fe) his(fgf) .(d) e(d) W(h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-202.png",
        nextFileName: "./pages/part-a-203.png",
    },
    {
        title: "part-a-202-1",
        gabc: "Ble-(ik) (dc) hold,(defe) 0(de) Lérd,(ddc) how(fhi) the(h) ci-(hg)ty(fg) 1is(g) a(hg) become(fef) de-(fe)so-(de) llte(dc) that(c) was(d) full(f) of(e) precious(fg)  (f) treasure;(d)  (d) s(cd) sit-(dhi) teth(hg) o(fe) T(fg) ful(g) that(hihgg)  (c) was(d) great(f) a-(e)mong(gf~) the(f) nations:(d) NS(d)  none(ff) can(dde) comfort(c)  (df) her(ffgf) but(f) on-(gh)ly(h) thou,(ghgffedc) 0(dg) our(fe)  God.(d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-202.png",
        nextFileName: "./pages/part-a-203.png",
    },
    {
        title: "part-a-203-0",
        gabc: "us,TO(cd)  (dhi)  (h)  (h)  (h) Lord,(hghihgg) with(fg) thine(hg) im-(ef) (f) pregnable(g)  (fe)  wall:(d) and(f) with(c) the(d) arms(ffg) of(f) thy(fh) pow-(hg)er(f) de-(fh)fend(hg)  (f)  us(f) al-(f)way,(ef) O(g) our(fe) God.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-203.png",
        nextFileName: "./pages/part-a-204.png",
    },
    {
        title: "part-a-203-1",
        gabc: "hou(d) n(c)  (d)  (f)  (e) .:.—F:J(dc) throne(d) of(e) the(f) heavens(d) :(dc) and(f)  beholdest(fgh)  (hi)  (h) the(gf) depths,(ghghih) O(hg)  (fedc) King(e) of(ef) kings;(d)  that(h) weighest(hg)  (hj) the(j) mountains(j)  (hg) and(h) holdest(hg)  (hj) the(ji) earth(hg)  in(g) the(h) hollow(jk)  (ih) of(i) thine(ij) hand:(h) ](hg) give(ef) 0(gh) Lord,(fe)  Un-(d)to(ffe) s,(dc) in(c) the(d) midst(ef) of(gh) our(fe) groanings.(d)  (d) —(h)  (g) [(f)  (gf) 5(d) ",
        groupIndex: 1,
        filename: "./pages/part-a-203.png",
        nextFileName: "./pages/part-a-204.png",
    },
    {
        title: "part-a-204-0",
        gabc: "I.(c) have(d) set(fe)  (de)  (d) thy(dc)  (d)  (fe)  (dfddc) 0(fh) Je-(g)ry-(fe) sa(fgf) lem,(d) which(f) shall(gh) nev-(h)er(gf) hold(gh) their(fe) peace(dcec) e(c)  nor(ik)  (df) night,(ffgf) praising(f)  (f) the(fgh) Name(ed) of(e) the(efe) Lord.(d) LT(hgfg)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-a-204.png",
        nextFileName: "./pages/part-a-205.png",
    },
    {
        title: "part-a-204-1",
        gabc: "hat(efdcd) wo(ffg) T(g) having(f) ten(g) pieces(gf)  (g) of(gh) silver,(f)  (f) if(f)  she(f) lose(fhihg) one(ih) piece,(gf) doth(f) not(f) light(g) a(f) can(fhihg) dle,(hg) and(hg~)  sweep(ff) the(df) house,(c)  sweep(k)  (ff) the(df) house,(c) and(d) seek(dc~) di(c) -(d)gent-(ffg)ly(f) un-(f)til(h)  she(gh) find(f) it.(f)  (h)  (f) &#39;(gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-204.png",
        nextFileName: "./pages/part-a-205.png",
    },
    {
        title: "part-a-205-0",
        gabc: "we(dhi)  (h)  (h) have(h) toiled(h)  (h) all(h) the(h) night,(hghihgg) and(fg) have(hf)  ta-(g)ken(fe) nothing:(d)  (d) nevertheless,(f)  (e)  (d)  (e) at(f) thy(gh) word(ghg) T(e) will(f)  let(ik)  (eg) down(gh) the(fe) net.(d) &quot;%(h)  (g) a4(f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-205.png",
        nextFileName: "./pages/part-a-206.png",
    },
    {
        title: "part-a-205-1",
        gabc: "£(defe) thou(ed) bring(d) thy(df) gift(fe) to(d) the(f) al(defd) tar,(d) and(cd) there(f)  re-(g) (f) memberest(g)  (hih) that(h) thy(gf) brother(g)  (d) hath(gh) ought(f) a-(ef)gainst(dfgd)  thee;(d) leave(hij) there(ji) thy(hj) gift(ji) before(hg)  (h) the(j) al(hijh) tar,(h) ",
        groupIndex: 1,
        filename: "./pages/part-a-205.png",
        nextFileName: "./pages/part-a-206.png",
    },
    {
        title: "part-a-206-0",
        gabc: "and(fhgg) go(fe) thy(fg) way;(g) first(hghg) be(ef) re-(g)con-(f)ci-(fe)led(d) to(f) thy(de)  .(dc)  (c) and(dc~) then(fdf) come(fhg) and(e) of-(g)fer(h) thy(fe) &quot;(dc) al(d)  le(efe) -(d)ia.(d) SUNDAY(h)  (g) AFTER(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png",
    },
    {
        title: "part-a-206-1",
        gabc: "I(g) have(ig) compassion(ij)  (i)  (i) Ton(i) the(i) mul-(iji):(hi) tude,(i) because(i)  (i) they(i)  have(i) now(i) been(ij) with(i) me(i) three(ij) days,(i) and(h) have(fg) nothing(hi)  (h)  to(h) -(e)and(e) if(f) I(h) send(h) them(h) a-(h)way(gf) =(hi) a(i) they(j)  will(i) faint(h) by(h) the(g) way,(ef) a(g) le-(f)lu(e) 1ia.(e)  (i)  (j)  (i)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png",
    },
    {
        title: "part-a-206-2",
        gabc: "D(c) good(cd) tree(dfddc) T(f) cannot(g) bring(ed) forth(efe) e(d) —vil(dc) -(d)",
        groupIndex: 2,
        filename: "./pages/part-a-206.png",
        nextFileName: "./pages/part-a-207.png",
    },
    {
        title: "part-a-207-0",
        gabc: "neither(f)  (g) can(h) a(g) corrupt(f)  (hg~) tree(gfe) bring(g) forth(fe) good(d) fruit:(d)  ev-(h)ery(j) tree(h) that(g) bringeth(e)  (f) not(h) forth(fe) good(d) fruit(d) is(f)  hewn(de) down,(c) and(e) cast(ge) in-(gh)to(f) the(e) fire,(def) al-(g)le-(fe)lu-(d)ia.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-207.png",
        nextFileName: "./pages/part-a-208.png",
    },
    {
        title: "part-a-207-1",
        gabc: "W(c) hat(fcdf) shall(f) I(fg) do??(e) for(e) my(f) lord(gg) taketh(fed)  (d) &#39;a-(fd)way(f) from(g)  me(e) the(h) stew-(gf)ard-(ghgf)ship:(e) I(dhi) can-(hgf)not(ghgf) dig;(e) to(f) beg(g)  (gf)  s(e) v(fe) a-(d)shamed:(d) &#39;I(fd) -(f)re-(f)sol-(fg)ved(f) what(f) to(de) do,(e) that,(dhi)  ‘when(h) I(h) am(gf) put(fghgf) out(e) of(e) the(dc)  (de) stewardship,(de) 8:(c) they(ffed) may(e)  receive(f) .(hg) me(g) in-(g)8(gf) their(ghgf) houses.(e)  (e) ol(h) el(g)  (h) R(ih) e(gfe) ](e) ",
        groupIndex: 1,
        filename: "./pages/part-a-207.png",
        nextFileName: "./pages/part-a-208.png",
    },
    {
        title: "part-a-208-0",
        gabc: "ut(eh) the(f)  (f) fatherTsaid(e)  (f) to(f) his(d) servants,(ef)  (e) Bring(igj) forg,(ji)  the(gi)  (i) best(hih) robe(he) and(f) put(h) it(gf) on(h) him;(e) and(hg~) put(i) g(h) Ting(g)  on(f) his(fh) hand,(gh) and(hi) shoes(iie) on(fhf) his(gf) feet,(e) al(fg) ](f)  lu-(e)1ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-208.png",
        nextFileName: "./pages/part-a-209.png",
    },
    {
        title: "part-a-208-1",
        gabc: "it(fgh)  (g) not(g) writ;ten,Th‘:ine(fef)  (def)  (dc) house(fg) shall(h) be(j) call-(jih)ed(h)  an(kj) house(ji) of(hg) T(h) prayer(g) for(gh) -(ih)S(g) A(g) but(jk) ye(ji) have(hg)  made(hg) it(gh) a(e) den(fg) of(f) roebbers.(edc)  (c) And(c) he(cgfgh) was(g) daily(gh)  (h)  with(ghgfg) )(gf) teach-(fhihj)ing(hg) in(h) the(hih) temple.(g)  (g) ——(j)  (i)  (j) 1(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-a-208.png",
        nextFileName: "./pages/part-a-209.png",
    },
    {
        title: "part-a-209-0",
        gabc: "his(gj) man(h) went(fg) down(g) Teo(h) his(j) house(jkjjg) jus-(k)ti-(j)fi-(ji)ed(hg)  rather(h)  (gf) than(h) the(h) other:(g)  (g) for(f) every(h)  (j) one(j)  (kj) that(h) ex-(j) -(ki~)alteth(ji)  (hg) himself(h)  (h) shall(e) be(f) a-(g)baséd;(ef)  (ed) and(hg) he(j) that(j)  humbleth(h)  (g) _(gh) himself(ghg) shall(e) be_(hg) ex-(fg) (g) alted.(g) 1(j)  (i)  (j)  (h) W](g) ",
        groupIndex: 0,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png",
    },
    {
        title: "part-a-209-1",
        gabc: "H(c) e(d) hath(fh) done(h) all(hg) things(fe) well:T(hih) he(h) maketh(ik)  (k) both(k) the(ih)  (i)  deaf(hij) to(ih) hear,(h) and(efgf) the(e) dumb(f) 4(ef) speak.(d) I(h)  (i)  (g)  (h)  (fh)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png",
    },
    {
        title: "part-a-209-2",
        gabc: "=(gd) certain(f)  (f) man(ghg) went(fgh) down(h) from(g) Je-(f)ru-(f)sa-(gh)lem(g) to(dfd)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-209.png",
        nextFileName: "./pages/part-a-210.png",
    },
    {
        title: "part-a-210-0",
        gabc: "Je-(f)e(e) cho,(defec) and(f) fell(g) a-(h)mong(ji) thieves,(hg) which(j) _(k) strippeg(i)  him(j) of(h) his(gh) raiment,(f)  (f) and(g) wounded(f)  (g) him,(h) and(j) departed,(ki)  (j)  (hg)  leaving(gf)  (d) him(ef) half(gh) dead.(g)  (j) [(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png",
    },
    {
        title: "part-a-210-1",
        gabc: "h&#39;(ik)  (cfd~)  (fe)  (dc) them,T(fgf) when(ef) he(fgh) saw(hg)  (hihgg) that(f) he(gh) was(fe)  healed,(ik)  (d)  (d) turned(gh)  (ef) back,(d) and(e) with(c) a(df) loud(ff) voice(f) glo(gh)  ri-(ik) (g) fi-(f)](e) -(dc)al(d) ..(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 1,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png",
    },
    {
        title: "part-a-210-2",
        gabc: "eek(dh) ye(hij) firstf(h) the(h) kingdom(h)  (h) of(h) God,(hg)  (ihgg) and(fg) his(hf) right-(gh) eousness;(fe)  (d) and(g) all(h) these(dgf) things(f) shall(e) be(f) added(g)  (fe) ",
        groupIndex: 2,
        filename: "./pages/part-a-210.png",
        nextFileName: "./pages/part-a-211.png",
    },
    {
        title: "part-a-211-0",
        gabc: "un-(d)to(fe) you,(dc) al-(d)le(efe) lu-(d)ia,(d) [(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png",
    },
    {
        title: "part-a-211-1",
        gabc: "A(f) great(ef) prophet(hi)  (i) is(i) ri-(h)sen(i) up(j) a-(h)mong(i) us:(i)  (i) and(gihg)  (f)  God(fe) hath(fe) vi-(d)si-(e)ted(f) his(h) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png",
    },
    {
        title: "part-a-211-2",
        gabc: "[](e) thou(g) art(h) bidden(ij)  (i) to(g) a(h) wedding,(ij)  (i) sit(ji~) down(ji) in(h) the(f)  (g)  lowest(gh)  (f) place;(e) that(cef) he(d) that(f) bade(h) thee(h) maysay(h)  (gf) un-(h)to(hi)  (i)  thee,(i) Friend,(jij) go(h) up(f) higher;(hi)  (g) then(j) shalt(i) thou(hg) have(f)  —(hihg) el(ef) in(e) the(f) presence(d) gV(f) of(h) them(h) that(g) sit(g) at(f) meat(h)  with(h) thee,(efh) al(ih) le(f) -(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-211.png",
        nextFileName: "./pages/part-a-212.png",
    },
    {
        title: "part-a-212-0",
        gabc: "W(cc) hat(ff) think(cdf) ye(ffe) of(de) Ch(dc) whose(cdf) son(f) is(gh) he?(gfe)  say(hg) un-(h)to(gf) him,(ghg) The(gf) son(g) of(gh) Da-(gfe)vid.(e) Jesus(e)  (f) sait],(ggh)  n-(de)to(f) them,(d)  (ec) How(dhi) then(h) doth(h) Da-(gf)vid(g) in(gh) spirit(gfe)  (e) cail\\(ef)  him(hg) }(e)  (fd) -(d) (ec) ing,(efe) The(f) Lord(fedc) said(d) un-(ef)to(f) -(h)Lord,(g)  Sit(h) thou(gf) on(g) my(ghg) right(e) hand.(e) T(h) et(g)  (h)  (ih) 7(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-212.png",
        nextFileName: "./pages/part-a-213.png",
    },
    {
        title: "part-a-212-1",
        gabc: "T(cc)  (c) he(cd) sick(d) 5(c) the(d) palsy&#39;r(ed)  (e) therefore(ef) a(e) took(d) ](e) his(d) bed(d)  whereon(cd) e(e) he(de) .-(c)glo-(cd)ri-(ef)fy-(gf)ing(de) God:(e) and(e) all(g) the(gh) peo-(hi) ple,(h) when(h) they(gf) saw(gf) bt(ef) gave(f) praise(gfd) [}(c) to(de) God.(e)  (h)  (g) =0(h)  (ji)  (hg)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-212.png",
        nextFileName: "./pages/part-a-213.png",
    },
    {
        title: "part-a-213-0",
        gabc: "nd(g) when(g) the(h) king(g) came(hjh) inTto(iji)  (ij) see(k) the(j) guests,(hg) he(gh)  saw(ji) there(g) a.(hi) man(h) which(e) had(gh) not(gf) on(h) &amp;(fg) wedding(g)  (gf) gar-(e) ment:(ik)  (e) and(d) he(d) said(ef) un-(gh)to(g) him,(g) Friend,(hjj) how(j) camest(h)  (g)  thou(ik)  (gh) in(g) hither(efg)  (g) not(g)  (fd) hav-(efg)ing(h) a(g) wedding(g)  (gf) garment?(e)  (e)   (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-213.png",
        nextFileName: "./pages/part-a-214.png",
    },
    {
        title: "part-a-213-1",
        gabc: "D(g) the(g) fa-(ggj)ther(hg) knew(hj) tthat(j) it(i) was(j) at(k) the(ji) same(hg) hour(hg)  (f)  ‘(ki~) in(f) the(h) which(ghji) Je(hg~hihg) sus(hg) said,(h) Thy(ef) son(ggh) &amp;(e) liveth:(e) and(h)  (g)  himself(h)  (j) be-(i)liev-(ghihg)ed,(hg) and(e) his(f) whole(ghg) house.(e)  (e) l(j)  (h)  (j) A(fi) ",
        groupIndex: 1,
        filename: "./pages/part-a-213.png",
        nextFileName: "./pages/part-a-214.png",
    },
    {
        title: "part-a-214-0",
        gabc: "bou(f) w1c£.(ffddc) ed(dc) ser-(fghf)vant,(f) T&#39;1(f) forgave(f)  (gi) thee(ih) al}](fg) that(gh)  debt,(f) e(g) because(fd) thou(f) desiredst(ef)  (g) m(fg) me:(e) [(c) shouldest(ed~) not(e) th:)u(ef)  al-(e)so(e) have.had(e)  (e) -(e) (f)  (e) on(d) a(c) fellow-(d) (de) s.ervant,,(c)  (c) o(f)  ven(f) as(f) I(egi) had(hgi) pi-(h)ty(g) on(h) thee,(gf) al-(g)le-(gh)lu-(f)ia.(f)  (h) |(f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-214.png",
        nextFileName: "./pages/part-a-215.png",
    },
    {
        title: "part-a-214-1",
        gabc: ".(c) en—der(d) thereforet(dhi)  (h) un-(h)to(g) Caesar(h)  (g) the(f) things(g) that(f) are(gh)  Cae-(fed)sar’s:(ed) and(d) un-(ef)to(d) God(f) the(f) things(g) that-(f)are(fe) God’(dc)  al(d) -(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-214.png",
        nextFileName: "./pages/part-a-215.png",
    },
    {
        title: "part-a-215-0",
        gabc: "ut(d) Je-(ef)sus(g) turned(g)  (e) him(f) about,t(e)  (d) dnd(d) when(f) he(g) saw(h) her,(g)  he(fg) said,(g) Daughter,(h)  (g) be(h) of(g) good(f) comfort;(hg)  (g) thy(cd) faith(f)  hath(ef) made(g) thee(fe) whole,(dc) al(d) le-(efe)lu-(d)ia.(d) |(h) T(g)  (f)  (gh) R(gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-215.png",
        nextFileName: "./pages/part-a-216.png",
    },
    {
        title: "part-a-215-1",
        gabc: "e-(d)ri-(d)ly(f) IT(dc) say(f) un-(g)to(fh) E%(hgg) ge(fg)  (h) -(gf)ra(gh) tion(h)  shall(cd) not(fe) pass,(cd) till(f) all(f) these(ef) things(gf) be(f)  (e) fulfilled.(d)  (d)  -(fh)ven(hghihgg) and(f) earth(ef) shall(g) pass(fe) a-(defe)wdy,(dc) but(c) my(df) words(ffgf)  shall(f) not(f) pass(f) .(g) way,(fe) saith(d)  (d) Lord.(d)  (h)  (g)  (f)  (fgh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-215.png",
        nextFileName: "./pages/part-a-216.png",
    },
    {
        title: "part-a-216-0",
        gabc: "Then(c)  (c)  (dh) those(hi)  (h) when(h) they(h) had(h) seen(h) the(h) mi-(h)ra—cle(h)  (hghihgg) that(fg)  Je-(h)sus(gf) did,(gfd) said(d) un-(d).(c) each(de) o-(ffg)ther:(f) This(h) B(g) of(f) a(e) trutj(g)  that(fe) pro-(d) (efe) &quot;(ddc) n(c) should(d) come(f) P(ef) to(gh) the(f)  (e) world.(d)  (h) [(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-216.png",
        nextFileName: "./pages/part-a-217.png",
    },
    {
        title: "part-a-216-1",
        gabc: "e(f) God,(gh) make(h) speed(gi) to(h) save(hg) me.(gh) R/.O(f) Lord,(gh) make(h) haste(ghi) to(h)  help(hg) me.(gh) Glory(f) be(gh)  (h) to(h) the(h) Father(h)  (h) and(h) to(h) the(h) Son,(h) and(h) to(ghi)  the(h) Ho-(h)ly(hg) Ghost;(gh) As(f) it(gh) was(h) in(h) the(h)  (h) beginning,(h)  (h) is(h) now(h) and(h)  a(gi) ev—er(h) shall(hg) be,(gh) world(h) without(h)  (h) end.(hi) A-(h) (g) men.+Al(h) ~le-(i)lu-(h)ia(g)  A(ik) Praise(h) be(h) to(h) thee,0(h)  (h) Lord,(h) King(h) of(h) e-(h)ternal(h)  (i) glory:(hg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-216.png",
        nextFileName: "./pages/part-a-217.png",
    },
    {
        title: "part-a-217-0",
        gabc: "e(dc) of(f) the(gh) two(hgg) which(fg) followed(h)  (gf)  (gh) the(fe) Lord(d) was(ffdfe~ec) An-(fg) (hh)  drew,(g) Simon(f)  (fe~) Peter’s(g)  (f) broth(fe) &#39;r,(dc) al(d) -(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png",
    },
    {
        title: "part-a-217-1",
        gabc: "Hoeil,(c)  (iig~) precious(i)  (j) Cross,(i) t(i) receive(j) the(i) disci-(i)ple(gh)  (ih) of(f) him(e)  who(h) hanged(h)  (f) on(h) thee,(gf)  (j) my(ef) Master(g)  (f) Christ.(e)  (d) ](i) [(j) ](i) g(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png",
    },
    {
        title: "part-a-217-2",
        gabc: "lessed(eh)  (f)  (f)  (e) [(ef)  (f) ](e) &quot;-(e)O(hhigij) Lord,(i) King(ijji) of(ih)  €(g) ternal(hi)  (dfhg) glory,(e)  (e) sust;1n(g)  (fe) me,(f) as(f) I(hg) hang(ihih) up-(h)on(fh)  the(g) tree.(e)  (h)  (g)  (h)  (f)  (e)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-217.png",
        nextFileName: "./pages/part-a-218.png",
    },
    {
        title: "part-a-218-0",
        gabc: "A(c)  (gj) ndrew,(h) the(g) servant(h)  (g) of(f) Je-(gh)sus(h) Christ,Ta(g) worthy(g)  (i)  (j) A_(k)  postle(jh)  (j) of(j) God,(i) was(j) Peter&#39;s(j)  (j) brother,(ih)  (g) and(i) partaker(g)  (h)  (h)  of(j) his(i) passion.(g)  (g)  (j)  (i)  (j)  (h) viij(g)  ax-(g)i-(g)mil-(gj)la,(h) beloved(h)  (h)  (g) of(f) Je-(gh) (h) sus,Christ,T(g) took(g)  the(i) A-(j) (k) postle’s(jh) bo-(j)dy:(i) and(j) in(j) a(j) place(j) of(j) honour(ih)  (g)  -(i)bu-(g)ri-(i)ed(g) it(h) with(h) sweet-(h)smelling(j)  (i) spices.(g)  (g) vij(j)  (i)  (j) !(h)  (g)  T(c) lLou(e) -(e)o-(g)verwhelmed(h)  (i) ](g) in(h) hell,(ij) 0(i) Lord,T(i) .(c) them(ij) that(h)  did(f) persecute(h)  (gh) =(ih) the(f) @5(e) righteous:(e) and(d) thou(fh) wast(hg) his(f) lead”(hi)  er(i) on(i) the(hj) wood(dfhf) of(g) the(f) Cross.(e)  (h) __I__l(i)  (j)  (i)  (h)  (dgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-218.png",
        nextFileName: "./pages/part-a-219.png",
    },
    {
        title: "part-a-219-0",
        gabc: "up(ef)  (hg) to(hi) usT(iji) a(h) man(j) so(i)  (k) righteous,(i) restore(k) us(j) a(h)  man(j) 8o(i) holy:(j) destroy(i)  (j) not(i) a(h) man(fg) so(h) dear(i) to(ih) God,(g)  righteous,(kj~)  (i) du-(h) (gh) ti-(ih)ful,and(f) gentle.(e)  (e) M(i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-219.png",
        nextFileName: "./pages/part-a-220.png",
    },
    {
        title: "part-a-219-1",
        gabc: "Wien(cd) blessed(d)  (fe) Andrew(de)  (d) cime(cd) to(f) the(fh) place(ihiih) where(h) the(g) Cross(hg)  had(ef) been(g) prepared,(cd)  (d)  (d) he(h) cried(h)  (hg) out(h) and(ij) said:(h) O(hhg) goodly(fe)  (fg)  Cross,(gi) so(dg) long(ffe) de-(de)sir-(dd)—(c)  (f) and(cd) now(dc) made(fg) ready(h)  (g) a(e) my(f)  eager(g)  (cd) spirit;(d)  (d) fearless(hg)  (h) and(j) joyful(hi)  (h) do(h) I(g) come(ef) to(fg) thee:(g)  therefore(ik)  (dhi)  (h) do(g) thou(hij) al-(hi)so(h) receive(h) N(ihg) me(fe) gladly,(fg) A(g)  (f) as(dg) (R(fdfe) dis-(de) ci~ple,(dd) =(c) who(c) did(d) T(edefhhgf) %(cded) .(efe) thee.(d) I(defgh) I(h) w(g)  (f) ey(g) 151(dgfed) ](dfh) ",
        groupIndex: 1,
        filename: "./pages/part-a-219.png",
        nextFileName: "./pages/part-a-220.png",
    },
    {
        title: "part-a-220-0",
        gabc: "y(f) this(g) I(gh) know(hg) Thou(fgh) S(g) favourest(fd)  (fg) me.(f) By(f) this,(g) That(ih)  mine(h) e-(gh)ne(g) my(g) doth(g) not(g) triumph(h)  (g) against(f)  (hg~) me.(hg) They(fgh)  favourest.(g)  (fd)  (fg) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Rr.(h) By(f) this.(g) ",
        groupIndex: 0,
        filename: "./pages/part-a-220.png",
        nextFileName: "./pages/part-a-221.png",
    },
    {
        title: "part-a-220-1",
        gabc: "A1l(gj) ge-(h)ne-(g)ra-(h)tions(g) T(c) shall(ffg) call(g) me(gh) blessed:(f)  (f) for(f)  (f) he(hj)  that(j) is(i) mighty(ji)  (hg) |(dge) mag-(f)ni-(gh)fi-(f)ed(e) me,(d) al-(cdeef)le-(fg)lu-(g)ia.(g)  [(j)  (i)  (j)  (h) ](g)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-a-220.png",
        nextFileName: "./pages/part-a-221.png",
    },
    {
        title: "part-a-221-0",
        gabc: "hou(f) ert(f) all(hh) fair,(i) C(g) Me-(g)ry;(hf~) there(fhf) is(ghg) 1o(fe) spot(fg) in(ef)  thee.(ik)  (d)  (fh)  (h)  (g)  (f)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png",
    },
    {
        title: "part-a-221-1",
        gabc: "by(g) raiment(h)  (g) is(hhf) white(j) as(j) snow,(i) thy(g) countenance(h)  (g)  (cef)  like(h) the(h) sun.(g)  (feh)  (j)  (i)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png",
    },
    {
        title: "part-a-221-2",
        gabc: "hou(h) art(h) the(h) ex-(g)al-(f)ta-(gh)tion(f) of(f) e(ded) ru-(ef)sa-(f)lem,(e) thou(e)  glo-(f)a(e) Is-(e)ra-(e)el,(f)  (f) thou(f) art(d) the(f) great(h)  T(g)  (g) 1(ii)  (hghih) of(fh) our(g) N(e) T(e) |(f) P(h) S(f)  (h)  (i)  (h)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-a-221.png",
        nextFileName: "./pages/part-a-222.png",
    },
    {
        title: "part-a-222-0",
        gabc: "Blessed(ig~)  (c)  (cig)  (i) art(j)  (i) 0(gh) Virgin(ih)  (f) Ma-(e)ry,(e) of(f) the(h) Most(h) Higlh(fh)  God,(g) above(f)  (f) ](e) the(f) women(f)  (f) up-(f)on(h) the(g) a.(e) earth.(j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png",
    },
    {
        title: "part-a-222-1",
        gabc: "-(ed)us,(g) O(hj) Maiden(i)  (j) 2(k) Ja(ji) 8(hi) .,(hg) we(g) will(h) run(ji) af-(ghhi) (g)  .(h) thee(h) in(g) a(e) goodly(fg) a(g) &#39;(h) fragrance(gf) of(g) thine(gf) n-(e)5(e)  ments.(ki)  (e)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png",
    },
    {
        title: "part-a-222-2",
        gabc: "he(f) Almighty(f)  (g)  (h) God(hg) Hath(f) girded(gh) 1=(g) &#39;me(fd) with(fg) strength.(gf)  The(ki~)  (f) Almighty(f)  (g) God.(gh)  (hg) ¥.(c) And(h) made(hi) my(h) way(ig~) per(fgh) fect.(hg)  Hath(f) girded.(gh)  (g) §.(c) Glory(h)  (h) be.(h) The(f) Almighty(f)  (g)  (gh) Cod-(hg)",
        groupIndex: 2,
        filename: "./pages/part-a-222.png",
        nextFileName: "./pages/part-a-223.png",
    },
    {
        title: "part-a-223-0",
        gabc: "he(g) Lord(hj) God(j) said(j) Tun—to(ij)  (k) the(ji) serpent,(g)  (g) I(h) will(h) put(j) en-(ij) mi-(h)ty(h) between(g)  (ef) thee(g) and(h) the(j) woman,(j)  (j) and(j) between(i)  (gh) thy(i) seed(h)  and(gh) her(jk) seed;(j) it(jkj) shall(g) bruise(h) thy(gf) head,(gh) al-(jh)le-(gf)lu-(e)ia.(e)  As(j) at(h) I(j) Vespers(ih) ",
        groupIndex: 0,
        filename: "./pages/part-a-223.png",
        nextFileName: "./pages/part-a-224.png",
    },
    {
        title: "part-a-223-1",
        gabc: "&#39;(c) [](c) us(d) ce-(fg)le-(fed)brate!(d) the(d) worshipful(e)  (d)  (d) Conception(efe)  (d)  (d) of(f)  the(g) blessed(h)  (f) and(g) glo-(f).(e) ous(dg) Virgin(e)  (fe) Ma-(dd)-(c)whose(cd) low-(fggf) li-(gh)ness(hgg) the(fg) Lord(hg) re-(f)gard-(ghgf)ed(d) when(gh) at(fe) the(dg) word(fe) of(d)  an(ik)  (fe) An-(dd)l(c) she(c)  (d) conceived(fg)  (f) the(f) world&#39;s(h)  (fe)  (d)  (dc)  al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 1,
        filename: "./pages/part-a-223.png",
        nextFileName: "./pages/part-a-224.png",
    },
    {
        title: "part-a-224-0",
        gabc: "n(cd) thy(f) patience(gh)  (h) Tthou(c)  (h) didst(h) possess(h)  (hj) thy(h) soul,(h) a(g)  Lu(ik)  (hg) cy,(def) spouse(g) of(fe) Christ:(d) thou(c) didst(e) hate(g) the(g) things(g)  which(ik)  (g) are(f) in(g) the(fe) world,(d) and(f) thou(g) shinest(hi)  (h) among(j)  (hi) the(g)  An-(ik) (f) gels:(f) resisting(f)  (h)  (g) un-(h)a(fe) -(d)a(e) didst(f) van-(g) quish(ik)  (g) a(e) =(f) &#39;e-(ed)-(d) (f)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-224.png",
        nextFileName: "./pages/part-a-225.png",
    },
    {
        title: "part-a-224-1",
        gabc: "W(c)  (c) thile(g) ho(igij) Iy(i) Lu-(ij)cyT(i) prayed,(hih)  (hgh) there(gh)  (h) appeared(h)  (hg)  (f) un-(ffh)to(h)  her(gi)  (g) the(f) blessed(gh) O(f) A-(h)ga-(h)e(g) who(e) S(g) consoled(i) t(h) A(f) hand-(gfh) maid(g) of(f) Christ.(e)  (fh)  (i)  (j)  (i)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-224.png",
        nextFileName: "./pages/part-a-225.png",
    },
    {
        title: "part-a-225-0",
        gabc: "O_(gi)  (e) virgin(g)  (h) Lu-(ij)cy,(i) dost(i)  (i) thou(g) ask(i) of(hg) me(ef) that(f) which(ed)  thou(g)  (e) thyself(f)  (fi) canst(hg) presently(hi)  (h)  (h) bestow(h)  (h) up-(gf)on(fgh) thy(g)  mother?(i)  (e)  (e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png",
    },
    {
        title: "part-a-225-1",
        gabc: "hrough(g) thee,(gj) O(h) virgin(hg)  (f) Lu-(gh)cy,(g) the(g) Sy-(i)ra-(j)cu-(k)san(jh) ci-(j)ty(i)  -(ik)shall(j) be(j) glori-(jk)fi-(ji)ed(g)  (g) by(i) the(g) Lord(h) Je-(j)sus(i) Christ.(g) T(j)  (i)  (j)  (h) |(fg) ",
        groupIndex: 1,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png",
    },
    {
        title: "part-a-225-2",
        gabc: "I&#39;(gd) bless(fg) thee,!(g) O(g) a(g) &quot;(g) of(g) my(h) Lord(ij) Je-(h)sus(i) Christ:(g)  for(g) by(g) thy(h) Son(ji) the(hg) fire(ge) is(g) quenched(fe)  (f) round(d) a-(ef)bout(gh)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h) _(g) ",
        groupIndex: 2,
        filename: "./pages/part-a-225.png",
        nextFileName: "./pages/part-a-226.png",
    },
    {
        title: "part-a-226-0",
        gabc: "O(e) Y(dc) o(c) sister(d)  (ef) s(e) God’(e) s(f) consecrated(e)  (f)  (fh) virgin,(hg)  (f) why(i)  (i)  dost(i) thou(i) ask(ijk) of(ji) me(ji) A(i) which(ig) thou(h) thyself(g)  (f) v(f)  (f)  presently(fi)  (h)  (h) bestow(h)  (g) up-(f)on(fh) thy(g) s(e) 8-(e)J|(h) oy(g)  (h) o=(f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png",
    },
    {
        title: "part-a-226-1",
        gabc: "A(d) pillar(df)  (e) art(f) thou(df) that(f) may(d) not(fh) be(gf) moved,(ghg)  (hih) O(h)  (gf)  (ef)  .(kj)  spouse(g) of(fe) Christ:(d) and(d) all(ffg) the(d) -(ef)people(e) are(d) waiting(cd) a.(c)  .(c) til(d) -(fg)re-(f)ceive(ighghih) -(ef)crown(g) of(fe) e(dc) al-(d)an(efe)  lu(d) .(d) ..(h) &amp;(g) ——(f) =(g) Te(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png",
    },
    {
        title: "part-a-226-2",
        gabc: "W(i) such(i) gravity(i)  (i) T(i) was(g) she(i) en-(j)du-(i)ed(i) by(j)  (g) the(h) Ho-(ih)ly(f) et(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-226.png",
        nextFileName: "./pages/part-a-227.png",
    },
    {
        title: "part-a-227-0",
        gabc: "a(e) Spirit,(e) that(h) the(h) virgin(h)  (h) of(f) the(h) Lord(g) remained(f)  (ef)  (g) un-(f) moved.(e)  (e)  (i)  (j) December(i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png",
    },
    {
        title: "part-a-227-1",
        gabc: "B(c)  (g) ecause(g) thou(f) hast(h) seen(j) me,T(i) Thomas,(g)  (i) thou(j) hast(h) be(g)  lieved:(hg)  (f) blessed(g)  (g) are(g) they(g) that(f) have(h) not(j) seen,(i) and(g)  yet(ki~)  (j) have(h) 2(g) believed,(h) p(gf) al(fgh) le-(h)lu=-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png",
    },
    {
        title: "part-a-227-2",
        gabc: "[](d)  (e)  (f)  (g) i(h)  (gh) .(j)  (j)  (j) [](i)  (h)  (j)  (i)  (g)  0(h)  (g)  (h) [(d) ](e)  (f) i(g) R(h)  (gh) i(gf) _—}(g)  (h) v(j)  (i)  (h)  )(j) 0(i) *(g)  (h) i(gh)  (ed) i(hj) R(g)  (f)  (ed) i(fgh)  (g) U(fe) S(d) T(e) |(efghi) ",
        groupIndex: 2,
        filename: "./pages/part-a-227.png",
        nextFileName: "./pages/part-a-228.png",
    },
    {
        title: "part-a-228-0",
        gabc: "0..(cc) most(f) blessed(g)  (f) of(gh)  (h) men!Twho,(f) .(h) rejecting(jj) ..(j) this(i)  (hi) world,(h)  bore(ik)  (jj) the(h) yoke(fg) of(f)  (fe) Bule(f)  (fg) from(fh)  (i) a(i) tender(hg) years(fghg) sio(fe)  loving-(ik) (f) 1ly;(fgf)  (f) and(h) be-(jjk)ing(j) made(j) o-(ih)be(gf) di-(g)ent(h) e-(ih) ven(ij)  (g) un-(h)a(fe) death,(fgf) he(h) de(j) -(jkj)ed(h) him-(ih)self,(gh) that(h)  he(i) might(ih) whol-(jjk)ly(j) cling(ih) to(g) Christ(hg) his(fe) Mas-(fgf)ter,(f)  al(f) le(fghfefihgh) lu-(cdfg)ia.(f) |(fh) =(h) O(f)  (gh) AT(g) I(f) ",
        groupIndex: 0,
        filename: "./pages/part-a-228.png",
        nextFileName: "./pages/part-a-229.png",
    },
    {
        title: "part-a-228-1",
        gabc: "T(ik)  (c) he(cded) blessed(g)  (hi) Mau-(j)rus,(i) T(c) born(ijk) of(j) a(j) renowned(j)  (ji)  (h) and(h) noble(i)  (h)  house,(ki~)  (g) from(g) his(g) boyhood(hi)  (h) esteemed(h)  (hij)  (g) the(g) reproach(g)  (e) of(fg) ",
        groupIndex: 1,
        filename: "./pages/part-a-228.png",
        nextFileName: "./pages/part-a-229.png",
    },
    {
        title: "part-a-229-0",
        gabc: "Christ(g) greater(gf)  (e) .(ed) miches(d) than(h) the(ij) treasures(h)  (gf) of(e) the(de)  world.(e)  (j)  (ji)  (hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png",
    },
    {
        title: "part-a-229-1",
        gabc: "Up-(e)held(g) by(h) wings(ih) of(g) o-(h)be-(ij) (i) di-(i)he(h) walked(jk)  (ji) up-(i)on(gh)  (i)  the(i) waters;(hg)  (e) and(e) borne(g) by(g) the(g) Spirit(hf)  (h) of(h) God,(g) he(g) was(h)  (i)  saved(ij)  (i) from(h) sinking(hf)  (gf) in(e) the(de) flood.(e) [(i) R,(j)  (i) &quot;(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png",
    },
    {
        title: "part-a-229-2",
        gabc: "a(e) blessed(c)  (d) Maurus,(idhi)  (h) a(h) disciple(h)  (g)  (f) of(gh) ho-(h)ly(h) Be-(hj)ne-(h)dict,(h)  from(gf) tender(fg)  (d) years,(d) stood(g) forth(g) as(g) a(g) zealous(h)  (g) follower(g)  (f)  (f)  ](e) his(f) .(g) master(dfe) &#39;s(d) excellence.(d) .(d)  (h)  (g)  (f)  (gh)  (g)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-a-229.png",
        nextFileName: "./pages/part-a-230.png",
    },
    {
        title: "part-a-230-0",
        gabc: "From(f) the(f) hotse(efddc) of(fg) prayer(g) he(g) passed(gf) a(g) o(ghf) ver(f) unto(f)  (f) the(f)  place(ki~)  (gf) of(f) the(f) -(fh)wondrous(ihg) ta-(i)ber-(h)na-(gf)cle,(f) e-(f)ven(f) un-(g)to(f) the(f)  house(fhihg) of(ih) God,(gf) with(efd) ‘exceeding(dc)  (f)  (fg) love(g) of(gf) whom(g) he(ghg)  burned.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-230.png",
        nextFileName: "./pages/part-a-231.png",
    },
    {
        title: "part-a-230-1",
        gabc: "He(c)  (dh) [(hi) ](hg) chosen?(f) by(g) the(gh) Lord(h) to(h) be(hj) an(h) example(g)  (fg)  (d) to(c) the(d)  (f)  cloistered,(f)  (f)  (f) and(h) a(g) chief(fg) observer(f)  (fe) ,(cd) of(fg) the(e) o(f)  (ed) Rule.(d)  .(h)  (g)  (f)  (gf)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-a-230.png",
        nextFileName: "./pages/part-a-231.png",
    },
    {
        title: "part-a-231-0",
        gabc: "o-(c)day(cd) ho-(d)1y(c) Maurus,(efd)  (d) lying(f)  (h) up-(h)on(h) a(h) goat-(hi)skin,(h) died(fg)  hap-(h)pi-(fe)ly(d) before(dg)  (fe) the(d) altar;(cd)  (d) to-(d)day(dg) the(g) first-(h)begot-(g) (fg)  ten(f) dis-(f)ci-(fe)ple(d) of(df) blessed(f)  (f)  (f)  (fe)  (dc) the(c)  (d)  guiding(ffg)  (f) of(g) the(f) Ho-(g)ly(gh) Rule,(h) came(hjk) up(ji) to(hg) Christ,(ijh) rising(h)  (g)  untroubled,(hg)  (f)  (e) accompdnied(d)  (fe)  (dc) by(c)  (e) choirs(g) of(dfe) Angels;(cd)  (d)  to-(d)day(dh) the(h) o-(h)be-(h)di-(g)ent(h) man,(gf) telling(g)  (g) his(gh)  (h) victories,(d) N(d)  vas(cd) worthy(fg)  (fh) to(h) be(g) crowned(hg)  (f) by(g) the(fe) Lord,(dc) al-(dg)le-(efe)lu-(d)ia.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-231.png",
        nextFileName: "./pages/part-a-232.png",
    },
    {
        title: "part-a-232-0",
        gabc: "lessed(h)  (fed)  (ef) in(e)  (e) the(g) midst(i) of(hg) the(fe) flames,(fe)  stretched(ig~)  (fi)  (h) out(hg) her(f) hands(h) and(g) prayed:(e)  (e) I(h) call(hg) on(fh)  thee,(hhe) O(gh) Father(i)  (hg) transcendent,(fh)  (h) -(h)august,(h)  (h) and(hiih~gih~hi) dread;(ih)  for(h) by(h) thy(i) ho-(j)ly(i) Son&#39;s(ij) pro-(h)tec(hghihi) tion(ih) I(i) have(e) es-(g) caped(i)  (h) the(h) threats(h) of(g) an(h) impious(f)  (e)  (f) tyrant,(de)  (e) and(f)  passed(de) a(e) unscathed(f)  (de) e«(e) through(e) the(i) foulness(hg)  (e) of(f) fleshly(hf)  (g)  —(f) pollution:(e) _a:(e) #d(c) behold,(de)  (ffe) I(ef) cbfie(cd)  (c)  (c) to(df) thee,(gfefgf) whom(f) I(f) have(i)  Ioved,(hg)  (ef) whom(hf) I(g) have(f) jught,(ed) whom(f) T(f) have(i) alway(h)  (hg) de-(fgf) sired.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-232.png",
        nextFileName: "./pages/part-a-233.png",
    },
    {
        title: "part-a-233-0",
        gabc: "Ag-(ig) (i) nes(j) en-(i)ter-(hi)ed(i) the(fh) place(ih) of(f) shame,(e) she(h) found(h)  the(h) An-(fh)gel(g) of(f) the(e) Lord(f) ready(f)  (h) beforehand.(g)  (e)  (e) A(i)  (j)  (i) N(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png",
    },
    {
        title: "part-a-233-1",
        gabc: "or(i) I(g) have(ij) with(i) &quot;(i) of(h) the(g) A(e) the(h)  Guardi-(h)an(g)  (h) of(fh) my(g) bo-(e)dy.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png",
    },
    {
        title: "part-a-233-2",
        gabc: "ith(ig) nis(ij)  (i) my(i)  (i) Lord(ij) Je-(i)sus(g) Christ(ih~) ](f)  (e) |(e)  me,(e) and(h) as(h) his(fh) bride(g) hath(f) he(e) crowned(fh)  (g) me.(e) |(i) R(j)  (i)  (h) |(gh) ",
        groupIndex: 2,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png",
    },
    {
        title: "part-a-233-3",
        gabc: "[(gd) bless(fg) thee,T(g) 0(g) Father(g)  (g) of(g) my(h) Lord(j) Je-(h)sus(i) Christ:(g) ",
        groupIndex: 3,
        filename: "./pages/part-a-233.png",
        nextFileName: "./pages/part-a-234.png",
    },
    {
        title: "part-a-234-0",
        gabc: "for(g) by(g) thy(h) Son(ji) the(hg) fire(ge) is(g) quenched(fe)  (f) round(d) aboyt(f)  (h)  (h)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png",
    },
    {
        title: "part-a-234-1",
        gabc: "R(gd) ejoice(f) with(fg) me(g) Tand(gi) be(k) exceeding(jh)  (j)  (j) glad,(i) because(k)  (k)  among(ik)  (j)  (j) all(k)  (k) these(jijkj) I(h) have(g) taken(h)  (h) a(h) throne(j) of(i) glory.(g)  (g) Y(jijh) ",
        groupIndex: 1,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png",
    },
    {
        title: "part-a-234-2",
        gabc: "o,(d) that(f) which(g) I(g) desired,T(g)  (gh)  (g) now(ge) I(fgh) see;(fed) that(c) for(d)  which(f) I(f) ‘hoped,(g)  (f) L(fd) now(fh) =(fg) possess;(ghg) I(f) am(g) u-(hj)ni(jjh) ted(ih)  in(g) heaven(h)  (g) un-(f)to(e) him,(g) whom(h) on(fed) edrth(ed) I(f) loved(fe)  (d) with(e)  a(f) A(gf) perfect(gh) de-(gf)T(e) tion.(e) S(h)  (g) -(h)S(ih)  (gfe) _I(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-234.png",
        nextFileName: "./pages/part-a-235.png",
    },
    {
        title: "part-a-235-0",
        gabc: "While(d) the(f) blessed(d)  (dc) Ag(fgh) nes(h) Twas(fg) standing(h)  (h) in(h) the(h) midst(hj)  of(h) the(h) flames,(ihghihgg) she(fg) stretched(h)  (gf) out(h) her(fe) hands,(d)  (j) andpray-(cd) (fdfgh)  ed(ki~)  (ed) un-(e)to(fe) God:(d) Almighty(h)  (h)  (gf) Lord,(g) worthy(d)  (f) of(f) all(fe)  (dc)  (cd)  ra(ki~)  (fdfgh) tion,(ed) fear,(e) and(ef) worship:(d)  (d) I(h) bless(h) thy(gf) ho(g) ly(defedcd)  Neme,(dc) and(c) I(d) glorify(f)  (g)  (f) thee(gh) for(g) ev-(fe)ér(dc) and(ef) ev-(d)er.(d) MTe(hg) de(fghgf) ",
        groupIndex: 0,
        filename: "./pages/part-a-235.png",
        nextFileName: "./pages/part-a-236.png",
    },
    {
        title: "part-a-235-1",
        gabc: "%—‘ﬁ(ffe)  (dc)  (dfd)  (e)  (e)  (f)  (dc)  (fe) a(fgf)  (d)  (ce) |(e)  (f) &amp;(g) =(h) @200(j) &quot;8(h) ](gfe)  M(f)  (dc)  (fe) &quot;(fgf) o(d)  (ce) o(e) &amp;(dedd)  (d) JL(edfd) &amp;(e) o(e) —(g)  (f) o(dc)  I(df)  (fe) i(de)  (e) -(ed)[(c) ](cd) -(de) (d)  (j) A(f)  (fh) |(fh) &amp;(fg) -(fe)T(de)  (e) |(dfg)  (efghi) ",
        groupIndex: 1,
        filename: "./pages/part-a-235.png",
        nextFileName: "./pages/part-a-236.png",
    },
    {
        title: "part-a-236-0",
        gabc: "a(e) a(e) An-(g)a-(h)ni(ihji) as,(i) and(i)  (j) enquire(ji) for(hih) Saul,(i) f,,(g)  behold,(gh)  (h)  (h) he(f) [(e) prayeth:(e) for(e) he(ei) is(i) a(i) chosen(i)  (i) vessel(h) -(gh)un-(ij) to(j) me,(i) to(j) bear(ih) my(fh) Name(hh) before(g)  (ij) the(i) Gentiles,(hg)  (fh) and(hih)  Kings,(fed) and(fh) the(h) -(h)children(g) of(h) Is-(ih)ra-(f)el.(e) -(i) (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-236.png",
        nextFileName: "./pages/part-a-237.png",
    },
    {
        title: "part-a-236-1",
        gabc: "T(c) hou(d) art(d) the(dc) shepherd(f)  (g) of(f) the(fh) sheep,(h) 0(hjkj) chief(hihhg) of(fe)  the(fg) &#39;A-(fe) (d) postles:(d) un-(g)to(g) thee(h) were(g) given(fe) .(c) the(d) keys(ffg)  of(f) the(f) kingdom(ef)  (g) of(fe) heaven.(d)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-a-236.png",
        nextFileName: "./pages/part-a-237.png",
    },
    {
        title: "part-a-237-0",
        gabc: "](c)  (eh) have(f) e(f)  (e)  (f) watered,(f)  (ed)  (ef)  (f)  (e) but(h) God(hf) gave(gh) the(f) fan-(ef) crease,(d) al-(ef)le-(f)lu-(e)ia.(e)  (g) e(e)  (e) w(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png",
    },
    {
        title: "part-a-237-1",
        gabc: "0(gh)  (e) gladly(eh)  (f) will(fe) I(d) glory(f) t(e) in(gh) my(i) in-(fh)firm-(h)i-(h)ties,(g) that(i)  the(gi)  (h) power(hj) of(i) Christ(hghih) may(f) rest(h) up-(g)on(e) me.(e) I(h)  (g)  (h) el(f) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png",
    },
    {
        title: "part-a-237-2",
        gabc: "T(c) he(f) grace(e) of(f) God(hi) Twhich(i) was(i) bestowed(i)  (i) )(h) up(i) on(j) me(i) was(h)  not(ij) in(j) vain:(i) but(f) his(i) grace(g) a-(h)bi(fe) deth(fe) with(de) me(fh)  always.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-237.png",
        nextFileName: "./pages/part-a-238.png",
    },
    {
        title: "part-a-238-0",
        gabc: "I(g) §(gj) Damascus,(h) T(hg) the(f) governor(gh)  (h) e«(g) under(g)  (i) A-(j)re-(k)tas(jh) the(j)  king(i) would(j) have(j)  (i) apprehended(h)  (j) me:(i)  (g) but(g) I(ch) was(g) let(h) down(g)  the(g) wall(fghgf) by(f) the(f) brethren,(g)  (f) in(g) a(h) basket;(jk)  (jijkj) and(j) so(k) es-(i) caped(ik)  (j)  (h) out(j) of(g) his(h) hands(g) in(g) the(g) Name(df) of(h) the(h) Lord.(g)  (jijhg) ",
        groupIndex: 0,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png",
    },
    {
        title: "part-a-238-1",
        gabc: "T(c) hrice(eh) 0(f) I(e) beaten(f)  (de) with(f) e(e) rods,t(j) once(fh) was(i) I(hf) stoned,(h)  (g)  thrice(i) I(i) suffered(h)  (h)  (h) shipwreck,(iji)  (hghih) for(f) the(e) Name(fghf) of(fg) Christ.(e)  N.(h) Thou(g)  (h) a(f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png",
    },
    {
        title: "part-a-238-2",
        gabc: ".(dd) L)(c) have(df) followed(g)  (f) )(de)  (d) .(c) sit(d) up-(f)on(f) twelve(fgh) ",
        groupIndex: 2,
        filename: "./pages/part-a-238.png",
        nextFileName: "./pages/part-a-239.png",
    },
    {
        title: "part-a-239-0",
        gabc: "thrones,(g) judging(g)  (e) the(g)  (fe) tribes(ef) of(gf) Is-(d)ra-(c)el,(ef)  saith(ki~)  (g) the(fe) Lord.(d) &quot;(h) a(g) _(f) &quot;4(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png",
    },
    {
        title: "part-a-239-1",
        gabc: "O(g) ho-(g)ly(f) A(fd) pos-(fh)tle(fg) Paul,(ghggf) thou(hj) preacher(j)  (i) of(j) the(g)  truth(h) and(h) Doctor(g)  (gh) of(h) the(g) Gen-(hgf)tiles,(f) &quot;(g) intercede(g)  (g) for(f)  us(h) un—to(j)  (i) God,(j) who(h) hath(gf) chosen(gh)  (h) thee.(g) -(j) (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png",
    },
    {
        title: "part-a-239-2",
        gabc: "I(e) the(e) hea-(eh)ven-(f)—(ed) kingdomT(ef)  (e) the(e) Blessed(g)  (h) have(i) their(hf)  dwelling-(h) (h) place,(g)  (f) and(ih) their(iji) rest(hghih) for(fe) ev-(fgh)er(f) and(gf) ev-(e)er.(e) ",
        groupIndex: 2,
        filename: "./pages/part-a-239.png",
        nextFileName: "./pages/part-a-240.png",
    },
    {
        title: "part-a-240-0",
        gabc: "he(c)  (c)  (cd) an-(dedf)cient®(d) carri-(d)ed(c)  (d) the(fe)  (decf) but(c)  (f) the(f) In-(ihih)fant(ghg)  -(e)governed(f) a(g) the(d) O(d) ancient:(d) he(d) whom(f) a(e) Virgin(f)  (e) bare,(d) and(e)  _(ik) after(d)  (c) bearing,(de)  (d) remained(ef)  (g)  (cd) virgin,(d)  (d) the(f) same(ghghih) was(hg)  worshipped(i)  (h)  (g)  (fe) by(dc) her(d) who(efe) bare(d) him.(d) &amp;(h)  (g) _—a(f)  (g) a,(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-240.png",
        nextFileName: "./pages/part-a-241.png",
    },
    {
        title: "part-a-240-1",
        gabc: "2(g) i-(h)me-(j)on,Ta(j) just(hj) and(i) a(g) ¥(hi) man,(i) a-(g)waited(iij)  (h) the(h)  —_—(f) so(h) -(i)tion(h) .(g) I(gh) ra-(gf)A(e) and(g) M(h) Ho-(j)1ly(ih) ",
        groupIndex: 1,
        filename: "./pages/part-a-240.png",
        nextFileName: "./pages/part-a-241.png",
    },
    {
        title: "part-a-241-0",
        gabc: "Ghost(h) was(g) up(ghg) a-(e)him.(e)  (j)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png",
    },
    {
        title: "part-a-241-1",
        gabc: "[(e) tvas(e) revealed(g)  (i)  (h) un-(h)to(f) Si-(h)me-(h)on(g) Thy(g) the(f) Ho-(h)ly(g) Ghost,(ghg)  that(h) he(i) should(h) not(f) see(hg) death,(g) a(e) hefore(gh) he(f) had(f) seen(g) the(f)  Lord.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png",
    },
    {
        title: "part-a-241-2",
        gabc: "S(g) me-(h)on(j) took(h) the(j) Child(i) Tup(h) in(h) his(ih) arms;(g) and(j)  giving(i) :(g) thanks,(hf) he(h) blessed(hi)  (g) the(g) Lord.(e)  (j) -(h)-(j)I(ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png",
    },
    {
        title: "part-a-241-3",
        gabc: "A(h) lightT(hg) [(e)  (gh) lighten(f) a(e) Gentiles,(f)  (d) and(d) the(f) glory(h)  (ge) of(g)  thy(h) people(f)  (f) Is-(g)ra-(f).-(e) (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-a-241.png",
        nextFileName: "./pages/part-a-242.png",
    },
    {
        title: "part-a-242-0",
        gabc: "A(c) nd(f) they(h) of-(j)fer-(i)ed(g) for(i) him(j) to(h) the(g) Lord(f) a(f) pair(f) of(h)  turtle(i) doves,(i) or(h) two(i) young(h) m-(g)pigeons.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png",
    },
    {
        title: "part-a-242-1",
        gabc: "A(c) hd(cd) when(f) the(gi) ™(ih) parentsTbrought(g) &amp;(fh) in(g) the(h) Child(ff) Je(dfe) dus,(dc)  (g)  then(igi) Si-(i)me-(hg)on(hi) took(ji) him(jkjh) up(h) in(f) his(gh) arms,(ghffd) and(gh) bless-(fe) d(dc) God,(df) say(defc) i:l&#39;g:(c) Lord,(gggfed) now(ef) lettest(gh)  (g) thou(fe) thy(defed)  ser(dc~fede) vant(ed) de-(ge)part(h) 1in(cdef) peace.(d) &quot;(h) a(g) _(f) d(gh) p,(dfgf) ",
        groupIndex: 1,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png",
    },
    {
        title: "part-a-242-2",
        gabc: "=(d) .(de) Tthe(ffh) blessed(h)  (fgf) Virgin(cdde)  (fgf) a(e) ry(e) a(dhg) presented(hi) the(i)  (i)  Child(ij) Je-(hg)@(fe) in(f) the(fgf) temple;(e) a(e) and(eef) _(d) me-(de)=(e) on,(j) fi”&#39;ed(fgh)  (fgf) ",
        groupIndex: 2,
        filename: "./pages/part-a-242.png",
        nextFileName: "./pages/part-a-243.png",
    },
    {
        title: "part-a-243-0",
        gabc: "with(e) the(d) Ho-(f)ly(hg) Spirit,(e)  (e) received(i)  (h)  (f) him(hg) in-(hi)to(h) his(hg) arms,(f)  and(hg) blessed(iji)  (hg) God(ef) for(gf) ev-(e)er.(e) tat(h)  (g)  (h)  (f) ](efe) ",
        groupIndex: 0,
        filename: "./pages/part-a-243.png",
        nextFileName: "./pages/part-a-244.png",
    },
    {
        title: "part-a-243-1",
        gabc: "T¥e(ik)  (dc) blessed(d)  (f) A~ga-(de) (dc) tha,(c) standing(f)  (h) in(h) themidst(g)  (f) of(e) the(g) pri-(fed) son,(ki~)  (d) with(cd) out-(dhi)SN(h) stretched(gf) hands(ed) entreated(cd)  (fe)  (gh) the(fe) Lord:(d) OLord(h)  (gh)  Je-(ji)sus(jkj) Christ,my(h)  (hgf) gracious(ed)  (efe) Master,(d)  (d) I(c) give(df) thanks(fe) un-(de)to(d)  thee(c) who(c) hast(df) en-(fe)a-(gh)bled(h) me(h) to(h) o-(h)ver-(gh)come(h) the(ed) torments(fh)  (g)  of(e) the(d) ex-(ef)e-(e) (d) tion-(cd)er:(d) bid(c) me(df) now,(fe) O(de) Lord,(dc) joy(f)  (hi)  ful-(hg)ly(gh) i(gf)  (fg) |(fe) S(d) to(d) thine(f) un-(fe)fading(gh) B(fe) CRNTRCH(d) |(d) I(hg) Y(fg) Y(gfe) ",
        groupIndex: 1,
        filename: "./pages/part-a-243.png",
        nextFileName: "./pages/part-a-244.png",
    },
    {
        title: "part-a-244-0",
        gabc: "ho(i) art(i) thou(i) that(i) comest(i)  (g) un(i) to(j) me(i) to(h) heal(ih) my(f)  wounds?(e) I(h) am(h) the(h) A-(h) (h) postle(f) of(h) Christ;(g) be(f) not(e)  doubtful(f) g(f) of(f) me,(h) my(g) a-(e).-(e) (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png",
    },
    {
        title: "part-a-244-1",
        gabc: "N(d) ever(e) have(f) I(g) a(g)  (gh) a(g) a(g) my(g) bo-(gh)dy(g) an(gf) earthly(gh)  (fe)  re-(d)me-(cd)dy:(d) but(f) I(fg) have(fe) a(c) Lord(d) a(c) sus(de) Christ,(ffgf) who(f)  by(gh) his(g) word(f) a-(f)lone(fefgf) restoreth(ef)  (g) [(fe) .(d) e(d) things.(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png",
    },
    {
        title: "part-a-244-2",
        gabc: "I(i) give(i) thee(g) .(i) O(j) A(i) Je-(j)sus(kj) Christ:(i) s(i) because(j) ",
        groupIndex: 2,
        filename: "./pages/part-a-244.png",
        nextFileName: "./pages/part-a-245.png",
    },
    {
        title: "part-a-245-0",
        gabc: "thou(i) art(i) mindful(hg)  (i) of(hg) me,(e) and(h) hast(h) sent(h) thine(h) A-(h)pos-(h) tle(h) un-(f)to(h) me(g) to(f) heal(h) my(g) T(e) wounds.(i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png",
    },
    {
        title: "part-a-245-1",
        gabc: "I(gd) bless(fg) thee,TO(g)  (g) Father(g)  (g) of(g) my(h) Lord(ji) Je-(h)sus(i) Christ:(g)  because(g)  (g) by(h) thine(j) A-(i) (hg) postle(g) thou(g) hast(g) &quot;(g) restored(fe)  (d) my(ef)  breast(gf) to(gh) my(h) bosom.(g)  (g) [(j) g(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png",
    },
    {
        title: "part-a-245-2",
        gabc: "O(e) hin(e) who(g) hath(h) deigned(ij)  (i) Tto(i) heal(j) me(i) of(g) all(h) my(h)  wounds,(g) and(h) a(g) restore(h)  (ij) my(i) breast(hg) to(fe) my(fg) hosom;(g)  (g) on(hg~)  him,(i) the(h) living(hj)  (i) God,(hf) do(g) I(f) call.(e) l_II—_I(i) &quot;(j)  (i)  (h) s(gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-245.png",
        nextFileName: "./pages/part-a-246.png",
    },
    {
        title: "part-a-246-0",
        gabc: "he(d) mul(f) titude(h)  (h) of(h) the(h) heathen,(h)  (g) fleeing(hg)  (fh) to(d) the(f) toph(hi)  of(h) the(h) vir-(i) (j) gin,(ih) took(f) thence(hj) her(i) veil(ij) to(i) defend(i)  (hi) they(h)  from(fh) the(hi) fire:(hif) that(d) the(f) Lord(h) might(g) shew(h) himself(g)  (f) a(d)  de~-(gi) (f) liv-(h) (g) er—er(f) from(e) the(fg) Burning,(ed)  (d) for(d) the(f) me(fege) rits(e) of(g)  A(fe) ga-(fg)tha(g) his(fg) blessed(hg) e(e) o(d) Martyr.(d) J(h) 0(i)  (g) 0=(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-246.png",
        nextFileName: "./pages/part-a-247.png",
    },
    {
        title: "part-a-246-1",
        gabc: "n(f) the(f) likeness(g)  (f) of(g) a(gh) dove(hg) *(h) The(g) soul(g) of(g) Scholasti(f)  (g) ice(g)  (g)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-a-246.png",
        nextFileName: "./pages/part-a-247.png",
    },
    {
        title: "part-a-247-0",
        gabc: "was(gh) seen(gfd) in(f) a(g) vision.(g)  (f) In(f) the(f) likeness.(g)  (f) The(c)  (ch) heart(hi)  of(h) her(h) brother(fh)  (g) rejoiced.(f)  (fh)  (hg) The(g) soul.(g) ¥.(c) Glory(h) be(h)  (h)  co(h) the(h) Father(hi)  (h) and(h) to(fgh) the(g) Son,(g) and(g) to(h) the(g) Ho(f) ly(g)  Ghost.(ki~)  (gh) the(f)  (f) likeness.(g)  (f)  N(gi)  (e) .(ef) e(f)  (fe) a8,(h) -(g) (f)  (e) -(h)8(i) o(j) .(ih) -(i) (i) -(j) |1(h)  (i)  (j)  (i)  (hg)  (hihg)  (f)  (f) |(f)  (fi)  (h)  (hf) &amp;]](g)  (f)  (e)  a(c) is(ef) this(f)  (fe) that(h) flieth(i)  (i) as(h) cloud?(j)  (i)  (hg)  (hihg)  (f)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-247.png",
        nextFileName: "./pages/part-a-248.png",
    },
    {
        title: "part-a-247-1",
        gabc: "Let(d) ill(cd) the(d) [](f)  (e) -(dc)[(e) the(f) a(g) ex-(ed) (efe) ult(d) in(d) the(dh)  glory(hi)  (h) e(g) a(g) gracious(gh)  (h) 5(cd)  (d) Scholas-(fgf)ti-(d)l.(c) -(d) (efg) and(dhi) ",
        groupIndex: 1,
        filename: "./pages/part-a-247.png",
        nextFileName: "./pages/part-a-248.png",
    },
    {
        title: "part-a-248-0",
        gabc: "chiefly(h)  (gh) let(h) the(h) com-(hg)pa-(fe).(dc) of(cd) vir-(fgh).(fe) be(fgf) -(d) (d)  c:le—brat.ing(h)  (j)  (ji) her(hg)  (fgh) So-(jk)lem-(jh)ni-(i)ty;(h) for(h) she(hg) besought(fe)  (fgh) the(h)  Lord,(hih) pouring(h)  (g) forth(fe) her(cd) tears,(d) and(c) of(df) him(ffg) received(f)  (gh)  (h)  greater(h) .(g) power,(fe) because(d)  (d) Her(dc) love(e) was(fe) greater.(d)  (d) |(h) )(gf) &amp;g(g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png",
    },
    {
        title: "part-a-248-1",
        gabc: "G(c) o(i) forth(ig) now,(hij) brother,T(i)  (i) go(i) forth(i) if(ghi) thou(hg) canst:(e) bid(h) me(h)  farewell,(fh)  (g) and(f) ](e) .(f) to(f) the(f) mo-(h)nas-(g)-(e)e(e)  (fghh) ||(i)  (j)  (i)  (h) ](gh) ",
        groupIndex: 1,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png",
    },
    {
        title: "part-a-248-2",
        gabc: "A(defhf) Imighty(h)  (hij) God(i) T(e) forgive(fg) thee,(h) my(cdegf) sister:(e)  (ee) what(f) is(fi) this(h)  thou(h) hast(g) ae(ee) done?(hi)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-a-248.png",
        nextFileName: "./pages/part-a-249.png",
    },
    {
        title: "part-a-249-0",
        gabc: "o,(g) I(f)  (h) entreated(j)  (i) thee,T(i) and(h) thou(g) wouldest(i)  (i) not(j) hear(hg)  (f)  me:(ki~)  (f) I(g)  (g) entreated(g)  (f) my(hj) Lord,(i)  (j) and(ggij) he(hi) heard(h) me.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png",
    },
    {
        title: "part-a-249-1",
        gabc: "Nowspeak(ikc)  (j)  (ji) we(hi) Te-(i)ven(hg) until(h)  (i) morning(j)  (h) of(j) heavenly(h)  (i)  (h) things,(g) in(g)  _(ik)  (ij) ly(h) converse(h)  (g) a(g) regarding(hg)  (f) the(d) life(ef) of(gh) the(h) spirit.(g)  (g)  (j) e(hj)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png",
    },
    {
        title: "part-a-249-2",
        gabc: "[(c) fo-(cfe)ly(fg) :(h) Ben_edictT(g)  (g) had(f) ](g) withdrawn(i) himself(h) a(g) in(g) his(h) cell(g)  for(f) three(gh) days,(g) he(g) lifted(g)  (g) up(h) his(j) eyes,(j) and(j) the(j) soul(ih)  of(g) M(ih) o(f) s(fg) e(fh) departing(i) .(h) Ay(g) the(f) bo-(gh)dy(g) in(g) the(h) like-(g) Ness(f) of(f) :(ed) dove,(df) [(f) enter(e) the(f) wm(g) secret(f) o(f) places(fd) of(e) the(d) oo(c) heavens.(c)   (g)  (h)  (g)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-a-249.png",
        nextFileName: "./pages/part-a-250.png",
    },
    {
        title: "part-a-250-0",
        gabc: "O(dfgh) how(f)  (gi) illustrious(hg)  (g) Tare(f)  (hj) the(j) merits(j)  (j) of(j) blessed(kj)  (ih) Scho.(g)  lasti-(hf)ca!(ef)  (f) O(ghi)  (fgi) how(i) great(ih) the(gf) power(gh) of(g) her(g) tears!(f)  through(fc) which(f) the(g) —renowned(h)  (h)  (gh) virgin,(ihi)  (h) out(fg) of(f) sunny(f)  (f)  clear(fhihgjj) ness,(j) drew(f) down(ef) from(d) iée‘(dc) air(fgh) a(g) mighty(fi)  (h)  flood(g) of(g) rain.(f) AT(h) IT(f)  (gh) VESPERS(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-250.png",
        nextFileName: "./pages/part-a-251.png",
    },
    {
        title: "part-a-250-1",
        gabc: "o-(f)day(fg) the(g) ho(hj) 1y(ji) virgin(j)  (hg) Scholastica,(f)  (fh)  (h) in(g)  (g) the(g) like-(f) ness(h) of(j) a(j) dove,(jkj) went(j) forth(kji) with(h) all(jj) gladness(j)  (j) to(j) the(j)  heavenly(jk)  (j)  (ji) places:(g)  (g) to-(g)day(gji) she(g) was(h) el(iig) ”(hg) worthy(f) *°(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-250.png",
        nextFileName: "./pages/part-a-251.png",
    },
    {
        title: "part-a-251-0",
        gabc: "enjoy(g)  (h) for-(j)ev-(j)er(hih) the(gh) &#39;bliss(j) of(g)  (g) celestial(h)  (fe) life(d) be-(ef) gide(gh) her(h) brother.(g)  (g) ALTERNATE(j)  (i) OFFICE(j)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png",
    },
    {
        title: "part-a-251-1",
        gabc: "T(c) he(e) Lord(ehg) hath(h) giv-(i)en(gh) un-(ij)to(i) me(i) Twings(hkkj) like(i) a(hj) dove,(i)  that(i) I(i) might(h) flee(hj) a-(i)way,(hghih) and(f) be(fh) at(g) rest.(e) T(i)  (j) &quot;(i)  (h) T(gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png",
    },
    {
        title: "part-a-251-2",
        gabc: "A-(e)rise(ehg) quiddy,(hi)  (i) Tmy(i) love,(j) my(ih) fair(i) one,(i) my(i) r(j) that(i) -(h)in(h)  the(f) clefts(h) of(i) the(hg) rock:(e) come,(f) a(e) receive(d) ](e) the(ef) -(fihhj)which(j)  the(i) Lord(j) hath(h) ](i) m(hg)  (f) for(df) N(d) thee(hgih) for(f) ev-(e)er.(e) T(i) -(ji)a1(h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-a-251.png",
        nextFileName: "./pages/part-a-252.png",
    },
    {
        title: "part-a-252-0",
        gabc: "Th(cd) praise,T(defd) O(d) Virgin(e)  (d) Mé-(cd)ry,(d) shall(d) not(e) depart(f)  (gh) from(g) tp,(e)  heart(g) of(fe) men,(d) which(d) remember(dg)  (gh) S(g) the(h) power(hg) of(h) God(j) for(i) .y(h) ever(h)  because(dh)  (hi) thou(hg) hast(f) not(e) spared(fg)  (e) thy(fe) life.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-252.png",
        nextFileName: "./pages/part-a-253.png",
    },
    {
        title: "part-a-252-1",
        gabc: "Behold,(g)  (ih) how(i) good(g) and(g) joy(dfhgh) ful(f) a(h) thing(jj) it(j) is,(jkjh) breth-(h) ren,(h) to(g) dwell(hgf) together(d)  (eef) P(gh) in(h) u-(g)ni-(g)ty.(g) ",
        groupIndex: 1,
        filename: "./pages/part-a-252.png",
        nextFileName: "./pages/part-a-253.png",
    },
    {
        title: "part-a-253-0",
        gabc: " (d)  (f)  (d)  (dc)  (fg)  (f)  (gh)  (hg)  (fg)  (h)  -(g)to(h) thy(fe) servants(d)  (d) health(d) of(c) soul(d) and(f) bo(d) dy.(d) ",
        groupIndex: 0,
        filename: "./pages/part-a-253.png",
        nextFileName: "./pages/part-a-254.png",
    },
    {
        title: "part-a-253-1",
        gabc: "0(f)  (ffe) [(d)  (e) i(g)  (h) Lk(f)  (e)  (g)  (h) [(g)  (hjji)  (g)  i(g)  (f)  (gh)  (h)  (h)  (g)  (hjji)  (gf)  (h)  (h)  (dffe)  :(ed) g(c)  (eg) =(fghf~) 1(gf) Ta(g)  (fe) =(e) ",
        groupIndex: 1,
        filename: "./pages/part-a-253.png",
        nextFileName: "./pages/part-a-254.png",
    },
    {
        title: "part-a-254-0",
        gabc: "e(dc) blessed(f)  (g) Gre-(f)go-(gh)ry,(h) T1ifted(h)  (g) up(h) to(ji) the(h) throne(jk) of(j) pe_(ihgh)  ter,(h) shewed(g)  (f) forth(g) i(h) deeds(g) .(fe) (](dc) of(d) the(e) Watchful’,(fe)  (d)  a(h)  (g)  (f)  (gh)  (gf)  he(j) .(j) excellent(i) [(g) shepherd(ij)  (h) left(h) a(g) behind(h) him(g) an(fe) example(d)  (e)  (f)  and(g) L(fge) pattern(g) of(g) priestly(gh)  (g) life.(e) I(j)  (h)  (j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png",
    },
    {
        title: "part-a-254-1",
        gabc: "](e) he(g) revealed(h)  (ij)  (i) fthe(h) mysteries(h)  (h) [](g) of(f) Ho~ly(i)  (h) Writ,(hg) there(h)  appeared(ig)  (ij) )(i) a(h) dove,(hg) whiter(f)  (fe) than(fgf) snow.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png",
    },
    {
        title: "part-a-254-2",
        gabc: "O(e) ye(g) servants(ef)  (f) of(g) the(h) Lord,(i) bless(gh) e(ij) the(j) Lord:(i) yoUr(i) ",
        groupIndex: 2,
        filename: "./pages/part-a-254.png",
        nextFileName: "./pages/part-a-255.png",
    },
    {
        title: "part-a-255-0",
        gabc: "gervant(g)  (i) Gre-(hg)go-(e)ry(ef) hath(df) ‘risen(h)  (f) to(g) the(f) heavens.(e)  (e) I(i)  (j) [](i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png",
    },
    {
        title: "part-a-255-1",
        gabc: "re-(dhi) (h) go—ry,T(h) mirror(h)  (g) of(h) the(gf) cloistered,(g)  (f)  (f) fathc;r(d)  (c) of(d) the(fg)  Ci(fe) ty,(e) .(g) beloved(gh)  (f) of(e) all(c) the(ef) world.(d) e(h)  (g) _(f) p(gf) d(fh) ",
        groupIndex: 1,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png",
    },
    {
        title: "part-a-255-2",
        gabc: "——(f) go-(ff)ry,(def) when(c) he(d) looked(ffg)  (f) up-(f)on(g) the(h) youthful(ih)  (g) Angles,(f)  (e)  2(ik) said:(ghggf) They(f) have(h) the(i) countenance(j)  (ih)  (g) of(f) An-(ghg)gels,(f) &lt;(c)  such(d) as(f) these(f) should(g) a(fe) of(f) the(g) fellowship(f)  (gi)  (ih) of(g) the(g)  An-(gf)gels(g) in(ghg) heaven.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-a-255.png",
        nextFileName: "./pages/part-a-256.png",
    },
    {
        title: "part-a-256-0",
        gabc: ".(cd) Ja(dhi)  (h) i(h) Jo-(hj) (h) seph,(hghihgg) the(g) husband(f)  (g) of(h) Ma(fe) 1y,(d) of(eg)  whom(gh) was(g) born(fg) Je-(d)sus,(d)  (ef) who(e) is(f) a(g) calledfChriat.(fe)  (d) P.T.(f)  rist,(dc) al(d) le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-a-256.png",
        nextFileName: "./pages/part-a-257.png",
    },
    {
        title: "part-a-256-1",
        gabc: "The(gi)  (fc) An-(fe)gel(fh) Ga-(gf)bri-(e)el(f) 1‘was(fe) sent(h) from(ji) God(j) to(j) a(i) virgin(kjk)  (j)  O(ig~) .(i) espoused(hg) e(h) to(i) a(g) man(ij) whose(h) name(i) was(hg) Joseph,(f)  (fi) of(h) the(h)  house(hg~)  (hg) of(fg) De-(f)vid:(e) a(c) the(e) virgin’s(f)  (ef) name(hg) e(e) 1y:(gg)  (f)  Y(gi)  (gg) ry,(f) al-(e)le-(ef)lu-(f)ia.(f) N(h) &amp;(g)  (e) =(f) ",
        groupIndex: 1,
        filename: "./pages/part-a-256.png",
        nextFileName: "./pages/part-a-257.png",
    },
    {
        title: "part-a-257-0",
        gabc: "=(de) Ma-(ghj)ry(hg) the(h) mother(j)  (ji) of(j) Je-(k)was(k)  (j) espoused(ji) to(h)  (i)  Joseph,(h)  (g) before(g)  (g) they(i) came(g) together,(h)  (fe)  (d) she(g) was(h) found(j)  with(g)  (ig) child(hg) of(e) the(f) Ho(ghgf) IyTGhost.(gf)  (e) P.T.TGhost,(ef) al(g)  le-(gf)lu-(e)ia.(e) =(ji)  (hi) —(h) &amp;(gh) ",
        groupIndex: 0,
        filename: "./pages/part-a-257.png",
        nextFileName: "./pages/part-a-258.png",
    },
    {
        title: "part-a-257-1",
        gabc: "Jo—seph(f)  (def)  (dc) [(de) ](e) being(gh)  (h) a(g) just(hi) man,(h) and(g) not(gh) will-(g) ing(f) to(g) make(gh) her(g) &quot;(f) public(g)  (f) .(e) am-(ef)ple,(d) was(e) minded(f)  (d) to(dc)  put(f) her(e) a-(f)way(ghg) Tpri-(fe)vi—ly.(de)  (e) vi—(fe)  (de) -(ef)al(g) le-(gf) lu-(e)ia,(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-a-257.png",
        nextFileName: "./pages/part-a-258.png",
    },
    {
        title: "part-a-258-0",
        gabc: "I(f) called(g)  (f) up-(f)on(g) the(gh) Lord,*(hg) The(gh) Father(g)  (fd) of(fg) my(g) Lorg;(f)  I(f)  (g) X.(f)  (c) That(h) he(hi) would(h) not(h) leave(fh) me(g) in(g) the(g) days(h)  of(g) my(f) trouble.(h)  (hg) The(gh) Father.(g)  (fd) X.Glory(h) be(h)  (h) to(h) the(h) Fa(hi)  ther(h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)1y(g) fhost.(h) B}(.I(f) called,(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-a-258.png",
        nextFileName: "./pages/part-a-259.png",
    },
    {
        title: "part-a-258-1",
        gabc: "0(f) called(f)  (f) up-(f)on(f) =(f) Lord,(g) the(f) Father(f) 2(e) of(g) my(g) Lord,(h) Al(h) le-(hg) lu-(g)ia,(f) al(d) le-(fg)1u(gf) ia.(f) I(f) called.(f)  (f) That(f) he(f) would(f) not(f)  leave(ik)  (g) me(f) in(f) the(f) days(f) of(f) my(e) trouble.(g)  (h) Al(h) le-(hg)lu-(g)ia.(f)  V.(i) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(ik) (h) ly(g) Ghost.(gf) I(f) called.(f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-a-258.png",
        nextFileName: "./pages/part-a-259.png",
    },
    {
        title: "part-b-000-0",
        gabc: "a(e) parents(eh)  (f) Ef(ed) Je-(ef)(B(e) susj&#39;went(gh) to(i) Je-(f) (h) ru_Sa_]em(h)  (g) s(hi)  (h)  year(hghih) at(f) the(e) feast(f) of(h)  (g) theTPsssover.(e)  (e)  (e) m(ce) 1](e)  (ef)  al-(g)le-(f)lu-(e)ia.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png",
    },
    {
        title: "part-b-000-1",
        gabc: "As(hig~)  (f) they(e) returned,f(c)  (ef)  (fe) the(f) Child(gh) Je-(i)sus(gf) tarri-(gh)ed(g)  (f) hehind(e)  (fh)  in(gi)  (i) Je-(h)ru-(ij)sa-(ih)lem;(h) and(hj) Jo-(h)seph(g) and(f) his(g) mother(ff)  (e) knev(gh)  ;(hgi) not(i) of(hg) fit.(f) it,(cfec) al-(e)le-(ef)lu-(f)ia.(f) |(h) m—(g)  (e) |(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png",
    },
    {
        title: "part-b-000-2",
        gabc: "a8(j)  &#39;nd(dde) when(g) they(h) found(g) him(hj) not,(j) they(hj) turned(k)  (j) back(k) a8(k)  to(j) 7(jifdfd~hfh) sa-(gffd)lem,(hjdf)  (ff) seeking(kff) -(ji)him:(hg) and(g) after(h)  (g)  (hj) |(j) ",
        groupIndex: 2,
        filename: "./pages/part-b-000.png",
        nextFileName: "./pages/part-b-001.png",
    },
    {
        title: "part-b-001-0",
        gabc: "they(ki~)  (ij) found(k) him(ji) 1n(h) the(g) a(e) temple,(gf)  (g) sitting(hj)  (h) in(g) the(f) midst(ghg)  of(i)  (g) the(f) doctors,(de)  (e) both(ef) hearing(e)  (d) them,(gh) and(fg) asking(g)  (h) them(gf) |(e)  fquestions.(i)  (e)  (e) &#39;fquestions,(e)  (ef) al-(g)le(gf) lu-(e)ia.(e)  (ji)  (hi)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png",
    },
    {
        title: "part-b-001-1",
        gabc: "His(ik)  (c)  (c)  (e) mother(f)  (d) said(cd) un-(fe)to(de) him,(e)  (eh) why(h) hast(g) thou(hj) thus(hgf)  dealt(ik)  (gh) with(gf) us?(ef) behold,(dh)  (h) thy(g) ](g) and(dc)  (de) I(e) have(f) sought(edfd)  _(ki~) g(ef) thee&#39;fsorrowing.(fgh)  (g) w(e) P.T{-(gh)Tsorrowing,(g)  (ef) &quot;(g) le-(gf)lu-(e)is.(e) w1(h)  (g) e(h) st(ih) Tea](gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png",
    },
    {
        title: "part-b-001-2",
        gabc: "]e-(gf)sus(d)  (ef) down(gh) with(h) -(g).aﬁd(g) came(f) to(h)  (j)  (j)  (jijkj)  and(j) was(h) [(jh) i(ih) E———(g)  (fg) e(gd) |(dfff)  (ef) T(fgfd) T(fe)  (fg) R(g)  (g)  .(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-001.png",
        nextFileName: "./pages/part-b-002.png",
    },
    {
        title: "part-b-002-0",
        gabc: "He(c)  (f) made(gh) im(hg) Lord(gfd) of(f) h1(g) house.(gf) H(f) made(gh)  ru-(hi)ler(h) of(g) all(g) his(f) substance.(gh)  (hg) Lord(gfd) of(f) hic(g)  Glory(h)  (h) be.(h) B.(h) e(f) made(gh) him.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png",
    },
    {
        title: "part-b-002-1",
        gabc: "He(f) nade(g) him(f) Lord(f) of(e) his(g) house,(h) *(h) le(hg) a(g) ia,(f) al-(d)fe.(fg)  lu-(gf)ia.(f) He(f) made(g) him.(f) And(f) ruler(g)  (f) of(f) all(f) :(e) sub-(g) stance.(h) TR(h) Al-(hg)lu-(g)ia.(f) |(c) A(f)  (f) be.(f) He(f) made(g) hin.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png",
    },
    {
        title: "part-b-002-2",
        gabc: "A(defd)  (dc) :(cd)  (d) o(f)  (e) s(d)  (e)  (e) p——(d) 41—(dfhi)  (h)  (h)  |(ik) ~(hg) I-(dgh) (f) 4(gh) _-(gd) (fg)  (d) 8(gfe) -(d) (dg) -(fe) (dc)  (dd) v(c)  e(f)  (fe)  (f)  (fddfg) :(dfefdffddcdfdhdhfhfdef)  (dd) L(dedf)  (dhdfdfddefdf) B(dcf) e(cd)  (d) ‘(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-002.png",
        nextFileName: "./pages/part-b-003.png",
    },
    {
        title: "part-b-003-0",
        gabc: "J‘;-(c) (ei) sus(gh) himself(ij)  (i) began(i)  (j) to(i) be(hi) a-(h)bout(hf) thirty(g)  (h) years(ij)  of(i) age,(i) being,(e)  (e) as(f) was(e) supposed,(d)  (ef)  (f) the(fi) son(h) ofT(fg)  (c) oseph.(fe)  (e)  Joseph,(fe)  (f) al-(g)le-(fg)lu-(e)I(i) e(j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-003.png",
        nextFileName: "./pages/part-b-004.png",
    },
    {
        title: "part-b-003-1",
        gabc: "e(c)  (g) Behold(g) a(h) faithful(j)  (j) and(j) wise(hj) servant,(j)  (i) whom(g) his(h) Lord(h)  hath(h) made(h) ru-(ih)ler(g) o-(h)ver(f) e(gf)  (c) o(e) o(e) P.T.}(c) house-(e) =(ef) a1-(g)S(gf) i(e) v(e) e(ddj) i(dh)  (djd) U(dih) 50(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-003.png",
        nextFileName: "./pages/part-b-004.png",
    },
    {
        title: "part-b-004-0",
        gabc: "Ho-(c) (cf) ly(f) Father(g)  (f) Ben-(g)e-(gh)dict,(hg) *(f) Intercede(gh)  (gfd) for(fg)  Father(g)  (f) Ben—e—dict..(gh)  (hg) That(h) we(hi) may(h) be(h) made(h) worthy(gh)  of(g) the(g) promises(h)  (g)  (f) of(gh) Christ.(hg) §.(f) Intercede(gh)  (gfd) for(fg) y,(gf)  R(c) Glory(h)  (h) be.(h) Ho-(f)ly(f) Father(g) e(f) Ben-(g)e-(gh)dict.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-004.png",
        nextFileName: "./pages/part-b-005.png",
    },
    {
        title: "part-b-004-1",
        gabc: "Hl°&#39;1Y(c)  (cf)  (f) Father(f)  (f) Ben;eadict,(g)  (f)  (f) :(f)  (e) intercede(g) for(g) .(h) *Al-(h)e-(hg) lu-(g)ia,(f) al(d) le-(fg)lu-(fg)ja.(f) Ho-(f)ly(f) e(f) :(f) Ben-(g)e-(f)dict(f) cic(f)  ‘We(ff) may(f) be(f) made(f) worthy(g)  (f) of(f) the(f) a(f)  (e)  (g) ot(g) ‘ot(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-004.png",
        nextFileName: "./pages/part-b-005.png",
    },
    {
        title: "part-b-005-0",
        gabc: "R(dc) S(cd)  (d) Mo(d) T(f)  (e) N(d) P(e)  (e) 1](d)  (idhi)  (h)  [(h)  (hg)  (gh)  (f)  (gh)  (g)  (fg)  (gfe)  (d)  (dg)  (fe)  (dc)  y(dd) =(c) loved(fe)  (fg) him(fe) and(dc) adorned(de)  (e) him.(defd) W(dc) o(cd)  (d) |(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-005.png",
        nextFileName: "./pages/part-b-006.png",
    },
    {
        title: "part-b-005-1",
        gabc: "T(c) et(d) hil(dc) the(d)  (f) multitdde(e)  (dc) of(e) the(f) faithful(g)  (ed) ex-(efe)ult(d) in(d) the(dh)  glory(hi)  (h) of(g) the(g) gracious(gh)  (h) Father(cd)  (d) Ben(fgf) le(dc) dict:(d) and(dhi) chief-(h) ly(gh) let(h) the(h)  (hg)  (fe) of(dc)  (cd) monks(fgh)  (fe) joyful,(fgf)  (d) ce-(h)le-(j) brating(ji)  (hg) his(gh) fes-(jk)ti-(ih)val(j) on(ij) earth,(h) in(h) whose(hg) goodly(fe)  (fg) fel-(e) a(efe) T(dc) the(cd) Saints(d) rejoice(fe)  (fgf) nTheaven.(ed)  (ef)  (d) p.T.T(c) L(e) &amp;(dc)  ol-(d)le-(efe)Ju-(d)jq.(d)  (h)  (g)  (f)  (g)  (dfgfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-005.png",
        nextFileName: "./pages/part-b-006.png",
    },
    {
        title: "part-b-006-0",
        gabc: "Thére(g) was(h) a(g) man(ji) of(h) ve-(ij)ne-(h)ra-(g)ble(fg) life,&quot;l&#39;(g) Be-(jk)ne-(j)dict(ji)  grace(ik)  (hg) and(e) by(fg) name,(g) who,(h) from(f) his(h) younger(k)  (j) years,(j) car.(j)  ri-(i)ed(hg) T(h) always(g) the(h) mind(ji) of(h) an(g) old(fg) man;(g) o-(j) (i) verpassing(jk)  (k)  age(kj) by(jk) virtue,(ji)  (hj) he(ji) de-(g)ni-(hg)ed(f) himself(f)  (hg) all(gji) vainT(hg) de-(fg) lights.(g) P.T.fdelights,(fg)  (gh) al-(i)le-(h)lu-(g)ia.(g) E—(j)  (i) ](j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-006.png",
        nextFileName: "./pages/part-b-007.png",
    },
    {
        title: "part-b-006-1",
        gabc: "he(e) b]egsed(f)  (e) man(d) Be-(g)ne-(hj)dict(j) de-(h)sir-(j)ed(i) rather(h)  (g) the(g) mi-(hi) ‘se-(h)ries(dgh) :(dg)  (d) .(dffdffdfdghg) world(fd~)  be(df) weari-(dhd~fhfddffiffjf)with(hfchgdfcdhfddfhdfhdhghdfdfdffdfdfddf) .(f)  (f) a(de) sake,(ddd) .(cf) to(d) be(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-006.png",
        nextFileName: "./pages/part-b-007.png",
    },
    {
        title: "part-b-007-0",
        gabc: "ex-(fg)alt-(h)ed(g) with(g) tran-(ghj)si-(g) (gh) to-(gf) (e) ryffavour.(e) Tfavour,(e)  (def)  al—]e-(g) (gf) ll.l-(e)ia.(e) i(j) ‘(i)  (hi) i(h) i(fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png",
    },
    {
        title: "part-b-007-1",
        gabc: "he(j) glorious(j)  (g) T(i) confessor(k)  (j) of(jk) the(j) Lord,(j) leading(ji)  (h) the(ij)  life(h) an-(g)ge-(h)lic(g) on(e) the(fg) earth,(g) was(g) made(g) a-(g) (h) mirror(g) of(h)  good(jk) works(ji) un-(g)to(hg) all(fd) the(f) world;(g) and(g) therefore(hj)  (j) with(j)  Christ(ji) he(h) rejoices(j)  (ih) R(g) |(fe) er-(d)more(ef) in(gh)  (h) theTheavens.(g) e(g)  a(g) Theavens,(gfd) -(fe)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png",
    },
    {
        title: "part-b-007-2",
        gabc: "B(c)  (d) e-(ef)dict(g) Tthe(g) man(gf) of(d) the(ef) Lord,(e) gentle(f)  (d) of(ef) a(g) a(g)  Nance,(g) was(g) 9(g) adorned(g) @(g) with(f) e(gh) angelic(h)  (gh) TN(e) wEETTE](d) so(dh) great(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-007.png",
        nextFileName: "./pages/part-b-008.png",
    },
    {
        title: "part-b-008-0",
        gabc: "a(h) brightness(i)  (h) shone(h) forth(h) round(g) a-(f)bout(gf) him,(e) that,(h)  although(ki~)  (h)  (g) yet(f) up-(g)on(fe) the(d) earth,(ed) he(d) might(e) be(f) -(h) :(g) among(g) =(f) celesti.alﬁI=(h)  (gf) beings.(e)  (e) beings,(c)  (e)  (f) dl-(g) (gf) lu-(e)ia,(e)   (h)  (g)  (h)  (ji)  (hg)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-008.png",
        nextFileName: "./pages/part-b-009.png",
    },
    {
        title: "part-b-008-1",
        gabc: "o(d)  (dc) de(f) the(g) man(f) ot(gh) God.(h) waa(h) filled(hj)  (h) with(h) the(h) apis(h)  rit(g) of(ef) all(g) the(fe) TS(d) righteous:(d) e(f) he(fe) SN(c) intercede(df)  (ffg) for(f) the(fe)  a(ik)  (cdc) L}(c) conventu-(eg) (e) alf(f)  (e) profession.(d)  (d) profession,(e)  (d)  (dc) al-(d) le-(efe)lu=-(d)1ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-008.png",
        nextFileName: "./pages/part-b-009.png",
    },
    {
        title: "part-b-009-0",
        gabc: "Be_ne—dicc,(d) thou(e) father(g)  (gh) and(dfg) guide(g) o(f) monks,(e) thou(g) most(g)  Be_ne—dicc,(f)  1y(h) Confessor(h)  (gg) of(g) the(ghg) Lord,(e) intercede(f)  (d)  (ggh) for(g) us(d) all(g)  hoe=-(ghj) and(g) for(gf) ourTsal-(g) (ghg) vation.(e)  (e) P.T.(eh) *salvation,(ghg)  (e) &quot;(ef) al-(g)le-(gf)ia.(e)  -(ik) (h)  (g)  (h)  (ih)  (gfe) AT(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-009.png",
        nextFileName: "./pages/part-b-010.png",
    },
    {
        title: "part-b-009-1",
        gabc: "To—day(eh) il(hgf)  (g) ho-(ef)ly(f) Be-(fg)ne-(f)dict,(f) while(fg) his(f)  (e) disciples(f)  (h) beheld(fg)  (f)  N(hgi) it,(e) =(f) ascended(fc) ;(f)  (f) way(f) of(f) the(f) L(fg) on(f) a(f) straight(f) path-(fh)L(f)  %ay(hig~)  (f) to(f) hea-(gh)ven:(jkijijkj) to—day(f)  (fj) with(j) hands(j) uplifted(j)  (ij)  (i) he(i) di-(ij)ed(i)  b(hgi)  (i) etween(i) the(i) r(i) of(h) his(f) =(h) supplica(h) -(fghgfef)(T(fe) T(e) e(ehg)  (hg)  |(gi) Y88(f)  (gf) received(ef) _:___l-(f)in-(e)to(f) -(h) (g) by(g) the(g) -(eg) (f)  (f) —l(h)  (gf)  (hg)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-009.png",
        nextFileName: "./pages/part-b-010.png",
    },
    {
        title: "part-b-010-0",
        gabc: "while(hgi)  (eh)  (hg)  (fg)  (ef)  (f)  (fg) his(f) disciples(f)  (h) beheld(fg)  (f) it,(e) N(f)  ;:ende.cl(ig~)  (cf)  (f) by(f) way(f) of(f) the(f) Fast(fg) on(f) a-(f)straight(fh) pathway(f)  (f) 0(f) }E_(h)  ven:(hig~)  (ijijkj) and(jf~) with(j) hands(j) uplifted,(j)  (j)  (i) he(i) di-(ij)ed(i) between(i)  (i) the(i)  words(hgi)  (i) of(h) his(f) supplica(h)  (h) -(fhgfef)tion,(fe) and(ehg) was(f) received(gf)  (ef)  (f) ip-(e) to(hgi)  (f) glory(h)  (g) by(g) the(g) Angels,(eg)  (f) al-(g)le-(hg)lu-(f)ia.(f) E}(h) w1(gf)  (hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-010.png",
        nextFileName: "./pages/part-b-011.png",
    },
    {
        title: "part-b-010-1",
        gabc: "e(f) smoke(f) of(f) the(f) incense(g)  (f) ascended(f)  (g)  (gh) up(hg) before(fd)  (fg) God:(dgf)  The(f) ‘smoke.(f)  (f) Out(c)  (i)  (hi) of(g) the(f) Angel&#39;s(g)  (gh) hand.(hg) Before(fd)  (fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-010.png",
        nextFileName: "./pages/part-b-011.png",
    },
    {
        title: "part-b-011-0",
        gabc: "7.(c) Glory(fh)  (h) be.(h) The(f) smoke.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png",
    },
    {
        title: "part-b-011-1",
        gabc: "he(f) smoke(f) of(f) the(f) incense(g)  (f) ascended(f)  (f)  (f) up(f) before(e)  (g) God,*(h)  Al-(ik) (h) le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu(gf) ia.(f) The(f) smoke.(f) T(c) Out(f) of(f) the(e)  Angel’(g)  (g) s(h) Al-(h)le(hg) lu-(g)ia.(f) Glory(f)  (f) be.(f) The(f)  smoke.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png",
    },
    {
        title: "part-b-011-2",
        gabc: "[(i)  (h) ](g)  (h) i;(dgfef) [(dc) »(g) a(g) |(f) [(g) :(h) =(h) !(h)  (j)  (k)  :(jih) o~(h) b(i)  (g) =ty(f)  (g) s(h) |(h)  (h) [(h)  (g) e(h) I(dgfef) .(dc)  (g)  0(g) z(g) Angel(f) e(gh)  (hgf) Rl(f) (v(ef) (e(fghg) T(e) L)(fe) G(d)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-011.png",
        nextFileName: "./pages/part-b-012.png",
    },
    {
        title: "part-b-012-0",
        gabc: "he(e) Angel(ei)  (i) Ge-(hg)bri-(hi)el(i) Tcame(i) in(jk) un-(j)to(i) Ma(hgf) ry(g) and(fgf) gajq(e)  Hail,(ei) thou(i) that(h) full(h) of(hi) grace,(i) the(i) Lord(j) is(k) =(ij)  thee;(i) blessed(j)  (j) art(hi) thou(hh) @(fe) &quot;(fgf) s(e) 8-(e)g(e)  (e)  al-(fg)le(f) -(e)ia.(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-012.png",
        nextFileName: "./pages/part-b-013.png",
    },
    {
        title: "part-b-012-1",
        gabc: "hen(e) Za—cha-(eh)ri-(f)as(f)  (e) twent(f) in-(ed)to(f) the(dhg) temple,(e)  (e) there(e) ap-(e) 0(ig~)  (jg~hi) peared(i) SR(j) to(ih) him(h) the(h) Angel(h)  (gf) Gabriel,(gh)  (g) T(e) o)(i) P(g) |(fe) T(fg) -(f) right(gh) side(hj) of(i) .(j) e(hf) =(hi) o(hg) offincense.(e) el(e) |(fhi) P.T.Tincense,(e) a5(ef)  al(g) -(f)&quot;(e) o(e) -(h) (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-012.png",
        nextFileName: "./pages/part-b-013.png",
    },
    {
        title: "part-b-013-0",
        gabc: "ut(d) the(f) L}(dc)  (f) said(g) un-(f)to(gh) him,(h) Fear(hj) not,(h) Za-(g)cha-(f) ri-(gh)as,(g) for(g) thy(ef) prayer(gh) isfheard.(fe)  (d) heard,(dc) al(d)  le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png",
    },
    {
        title: "part-b-013-1",
        gabc: "[(ff) dm(dc) the(f) An—gel(g)  (fg) Ga-(h)bri-(gf)el,T(f) that(f) stand(gi) in(i) the(h)  |(ik) presence(g)  (i) of(h) God;(hgf) and(g) e(h) sent(f) L(dc) -(dg)S(gh)  (g) ||(f)  fthee,(fe) al(g) ~le(gh) -(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png",
    },
    {
        title: "part-b-013-2",
        gabc: "L](e) An-(ei)gel(i) Ge-(hg)bri-(hi)el(i) e(jk) un-(j)caenesseessesalice.(i) Ma(hgf) .(g) e(e) A(e)  a(e) Behold,(ei) thou(i) shalt(h) a(g) conceive(h) in(h) &quot;(hij) womb,(i) and(i) bring(jk) ",
        groupIndex: 2,
        filename: "./pages/part-b-013.png",
        nextFileName: "./pages/part-b-014.png",
    },
    {
        title: "part-b-014-0",
        gabc: "forth(ig~)  (j) a(ij) Son,(jih) an_d(h) shalt(f) call(hg) his(fe) Nape(fgf)  (e) =(e)  al(gi)  (e)  (e)  (fg) =le-(f)1lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 0,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png",
    },
    {
        title: "part-b-014-1",
        gabc: "hen(j) said(hg) Ma-(hj)ry(j) Tun-(j)to(h) the(ih) An-(g)gel,(g) How(hg) shall(ef) this(gf) be,(df)  seeing(f) )(e) I(d) 8(ef) =(h) a(g) 53(e) And(d) the(d) An-(hd)gel(h) Ga-(h)bri-(g)el(h)  answered(ik)  (j)  (i) a(g) and(g) said(ij) un-(i)to(h) her,(h) The(h) Ho-(hk)ly(j) Ghost(j) shall(hf)  come(gh) up-(g)ﬁ(ec) thee,(de) a(e) &quot;(e) :(f) .(d) e(e) .(f) .(fh) -(g)e(h)  -(ik) (g)  (f) s(g) i(ghg) e(e) e(df) a0(g)  (gf) S(e)  (e) —(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png",
    },
    {
        title: "part-b-014-2",
        gabc: "5(f) presence(fdfdgfdfdf) ——(fdf)  (cddcf)  (ddfgh) I(ddfdhg)  (dfdddcfg) P(f) .&quot;2:11:.1(fc) sing(g) p!(fgh) raiseé(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-014.png",
        nextFileName: "./pages/part-b-015.png",
    },
    {
        title: "part-b-015-0",
        gabc: "un(g) to(fd) thee,(fg) O(g) my(f) God.(f) 1In(f) the(f)  (g) presence.(f) I(c)  (h) will(h)  worship(hi)  (h) toward(h)  (h) thy(h) ho(h) 1ly(h) temple,(gh)  (g) and(g) praise(f) thy(gh) Name.(hg)  will(g)  (f) sing.(g) Glory(h)  (h) be.(h) In(f) the(f) presence.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-015.png",
        nextFileName: "./pages/part-b-016.png",
    },
    {
        title: "part-b-015-1",
        gabc: "In(cf) e(f) presence(f)  (f) of(f) the(f) Angels(g)  (f) I(f) will(f) sing(f) preise(g)  un-(f)to(f) thee,(f) ](e) my(g) God,(h) Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f)  In(f) the(f)  (f) presence.(f) V.(c) I(f) will(f) worship(f)  (f) toward(f) thy(f) ho-(f)ly(f)  temple,(g)  (f) a(e) praise(g) thy(g) Name.(h) Al-(h)le(hg) lu-(g)ia.(f)  Glory(f)  (f) he,(f) In(f) the(f) presence.(f)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-015.png",
        nextFileName: "./pages/part-b-016.png",
    },
    {
        title: "part-b-016-0",
        gabc: "g(d)  (fh)  (h)  (i) LI(dhg)  (h)  (i) gﬁ-(jh) (k)  (i)  (j)  (h)  (ih)  %—(gf)  (e)  (f)  (d)  (d)  (e) (](d)  (gf)  (e)  (f) |(h)  An(f)  (h) Angel(f) stood(g) at(fed) L(c) of(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-016.png",
        nextFileName: "./pages/part-b-017.png",
    },
    {
        title: "part-b-016-1",
        gabc: "T(c)  (c) he(e) An-(g)gel(h) Ga-(i)bri-(j)el(i) W(j) Y(hi) R(i) to(g) Za-(i)A(h) e(hh) as,(e) and(f)  said(hf) vmn(g) to(f) him:(e) Thy(f) wife(ed) shall(ef) bear(fi) thee(h) a(ij) son,(i) and(j)  thou(dhg) shalt(f) call(ghi) his(h) name(k) John;(ji) and(e) ma—ny(ef)  (d) shall(f) re-(i) joice(hi) at(j) his(ih) birth;(ikjk)  (i) for(j) he(i) shall(h) ](g) before(h)  (i) the(h) face(ij)  of(fgji) the(hi) :(i) G(dfhgfi) &gt;(hgf) pare(g) his(fgf) Tways.(e) |-(e) al(fg) le(f) -(d)lu(e) ia.(e)  (hh)  (if)  (ddjd)  (di)  (d)  (dh)  (d)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-016.png",
        nextFileName: "./pages/part-b-017.png",
    },
    {
        title: "part-b-017-0",
        gabc: "The(c)  (cd)  (df)  (d) Gabriel(ed)  (c)  (d)  (f) Tsaid(g) un-(fe)to(c) Ma-(ef)ry:(d) With(fg) God(hgg)  nothing(ik)  (h)  (g) shall(f) be(g) impossi-(e) (gh) ble.(fe)  (d) And(dhh) Ma(hj) ry(h) said,(h) Be-(f) hold(ki~)  (h) the(gf) handmaid(g)  (fe) of(d) [(c) Lord:(df) be(f) it(de) un-(d)[](c) -(df)ac-(e) cording(ki~)  (f)  (g) to(h) thy(gf) word.(ffgf) And(fh) the(gf) Angel(g)  (d) cﬂaparted(ef)  (g)  (fe) from(d)  Ther.(de) ‘Ther,(dc) al(d) le-(efe)lu-(d)ia.(d) SN(h) o(g) sl(f)  (g) el(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-017.png",
        nextFileName: "./pages/part-b-018.png",
    },
    {
        title: "part-b-018-0",
        gabc: "T(c) he(cgd) Ho-(f)1y(gh) Ghost(g) shall(g) come(g) up=-(h)on(g) thee,(f) Ma-(gh)ry.(h) S(f)  the(h) power(jji) of(h) the(hi) Highest(hg)  (g) shall(g) —(gf) o—ver-(d) (f) s}xa—doth},ee_(fg)  (c)  (g)  al-(g) (ih) le-(h)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-018.png",
        nextFileName: "./pages/part-b-019.png",
    },
    {
        title: "part-b-018-1",
        gabc: "The(cc)  (ch) An—gelT(fg)  (gh) Ga-(f)bri-(g)el(i)  (hi) was(hf) sent(h) to(j) Ma-(i)ry,(j) &amp;(h) Virgin(j) -(ij)es-(h) oo(gf) poused(fgh) to(i) =(h) Joseph.(g) Al(ef) -(fg)le-(g)lu~ia.(g) |(hf) e(j)  (i) e(j)  (h) )(gh)  Ma-(cd) (idhi) ry,(h) T(j) thou(h) that(g) art(f) full(g) of(gh) grace,(h) the(f) Lord(h)  is(gf) with(g) thee:(d)  (fh) blessed(g)  (h) art(g) thou(dfe) 7](f)  (dfgf) =(c)  (d)  (d)  women,(dc)  (ef) al-(g)|(defe) lu-(d)ia.(d) |(dfhfghi) .(h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-018.png",
        nextFileName: "./pages/part-b-019.png",
    },
    {
        title: "part-b-019-0",
        gabc: "Fear(c)  (gj) not,(hgf) Me-(gh)ry,(gh) for+thou(f)  (g) hast(g) found(cdgh) fa(ijkji) vour(gh) with(i)  the(h) Lord:(g) behold,(g)  (h) thou(ge) shalt(f) conceive,(gh)  (fed) and(d) bring(ef)  forth(gh) afSon.(h)  (g) Wy(gfd) al-(f)le-(fg)lu-(g)ia.(g) e(j) e(i) e(j)  (h) o(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png",
    },
    {
        title: "part-b-019-1",
        gabc: "The(c)  (c)  (d) Lord(d)  (cd) give(fg) un-(f)to(gh) him(h) the(h) throne(ih) of(g) his(f) fa-(gh) ther(fe) We(dfe) vid,(dc) .(dc) he(f) shall(ef) reign(g) |(fe) orfev-(d)er.(d) phe——(d)  Er,(cd) al(d) -(efe)lu-(d)ia.(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png",
    },
    {
        title: "part-b-019-2",
        gabc: "the(c)  (j)  (ji)  (hg) handmaid(hi)  (h) of(fgh) the(h)  (g) be(ge) it(g) un-(f)to(e) me(f)  8ccording(d)  (e)  (f) to(fgh) thy(h) word.(g) al-(hi)T(h) lu-(g)ia.(g) [(j)  (h) ](j)  (k)  (j) ",
        groupIndex: 2,
        filename: "./pages/part-b-019.png",
        nextFileName: "./pages/part-b-020.png",
    },
    {
        title: "part-b-020-0",
        gabc: "T(cc) he(f) Angel(g)  (f) of(g) the(gh) Lord(hg) *(f) Announced(h)  (g) un(fd) to(fg) Ma-(g)ry.(f) Tpe(f)  .(g) Angel.(f) And(h) she(hi) conceived(h)  (fh) by(g)  (h) the(g) Ho-(f)1ly(gh) Ghost,(hg)  R.(f) Announced(gh)  (g) un-(fd)to(fg) Ma-(g)ry.(f) ¥.(c) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h)  and(h) to(gh) the(g) Son(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) The(f) Angel(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-020.png",
        nextFileName: "./pages/part-b-021.png",
    },
    {
        title: "part-b-020-1",
        gabc: "T(c)  (c) he(f) Angel(f)  (f) of(f) the(f) Lord(f)  (f) announced(g)  (f) un-(f)to(e) Ma-(g)ry,(h) Al(h) le-(hg) lu-(g)1a,(f) al-(d)le-(fg)lu-(gf)ia.(f) The(f) Angel.(f)  (f) And(c)  (f) she(f) conceiv-(f) (g)  ed(f) by(f) a(e) Ho-(g)ly(g) Ghost.(h) Iy(h) -(hg)lu-(g)ia.(f) Glory(f) be(f)  (f)  to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)1¥(g)  The(f) Angel:(f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-020.png",
        nextFileName: "./pages/part-b-021.png",
    },
    {
        title: "part-b-021-0",
        gabc: "a(c)  (c)  (e) shall(g) this(ih) be,TO(fh)  (h) Angel(h)  (g) of(f) God,(efhfghg) seeing(g)  (h) I(iji) know(hf) mot(g)  a(ig~)  (f) man?(e) Hearken,(iji)  (i) O(jjk)  (k) Virgin(jkj)  (ji) Ma-(j)ry:(ijig) The(h) Ho-(j)ly(i) Ghost(hih)  shall(hg) come(ij) up-(i)on(hg) thee,(fh) and(h) the(i) power(hg) of(f) the(gh) Highest(f)  (e)  shall(e) o-(e) (ef) vershadow(fe)  (de) TR(e) Al-(gf~)le-(f)lu-(e)ia.(e) [(j) I(i) e(h) e(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-021.png",
        nextFileName: "./pages/part-b-022.png",
    },
    {
        title: "part-b-021-1",
        gabc: "T(c) a(e) An-(e)gel(i) Ga-(hg)bri-(hi)el(i) spake(jk) un-(j)to(h) Ma-(g)ry,(fgf) B(e) B(e)  Bail,(ei) thou(ii) that(h) art(g) full(h) o(hi) grace,(i) the(i) Lord(j) is(k) with(j)  thee;(i) blessed(j)  (j) art(hi) thou(hh) a-(dfe)mong(fgf) @~(e) 8-(e)Al(gf~) Te-(f) lu-(e)ja,(e)  (i)  (j)  (i)  (h)  (gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-021.png",
        nextFileName: "./pages/part-b-022.png",
    },
    {
        title: "part-b-022-0",
        gabc: "He(c)  (cf) hathmade(f)  (gh) me(hg) *(fd) so-(fg)late,(gf) He(f) hath(f) made.(gh) Apg(h)  (hi) =(g)  all(f) the(gh) day.(hg) -(fd)so-(fg)late.(gf) ¥.Glory(c)  (h) f_l(h) be.(h) BiHe(f) l—_l—la{(f) magy,(gh)  =(f)  (g)  (h)  (g)  (h)  (j)  (i)  (h) i(h)  (g)  (f)  (e) S(d)  (e)  (d) 1(c)  ](g) [(f)  (g)  (h) a(g)  (f) -(f)a(f)  (g) a(h)  (g)  (h)  (j)  (i)  (h)  Pray(h)  (g) for(f) a(e) O(d) 2(e)  (d) .(c)  (g)  (f)  (g)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-022.png",
        nextFileName: "./pages/part-b-023.png",
    },
    {
        title: "part-b-022-1",
        gabc: "Si-(f)me-(gh)on(f) Tsaid(f) un-(dfe)to(dc) :(ifghghi) ry,(h) Yea,(hj) a(h) sword(h) shall(fg) pie(fe)  through(dg) thine(gf) own(gddd) soul(ghg) al-(ddfd)so.(fd) =(ddfddddh)  (f)  (fh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-022.png",
        nextFileName: "./pages/part-b-023.png",
    },
    {
        title: "part-b-023-0",
        gabc: "-(g) (g) O(f) a(e)  (f)  (hg) :(fg)  (g) a(gh)  (i)  (j) [](h)  (i) _.n(g)  (fg)  (g)  Hymn(j)  (h) Melody(i)  (g) at(hg)  (f) Prinma,(fh) :(h) Terce,(hg) Sext,(e)  (f) and(h) None(ih)  (g)  (fg)  (g)  U(ig~)  (e)  (f)  (gh)  (g)  (fe) N(f)  (g)  (f)  (f)  (g)  (h)  (ih)  (g)  (fh)  (hg)  (g)  e(gi)  (g) S(i)  (ij) e(ji) |(hg) B(fh) )(hg) B(g) T(e)  (f)  (gh) T(g)  (fe) I(fg)  (gf) |(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png",
    },
    {
        title: "part-b-023-1",
        gabc: "[(d) will(d) get(dh) me(h) to(h) the(h) mountain(j)  (k) of(ji) myrrh,(h) and(h) to(g) the(h)  hill(h) of(h) sl(efe) o(d) e(d) sk(h) RS(g) e(f) Sieboaat(gh) g(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png",
    },
    {
        title: "part-b-023-2",
        gabc: "&#39;(cgi)  (cfe)  (c) Tis(ef)  (f)  (h) white(g) and(ef) ruddy:(fg)  (f) the(h) locks(j) of(ih) his(hj) head(j)  :(i) re(h) as(i) royal(ji)  (hg) purple,(fefh) _-(hg)bound(fe) in(c) _l-(ef)tresses.(f) [(h) —l(g)  (e) =](f) _(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-023.png",
        nextFileName: "./pages/part-b-024.png",
    },
    {
        title: "part-b-024-0",
        gabc: "W(cc)  (ghj) hither(j) thy(j) be-(j)lov-(ji)ed(hi) gone,(i) O(ik) thou(j) fajreg,(ji) L(g) (](h)  (g)  women?(ef) ](g) whither(g) e(h) is(h) thy(j) be-(h)lov-(h)ed(gf) turned(gh)  (g) a-(gf)Wi(e) side?(ji) mh&#39;(hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png",
    },
    {
        title: "part-b-024-1",
        gabc: "A(ff) buncle(h)  (h) of(hj) myrrleis(i)  (i) my(i) well-(h)be-(i)lov-(j)ed(ih) un~to(ij)  (j) me;(i) he(f)  shall(i) lie(g) all(h) night(fe) betwixt(fe)  (de) my(fh) breasts.(f)  (i) Bl(h)  (i) 1(j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png",
    },
    {
        title: "part-b-024-2",
        gabc: "Stay(de) me(f) with(ge) tlagons,(fe)  (d) T(f) comfort(g) me(h) with(ig) apples;(h)  (h) for(dhhg)  I(fe) pbm(dc) sick(e) of(ef) love.(d) a(h)  (g) gardinpiiE]l(f)  (gh) e(gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png",
    },
    {
        title: "part-b-024-3",
        gabc: "O(f) God,(g) my(gh) life(hg) I(f) have(g) declar-(h)ed(gfd)  (fg) un-(g)to(f) thee.(f) O(f)  (f) Go(g) ",
        groupIndex: 3,
        filename: "./pages/part-b-024.png",
        nextFileName: "./pages/part-b-025.png",
    },
    {
        title: "part-b-025-0",
        gabc: "‘z_(ki~) Thou(hi) hast(h) put(g) my(h) tears(g) in(f) thy(gh) sight.(hg) I(f) have(g)  declared.(ik)  (h)  (dgfd)  (fg) Clory(h)  (h) be.(h) G(f) God.(g)  —(ik)  (f)  (e)  (fg) L](h)  (g)  (e) .-(f) (e)  (h) T(h)  (g)  (f) [(e) ](de) [(e)  [(ki~)  (g) ](c)  (f)  (d)  (e) =(e)  (e) a(c)  (d)  (e)  (e)  (e)  (e)  (f)  (e)  ¥(ik)  (f) and(g) By(h) at(h)  (h) Vespers(h) above.(i)  (h)  (f)  (g)  (h)  (g)  (fd)  (d)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-025.png",
        nextFileName: "./pages/part-b-026.png",
    },
    {
        title: "part-b-025-1",
        gabc: "When(cc)  (gd) Je-(fg)sus(gh) therefore(h)  (hghih) Tsaw(f) his(gh) mother(j)  (g) standing(h)  (g) by(f)  the(fe) -(d)and(g) the(g) disciple(g)  (gh)  (g) 7(e) he(f) =(gh) loved,(g) he(g) saith(hj)  un-(ji)to(hg) T(fg) T(g) mother,(g) |(gi) S(ih) e(j) behold(hg) thy(hih) son!(g) Then(gd)  saith(fgh) he(g) to(h) the(g) disciple,(f)  (gh) -(h)Behold(j) -(hg)thy(fhih) [(g)  (g) ](fh)  (j) 1(ij)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-b-025.png",
        nextFileName: "./pages/part-b-026.png",
    },
    {
        title: "part-b-026-0",
        gabc: ".(e) blessed(f)  (ed) Anselm(gh)  (g) Tinstructed(g)  (g)  (g) the(h) princes(j)  (ij) ———a(k) his(ji)  time,(hi) saying:(g)  (g) God(jj) O(hg) esteemeth(h)  (ge) nothing(f) a(e) more(f) highly(gh) i(g)  in(h) this(j) world,(ij) than(i) the(j) freedom(kj)  (hj) of(g)  (gf)  (c) |(e)  P.T.TChurch,(ef) al(g) =le-(gf)lu-(e)ia.(e) ](ji) _l_l(hi)  (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-026.png",
        nextFileName: "./pages/part-b-027.png",
    },
    {
        title: "part-b-026-1",
        gabc: "0O-(igij) (i) ans(hih) N(h)  (hg) full(d)  (hg) of(f) the(h) Ho-(hi)ly(hg) Spirit,(e)  (e) ](d) ve-(f)",
        groupIndex: 1,
        filename: "./pages/part-b-026.png",
        nextFileName: "./pages/part-b-027.png",
    },
    {
        title: "part-b-027-0",
        gabc: "newed(h)  (g) the(f) glory(hi)  (i) of(i) the(i) mo-(ij)nas-(hgf)tic(h) Order(f)  (ed) tlroughout(e)  (fh)  tle(hg) world,(ef) al-(g)le-(f)lu-(e)ia,(e) .(i)  (j)  (i)  (h) viij(h)  Ma(cfgh) jolus,(g)  (g) +(g) overflowing(g)  (h)  (g) with(h) love(g) and(f) favour,(gh)  (f) and(h)  striving(j)  (i) to(h) attain(j)  (jk) an-(hg)gel-(h)ic(g) loliness,(f)  (f)  (defeded) &quot;was(cd) lifted(fg)  (g)  high(f) n(g) above(h) mankind(gf)  (hj) in(i) virtue,(g) =(fgh) al-(i)le-(h)lu-(g)ia.(g) W(j)  (i) -(j) (h) 1(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-027.png",
        nextFileName: "./pages/part-b-028.png",
    },
    {
        title: "part-b-027-1",
        gabc: "-(cdf) (f) d1—loTwonderfully(f)  (f)  (e)  (de) showed(edc)  (d)  (c) what(d) charity(f)  (fe) of(d)  (de) heart(ge)  he(fe) %(d) maintained;(cd)  (d) who,(dh) grieving(hi)  (h) for(h) the(g) é(gh) sufferings(g) ](g) of(g)  the(g) -(gf)a(g) departed,(gh)  (fg)  (f) vearly(h)  (gf) decreased(g)  (fe) -(d)them(d) by(d) n(e)  e(f)  (gh) v(g) of(f) g(ef) &amp;(g)  (e) |(fe) refreshment,(d) =(dc) al-(d)le(efe) lu-(d)soga(d) =(h)  (g) 7(f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-027.png",
        nextFileName: "./pages/part-b-028.png",
    },
    {
        title: "part-b-028-0",
        gabc: "Ween(cc)  (ed) blessed(g)  (hj) Hu-(ij)go(j) fwas(i) about(j)  (k) to(j) die,(j) on(j) the(j) g3(ij)  (h)  the(g) rites(h) of(g) Ho-(f)ly(d) Sabbath,(ef)  (e) he(d) greeted(h)  (g) a(g) ney(hg) light(hj)  like(ik)  (h) e(gf) aPaschal(g)  (h) can-(gfe)dle,(e) earnestly(g)  (h)  (j) entreating(j)  (ji) (s(hg) witj(hg)  requent(fe)  (d) sighs(e) that(dh) it(g) might(f) reach(gh) the(h) earth(j) by(h) way(h)  of(ki~)  (gf) happy(g)  (h) promise,(gfe)  (ef) al-(g)le(gf) 1lu-(e)ia.(e)  (ji) -(hi) (h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-028.png",
        nextFileName: "./pages/part-b-029.png",
    },
    {
        title: "part-b-028-1",
        gabc: "are(c)  (ddc)  (cf)  (fe) a(dc)  (c) vye(d) Saints(f) of(gh) God,(gfe) who(fe) have(d) [](c)  worthy(df)  (f) to(g) share(dc) in(f) heav’&#39;n-(ffg)ly(fe) perfections,(de)  (dd) .(c) and(fg) to(f) [}(e)  -(ggh),.(c) the(d) honour(fg)  (f) of(f) high(f) rendwn,(fe)  (dc) al(d) le(efe) lu-(d)1a.(d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-028.png",
        nextFileName: "./pages/part-b-029.png",
    },
    {
        title: "part-b-029-0",
        gabc: "hy(f)  (gg) 0(h) Lord,(h) shall(g) be(df) whiter(g)  (g) than(fe) show,(dc) al-(d) le-(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png",
    },
    {
        title: "part-b-029-1",
        gabc: "T(ki~) he(f) righteous(fg)  (g) shall(f) give(h) thanks(j) tun-(j)to(i) thy(hg) Name,(hg) and(g)  the(ik)  (g) just(fe) shall(f) continue(d)  (e) ST(f) in(gh) thy(h) sight,(gfd) al(fe) -(fg)1lu-(g)ia(g)  =(ik)  (j)  (i)  (j) a(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png",
    },
    {
        title: "part-b-029-2",
        gabc: "1(e) you,(gh) my(hji) Saints,(i) who(ih) in(i) this(j) world(kj) have(i) en-(hij)dur-(h)ed.(f)  the(ghi) struggle,(g)  (g) do(g) I(h) render(ij)  (i) the(h) reward(h)  (hih) of(f) your(f) la(fe)  bours,(d) a](ef) e-(f)1y~(e) ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-029.png",
        nextFileName: "./pages/part-b-030.png",
    },
    {
        title: "part-b-030-0",
        gabc: "0(dh) ye(hj) Spirits(hg)  (h) Tand(f) ho-(g)1ly(f) Souls(fgh) of(f) the(e) righteoys(d)  (d)  a(ef) hymn(g) un-(f)to(fe) God,(dc) al-(d)le~(efe) lu-(d)ia.(d) |(h)  (g) s(f)  (gh)  (gh)  ¢(j) are(j) lo-(ih)ly,(h) G(gfe) the(fg) Lord;(g) end(g) :(f) Twill(g) muleg;.(h)  (j)  ply(j) your(jkj) number,(h)  (h) to(j) make(j)  (ih) supplication(gh)  (i) for(h)  (h) my(gf) people(gh)  (h)  in(ik)  (h) this(g) place,(gfd) al-(fe)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j) |(k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-b-030.png",
        nextFileName: "./pages/part-b-031.png",
    },
    {
        title: "part-b-030-1",
        gabc: "righteous(cccdc)  (cf)  (fe) shall(de) s(dc) and(c) run(df) to.(gf) and(d) fro(ed) like(d)  sparks(efedcdfe) among(fghg)  (ed) the(fe) stubble;(d)  (d) they(ef) shall(gh) judge(fe) the(de) na-(d) a-(c)[}(c) shall(d) reign(f) for(gh) ev-(fe)ér,(dc) al-(d)le-(efe)lu-(d)1a.(d)  (hgfggfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-030.png",
        nextFileName: "./pages/part-b-031.png",
    },
    {
        title: "part-b-031-0",
        gabc: "et(c)  (f) not(ef) your(de) hehrt(ddc) be(cd) troubled,(ffgf)  (f) neither(fe)  (g) let(gh) it(g) be(f)  a-(fgf)fraid;(f) ye(f) believe(gh)  (h) in(j) God,(ihgf) a(e) bhelieve(fg) al(gfe) s0(d) 1in(ef)  e:(dc) in(d) my(cd) Fa-(ffg)ther’s(f) house(f) are(h) ma-(g)ny(h) mansions,(f)  (dg) al-(c) le-(d)lu-(fg)ia,(fe) al-(g)le-(gh)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-031.png",
        nextFileName: "./pages/part-b-032.png",
    },
    {
        title: "part-b-031-1",
        gabc: "Lord,(c)  (hgih~) shew(ig) us(ij) the(i) Father,(hhi)  (h) and(h) it(h) suf-(f)fic-(hih)eth(g) us,(ef)  L](g) le-(f)&quot;(e) a.(e)  (i) .(j)  (i)  (hi)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-031.png",
        nextFileName: "./pages/part-b-032.png",
    },
    {
        title: "part-b-032-0",
        gabc: "Phi-(c) (hg) lip,(hi) The(ig) that(ij) hath(i) seen(h)  (ih) me(h) hath(h) seen(h) my(f)  a(e) so,(f) al-(g)le-(f)-(e)A-(e) (i)  (j)  (i)  (hi)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png",
    },
    {
        title: "part-b-032-1",
        gabc: "Have(c)  (c)  (g) I(hj) beentso(jji)  (h) long(ji) time(ji) with(h) you,(g) and(g) yet(hj) hest(j)  not(hi) known(i) me,(kj) Philip?(hi)  (i) he(i) that(j) hath(i) seen(hi) me(g) N(g)  seen(ih) my(hg) Father(h)  (g) dal-(fe)so,(d) al-(g)le-(gf)lu-(e)ia.(e) =(j)  (h) saaea](j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png",
    },
    {
        title: "part-b-032-2",
        gabc: "If(ce) ye(ehg) had(hi) known(hij) me,T(i) ye(i) should(h) have(j) known(k) my(ji) a(g) e(h)  al-(ij)so:(i) and(i) Pt(jih) henceforth(h) ye(i) know(hgf) him,(hg) and(i) have(i) seen(ji)  him,(hgf) al-(f)le-(e)lu-(fhg)ia,(f) al-(fgh)le-(i)=lu-(hg)ia,(f) S(g) le-(f)lu-(e)ia.(e)  (hdj) -(i) (h)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-032.png",
        nextFileName: "./pages/part-b-033.png",
    },
    {
        title: "part-b-033-0",
        gabc: "If(cgj) ye(h) love(g) me,T(i) keep(ij) my(k)  (ji) commandments,(h)  (hi) al(g) le-(ge)&#39;lu-(fe)ia,(d)  al(hg) le-(i)lu-(h)1ia,(gf) al(g) -(gf)lu-(e)1a.(e)  (j)  (h)  (j) 1(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png",
    },
    {
        title: "part-b-033-1",
        gabc: "T(h) an(h) the(h) way,T(gfe) the(i) truth,(ih) and(ij) the(j) life:(i) no(i) man(i)  cometh(ji)  (h) un-(h)to(h) the(i) Father,(hg)  (ef) but(hf) by(gf) &#39;me,(ed) al-(ef)le-(f)lu-(e)1ia.(e)   (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png",
    },
    {
        title: "part-b-033-2",
        gabc: "1fye(c)  (c) .(e) abide(f)  (g) in(h) [](g) [(g) my(fh) words(j) T(i) abide(hg) in(efg) you,(g) [](g)  shall(g) agk(hg) what(f) ye(d) will,(f) and(f) it(f) shall(e) |(g) a(g) un-(f)to(e)  =(d) al-(d)=(c) ly(efe) III-(dd)al-(ef)e-(gdfedd)3_____(de)  (dd) lu-(c)ia.(c)  (fg) [(hg)  (f)  (ed) ",
        groupIndex: 2,
        filename: "./pages/part-b-033.png",
        nextFileName: "./pages/part-b-034.png",
    },
    {
        title: "part-b-034-0",
        gabc: "We(cc)  (f) adore(f)  (g) thee,(f) 0(f) Christ,(f) and(f) 5(e) bless(g) thee,(h) A}(h)  lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) We(f) adore.(f)  (g) V.(c) Because(f)  (f) by(f) thy(f)  Cross(g) thou(f) lLast(f) redeemed(f)  (f) a(e) the(g) world.(h) Al-(h)le(hg) lu-(g)iq,(f)  y.(c) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) R(h) the(g)  Ho-(h)ly(g) Ghost.(gf) We(f) adore.(f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-034.png",
        nextFileName: "./pages/part-b-035.png",
    },
    {
        title: "part-b-034-1",
        gabc: "0%(cd) Cross,(ff) t(cd) irpassing(f)  (gh) all(h) the(g) stars(fe) in(d) splendodr;(g)  (cd)  world(de) renowned,(d)  (cdf)  (f) exceeding(hfe)  (dfdd) déar(dfedddc) un(ffh) to(gfegh) the(fe) heas(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-034.png",
        nextFileName: "./pages/part-b-035.png",
    },
    {
        title: "part-b-035-0",
        gabc: ",f(fe) men,(ddc) ho(eghg) li-(fe)er(fgf) than(ef) all(d) things:(d) thou(dh) on(h) ly(gfegh)  wert(fe) counted(d)  (fe) worthy(dd)  (c) to(c) uphold(d)  (ffg) the(ed) world’s(eef) ransom.(d)  (d)  Gyeet(h) the(gf) wood,(ghghih) sweet(f) the(ed) i(dgf) ron,(g) [](c) bearing(d) so(fgf) sweet(ed)  a(efe) burden:(d)  (d) o(hg) bring(hih) aid(ghgfed) to(f) this(g) B(de) congregaktion,(fe) ,(dc) @-(c)L}(c)  are(d) here(fe) as-(f)sem-(gh)bled(g) to(cd) ce-(fg)le-(f)brate(ed) thy(efe) -(d)5(d)  il(cd) le(fgfe) .(gh) lu~ia,(fedc) al-(ddg)le-(efe)lu-(d)ia.(d) u(h)  (g) _(f) &amp;«(g) a,(gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-035.png",
        nextFileName: "./pages/part-b-036.png",
    },
    {
        title: "part-b-035-1",
        gabc: "0(igij) mighty(ij)  (i) Twork(ig) of(hg) mercy!(e) B(e) death(h) then(f) di-(h)ed,(g) when(h) life(hiji)  e(h) ed(f) up-(e)T(fh) the(g) o(ef) s(g) ](f)  (e) ia.(e) [(i) |(j)  (i) o(h) )(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-035.png",
        nextFileName: "./pages/part-b-036.png",
    },
    {
        title: "part-b-036-0",
        gabc: "Save(g) us,TO(hj)  (j) Christ(j) our(h) Saviour,(j)  (i) by(g) the(h) virtue(h)  (h) of(i)  the(h) Cross:(g) thou(g) who(h) savedst(i)  (h) Peter(j)  (i) in(gi) the(hg) sea,(h) haye(g)  mercy(gf) i(gh) up-(gf)on(e) us,(ef) al~le(g)  (fg) lu-(e)1a.(e) |(j)  (h) —1(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png",
    },
    {
        title: "part-b-036-1",
        gabc: "B(d) ](e) the(f) Cross(ge) of(f) the(e) e(d) Lord;Tflee(fh) a-(h)way,(hghihgg) Ye(ef) ad-(g) -(ki~)versaries:(fe)  (d)  (ded) the(c) [1-(cd)on(d) of(d) the(d) tribe(e) of(f) Ju-(gh)dah,(ghg) the(g) Root(ef)  of(i)  (g) Da—vid(f) .(edc) hath(d) 3(f) prevailed,(d) .(dc) al-(d)le(efe) lu-(d)ia.(d)  (h) &quot;2(g) g(f)  (h) |(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png",
    },
    {
        title: "part-b-036-2",
        gabc: "But(ig) as(j) for(i) us,T(i) it(i) behoveth(i)  (i)  (g) us(hi) to(hg) A(e) a-(e)in(h) the(h) Cro%(h)  of(f) our(h) Lord(gfe) Je-(fg)us(f) Christ,(ef) al-(g)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-036.png",
        nextFileName: "./pages/part-b-037.png",
    },
    {
        title: "part-b-037-0",
        gabc: "By(c)  (dd) n(c) -(df)of(fe) the(de) Cross,(dc) de-(fg)liv-(hi)er(g) us(hih) from(h) our(g)  e-(f)ne-(fe)mies,(dc) 0(d) our(efe) God,(dc) al-(d)le-(fe)lu-(d)ia.(d)  (h) &amp;(g) .(f) 9(h) &amp;l(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-037.png",
        nextFileName: "./pages/part-b-038.png",
    },
    {
        title: "part-b-037-1",
        gabc: "This(c)  (f) sign(f) of(f) the(f) Cross(g) shall(f) be(f) in(e) heaven,(g)  (h) Al(h) ~le(hg)  lu-(g)1ia,(f) al(d) le(fg) -(gf)1ia.(f) This(f) sign.(f) When(f) the(f) Lord(g)  shall(f) come(f) a(e) judgment.(g)  (h) B/&#39;.Al—le-(h)lu-(hg)ia.(g)  (f) Y.(c) Glory(f)  (f) be.(f)  This(f) sign.(f)  |(j)  .(d)  (e) B(gh) |(hg) TR(h) ](j) [(ji) T(hg) e(i)  (j) |(j) L(hg) (](j) b(ih) (e(h)  5(h)  (hji)  (g) A(ge)  (f)  (dc) aw:__(de)  (efe) o(d) T(dh) [(fhg) #(ed) —(f) 8(ed) |(d)  .(h)  (hji)  (g)  (ge)  (f)  (dc)  (de)  (f)  (edfe)  (d)  (d)  (dddhd)  (dhgd)  (ed)  (fd)  (ed)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-037.png",
        nextFileName: "./pages/part-b-038.png",
    },
    {
        title: "part-b-038-0",
        gabc: "alone(ccc)  (c)  (d)  (f) T(fe) excellest(d)  (ef) in(de) P(d) &gt;(c) all(f) the(g) cedars(hg)  (e) ._(fg) Tep(fe)  —(ki~) a-(d)non:(d) for(f) on(fe) tiee(dc) the(df) Life(fh) of(g) the(f) world(fe) was(de) hang;[i(dd)  (c)  -(f)thee(fe) was(g) Christ(gh) vic-(ed)to-(fe) (d) ri—ous,(d) and(dc) death(deed) -(degh)ver(g)  death(fgf) did(f) for(dfe) ev-(dc)er(d) triumph,(fe)  (f) -(g)le-(fe)lu-(d)ia.(d)  (f) I(h)  (g)  (f) v(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-038.png",
        nextFileName: "./pages/part-b-039.png",
    },
    {
        title: "part-b-038-1",
        gabc: "‘He(c)  (ce) the(ef) ho-(f)ly(h) Cross(hg) S(fg) endured,(g) Burst(ghi) the(g) gates(hg) of(f) hell(gf)  in(ef) twain:(f) Begirt(f)  (fe)  (c) might(e) and(fh) ma-(hg)jes-(fg)ty,(g) On(i) Eas-(iji) ter(gi)  (g) morn(hg) he(f) rose(gf) a-(ef)gain,(f) al-(ge)le(cgfhdhfgf) lu-(fe)ia.(f)  (ff) %(h)  (g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-038.png",
        nextFileName: "./pages/part-b-039.png",
    },
    {
        title: "part-b-039-0",
        gabc: "Jolm(ff) the(d) A-(f)pos-(ef)tle,(f) Ee-(fe)ing(d) cast(ef) in-(gh)to(f) a(gf) caldron(e)  (e)  g(dc) boiling(d)  (de) 0il,(e) by(dhi) vir-(h)tue(gf) of(g) pro-(ghg)tect-(fe)ing(de)  a2(e) came(eg) forth(gf) un-(ghg)harm-(e)ed,(ef) al(fg) le(de) lu(e) 1ia.(e)  a(h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-039.png",
        nextFileName: "./pages/part-b-040.png",
    },
    {
        title: "part-b-040-0",
        gabc: "%hy(c)  (c)  (f) a(fg)  (g) hath(fh) broke_ré_my(j)  (ih) .heart;(jk)  (h) I(h) am(h) full(e) of(f)  (gh) he“i_?(h)  some(j)  ness:(g) 1(j) looked(k)  (j) for(ik) some(k) to(k) have(j) pi-(ji)ty(hj) on(jj) me,(g) but(gf)  there(g) was(gh) no(f) man;(f) neither(f)  (g) found(f) I(gh) h-(fe)ny(d) to(ef) comfort(fh)  (h)  e(g)  (f)  (j)  (i) AT(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png",
    },
    {
        title: "part-b-040-1",
        gabc: "=(c)  (gj) of(hghhj) me,(i) for(ij) I(k) am(ji) meek(g) andlowly(h)  (gf) in(g)  (fg) heart.(e) &#39;I(j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png",
    },
    {
        title: "part-b-040-2",
        gabc: "1(d) have(cd) sancti-(fg)L](e) ed(fe)  (d) this(cd) house,(d) that(dc) my(f) Name(g) may(fe) be(gh)  there(hihg) for(ef) ev-(gf)=(f) and(dh) mine(hi) eyes(hg) and(f) mine(gh)  (ij) heart(hjijkj) shal(h)  be(gf) there(ghi)  (hghg) T(ef) perpetually.(g)  (fe)  (d)  (h) 1(g)  (f)  (fgh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-040.png",
        nextFileName: "./pages/part-b-041.png",
    },
    {
        title: "part-b-041-0",
        gabc: "And(c)  (f) %(cdf) said:(f) TThen(ff) have(d) T(ef) cleansed(g)  (e) my(f) héart(dc) in(d) vain,(e)  and(gh) wash-(gfe)ed(e) my(ce) hands(g) in(g) in-(e)no-(fe)cen-(de)cy;(d) all(c) the(e) day(ge)  long(gh) have(hj) I(h) been(gf) punish-(g)ed.(ghg)  (e) e(h)  (g) T(h) e(ih) WO(gfe) el(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png",
    },
    {
        title: "part-b-041-1",
        gabc: "In(cf) the(g) multitude(gh)  (g) L](g) fof(f) tle(h) sorrows(j)  (i) that(h) I(ji) had(hg) in(h) my(h)  heart,(g) thy(j) comforts(j)  (i) have(h) A(g) refresked(h) =(e) my(fg) soul.(g) e(j) e(i)  (j)  (h) A(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png",
    },
    {
        title: "part-b-041-2",
        gabc: "S‘et(hg) me(hih) as(f) a(f) seal(fi) up-(i)on(jih) thine(ih) heart,(f) as(i) a(hg) seal(f) up-(ed) on(fe) =(e) —(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png",
    },
    {
        title: "part-b-041-3",
        gabc: "—(cc)  (f) 0(f) a.(g) hast(f) broken(gh) R(hg) *(f) My(fgh) bonds(gfd) in(fg) T(g) sunder.(f) ",
        groupIndex: 3,
        filename: "./pages/part-b-041.png",
        nextFileName: "./pages/part-b-042.png",
    },
    {
        title: "part-b-042-0",
        gabc: "‘Thou,(f) O(f) Lord.(g) ¥.(c) I(h) will(h) offer(hi)  (h) to(h) thee(h) the(h) )(h)  (g) :(g)  of(g)  (f) thanksgiving.(gh) .(hg) My(h)  (fgh) bonds.(gfd) Glory(h)  (h) be(h) to(h) o(h)  Father(hi)  (h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh)  Thou,(ik)  (f) C(f) Lord.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png",
    },
    {
        title: "part-b-042-1",
        gabc: "S(e)  (fed)  (e)  (f)  (e)  (f) WS(hg) S|(fe) a(e) [](g)  (iji) &quot;(h)  (gf)  o(e)  (f) [(d)  (e)  (g)  (i) a8(i) a(j)  (i) I(h)  (g)  (fge)  x.(e) Surely(cdefed) he(e) hath(f) borne(e) wa(f)  (hg) g(fe) ](e) ",
        groupIndex: 1,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png",
    },
    {
        title: "part-b-042-2",
        gabc: "e(c)  (hc~)  (f) was(edf) wounded(fhg~dedfgddfdfd) &#39;ffor_our(jfdffdfhdf)  (dfhi) transgressions;(fddfijdifhfdf)  (d)  (dhd) the.(f)  (df)  (di) wad(dfk) =(fdkj) ",
        groupIndex: 2,
        filename: "./pages/part-b-042.png",
        nextFileName: "./pages/part-b-043.png",
    },
    {
        title: "part-b-043-0",
        gabc: "ed(ih) for(h) our(f) i-(e) (f) ni-(ed)ties:(ef) the(gg)  (g) chastisement(dfgf)  (e) of(f) our(d)  peace(eg) was(f) up-(h)on(gh) him,(f) and(d) with(ef) his(fg) stripes(fed) we(ef) are(e)  healed.(d)  (d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-043.png",
        nextFileName: "./pages/part-b-044.png",
    },
    {
        title: "part-b-043-1",
        gabc: "He(f) ma-(gh)keth(hg) Peace(g) &#39;in(fd) thy(fg) e(g) borders.(f) He(f) ma-(gh)keth.(hg)  And(h) filleth(hi)  (g) thee(g) with(h) the(g) flour(f) of(fgh) wheat.(dhg)  (h)  (i) Peace.(c)  (g)  (f)  K.(c) Glory(h)  (h) be.(h) He(f) ma-(gh)keth.(hg)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-043.png",
        nextFileName: "./pages/part-b-044.png",
    },
    {
        title: "part-b-044-0",
        gabc: "But(c)  (d) when(d) .ey(dc) came(f) to(g) Je-(fh)sus,T(h) and(h) saw(hj) that(h) he(h) ygqq(gf)  dead(i)  (gh) already,(hi)  (h)  (h) they(g) brake(g) -(e)his(fe) le;g&#39;sz(cd) but(d) one(f)  (d)  .(e) soldiers(f)  (ghg) with(h) a(gh) spear(jkh) pierced(h)  (gf) his(hi) side,(h) ang(gh) forth.(fg)  with(f) came(f) there(f) out(ef) blood(g) and(fe) water.(d) i(d) B(h)  (g)  (f)  (gh) |(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-044.png",
        nextFileName: "./pages/part-b-045.png",
    },
    {
        title: "part-b-044-1",
        gabc: "He(e) shall(f) go(h) before(h)  (ij) him(i) Tin(h) the(i) spirit(k)  (j) and(i) pow-(i)er(g) of(ji~)  E-(i)1i-(hih)as,(gh) to(h) make(h) ready(h)  (g) a(f) people(gh) =(f) prepared(e)  (h) for(gh)  (fh)  E-(d) the(g) 5(e)  (i)  (j)  (i)  (h) .(cgf) ",
        groupIndex: 1,
        filename: "./pages/part-b-044.png",
        nextFileName: "./pages/part-b-045.png",
    },
    {
        title: "part-b-045-0",
        gabc: "shalt(f)  (fg) call(g) his(hg) name(j) John:(h) shall(g)  (g) drink(f) neither(g)  (h)  wine(ki~)  (j) nor(h) strong(ji) drink:(g) and(j) ma(kjji) ny(h) shall(ghih) rejoice(g)  (gf) [(e)  his(ki~)  (fg) birth.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png",
    },
    {
        title: "part-b-045-1",
        gabc: "Fron(c)  (d) the(d) womb(dc) of(f) the(g) ag-(fh) (h) edTand(h) barren(h)  (g) a(e) brought(fg)  forth(fe) John,(c) the(ef) .(g) Forerunner.(fe)  (d)  (d) =(h)  (g)  (f) dp(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png",
    },
    {
        title: "part-b-045-2",
        gabc: "E(cd) -(fg)a(g) a(g) great(h) L)(g) the(f) sight(gh) of(f) a(e) -(d) for(d) n(g) [(g) &quot;(g) the(f) Lord(gfed) is(c) with(edffd~) him.(fd~dd)  (d) |(h) &quot;o(h)  (g) _osa(f)  (g) _(gfedf) ",
        groupIndex: 2,
        filename: "./pages/part-b-045.png",
        nextFileName: "./pages/part-b-046.png",
    },
    {
        title: "part-b-046-0",
        gabc: "A(f) mong(f) them(f) that(f) are(f) born(g) of(f) wo-(gh)men(hg) There(f) O(g) |(h)  ri-(ki~) (g) sen(fd) a(fg) greater.(g)  (f) Among(f)  (f) them.(f) V.(c) Thap(h) John(hi)  (hi) the(h) Bp(gh)  tist.(ik)  (hg) There(f) hath(g) not(h) T(g) ri.sen.(fd) b.(c) Glory(h) E——(h) be,(h) R.A-(f) mong(i)  (f) them,(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png",
    },
    {
        title: "part-b-046-1",
        gabc: ".(e) T(f) el(h) Be———r(fg) T(f) R(f) a(f)  (e)  (f) TR(g)  (g) &quot;(ig) a(g)  (f)  a(ig~)  (fge)  (f)  (j) ;(h)  (i)  (j) -(i) (hf)  (f)  (iji) |(hg)  (h)  (i)  (f)  O(j) a(i) s,(j)  (hi) el(j)  (j) [(ih) |(gf) ](e) Lo(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png",
    },
    {
        title: "part-b-046-2",
        gabc: "hen(e) Za-(efh)cha-(f)ri-(f)as(e) Twentlin-(c) (f) to(de)  (f) the(dfhg) temple,(e)  (e) ther(e)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-b-046.png",
        nextFileName: "./pages/part-b-047.png",
    },
    {
        title: "part-b-047-0",
        gabc: "pear-(ghi)ed(i) un-(ij)to(ih) him(h) the(h) An-(h)gel(gf) Ga-(fgh)bri-(g)el,(e) standing(g)  (fe) on(fg)  (f)  the(f) right(gh) side(ij) of(i) the(j) al-(hf)tar(hi) of(hg) incense.(e)  (e) |(hfh) [(h) el(g)  (h)  (f) |(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png",
    },
    {
        title: "part-b-047-1",
        gabc: "](g) Eli—sa-(g) (h) beth,T(j) the(j) wife(j) of(j) Za-(j)cha-(h)ri-(j)as,(i) brought(gh) forth(h)  a(jk)  a(h) mighty(i)  (h) son,(g) John(j) the(ig) Baptist,(h)  (hf) the(hj) Lord’s(g) Fore-(gf) runner.(e)  (e)  (j)  (h)  (j)  (dih) ",
        groupIndex: 1,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png",
    },
    {
        title: "part-b-047-2",
        gabc: "made(d)  (ef) W(fge) s1gnsTto(gh) his(fe) father,(de)  (e) how(e) he(c) would(e) heve(fe~g) him(fe) call-(d) S(d)  (h) afid(ec) he(g) |(cdefge) e(gh) e(h)  (j) His(i) e(g) is(fg) T(e) |(h)  (f) e(h)  (g)  (h) o(ih)  (dgfe) W(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-047.png",
        nextFileName: "./pages/part-b-048.png",
    },
    {
        title: "part-b-048-0",
        gabc: "His(d) ](dc) shall(f) be(g) called(f)  (h) John:&#39;and(h)  (h) ma(ih) :(g) 0(e)  (f)  joice(g) at(e) his(fe) birth.(d)  (h)  (g)  (f)  (gh) -(gf) A(ch) mong(h) them(h) that(f) are(h) bornt(g) a(e) wo-(fgf)[B(e) there(h) hath(h) not(f)  risen(h) .(g) [](e) greater(f)  (fd) than(fh) John(e) the(d) Il_l(c) Raptist.(c) ateaats(h)  (f) |ERET(h)  (g)  =(fh) child,(hhg) shalt(f) be(h) called(hg) a(e) a(e) a(e) prophet(fg) of(f) 8(e) High(cde)  est;(e) for(e) thou(e) shalt(f) go(h) before(h)  (h) the(f) face(h) of(g) the(f) Lord,(e)  _to(f) prepare(ed)  (e) his(ed) :(c) o(h) od(f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-048.png",
        nextFileName: "./pages/part-b-049.png",
    },
    {
        title: "part-b-048-1",
        gabc: "here(f) was(f) aman(gh) *(fddfhgfdfhfhfddfdhfd) Cod.(gdfcdfgfdffdfff) was(fddff)  (hf) @(fgh) man(hg) ",
        groupIndex: 1,
        filename: "./pages/part-b-048.png",
        nextFileName: "./pages/part-b-049.png",
    },
    {
        title: "part-b-049-0",
        gabc: "j.(c) Whose(hihi) name(g) was(gh) John.(hg) R(ef) Sent.(fd) F.(f)  (c) Glory(h)  (h) be.(h)  There(f) was(f) a(gh) man.(hg)  (fi) ",
        groupIndex: 0,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png",
    },
    {
        title: "part-b-049-1",
        gabc: "a(i)  (f)  (d)  (e) -(e)-(e)](e) ](e)  (g)  (h) __&#39;_&#39;__&#39;__&#39;_&#39;__t—:::&quot;(h)  (g)  (f)  (h)  (i)  (h)  [(ki~)  (g)  (g)  (h)  (g)  (f)  (d)  (e) &quot;(e) -(f)-(d) (c)  (d) .(d)  X.(f) This(g) child(h)  (g) shall(g) be(f) great(h) in(g) the(f) -(e)-(e)",
        groupIndex: 1,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png",
    },
    {
        title: "part-b-049-2",
        gabc: "he(f) mouth(d) of(de) a(e) a(e) ri(fggh) as(hg) was(fe) o(f)  (e) o-(e)and(g) he(h)  Prophesi-(i) (h) ed,(f)  (h) saying:(h) =(g) Plessed(g)  (h) be(hij) the(i) God(dhghih) of(ih) Is(defe)  ra(def) e},(e)  (fhgh)  (h)  (g)  (h)  (f)  (ef)  (fgh) ",
        groupIndex: 2,
        filename: "./pages/part-b-049.png",
        nextFileName: "./pages/part-b-050.png",
    },
    {
        title: "part-b-050-0",
        gabc: "s(g)  (g)  (f)  (e)  (d)  (fhg)  (fg)  (g)  (hjji)  (h)  (hg)  (h)  (ig)  (h)  (g)  (f)  a(g) a(g) .(f)  (g)  (h) a(j)  (g) AT(ihih) VESPERS(h)  (h) ](ghg)  (e)  (f) =(hg)  (fg)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png",
    },
    {
        title: "part-b-050-1",
        gabc: "a(e) child(ei) Tthat(i) is(i) born(hg) un-(h)to(hi) us(i) 1s(ij) more(h) than(f) a(g)  ](gf) P(e) for(df) this(h) is(ij) he(i) of(j) whom(h) the(f) M(hf) &amp;(gf) saith:(e)  Among(d)  (f) them(h) that(h) are(h) born(g) of(f) -(hij)men,(i) there(i) hath(j) not(i)  risen(h)  (h) a(f) greater(h) .(g) ](e) =(gh) the(f) &quot;(e) a.(e)  (i)  (j) |(i)  (h)  (gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png",
    },
    {
        title: "part-b-050-2",
        gabc: "ne(cd) 1(dhi) -(h)stood(h)  (d) before(fhfdh) the(f)  (f)  (hd) Lord,(ihghihgg) and(f) were(g) not(gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-050.png",
        nextFileName: "./pages/part-b-051.png",
    },
    {
        title: "part-b-051-0",
        gabc: "5(ki~) ge-(g) (f) pa—ra—ted(f)  (f) one(fe) from(gh) an-(fe)o~(de) ther:(d) they(d) drank(dgfgh) of(g)  the(f) cha(ghghi) lice(h) of(fghg) the(hgfg) Lord,(gf) and(f) were(f) called(f)  (f) the(ef)  friends(g) of(e) God.(d)  (h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-051.png",
        nextFileName: "./pages/part-b-052.png",
    },
    {
        title: "part-b-051-1",
        gabc: "These(ik)  (f) are(dc) the(d) ho-(dhi)ly(h) ones,T(h) who(h) for(h) the(h) love(h) of(h) Christ(ehghihgg)  despised(fg)  (h)  (g) the(f) threats(gh) f(fe) men:(d) in(f) the(f) kingdom(f)  (d) of(c) heaven&#39;(dd)  (c)  »(e) ho(g) 1y(f) =(fg) Martyrs(f) lexult(ed)  (dg) with(fe) e(d) Angels:(d) [(fgh) 1R(dhgfhjh) how(hg) precious(h) a(g)  ~(ik) 1is(h) the(gf) death(ef) of(gh) the(fe) Saints,(d) who(fed) stand(ef)  (fgh) unceasingly(g)  (f) be-(fe) (dc)  the(ki~)  (ddg)  (ef) Lord,(d) and(c) are(d) not(f) —&#39;_I:_I(f) separhted(de)  (dc) —_i(c) one(def) from(gh) an-(fe) (d) other.(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-051.png",
        nextFileName: "./pages/part-b-052.png",
    },
    {
        title: "part-b-052-0",
        gabc: "a(dhhi)  (g)  (hi)  (jihg)  (h)  (k)  (j)  (ih)  (g)  (j)  (ihg) =(h)  (h)  (hjih) Y(g)  (f)  :(fgf)  (ed) a(g)  (hi)  (j)  (ih)  (g)  (h)  (h)  (k) Y(ji)  (k)  (ji)  (h)  (i)  (j)  (h)  (i)  [(g)  (h) :(h) pastor(h) ANTIPHON(hjih)  (g)  (fgf) ON(ed) MAGNIFICAT(e)  (f)  (d)  (e) L(c)  (d)  (d)  T(c) hou(d) art(d) the(cdc) shepherd(f)  (g) of(f) the(fgh) sheep,(h) 1.0(hjfkj) chief(jihihhg) of(fe) the(fg)  A(fe) -(d)postles:(d) un-(g)to(g) thee(h) were(g)  (fe) the(c)  (d) keys(ffg) of(f) the(f)  kingdom(ef) a(g) of(fe) heaven.(d)  (d) e(h)  (g) LAUDS(f) o(gh) p(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-052.png",
        nextFileName: "./pages/part-b-053.png",
    },
    {
        title: "part-b-052-1",
        gabc: "e-(gj)ter(h) and(fg) S,(g) ;-(d) (d)  (dg)  (d) Raa(fdfdfidf)  (dd) “together(jdf)  (ffk)  (fddfj) in-(d) (d)  (j) to(j) the(hj) temple(j)  (i)  at(j) the(j) .(jkj) hour,(fhj)  (ji)  (d) &gt;(ffd) e(djdfddfhdfijfcfhf) ——(fdffjfdhfdffdddhifd~dd) prayer.(dg)  (g) I/(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-052.png",
        nextFileName: "./pages/part-b-053.png",
    },
    {
        title: "part-b-053-0",
        gabc: "S(ighj) il—verT(i) and(i) gold(hj) have(i) I(hih) none;(h)  (hg) but(h) such(gf) as(fgh) I(g) hLave,(e)  give(hf) I(gf) thee.(e) reremie(i)  (j) e(i) e(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png",
    },
    {
        title: "part-b-053-1",
        gabc: "The(h) Angel(h)  (f) said(h) un-(h)to(g) Peter,!(e) Cast(e) thy(h) [(ig) garment(ij) a-(i)bout(hg)  a-(e)and(f) follow(hf)  (gf) me.(e) e(h)  (f) il(h)  (i) e(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png",
    },
    {
        title: "part-b-053-2",
        gabc: "he(e) Lord(g) hath(h) sent(i) his(hf) Angel,Tand(h)  (g)  (h) hath(g) de-(h)liv-(chj)er-(i)ed(h)  (c)  me(h) out(f) of(h) :(g) hand(f) s(e) Herod,(f) i(ed) al-(fgh)(&quot;(hgfefgf) lu-(e)ia.(e) |7(iji)  (hgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png",
    },
    {
        title: "part-b-053-3",
        gabc: "3(ig) art(j) a(i) Peter,T(i) a(i) up-(g)g(h) this(g) rock(e) I(h) will(h) huild(fh) ](g)  Q.(e) Church,(j)  (j)  (i)  (h)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-b-053.png",
        nextFileName: "./pages/part-b-054.png",
    },
    {
        title: "part-b-054-0",
        gabc: "[(ffe)  (dc)  (dfd)  (e)  (e)  (f)  (dc) ](fe)  (fgf) 8.(d)  (ce)  (e)  (g)   (h)  (j)  (h)  (gfe)  (f)  (dc)  (fe)  (fgf)  (d)  (ce)  (e)  (edc)  (d)  [(dfd)  (e)  (e) ](g)  (f)  (dc) [(df)  (fe)  (de) B(e) -(ed)[}(c)  (cd)  ANTIPHON(de)  (d)  (f)  (gh)  (gh)  (fg) ON(fe)  (de) BENEDICTUS(e)  hat-(h)so-(fg) (g) ev-(g)thou(g) a(e) -(fg)on(ef) s(d) shall(f) be(g) N(hj)  er(j)  in(hi) hea-(g)ven:(g) and(j) what-(j)so-(jh)ev-(jk)er(k) thou(ji) shalt(g) loose(h) on(g)  earth(fh) shall(jjkg) be(g) loos-(h)ed(ge) in(fg) hea-(ef)ven:(d) ‘saith(h) the(h) Lord(hj)  un-(h)to(h) Si-(hi)mon(h) Pe-(g)ter.(g) PrT(j)  (i) |(j) -(h)I(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-054.png",
        nextFileName: "./pages/part-b-055.png",
    },
    {
        title: "part-b-055-0",
        gabc: "&#39;T‘;_da§TSi—mon(c)  (cd)  (def) Pe-(fe) (de) ter(dc) ascended(f)  (gh)  (hih) the(fg) gibbet(hh)  (f) of(g) the(fe)  cHbss,(i)  (dc) al-(dg)le(fe) —lu-(d)ia:(d) t8-(cd)day(dhi) the(h) Key-(h)bearer(h)  (g) of(g) the(f)  joyfully(gh)  (hih)  (de)  (d)  (d)  (f) to(f)  (fe)  (de)  (ddc) Paul(c)  (dcd)  (f) lie(fe)  A—postle,(de)  (dc) -(c)the(d) light(f) of(g) the(e) whole(fe) world,(d) bowed(dhi)  (hg) down(h)  his(ji) head;(h) and(h) for(h) the(f) Name(g) of(fe) C(dc) received(cd)  (f)  (f) the(ef)  .(ik) crown(h) of(g)  (f) martyrdom,(fe) T(c) al-(d)le-(efe)lu-(d)ia.(d) e(h) =(g) |(f)  (g) B(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-055.png",
        nextFileName: "./pages/part-b-056.png",
    },
    {
        title: "part-b-056-0",
        gabc: "Who(e) is(gi) this?(hg) that(f) cometh(e)  (f) from(h) E-(f)dom,(g) with(e) dyeq(g) gar-(ih) ments(g)  (ij) from(ih) Bozrah(g)  (g) this(i) that(h) .(f) glorious(g) =(f)  (e) in(f) hijs(fh)  a:(gi)  (g)  (e) A(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png",
    },
    {
        title: "part-b-056-1",
        gabc: "I(jkkj) Tthat(j) speak(ji) in(h)  (ji) righteousness,(g)  (g) mighity(hijh) =(i) to(h) save.(g)   (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png",
    },
    {
        title: "part-b-056-2",
        gabc: "H(c)  (c) C(e) was(f) *(hi) clothed(i) with(h) a(i) vesture(ji)  (h) dipped(j) a(i) in(h) blood:(i) 3(f)  h1§(i) Name(h) is(g) =(fe) CRlCPar(fe) the(fd) 1o,(cdedfdfhdfhhd~) o(dfdfh) of(f) o(hf) e(i)  (fh) D(i)  (d)  (j) |(h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-056.png",
        nextFileName: "./pages/part-b-057.png",
    },
    {
        title: "part-b-057-0",
        gabc: "-(c) (c)  (hg)  (e) tart(fh) thou(h) red(i) in(h) thine(ij) ap-(i)pa-(h)rel,(h) and(i) thy(h)  garments(ig~)  (gh)  (f) like(df) him(h) that(e) treadeth(fe)  (cd) in(ef) the(f) wine-(e)fat?(e)  SHORT(h)  (f)  (h)  (i)  (h)  hou(f) hast(f) redeemed(f)  (g)  (f) us,(f) O(fgh) Lord,*(hg) By(gfd) thy(fg) Blood.(gf)  (i) Thou(f)  hast(ki~)  (f) redeemed.(f)  (g)  (f) ¥.(c) Out(h) of(h) ev-(h)ery(h) kindred,(hi)  (h) and(gh) tongue,(g)  and(g) people,(h)  (g) and(f) nation.(gh)  (fhg) By(gfd) thy(fg) Blood.(fgf) K.(c) Glory(h) v(h) be.(h)  Thou(f) hast(f) redeemed.(f)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-057.png",
        nextFileName: "./pages/part-b-058.png",
    },
    {
        title: "part-b-057-1",
        gabc: "a(g)  (e)  (f)  (d)  (g)  (g)  (j)  (gh)  (g)  (fedg)  (g)  (fg)  (g)  (g)  (dhg)  P(hiji) RS(h)  (gh)  (h) G(j)  (h) n(g) e(fe) &quot;(fg) m(g) .-(g)[(g) e(gji)  (jk) .(k) e(jk) e(k)  P(k) e(k)  (ji) RS(h) T(g) T(fg) [l(g) T(efgh)  (g) T(g) R(fe) e(d) =(g) B(g) o(fg) L(g) |(fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-057.png",
        nextFileName: "./pages/part-b-058.png",
    },
    {
        title: "part-b-058-0",
        gabc: "But(c)  (g) ye(gj) are(hg) come(h) un-(h)to(g) mount(hi) Si-(ij)on(i) and(ji) un-(h)to(i) the(j)  ci-(k)ty(k) of(j) the(j) living(i)  (jk) God,(kh) the(h) heavenly(i)  (j) Je-(k) (j) ru-(hj)sa-(i)le,(i)  and(h) to(g) Je-(hi)sus,(fh) the(gh) me-(j)di-(ji)a-(h)tor(g) of(h) the(g) new(fe) CO-(fg)Ve-(g)nant,(g)  and(ki~)  (g) to(hi) the(g) Blood(g) of(h) a(fe) .(d) that(e) speaketh(f)  (d) a(e) better(f)  =(gh) than(gf) that(gh) of(gf) A-(e)bel.(e) e(j)  (h) R(j) |(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-058.png",
        nextFileName: "./pages/part-b-059.png",
    },
    {
        title: "part-b-058-1",
        gabc: "What(dd) are(c) f(d) which(f) are(fe) ar-(de)ray(d) ed(cd) in(fe) white(fgh) robes:(h)  (d)  ~and(efg) whence(dfe) came(dfd)  (dd) they?(dd)  (fd)  (f) :(fdhdfghdfddhfdgdddfd) -(hdfgh) (fdddg)  (dfd)  (fddff) ",
        groupIndex: 1,
        filename: "./pages/part-b-058.png",
        nextFileName: "./pages/part-b-059.png",
    },
    {
        title: "part-b-059-0",
        gabc: "T’:[‘@lgsae(dh) are(hj) theyT(h) which(h) came(hg) out(fe) of(fg) great(g) tri-(f)bu-(e)la-(df)tion,(fc)  and(c) have(d) washed(ffg)  (f) their(ef) robes(gh) in(e) the(f) Blood(g) of(e) the(fe) Lamb.(d) |(de)   (h)  (g)  (f)  (gh)  (fgh) ",
        groupIndex: 0,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png",
    },
    {
        title: "part-b-059-1",
        gabc: "T(fg) [P(gf) tare(gh) they(f) before(e)  (f) the(gh) throne(hi) of(h) God,(h)  (gf) and(gh)  (f)  F,(jk)  serve(f) him(e) day(d) and(de) night(c) in(gf) his(gh) temple.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png",
    },
    {
        title: "part-b-059-2",
        gabc: "=(e) =(ei)  (i) e(hg) came(g) the(h) a(fihij) [E(i) Tby(h) the(j) Blood(kji) of(h) the(ij)  -(i)and(g) by(ij) the(i) word(h) of(f) their(h) tes(cdgfe) T(fgf) mo-(e)ny.(e)   (i)  (j)  (i)  (h)  (gi)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-b-059.png",
        nextFileName: "./pages/part-b-060.png",
    },
    {
        title: "part-b-060-0",
        gabc: "Blessed(h)  (fg) Tare(fh) they(hg) which(h) have(j) washed(ji)  (h) their(g) pope,(ghg) &amp;(h)  the(j) Plood(jih) of(i) the(hi) Lamb.(g)  (j)  (i)  (j)  (h) |(fgh) ",
        groupIndex: 0,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png",
    },
    {
        title: "part-b-060-1",
        gabc: "Christ(f) loved(g)  (f) us,(f) and(f) washed(g)  (gh) us(hg) In(fgh) his(gfd) own(gf~) Blood,(gf)  Christ(ki~)  (f) loved(g)  (f) us.(f) V.(c) And(h) hath(h) made(hi) us(h) kings(gh) and(g) priests(g)  un-(g)to(g) God(h) and(g) his(f) Father.(gh) |(hg) In(fgh) his(gfd) own(fg) Blood.(gf)  v(c) Glory(h)  (h) be.(h) Christ(f) loved(g)  (f) us.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png",
    },
    {
        title: "part-b-060-2",
        gabc: ";(ded)  (g)  (hj) e(jji)  (hg)  (hi) e(hg)  (g) S(g)  e(j) |(ji)  (hg)  &quot;(h)  (gf)  (e)  &quot;(h)  (gf)  (ded) [(dh)  (h) T(g) Wi(h) B(ji) R(hg) )(hi)  (hg)  (g)  O(h)  O(h)  (h)  (g) F(fe) o(d) &amp;(efg) fa(fe) e(e) ||(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-060.png",
        nextFileName: "./pages/part-b-061.png",
    },
    {
        title: "part-b-061-0",
        gabc: "he(gh) Blood(j) of(i) the(hg) Lamb(g) shall(f) be(g) to(h) you(g) for(h) a(j) token,(jg)  (g)  saith(g) the(fe) Lord;(e) and(j) when(j) I(k) see(ij) the(h) Blood,(ghg) I(g) will(g) pass(i)  o-(ik) (g) ver(h) you,(hg) and(fe) the(d) plague(e) shall(f) not(fh) be(h) up-(gf)on(fh) you(h) to(hig)  |(ik)  (gf) i(e) R(e) s(j) e(h) i(j) e(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-061.png",
        nextFileName: "./pages/part-b-062.png",
    },
    {
        title: "part-b-061-1",
        gabc: "nd(d) this(d)  (dc) shall(f) be(g) un-(f)to(h) you(h) for(h) a(gf) me-(eg)mo-(fe)ri-(d)al;(d)  (f)  and(hih) ye(g) shall(h) keep(jk) it(j) a(ih) feast(h) to(ih) the(fhji) Lord(fgh) throughout(h) a(g) your(f)  N(e) ne-(dg)3(gf) .(f) tions(j) by(d) an(e)  (fg) ordinance(dcd)  (e) for(fe) ever.(d)  (d) =~(h) &amp;(g) o(f)  (gh) »(dfgf) ",
        groupIndex: 1,
        filename: "./pages/part-b-061.png",
        nextFileName: "./pages/part-b-062.png",
    },
    {
        title: "part-b-062-0",
        gabc: ".(ik) Blessed(c)  (gj)  (h) art(g) thou,T(h) 0(gf) Ma-(gh)ry,(gh) for(g) thou(gf) hast(g) .(h) believeg.(hj)  (jkj)  and(h) there(i) shall(j) be(h) a(h) a(g) performance(h) [(g) in(fg) R(g) of(gh) those(fe)  things(d) which(e) were(f) told(hg) thee(h) from(g) the(fg) Lord,(gfd) &amp;l(f) -(fg) lu-(ik) (g) ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-062.png",
        nextFileName: "./pages/part-b-063.png",
    },
    {
        title: "part-b-062-1",
        gabc: "a(e) ry(gg) arose,&#39;T(h)  (i) and(i) went(ij) in-(h)to(f) the(h) —(gh) country(ihf)  (g) with(f)  -(e)in-(e)to(d) a(f) ci-(dhdd)ty.(f) of(gdf) Ju-(e)da.(e)  (h)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-062.png",
        nextFileName: "./pages/part-b-063.png",
    },
    {
        title: "part-b-063-0",
        gabc: "Ma-(hgi) (c)  (f)  (ef) ry(fe) en(fghf) ter-(ef)—ed(f) in-(f)to(f) the(fgh) house(i) of(i) Zacha(i)  (h)  ri-(ij)as,(j) and(hj) sa-(hi)lu-(hg)ted(fec) E-(ef) (h) li-(g)sabeth.(f) S(h)  (g) mcie(e) e(f) ||(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png",
    },
    {
        title: "part-b-063-1",
        gabc: "hen(e)  (ed) E‘—li—sa—beth(g)  (hj)  (ij) heard(j) Tthe(j) sa-(k)lu-(j)ta-(k)tion(ji) of(hi) Ma-(h)ry,(g)  the(g) babe(cdfe) leaped(f)  (gh) in(j) her(i) womb,(hg)  (g) and(h) she(ij) was(k) filled(ji)  (hg) with(h)  the(gf) Ho-(g)ly(f) Ghost,(ef) &quot;(g) al-(defgf)lu-(e)ia.(e) [l(h)  (ji) T(hi)  (h) s(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png",
    },
    {
        title: "part-b-063-2",
        gabc: "Blessed(e)  (g) art(h) thou(i) T(gg) among(h) women,(j)  (i) and(j) blessed(defhg)  (ef) is(d) the(f)  fruit(h) of(dhf) N(gf) ToE(e) e(i)  (j) e(i)  (h) L(dfgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-063.png",
        nextFileName: "./pages/part-b-064.png",
    },
    {
        title: "part-b-064-0",
        gabc: ".(d) lo,(f) as(fg) soon(g) |(g) ‘agsthe(g) 3(g) of(g) thy(f) e(gh)  (h)  (g)  (g)  sounded(d)  (f) in(e) mine(df) ears,(df) the(cd) babe(ffd) leaped(fh)  (g) in(h) my(gf) yop}(ghg) i(fe)  ](dc) al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (gh) |(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png",
    },
    {
        title: "part-b-064-1",
        gabc: "W(ikcc) hen(gd) E(fg) li-(gh)sa-(g)beth(g) Theard(h) the(g) a(g) sa~-(f)lu~ta-(gh)tion(h) of(hji) Ma-(g)ty,(g)  she(ij) spake(k) out(k) with(k) a(k) loud(jh) voice,(j) and(kj) said:(i) Whence(j) is(hg)  this(ik)  (h) to(i) me,(ihg) that(g) the(hj) mother(j)  (g) of(h) my(gf) Lord(g) should(gh) cor(f)  -(e)Y(d) al-(f)le-(fgh)lu-(g)ia,(g) m}__!(j) i(i) S|(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png",
    },
    {
        title: "part-b-064-2",
        gabc: "Au(gj)  (h) generations(g)  (h) ;(g) Tshall(dfdfg)  (df) call(ffg) -(ff) (dfghdd)  (d) blessed:(f)  (f) for(fg) God(h) hath(g) ré-(df)",
        groupIndex: 2,
        filename: "./pages/part-b-064.png",
        nextFileName: "./pages/part-b-065.png",
    },
    {
        title: "part-b-065-0",
        gabc: "garded(ik)  (g)  (h) the(h) lowliness(jk)  (j)  (jijkj) of(h) his(h) handmaiden,al-(j) (g) le-(gh)lu-(i) (h) ia.(g)  (g)  WITHIN(j)  (i)  (j)  (h) L)(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png",
    },
    {
        title: "part-b-065-1",
        gabc: "(G(f) lorious(g) princes(fgi)  (i) T(i) ver(h) all(g) the(h) earth,(hgf) as(f) in(i) life(i)  they(i) loved(i)  (i) one(i) an-(ih)o-(h)ther,(h) so(hjkj) e-(j)ven(ih) in(h) deat(hgefddc)  they(fhi) were(gf) not(h) S(gh) divided.(f) e(f) e(h)  (f) o(gh) T(g) i(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png",
    },
    {
        title: "part-b-065-2",
        gabc: "Pe-(eh)ter(f) L](e)  (d) Apostle(ef) a(e) a(e) ](g) the(h) a(i) Doctor(h) of(h) the(f) Gen-(h) =(g) these(i) ;(h) taught(iji) [(hghih) thy(fe) o(fhf) P,(gf) i(e) )(h) N(g) vl(h)  (f) |(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-065.png",
        nextFileName: "./pages/part-b-066.png",
    },
    {
        title: "part-b-066-0",
        gabc: "L(ki~) ¢(d) a(dc) the(d) .(f)  (e) mltichie(dc) Tof(e) the(f) faichbul(g)  (ed) ss(efe) T(d) Tt(d)  ‘the(dh) glory(hi)  (h) of(g) the(g) gracious(gh)  (h) Father(cd)  (d) Ben-(fgf)le-(dc)dict:(d) and(dhi)  chiefly(ik)  (h) =(fh) let(h) the(h)  (hg) a(fe)  (dc) of(cd) monks(fgh) be(fe) joyful,(fgf)  (d) ce-(h)le-(j) brating(i)  (ji)  (hg) his(g) So-(h)lem-(jk)ni-(ih)ty(j) on(ij) earth,(h) in(h) whose(hg) A(fe) oodly(fg)  fellowship(e)  (efe)  (dc) the(d) Saints(d) rejoice(fe)  (fgf) in(ced) heaven.(ef)  (d)  (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-066.png",
        nextFileName: "./pages/part-b-067.png",
    },
    {
        title: "part-b-066-1",
        gabc: "Be-(i) (d)  (dc) the(f)  (g) man(f) of(gh) God,t(h) made(igi) the(hgf) sign(fh) of(f) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-066.png",
        nextFileName: "./pages/part-b-067.png",
    },
    {
        title: "part-b-067-0",
        gabc: ":(d) and(gd) that(g) poison-(g) (f) laden(g)  (h) vessel(gf)  (f) was(h) so(gf) broken(h)  (hghih) as(h)  though(g) the(fe) sign(f) had(fg) been(g) a(f) stone(f) thrown(g) against(fe)  (d) it.(d)  (e)  (hg) BT(fhgf) ",
        groupIndex: 0,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png",
    },
    {
        title: "part-b-067-1",
        gabc: "his(c)  (d)  (de) prayer(e) was(fe) o-(fe)-(d)ve:r,T(j) he(d) took(e) three(fh) stones(hg) and(fe)  (f)  laid(f) in(fg) their(f) T(e) and(hg)  (h) Almighty(i)  (hg) God(hi) brought(i)  (i)  forth(ij) |(hg) ](efh) [(hg) the(e) top(fed) of(ef) that(f) ](e) (i(e) e(h)  (g) D(h)  (f) DN(efed) ",
        groupIndex: 1,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png",
    },
    {
        title: "part-b-067-2",
        gabc: "T(c)  (ed) glorious(g)  (hj)  (j) JfConfessor(j)  (i)  (j) of(k) the(j) after(j)  (h) some(i) praying,(i)  (hg)  e(fd) to(e)  (fg) stone(h) his(gf) SR(de) )(e) R~(ef) 2(ed) 5(g) where—(hj)  on(j) Anos(k) Ncient(ji) foe(h) ———(g) sat,(hj) was(hg) —‘_I—l—l=.l(f) e(ghg) WS(e) W(e) 3(efghiji)  (hi) e(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-067.png",
        nextFileName: "./pages/part-b-068.png",
    },
    {
        title: "part-b-068-0",
        gabc: "A(c)  (d) the(f) soul&#39;s(g) re-(ge) (fe) turning,(d) the(fe) little(g)  (h) ho-(g)dy(g) of(g) the(g)  stripling(f)  (h) trembled:(h)  (g) and(g) beneath(h)  (j) the(hg) eyes(e) of(f) al](g) (](e)  were(f) present,(e)  (d) appeared(f)  (gh) [(g) living.(e)  (e)  (h)  (g)  (h)  (ih)  (gef)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png",
    },
    {
        title: "part-b-068-1",
        gabc: "When(f) Placidus(hj)  (i)  (i) 1’was(j) drawn(hgf) from(hg) the(h) water,(hi)  (i) he(ik) saw(j) up-(ih)on(j)  his(j) head(i) the(h) garment(h)  (f) of(h) the(h) Ab-(h)bot,(hgh) who(f) rescu-(h)ed(g)  (ef) hin(ed)  from(ef) the(f) 0(e) @(e)  (i)  (j)  (i) f(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png",
    },
    {
        title: "part-b-068-2",
        gabc: "B(f)  (fe)  (d) »(e)  (g) father(gh) and(fg) guide(g) of(f) ..(e) monks,(f) thou(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-068.png",
        nextFileName: "./pages/part-b-069.png",
    },
    {
        title: "part-b-069-0",
        gabc: "most(g) ho(hjhgf) 1y(h) Confessor(h)  (g)  (g) of(g) the(ghg) Lord,(e) in-(fe) (d) tercede(ggh) for(g)  us(d) all(g) and(g) for(g) our(g) sal-(ghg)va-(e)tion.(e)  (h) ](g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-069.png",
        nextFileName: "./pages/part-b-070.png",
    },
    {
        title: "part-b-069-1",
        gabc: "0(dfddc) thou(f) pattern(gh)  (h) of(h) life(g)  (f) celestial(gh) ,T(h) our(h) Teacher(h)  (fgf) and(g)  Leader(h)  (fgf) Be-(d)ne-(cd)dict,(d) whose(dc) spirit(f)  (gh) now(h) rejoices(h)  (jkj)  (h) with(h)  Christ(ik)  (gf) in(gf) the(d) heavens:(cd)  (d) preserve(h)  (hij) thy(gf) flock,(gh) kindly(k)  (h)  (hg)  Shepherd:(fgefd) R(d) R(k) S(hg) them(h) by(g) thy(f) ho-(d)e(cd) e(d) o(d) and(c)  o0(d) a(f) way(ffg) made(f) clear(gh) by(h) thee(gf) their(fh) guide,(h) make(h) them(d)  .(e) =(c) B(fghgfe) N(cd)  (d) e(d) e(h)  (h) e(g)  (f) [(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-069.png",
        nextFileName: "./pages/part-b-070.png",
    },
    {
        title: "part-b-070-0",
        gabc: "O(efg) ho-(ddc)ly(de) Ma-(e)1y,(e) help(gh) thou(hhg) the(ed) suf(efgfe) -(de)fering,(e) strenp.(dfhhg)  then(gf) the(d) faint-(ef)hearted,(de)  (e) omfort(cdde)  (dc) the(c) sor(efgfe) rowful;(de)  (e) pray(dfhhg)  for(gf)  (dc) peoplé,(df)  (efed) entreat(d)  (dh) for(hih) the(gh) c]erg}.&#39;,(gf)  (ed) intercede(d)  (fh)  (h)  for(g) all(gf) womankind(dc)  (df)  (efed) vow-(fhhgf)ed(g) un-(gfe)to(de) God:(e) may(c) all(df) ac-(fd) knowledge(ef)  (g) the(g) help(gh) of(gf) thy(de) prayer,(dd)  (c) who(cd) ce-(fe)le-(fg)brate(gh)  thy(g) solemn(gh)  (g) Commem-(gf)o-(g) (ghg) ra-(e)tion.(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-070.png",
        nextFileName: "./pages/part-b-071.png",
    },
    {
        title: "part-b-070-1",
        gabc: "hine(f) head(g) up-(f)on(fgi) thee(i) is(dhi) like(d)  (gf) Carmel:(gh)  (f) and(f) the(gi) heif(hi) ",
        groupIndex: 1,
        filename: "./pages/part-b-070.png",
        nextFileName: "./pages/part-b-071.png",
    },
    {
        title: "part-b-071-0",
        gabc: "thine(i) head(gh) is(jk) as(j) royal(ih)  (gh) purpl(gf)  (efddc) &quot;bound(f) in(gi) tresses,(hi)  (gfe)  ‘(ge~) of(j)  al(g) le(gh) =lu-(f)ia.(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png",
    },
    {
        title: "part-b-071-1",
        gabc: "The(g) glory(gj)  (h) of(gf) Le-(gh)ba-(h)nonT(g) shall(h) be(g) given(f)  (h) un-(jjk)to(j) her,(j)  the(j)  (k) excellency(j)  (i) of(h)  (h) Carmel(j)  (i) and(g) Sharon,(h)  (gf) al-(gh)le-(h)lu-(g)ia.(g)  [(j)  (i)  (j)  (h) 8(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png",
    },
    {
        title: "part-b-071-2",
        gabc: "0(cd) mer-(idhih)ci-(gf);(gh) T(hgg) whose(fg)  (hg) righteousness(fg) [(gg)  (c) not(d) been(f)  geed(gf)  (d)  (d)  (dc)  (fg) standeth(f)  (gh) fast,(h) and(h) whose(gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-071.png",
        nextFileName: "./pages/part-b-072.png",
    },
    {
        title: "part-b-072-0",
        gabc: "children,(fh)  (h) for(h) their(jk) gakes,(jihg) shall(gf) remain(fh)  (h) with(h) glory(fhge)  ev-(ffed) (cd) er!(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png",
    },
    {
        title: "part-b-072-1",
        gabc: "o(g) e(hi) e(ih) e(j)  (ih) S(g) S(h) TS(i) a(g)  (i) (L(g)  (h)  (e)  o(f)  (e) 5(d) EE=————(g)  (i)  (h)  (j) T(k)  (j)  (ih)  (g)  ¥.(hj) Mary(g) hath(h) chosen(f) that(gh)  (g) good(fe) part.(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png",
    },
    {
        title: "part-b-072-2",
        gabc: "A&quot;(c) wo-(efg) (g) manTin(f) the(gi) ci-(h)ty(g) which(f) was(h) a(ih) sinner,(g)  (g) wher(hi)  she(ij) knew(jijig) that(h) Je-(i)sus(hg) sat(h) at(g) meat(fg) in(f) the(g) house(fe) f(dc) ",
        groupIndex: 2,
        filename: "./pages/part-b-072.png",
        nextFileName: "./pages/part-b-073.png",
    },
    {
        title: "part-b-073-0",
        gabc: "Gi-(f)mon(g) the(ih) leper,(g)  (g) brought(cddcdfedcd) an(d) I(c) _a&#39;~la-(df)bas-(fgf)ter(fed) box(e) of(ded)  :(c) .(c) and(ce)  (gf) stood(g) behind(fg)  (cg) &amp;t(c) the(d) feet(f) of(g) Je-(ih)sus,(g) and(hghhj)  began(g)  (h) to(g) wash(fe) his(d) feet(f) with(g) tears,(ihg) and(hi) did(ij) wipe(jijig) them(g)  with(i) the(hg) hairs(hg) of(e) her(gf) head,(g) and(dc) kiiss(dcfd~edcd) —_._-(cdc)his(df) feet,(fgffed)  and(ge~)  (ef)  (fg) anointed(gh)  (f) them(ed) .(e) the(ded) ointment.(c)  (c)  (g) I(h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-073.png",
        nextFileName: "./pages/part-b-074.png",
    },
    {
        title: "part-b-073-1",
        gabc: "therefore(c)  (c)  (f)  (g)  (fh)  (h) T(h) anointed(i)  (gf) the(g) feet(g) of(gh) Je-(f)sus,(f) and(g)  wi-(hi)ped(h) them(hi) with(ji) her(gh) hair,(h) and(h) the(jk) house(jih) was(fgh) fil-(hgf) |(ffddc) with(ff) the(fh) T8(hih) S(g) of(h) ST(fgh) -(f)ointment.(f) e(h)  (f)  (gh) e(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-073.png",
        nextFileName: "./pages/part-b-074.png",
    },
    {
        title: "part-b-074-0",
        gabc: "A(f) wo-(de)man(efe) Tin(d) the(f) ci-(f)ty,(e) which(d) was(ffgh) a(fg) sinner,(f)  (e) brought(g) i(hi)  a-(j)la-(i)bas-(h)ter(g) box(f) of(i) 4&quot;(gh) ointment,(e) and(e) stoodat(ef)  (f) the(e) Lord&#39;(fe)  feet,(d) and(ef) be-(de)gan(e) to(e) wash(f) his(ed) feet(f) with(h) tears,(hghih) and(h)  did(h) wipe(i) them(g) with(h) the(fe) hairs(fe) of(c) her(de) head.(e) I(h) I(g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-b-074.png",
        nextFileName: "./pages/part-b-075.png",
    },
    {
        title: "part-b-074-1",
        gabc: "The(cc) )(e) Lord(gh) gave(ij) them(i) Tthe(g) blessing(h)  (fe) of(f) all(gh) 7(fh) nations,(g) and(i)  es-(h)tab-(hij)lish-(i)ed(hghih) his(fe) co-(f)ve-(f)nant(g) -(h)on(g) their(f) heads.(e)  Be(i)  (j) glad,(i)  (h) O(gf) rightous,(fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-074.png",
        nextFileName: "./pages/part-b-075.png",
    },
    {
        title: "part-b-075-0",
        gabc: "a(e)  (ef)  (fe)  (dc)  (de) a(e)  (f)  (h)  (hg)  (fe)  (de)  (e)  ®.(h)  (ij)  (j)  (ih)  (i)  (i)  (hfe) 26(fh)  (f) n(fe)  (dc)  (de)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png",
    },
    {
        title: "part-b-075-1",
        gabc: "An(e) -(g)ev-(h)er-(i)lasting(j) name(i) Twill(j) I(i) give(h) my(fh) =(gh) saith(fg) the(f) ..(e)  they(g) shall(g) obtain(h)  (fh) joy(g) and(f) gladness(f)  (h) for(g) ev-(e)er.(e) I(i)  (j)  (i) bl(h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png",
    },
    {
        title: "part-b-075-2",
        gabc: "The(d) i,(dd) 0(c) al-(d)so(dfddc) shall(f) give(g) thanks(h) un-(g)to(g) thy(ffg) Name,(f)  and(f) the(f) just(fg) shall(f) continue(f)  (f) .(ef)  (g)  (fe) sight.(d)  (d)  (h)  (gddf)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-075.png",
        nextFileName: "./pages/part-b-076.png",
    },
    {
        title: "part-b-076-0",
        gabc: "[(g) will(g) give(h) my(h) Saints(gf) s(h) place(ji) and(h) a(j) name(i) in(h) tle(g) king(h)  dom(h) of(h) my(h) Father,(i)  (h) saith(g) the(fg) Lord.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png",
    },
    {
        title: "part-b-076-1",
        gabc: "O(dh) ve(hj) (e(hg) Spirits(h) and(f) ho-(g)ly(f) Souls(h) of(f) the(e) TR(d) righteous,(d) sing(fd)  d(ef) hymn(g) un-(f)to(fe) God,(dc) al-(d)n(efe) lu-(d)ia.(d) TR(h)  (g)  (f) e(gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png",
    },
    {
        title: "part-b-076-2",
        gabc: "T(c) he(f) peo(g) leTwill(fe)  (hg) tell(gf) of(e) the(e) wis-(ddc)dom(df) of(fe) the(de) Saints,(e)  and(g) the(hj) I(ji) congregation(gh)  (gf) will(efddc)  (gfg) shew(ghg) forth(ef) their(de) praise:(e)  Short(h)  (g) Respond,(h)  (ih)  (gfe) ¥(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-076.png",
        nextFileName: "./pages/part-b-077.png",
    },
    {
        title: "part-b-077-0",
        gabc: "I(g) am(hi) the(ij) God(k) Tof(j) your(hg) fathers,(hi)  (h) saith(gh) the(h) Lord:(g) I(g)  have(ij)  (g) seen(j) the(h)  (hg) affliction(h)  (g) of(f) my(h) &quot;(e) a-(e)and(g) have(h)  heard(ik)  (jkj) their(j) cry;(h) and(h) I(j) am(i) come(j) to(hg) de(hgf) liv-(g)er(gf) th-(ef) al(ik)  (g) le(gf) -(e)1ia.(e) [(j)  (h) I—_I(j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-077.png",
        nextFileName: "./pages/part-b-078.png",
    },
    {
        title: "part-b-077-1",
        gabc: "he(c)  (c)  (c)  (c) no-(cd)ble(d) stock(df) of(d) Jésse(cd)  (d) hath(f) brought(gh) forth(hg) a(f)  (g)  Pleasant(g)  (fe) stem,(d) from(h) which(dgf) doth(gh) spring(higih) [(hgf) flower(g)  (fe) of(ccd)  Wondrous(f)  (efe) fragrance.(d)  (d)  (h)  (h)  (g) ;(f)  (gh)  (gfed) ",
        groupIndex: 1,
        filename: "./pages/part-b-077.png",
        nextFileName: "./pages/part-b-078.png",
    },
    {
        title: "part-b-078-0",
        gabc: "a(f)  (e) 8(d)  (cdf)  (f)  (e) e(f)  (g) a(fe) a(d)  (c) .(d)  (f) |(h)  (h)  (T(h)  (d)  (f)  (gh)  (g)  (fe)  (d)  (e)  (e)  (g)  (h) 1(j)  (j)  (jh)  (hj)  (fh)  et(ij)  (g)  (gf)  (e)  (fg)  (g)  (g)  (hi)  (h)  (gh)  (h)  (h) i(hj)  (g)  (ge)  (f)  (ed)  (e)  a(i)  (c)  (d) art(f)  (ef) Peter.(d)  (e)  (f)  (gh)  (gf)  (d) |(e)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-078.png",
        nextFileName: "./pages/part-b-079.png",
    },
    {
        title: "part-b-078-1",
        gabc: "He-(gj)rod(h) the(g) king(h) t(g) proceeded(g)  (g) further(h)  (g) to(h) take(gf) Pe-(g)ter(gh)  al-(jk) (jk)  al-(f)so:(f) and(f) when(g) he(f) had(f)  (d) 384(dg) apprehended(h)  (dikj) him,(j)  (jijkj) B(hg)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-078.png",
        nextFileName: "./pages/part-b-079.png",
    },
    {
        title: "part-b-079-0",
        gabc: "him(j) in(i) prison,(g)  (g) a(g) intending(eg)  (g) after(e)  (g) Easter(fe)  (f) to(d) bring(e) him(fg)  forth(gf) to(h) the(ih) people.(g)  (g) [ees(j) Neats(i)  (j) e(h) s(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-079.png",
        nextFileName: "./pages/part-b-080.png",
    },
    {
        title: "part-b-079-1",
        gabc: "e-(f)ter(g) therefore(fgh)  (g) Twas(ef) kept(g) in(f) prison;(d)  (d) but(d) prayer(d)  was(ik)  (f) made(dc) without(f)  (g) ceasing(fh)  (h) of(h) the(g) Church(hg) to(f) God(g)  him.(fe)  (d)  (h)  (g)  (f)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-079.png",
        nextFileName: "./pages/part-b-080.png",
    },
    {
        title: "part-b-080-0",
        gabc: "L-(cdf)oo—sen(f) these(f) earthly(fe)  (de) %ﬁ(edc) tat(c)  (d) the(c)  (d) command(e) of(f)  God,(gf) O(de) Peter;(e)  (e) and(dhi) let(h) the(gf) king-(g)dom(ghg) of(fe) heaven(df)  (f)  be(efgfe) o(de) pen-(dc)ed(c) un-(fg)to(gh) the(gf) blessed.(e)  (e) B(h)  (g)  (h)  (ji)  (hg) !(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-080.png",
        nextFileName: "./pages/part-b-081.png",
    },
    {
        title: "part-b-080-1",
        gabc: "=5(ikc) Thou(f) hast(f) crowned(g)  (f) him(f) with(f) glory(f)  (f) and(f) honour,(f) a(e) O(g) Lord,*(h)  Al-(ik) (h) le(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(dgf)ia.(f) Thou(f) hast(f) crowned.(g)  (f) §1.And(c)  (f)  madest(ki~)  (f)  (f) him(f) to(f) have(f) dominion(f)  (g)  (f) of(f) the(f) works(f) a(e) thy(g) bands(h)  B.(ik) Al-(h)le-(hg)lu-(g)ia.(f) ¥,(h) Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) t0*(hi)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-080.png",
        nextFileName: "./pages/part-b-081.png",
    },
    {
        title: "part-b-081-0",
        gabc: "Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Ghost.(gf) Thou(f) hast(f) crowned.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png",
    },
    {
        title: "part-b-081-1",
        gabc: "-(f) (egh)  (g)  (fd)  (f)  (efg)  (f) __.:_.&#39;-(e) (g)  (hj)  (h) :_(gf)  (g)  (g)  (f) i(ed)  V.(cd) n(d)  (dc)  (d) LI(fe)  (de) R(e) R(e) e(g) T(gh) ](g) P(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png",
    },
    {
        title: "part-b-081-2",
        gabc: "Christ(cd) a(cdf) sus,t(f) the(e) brightness(d)  (ef) of(g) the(gh) Fa-(gfe)-(e)and(d) a(c) ex-(d) Press(f) im-(fe)age(d) of(e) his(dc) person,(de) e(e) who(dg)  (g) upholdeth(h)  (gh) N(ij) allthings(gh) by(h)  the(g) word(g) of(gf) his(de) =(edc) w-(c)e.r.:,while(d) heRwes(c)  (d) by(f) himself(d)  (ef) purging(g) L(g)  (e)  Y@y(fe) our(de) sing,(e) vouchsafed(dh)  (hi) on(h)  (h) this(h) day(gf) shew(dc)  (df) himsel(f)  (e)  &#39;(ik)  (f) glo(gfgh) O(hg) up-(g)i(h) ey(ffg) y(ghg) oo(e) |(e)  (h) )(g)  (h) [(ji) |(hg) Pl(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-081.png",
        nextFileName: "./pages/part-b-082.png",
    },
    {
        title: "part-b-082-0",
        gabc: "Je—sus(ki~)  (c)  (c)  (d) takethT(dh)  (ihi) Pe-(h)ter,(ghg) James,(f) and(e) John(fg) his(fe) brother,(d)  (d)  and(ik)  (dhi)  (h) I:—&#39;-(h)them(g) up(h) in-(h)to(j) an(i) high(jk) mountain(k)  (ji) é-(g)part,(ijh)  and(h) was(h) .(gf) transfigured(g)  (fe) before(dc)  (f)  (d) them.(d)  (h) S(g)  (f) S(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png",
    },
    {
        title: "part-b-082-1",
        gabc: "His(c)  (g) face(gj) did(h) shineT(gf) as(g) the(h) sun,(f) and(f) his(h) raiment(jk)  (jijkj) Wes(i)  white(j) as(hg) the(hg) light,(ef) al-(hg)le-(h)lu-(g)ia.(g) _ld(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png",
    },
    {
        title: "part-b-082-2",
        gabc: "Wl(f) ,b.e‘}“?.ld,t(fe) =iy(de) ‘there(d) TRV(c) AL(de) BT(ed) 5(e) &amp;3(fed) them(e) Mo-(ghj)ses(h) &amp;(gh)  E-(dfe) (d) li-(dfg)as,(g)  (fddf) talking(f)  (fd)  (fd) with(fd) Je-(cde)sus.(dddedhd)  (dg)  (hd)  (dih)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-082.png",
        nextFileName: "./pages/part-b-083.png",
    },
    {
        title: "part-b-083-0",
        gabc: "answered(c)  (fh)  (i)  (i)  (gf)  (h) Pe-(f)t.er,T(f) and(f) said(f) u.n-(c)to(df) .&#39;Je—sus,(ffg)  (f) Lord,(hfgi)  it(hi) is(hg) good(hj) for(ih) us(fe) to(gh) bhe(gf) here.(f) IS(h) et(f)  (h) arrei(g) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png",
    },
    {
        title: "part-b-083-1",
        gabc: ";(cc) While(e) he(ghg) yet(hj) |l(hghihgg) A(e) |(gh) a(fe) bright(df) clioud(dc) o-(d)ver-(ef) skadowed(g)  (f)  (ghg) them.(e)  (h)  (g)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png",
    },
    {
        title: "part-b-083-2",
        gabc: "lori-(f) (f) ous(f) didst(f) thou(f) appear(f) SR(g) in(f) the(f) sight(f) of(e) Lord,*(h)  Al-(h) (hg) ]u-(g)ia,(f) SRS(d) le-(fg)lu-(gf)ia.(f) Glori-(f)R(f) ous.(f) |(f) V.(c) Because(f)  (f)  the(f) Lord(f) hath(f) a(g) -(f)thee(f) with(e) ma-(g)jes-(g)ty.(h) Al-(h)le-(hg) lu-(g)ia,(f) A(c) Glory(f)  (f) be.(f) Glori-(f) (f) ous.(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-083.png",
        nextFileName: "./pages/part-b-084.png",
    },
    {
        title: "part-b-084-0",
        gabc: "l;ehold(c)  (c)  (e) a(fg) voice(g) Tout(gh) of(f) the(h) cloud,(hih) which(gf) sajq(g)  This(gi) is(h) my(jg) lov-(hihg)ed(h) Son,(hg) in(gh) whom(h) I(fg) am(g) wel](fd)  pleased;(fe)  (e) hear(gfd) ye(f) =(ef) al-(gf)le-(d)8(c) &amp;(c) W(g)  (h) e(g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-084.png",
        nextFileName: "./pages/part-b-085.png",
    },
    {
        title: "part-b-084-1",
        gabc: "And(i)  (c)  (h) when(fg) the(g)  (g) disciples(g)  (fh) heard(jjk) it,T(j) they(ji) fell(jk)  (hg) on(f) their(fh)  face,(ik)  (g) and(h) were(gf) sore(g) afraid:(fgh)  (f) and(fg) Je-(hj)sus(jk) came(hjig) and(h)  touch-(hij)ed(gj) them,(g) and(hg~) said,(fed) A-(fhg)rise,(fg) and(g) be(fh) not(j) 2~(hij)  fraid,(ik)  (hgf) al-(gh)1le(h) lu-(g)ia.(g) e(jdd) of(i) gt(j)  (h) (6|(fgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-084.png",
        nextFileName: "./pages/part-b-085.png",
    },
    {
        title: "part-b-085-0",
        gabc: "[(gj) aurence(h) the(gf) i(h) Deacon(g) hath(ij) wrought(k) a(jh) pious(j)  (j) work;(i) who(k) by(k)  the(k) sign(j) of(j) the(k)  (k) Cross(jijkj)  (h) enlightened(h)  (g) the(h)  (ji) blind:(g) and(g)  &quot;(g) distributed(g) a(e) T(g) to(fgh) the(fe) poor(d) the(ef) Church’s(gh) s(h)  (g) treasures.(g) e(j)  (i)  (j) e(h) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-085.png",
        nextFileName: "./pages/part-b-086.png",
    },
    {
        title: "part-b-085-1",
        gabc: "I,(d) a(e) hath(f) =(eg) entered(fg)  (ef) in,T(d) jnd(cd) as(f) a(g) Martyr(h)  (g) hath(g)  (c)  |(jk)  confessed(f)  (g) é(gh) [(g) Name(h) of(g) the(fe) Lord(cd) Je-(d)sus(efe) Christ.(c)  (d) “(f)   (h)  (g)  (f)  (fgh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-085.png",
        nextFileName: "./pages/part-b-086.png",
    },
    {
        title: "part-b-086-0",
        gabc: "L(fg) aurence(g) hath(g) wrought(h) a(gf) pious(gh)  (h) work;(g) who(g) a(e) the(g) i(g)  of(f) .(e) Cross(f) .(d)  (e) enlightened(f) the(fh)  (h) blind.(g) ](j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png",
    },
    {
        title: "part-b-086-1",
        gabc: "M(c)  (c) y(e) =(gh) cleaveth(f) 0(e) -(gh)un-(f)to(h) thee,(g) for-(i)as-(i)much(hf) as(h) my(h)  flesh(fgh) hath(f) been(e) burned(gh)  (f) for(e) thee,(gh) O(f) my(f) God.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png",
    },
    {
        title: "part-b-086-2",
        gabc: "he(gh) Lord(j) hath(i) sent(dhf) his(h) An-(h)gel,(g) and(h) [(g) de-(h)liv-(ij)er-(i)ed(h)  ;(jk)  me(h) out(h) of(g) the(h) midst(gf) of(e) the(f) :(ed)  (fh) and(fgh) I(fe) am(fg) notbume(f)  (e) d.(e)   (i)  (j)  (i)  (h)  (ih)  B(c)  (c) lessed(efh)  (fe) Laurence(f)  (ed) a4(ef)  (f) [(e) (B(e) a(fh)  (de)  (fd) ren(dhfhigdhij) -(dddfd)der(id) ",
        groupIndex: 2,
        filename: "./pages/part-b-086.png",
        nextFileName: "./pages/part-b-087.png",
    },
    {
        title: "part-b-087-0",
        gabc: "un-(i)to(i) thee,(hi) O(hg) Lord,(ef) who(d) hast(f) counted(h)  (g) me(f) worthy(hi)  (i) to(fh)  en-(gi) (i) ter(g) within(h)  (fh) thy(gf) gates.(e) (N(h) s(g)  (h)  (f) W](e) ",
        groupIndex: 0,
        filename: "./pages/part-b-087.png",
        nextFileName: "./pages/part-b-088.png",
    },
    {
        title: "part-b-087-1",
        gabc: "O&#39;n(c) the(d) i-(f)ron(ed) grate,T(d) 0(fg) God,(g) I(g) de-(f)ni-(g)ed(h) thee(h) not;(h)  and(hi) when(hg) fire(gg) [(g) kindled(h)  (fe) me,(d)  (d) 0(f) Christ,(f) I(df)  confessed(ef)  (d)  (c) th:a.e:(c) thou(c) hast(d) proved(f)  (f) my(fh) heart(g) and(f) hast(gh)  Vi-(i)si-(h)ted(gf) me(e) in(df) the(f) night(hg) season;(fg)  (f) thou(f) hast(g) tri-(hg) ed(f) a(e) with(fg) &quot;-(g)and(d) hast(f) f%nd(ddc) no(ef) 4(g) wickedness(fe)  (d) in(d) me.(d)  |(h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-087.png",
        nextFileName: "./pages/part-b-088.png",
    },
    {
        title: "part-b-088-0",
        gabc: "Blessed(eh) D(fed) L(ef) Laurence,T(e) when(e) laid(g) and(h) burning(i)  (h) on(g) the(h) i-(ij)1op(j)  &gt;(i) grating,(i) spake(g) to(i) the(i) im-(ji)pious(h) [~(hf) [(g) s(e) saying:(e)  The(gi)  (e) feast(fg) is(fe) ready,(f)  (ed) turn(e) and(ef) eat;(d) but(hhf) the(hi) Church’s(j)  (ih)  treasures,(ig~)  (iji)  (hg) which(i) thou(iji) claimest,(h)  (h) have(h) been(h) garner&#39;d(hi)  (hg)  up(f) in(h) heaven,(hg)  (e) by(f) the(efed) hands(dhf~) of(gf) the(g) poor(ih) and(f)  needy,(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-088.png",
        nextFileName: "./pages/part-b-089.png",
    },
    {
        title: "part-b-089-0",
        gabc: "Ma-(fg)ry(f) is(f) taken(gh)  (f) up(fe) 1n-(dc)to(f) hea-(fghi)ven:*(h) The(hij) An(ihgfe) gels(gh)  triumph.(gf)  (f) Ma-(fg)ry(f) is(f) taken(gh)  (f) up.(fe) V.(c) Ex-(f) (gh) alting(f) and(f) bless-(fe) x.1g(dc) the(fg) Lord.(i) The(hij) An(ihgfe) gels.(gh)  (c) Glory(f)  (f) be.(g)  Ma-(fg)ry(f) is(f) taken(h)  (f) up.(fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-089.png",
        nextFileName: "./pages/part-b-090.png",
    },
    {
        title: "part-b-089-1",
        gabc: "O(d) most(f) prudeint.(d)  (d)  (fh)  (h) go-(j) (h)  (ge)  (gh) est(fe) thou,(d)  (fh) shi-(c) ning(d) re-(d)splen-(dhihg)dent(gh) like(h) the(ge) glowing(g)  (ef) Daughter(f)  (g)  of(e) Si-(f)on,(d) thou(dc) art(f) all(gh) comely(hi)  (h) and(h) beautiful(j)  (h) ,(gh) fair(fh)  38(ghf) the(g) moon,(ghfd) clear(fg) as(c) the(ef)  (f) sun.(d)  (hfhdf)  (dh)  (g)  (f)  (gh)  (gf)  (hi) ",
        groupIndex: 1,
        filename: "./pages/part-b-089.png",
        nextFileName: "./pages/part-b-090.png",
    },
    {
        title: "part-b-090-0",
        gabc: "T(c) Ma-(c) (e) ry(e) is(e) taken(g)  (h) upt(i) in-(j)to(h) heaven:(ii)  (g) the(h) Angels(gh)  (ef) triug,(h) [(g)  exalting(gi)  (h)  (ij) s(i) and(h) blessing(fh) .(h) the(g) Lord.(e) IR(i) I(j)  (i) 7%(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png",
    },
    {
        title: "part-b-090-1",
        gabc: "T(ik) be(g) Virgin(g)  (g) Ma(gfd) ](e) ry.&#39;::_is(f) taken(fh)  (h) up(g) in-(f)to(h) heavenly(k)  (j) chan-(h) (j)  S(ik)  (i) wherein(k)  (i) e(j) King(k) C(k) BN(jijkj) ST(h) sitteth(h) ](g) on(hij) a(h)  starry(ik)  (i)  (h) throne.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png",
    },
    {
        title: "part-b-090-2",
        gabc: "We(e) will(f) Tun(h) af-(h)ter(ij)  (i)  (i) of(i)  (h) the(i) savour(j)  (i) of(h)  We(cdc)  thine(ij) oint(fgh) NHMeNts:(f) ex(gihg) ceedingly(f)  (e) :(fe) -(d)=(ed) virgins(f)  (h) 1(f)  thee.(f)  (i)  (h) ﬁ(i)  (j)  (h)  (fh)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-090.png",
        nextFileName: "./pages/part-b-091.png",
    },
    {
        title: "part-b-091-0",
        gabc: "Blessed(c)  (c)  (hg)  (h) art(ihij) thou,T0(i)  (ij) daughter,(ih)  (hg) from(fi) the(h) Lord:(ef) for(ed) by(ef)  thee(gi)  (f) we(ii) have(e) partaken(f)  (hf) of(g)  (f) the(ed) fruit(ef) of(f) life.(e) e(j)  (i) S(h) )(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png",
    },
    {
        title: "part-b-091-1",
        gabc: "Thou(f) art(f) fair(h) and(hhi) comely,(g)  (h) O(f) daughter(h)  (g) of(h) Je-(f)ru-(g) (fe) salem:(def)  (f)  &quot;(c) art(d) ter-(f)ri-(fg)ble(g) as(f) an(gh) ar-(fe)my(dg) with(efe) banners.(d) et(d) |(f) S(h)  (g) =(f)  (g) ||(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png",
    },
    {
        title: "part-b-091-2",
        gabc: "he(ik)  (c)  (f) Virgin(f)  (f) Ma—ry(g)  (f) is(f) taken(g)  (gh) up*(hg) In-(f)to(h) heaven-(g) (fd) ly(fg) cham-(g) bers.(ik)  (f) The(f) Virgin(f)  (f) Ma-(g)ry.(f) ¥.(c) Wherein(h)  (hi) the(h) King(gh) of(g) kings(g)  Sitteth(g)  (g) up-(g)on(h) a(g) starry(f)  (gh) throne.(dhg) In-(f)to.(gh) V.(cef) Glory(h)  (h) be.(h)  The(f) Virgin(f)  (f) Ma-(g)ry.(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-091.png",
        nextFileName: "./pages/part-b-092.png",
    },
    {
        title: "part-b-092-0",
        gabc: "is(c)  (d) she(dhi) Tthat(hg) riseth(h) ey(ghg) up(ef) as(gh) the(fe) morning,(d)  (d) fair(ff)  ’(ik) as(d) the(f) moon,(ffd) -(fedc)clear(fgh) as(gf) the(ghg) sun,(f) and(fghgf) ter-(g)-(fg)h]e(d) o(g)  an(h) ar-(fe)my(cd) with(fe) B(d) banners?(d) e(h)  (g)  (f) e(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-092.png",
        nextFileName: "./pages/part-b-093.png",
    },
    {
        title: "part-b-092-1",
        gabc: "On(ik)  (f) this(fg) .(g) dayTthe(hj) Vir-(ji)gin(gh) Ma-(h)ry(g) went(j) up(ji) in-(h)to(g) heaven(h)  (ghgf)  i(ik) rejoice,(fg)  (g) because(fg)  (g) she(h) T(j) reigneth(i) with(j) Christ(h) for(fgh) ev-(g)er(f)  .(ik) and(fh) ev-(g)er.(g) TR(j) e(i)  (j) e(h) Sl(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-b-092.png",
        nextFileName: "./pages/part-b-093.png",
    },
    {
        title: "part-b-093-0",
        gabc: "Let(e) us(e) praise(eh) a(f) man(d) famous(ef)  (e) in(g) his(hg) gen-(f)e-(h)ra(gfe) tion,(e)  with(gi)  (f) whom(d) the(fh) Lord(hihf) es-(i)tab-(g)lish-(h)ed(i) the(h) blessing(ij)  (hg) of(fe)  all(fh) nations,(hhi)  (h) and(h) the(gh) cov-(f)e-(e)nant,(d) |(de) made(ef) it(f) rest(h)  ](gf) on(gh) his(g) head.(e) e(h) s(g) e(h) e(f) ose(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-093.png",
        nextFileName: "./pages/part-b-094.png",
    },
    {
        title: "part-b-093-1",
        gabc: "He-(c)rod(d) sent(dh) Tan(h) ex—e-(h) (gf) cu-(gh)tion-(h)er,(h) and(f) commanded(g)  (hg) him(fe)  (d)  to(f) behead(f)  (ef) Jbhn(dc) in(d) the(dfe) prison:(c) .-(c)and(cd) when(df) his(f) .(d) =(dc)  Ples(fg) heard(f) of(h) it,(h) they(hjj) came,(hih) and(f) took(g) up(h) his(dgf) bo-(g)dy,(def)  (j)  and(ik)  (f) laid(f) it(ef) in(g) a(cdfe) tomh.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-093.png",
        nextFileName: "./pages/part-b-094.png",
    },
    {
        title: "part-b-094-0",
        gabc: "He-(c) (cg) rod(g) himself(h) T(j) had(h) sent(j) forth(i) Tand(g) laid(h) e(j) o(h) S(j)  John,(ki~)  (i) and(h) bound(g) him(h) in(h) prison(ih)  (g) for(g) He-(g)ro-(h)di(hf) ag’(fg) seke,(e)  |(j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png",
    },
    {
        title: "part-b-094-1",
        gabc: "My(j) lord(hij) the(ji) king,t(g) give(j) me(i) in(h) a(g) charger(hgh) ..(e) the(ef) head(g)  of(h) John(g) the(gf) Baptist.(e)  (e) LAl(j) ‘(h) pongiivia(j) Casagg(i) ",
        groupIndex: 1,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png",
    },
    {
        title: "part-b-094-2",
        gabc: "hen(d) the(dc) damsel(f)  (g) danced,(fgh)  (hgg) her(fg) mother(h)  (gf) bade(ggf) her:(d) Ask(g)  for(g) nothing(h) a(g) else(fgf) a(e) the(f) head(g) of(fe) John.(d) —E-(h) (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png",
    },
    {
        title: "part-b-094-3",
        gabc: "olin(d) reproved(d)  (d) dt(d) He-(ff)L2(defedc~) for(f) [(gd) sake(h) ](fdg) He-(g)di(fd) ",
        groupIndex: 3,
        filename: "./pages/part-b-094.png",
        nextFileName: "./pages/part-b-095.png",
    },
    {
        title: "part-b-095-0",
        gabc: "4hom(h) he(fe) took(df) for(cd) wife(ffgf) from(f) his(fg) brother(e)  (fe) Philip.(d)  (d)   (h)  (g)  (f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png",
    },
    {
        title: "part-b-095-1",
        gabc: "ive(f) me(ef) in(h) a(h)  (hj)  (i) head(i)  (h) of(i) John(j) the(ih) Baptist:(i)  (i)  (i)  and(i) the(i) -(fgi)was(g)  (h) exceeding(f) ](e) sorry(f) a(e) for(de) his(fh) oath’s(f) sake.(f)  (e)  Antiphon(ig~)  (i)  (h) on(i) Benedictus,(j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png",
    },
    {
        title: "part-b-095-2",
        gabc: "The(ccc) ](e) L](eh) the(f) un-(fe)be-(d)liev-(ef)a(e) sent(e) his(g) de-(h)test-(i)a-(h)ble(fh)  (h)  2(h) =(g)  (h) and(i) commanded(i)  (h)  (iji) them(hghih) to(f) behead(f)  (fe) John(fh) the(g)  (e)  Baptist.(e)  (e)  (f)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 2,
        filename: "./pages/part-b-095.png",
        nextFileName: "./pages/part-b-096.png",
    },
    {
        title: "part-b-096-0",
        gabc: "et(c) us(d) ce-(fg)le-(fed)brate(d) the(d) wors(e) 1pful(cd)  (d) Na-(efe)ti-(d)vi-(d)ty(d) of(f)  the(g) blessed(h)  (f) and(g) glorious(f)  (e)  (dg) Virgin(e)  (f) Ma-(dd)r;&quot;:(c) for(d) ihe(dc) hath(f)  ob-(ki~) (g) T(fgh) ed(hgg) the(fg) dig-(h)ni-(g)ty(g) of(f)  (gh) Motherhood,(fed) O(d) and(dgfe) yet(de) lost(dd)  not(ki~)  (c) her(ef) maiden(gh)  (fe) pu-(d)ri-(d)ty.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-096.png",
        nextFileName: "./pages/part-b-097.png",
    },
    {
        title: "part-b-096-1",
        gabc: "et(g) us(h) ce-(ghij) (j) lebrate(j) fthe(j) W,(j) worshipful(hj)  (i) Na-(h)ti-(g)vi-(gh)ty(h) of(g) the(h)  blessed(j)  (ji) and(kj) glo-(k)ri-(k)ous(j) Virgin(kj)  (k) Ma-(j)ry:(j) for(ji) she(jk) hat(k) !(j)  -(ik) (ji) tained(h) the(j) r(h) ni-(hg)ty(f) of(hi)  (h) Motherhood,(gh)  (h) and(h) yet(jh) 1ost(ggf) nob(d)  her(ik)  (ef) maiden(fgf)  (ghf) pu-(g)ri-(e)ty.(e) e(ji) |(hi)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-096.png",
        nextFileName: "./pages/part-b-097.png",
    },
    {
        title: "part-b-097-0",
        gabc: "’The(cc)  (g) Na-(g)ti-(g)vi-(g)ty(gd) Tof(f) the(gh) glorious(g)  (g) Virgin(hi)  (gh) Ma-(gf)ry,(f) of(f) the(g)  seed(h) of(h) A(hiji) bra-(hg)ham,(g) sprung(hg) from(g) the(g) tribe(g) of(fefgf) Ju-(dc)da,(c)  5f(c) the(d) no-(dfgh)ble(gf) stem(hg) of(hi) David.(h)  (g) G(j) N(i)  (j) Y(h) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png",
    },
    {
        title: "part-b-097-1",
        gabc: "T(c)  (c) o-(i)day(i) is(g) the(i) Na-(j)ti-(i)vi-(hi)A(i) Tof(i) the(i) ho-(i)ly(g) ————_—(h) Virgin(g) Ma-(e)ry,(e)  whose(h) glorious(h)  (f)  (h) life(g) il-(f)lu-(f)0(e) mineth(f) all(h) the(g) &quot;(e) e(e)  (jihgh) ",
        groupIndex: 1,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png",
    },
    {
        title: "part-b-097-2",
        gabc: "from(f)  (g) a(f) royal(g)  (f) race;’(g) lo,(ghg) Ma-(f)ry(f) shineth(jifhihg)  (g) resplen—(i)  (hgf)  dent:(ki~)  (f) by(f) g(f) —(g) we(f) ask(fhihg) L(g)  (h) 6(g)  (f) that(f) ==(ff) may(efd)  b(cd)  (fg) a1ded(f) both(g) RN(dffg)  (g) e(ggh) s(f) s(f) [(hhh) o(g)  (h)  (f) (o,(hhh) i(f)  (gh) i)(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-097.png",
        nextFileName: "./pages/part-b-098.png",
    },
    {
        title: "part-b-098-0",
        gabc: "With(c)  (gfd) all(e) our(f) heart(gh) and(h) soul(g) let(g) us(g) sing(g) glory(h)  (g)  Christ(d)  (ef) on(c) this(d) ho-(fg)ly(g) so-(g)lem-(h)ni-(fg)ty(g) of(h) Ma(hji) -(kjh)IV,(ih) the(g)  ex-(g)alt-(hi)ed(g) Mother(hg)  (fe) of(fg) God.(g) =(j)  (i) “a(j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png",
    },
    {
        title: "part-b-098-1",
        gabc: "With(c)  (i) joy(i) and(g) gladness(ij)  (i) let(i) us(i) ce-(ij)le-(i)brate(i) the(i) Na-(i)ti-(i) vi-(i)ty(i) of(g) blessed(hi)  (hg) a(e) ry:(e) that(f) she(h) may(h) intercede(h)  (h)  (h) =(fh)  us(g) un-(f)a(e) Jesus(f)  (f) Christ(h) our(g) Lord.(e) holy(h) Virgin(i)  (j) -(i) (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png",
    },
    {
        title: "part-b-098-2",
        gabc: "T°&#39;dﬂY(g)  (gh) let(h) us(fhghf) ce-(gh)s(h) T(g) Twith(g) due(hgjh) so-(gf)lem-(fgh)ni-(h)ty(g) the(ji)  Na-(j)ti-(jk)vi-(j)ty(ji) of(h) God’s(fji) Mother,(fhg)  (g) the(g) ev-(g)er(g) Virgin(hi)  (fgh) Har¥:(g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-098.png",
        nextFileName: "./pages/part-b-099.png",
    },
    {
        title: "part-b-099-0",
        gabc: "from(g) whom(g) the(g) Son(gh) of(g) the(f) High-(h) (ij) est(jijkj) proceeded,(j)  (hg)  (f) al-(hg)le-(h) lu-(g)1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-099.png",
        nextFileName: "./pages/part-b-100.png",
    },
    {
        title: "part-b-099-1",
        gabc: "Thy(d)  (dc) iaé—ti—vi-(f)ty,(gh) t(h) 0(h) Virgin(h)  (g) Mother(fe~)  (g) God,(fe)  (d) hath(d) pro-(f) —e(d) joyful(f) L(g) ti-(fh)dings(hgfed) un-(f)to(g) all(e) the(fe) world:(d) for(h) out(h)  of(h) thee(h) hath(g) a-(f) (gh) ris—en(h) the(h) Sun(h) of(gi)  (h) righteousness,(gh) (9(hgfed)  e-(f)ven(g) [(e) M(fe) o(d) who,(df) taking(dc)  (f) a-(g)way(f) the(gh) curse,(h)  hath(h) «(g) Best;weda(ef) [](g)  (fe) L(d) a:ld(c)  (d) confounding(ef)  (c) death,(d) hath(fed)  g(e) en(f) a(g) =(fh) us(hgfed) life(fg) K_-(e)ev-(fe)er-(d)lasting.(d) C_I—_I(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-099.png",
        nextFileName: "./pages/part-b-100.png",
    },
    {
        title: "part-b-100-0",
        gabc: "We(c)  (c)  (f) adore(f)  (g) thee,(f) .(h) Christ,*(hg) And(fd) we(fg) bless(g) thee,(f) We(f) ¢(f)  dore.(g) ¥.Pecause(h)  (hi) by(h) thy(h) Cross(g) thou(g) hast(g) redeemed(h)  (g)  (f)  the(fh) world.(hg) And(fd) we(fg) hless.(g) Glory(h)  (h) be(h) to(h) the(h) Fathe(hi)  (h)  and(h) to(h) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) We(f) a-(f)dore.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-100.png",
        nextFileName: "./pages/part-b-101.png",
    },
    {
        title: "part-b-100-1",
        gabc: "0&quot;(cd) Cross,(ff) T(cd) iurpassing(f) all(gh)  (h) the(g) stars(fe) in(d) splendour,(g)  (cd)  d(d) renowned,(d)  (cdf) o(f) exceeding(fe)  (d)  (fe) dear(ddc) -(fgh)to(gfefgh) the(fe) hearts(d)  of(fe) mén,(ddc) ho-(eghg)li-(fe)er(fgf) than(def) e(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-100.png",
        nextFileName: "./pages/part-b-101.png",
    },
    {
        title: "part-b-101-0",
        gabc: "wert(i)  (fe) counted(fe) worthy(dcd)  (c) to(c) uphold(d)  (ffg) the(ed) world’s(e)  (ef) ransom.(d)  (d)  Sweet(h) the(gf) wood,(hghghih) sweet(f) the(ed) .(dgf) ron,(g) -(c).(d) so(fgf) sweet(ed)  e(ik)  (efe) ESPE(d) burden:(d) 2(hg) bring(hih) 5(hgfed) to(f) .(g) e(de) congrega&#39;tion,(fe) i(ddc) u-(c).(c)  are(d) here(fe) as-(f)sem-(gh)bled(g) to(cd) ce(fg) -(f)brate(d) thy(e)  (e) praises.(d)  (d)   (h)  (g)  (f)  (g)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-101.png",
        nextFileName: "./pages/part-b-102.png",
    },
    {
        title: "part-b-101-1",
        gabc: "0(igj) mighty(j) G(i) Twork(ig) al(hg) s(e) b(e) death(h) then(f) di-(h)ed,(g) when(dgh)  life(hiji) di-(h)ed(f) .(e) -(fh)the(g) .(e) [(i) i(j) o(i)  (h) v(gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-101.png",
        nextFileName: "./pages/part-b-102.png",
    },
    {
        title: "part-b-102-0",
        gabc: "@.(g)  (hj)  (j)  (j)  (h)  (j) .-(i)o(g)  (h) 9(h)  (h)  (i) e(h)  Cross:(g) thou(g) who(h) savedst(i)  (h) Peter(j)  (i) in(gi) the(hg) =(h) [(g) e,(gf)  ¢y(gh) up-(gf)on(e) us.(e) Y(j)  (h)  (j) &#39;(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png",
    },
    {
        title: "part-b-102-1",
        gabc: "B(d) n(e) the(f) Crass(ge) of(f) the(e) Lord;(d) [flee(fh) e(h) 1T(hghihgg) vye(ef) ‘(g)  ver-(fe)sa-(d)ries:(ded) a(c) Li-(cd)-(d)of(d) the(d) a(e) of(f) Ju-(gh)dah,(ghg) the(g)  Root(ef) of(g) Da-(f)—(edc) hath(d) prevaildd,(ef)  (d)  (dc) al-(d)le-(efe)lu-(d)ia.(d)  (hgf)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png",
    },
    {
        title: "part-b-102-2",
        gabc: "But(ig) s(ij) for(i) us,(i) it(i)  (i) behoveth(i)  (g) us(hi) to(hg) glory(e)  (e) in(h) the(h) Cross(h)  of(f) our(h) Lord(gfe) Je-(fg)sus(f) i(e) e(i) s(j) e(i)  (h) ;(fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-102.png",
        nextFileName: "./pages/part-b-103.png",
    },
    {
        title: "part-b-103-0",
        gabc: "t,h-(dd)e(c) si;zn-(df)rof(fe) the(de)  (dc) de-(fg)liv-(hihi)er(g) us(hih) from(h) our(g)  e(f) ne-(fe)mies,(dc) O(d) our(efe) God.(d) =&quot;(h) w(g) &amp;(f) d(gh) aoW](g) ",
        groupIndex: 0,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png",
    },
    {
        title: "part-b-103-1",
        gabc: "This(f) sign(g) of(f) the(fhg) Cross(hg) Shall(fgh) be(gfd) in(fg) heaven.(g)  (f) This(f) sign(g)  V.(ki~) When(h) the(h) Lord(i) shall(h) come(g) to(f)  (gh) 17.(hg) Shall(fh) be.(cgfd)  X’_,(i)  (c) Glory(h)  (h) be.(h) This(f) s&#39;ign.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png",
    },
    {
        title: "part-b-103-2",
        gabc: "Ve(ij)  T(d)  (e)  (gh)  (hg)  (h) e(j) Lo(ji) |(hg) s(i) iy~(j) Ve(j) )(fhg) [y(j) N(ih) el(h)  (8(h)  (hji)  (g)  (ge) st(f)  (dc)  (de)  (efe) RS(d)  (dfh) s(hg)  (ed) e(f)  (ed)  (d)  We(h) «(hji)  (g) m(ge) i(f)  (dc) YR(de) and(efe)  (j) we(d) RS(dh) bless(hg) s(ed) thee.(f) e(ed) i‘:—i(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-103.png",
        nextFileName: "./pages/part-b-104.png",
    },
    {
        title: "part-b-104-0",
        gabc: "Thou(c) a-(d)lone(f) Texcellest(fe)  (d)  (ef) in(de) stature(d)  (c) all(f) the(g) cedarg(hg)  (e) of(fg)  Leb-(fe)a-(d)non:(d) for(f) on(fe) the(dc)  (df) Life(fh) of(g) the(f) world(fe) yag(de)  -(dd) (c) on(f) thee(fe) .(g) Christ(fh) vic-(ed)to-(fe)ri-(d)ous,(d) and(cd) deit)(deed)  o(defgh) ver(g) death(fgf) did(fe) for(dc) ev-(d)er(fe) triumph.(d)  (d) i(h)  (g) e(f)  (gf) —(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png",
    },
    {
        title: "part-b-104-1",
        gabc: ":(ik)  (cdffghgefd) (e(d) ex—ceed-(h) (gf) ing(gh) blessed,(defd)  (d) which(defe) a-(de).(ddc)  wast(ik)  (f) count—ed(fghhg) W(edfe) e(d)  (dc) worthy(d) to(hg) R(hjighihgf) A(gh) the(cd) Ldrd,(ddc) the(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png",
    },
    {
        title: "part-b-104-2",
        gabc: "qm(dcdede) ia,(d) S(fg) st(dfdh) |(dfgdffhdfgffdgdfefdf) (|(hhfdf) ",
        groupIndex: 2,
        filename: "./pages/part-b-104.png",
        nextFileName: "./pages/part-b-105.png",
    },
    {
        title: "part-b-105-0",
        gabc: "bundle(cf)  (g)  (f) of(gh) myrrh(hg) Is(g) my(f) well-(g)be-(gh)lov-(gfd)ed(fg) un-(g)to(f) me.(f)  A(f) bundle(g)  (f) of(gh) myrrh.(hg) V.(c) He(hi) shall(h) lie(h) all(g) night(g) betwixt(gf)  (g)  my(gh) breasts.(hg) Is(g) my(f) well-(g)be-(gh)lov-(gfd)ed(fg) un-(g)to(f) me.(f)  Glory(h)  (h) be.(h) A(f) bundle(g)  (f) of(gh) myrrh.(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-105.png",
        nextFileName: "./pages/part-b-106.png",
    },
    {
        title: "part-b-105-1",
        gabc: "a(d)  (e)  (f)  (g)  (h) —_—(h)  (h)  (g) [](e)  (f) -(gf) (e) a(d)  (e)  (f)  a(g)  (h)  (h)  (g)  (e)  (f)  (g)  (h)  (h)  (h)  (hi)  (ih)  (g)  (h)  (h)  D(h)  (g)  (e)  (f) :(ed) =(d)  (g) O(f)  (g)  (e) (S(fe) e(d) D(e) o(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-105.png",
        nextFileName: "./pages/part-b-106.png",
    },
    {
        title: "part-b-106-0",
        gabc: "ook(d) not(d) T(f) on(de) me,(dc) because(fg)  (fe) I(gh) am(h) black,(h) becauge(h)  (h) K(g)  sun(h) hath(g) =(fe) looked(f) up(fgf) on(d) me:(d) my(h)  (d) mother’s(dg)  (ef) childrep(fh)  (fe) e(dc)  an(def) gry(d) with(cd) me.(d) a(h)  (g) [(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-106.png",
        nextFileName: "./pages/part-b-107.png",
    },
    {
        title: "part-b-106-1",
        gabc: "Whi—therris-(cffg)&lt;(f)  (f) thy(g) be-(h)lov-(ih)ed(fg) gone,(f) O(ff) @(c) fairest(f) [](g) -(f) (e)  women?(gh)  (h) whither(hi)  (h) is(fggh) thy(g) be-(f)lov-(e)ed(f) et(g) 0y(f) a-(ed)&amp;~(c) that(gf)  we(e) may(d) seek(cd) him(df) with(gf) thee.(f)  (h)  (f)  (gh) |(g)  (f)  Look(dh) a-(h)vay(hj) from(h) me;(h) T1(g) will(fgf) weep(e) bit-(def)ter-(d)ly,(d)  (f) labour(cd)  (dg)  not(ed) to(cdfe) comfort(d)  (ce) me.(d)  (h)  (g)  (f) |(gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-106.png",
        nextFileName: "./pages/part-b-107.png",
    },
    {
        title: "part-b-107-0",
        gabc: "H(c)  (c) e(e) hath(f) no(h) form(h) nor(h) comeliness;(j)  (i) and(i) when(hi) we(j) shall(ih)  see(i) him,(i) there(i) is(fi) no(hg) beauty(fe)  (fe) that(d) we(e) should(fh) de-(hg)sire(f)  him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png",
    },
    {
        title: "part-b-107-1",
        gabc: "From(hghc)  (h) the(h) sole(hg) of(e) the(h) foot(f) T(e) ven(f) un—-(hf)to(gf) the(e) head,(e)  (f)  there(fge) is(ec) no(def) soundness(h) e(g) in(g) him.(f) RIBD(h)  (g) e(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png",
    },
    {
        title: "part-b-107-2",
        gabc: "Stay(ik)  (de) me(f) with(ge) flagons,‘f(fe)  (d) comfort(f)  (g) me(h) with(ig) apples;(h)  (h) for(dhhg)  I(fe) (0w(dc) sick(e) W(ef) love.(d) [sreen(h)  (g) ey(f) el(fh)  (dgf) ",
        groupIndex: 2,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png",
    },
    {
        title: "part-b-107-3",
        gabc: "&gt;(ikc)  (c)  (f) :(g) T(h) fa-(hg)BEELEE(fgh) R(defdfg) e(g) T(f) |(h)  (fghi) e(f) B(g) |(hi) ",
        groupIndex: 3,
        filename: "./pages/part-b-107.png",
        nextFileName: "./pages/part-b-108.png",
    },
    {
        title: "part-b-108-0",
        gabc: "My(h) heart(hi) within(h)  (fgh) me(g) .(f) troubled.(fh)  (hg) s(fdfg) Veeping,(g)  (f)  Clory(h)  (h) be.(h) Mine(f) eyes.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png",
    },
    {
        title: "part-b-108-1",
        gabc: ".(gi)  (e) ;(f) :-(gh) (g) [(fe)  (f) &amp;(g) &amp;(f) |[=(f) ==_&quot;:-(g).(h)  (ih)  e(ig~) L-(g)e(fgh) |(hg) s(g) ‘I.-(g)e(i) e(ij) i:-(ji)[(hg) wiases(fgh)  (hg) 0(g)  X.(gi) 0(e) o(f) e(gh) e(g) 110(fe) S(fg) )(gf) Rl(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png",
    },
    {
        title: "part-b-108-2",
        gabc: "ome(f) ye,(de) and(e) let(d) us(f) go(h) up(hg) to(f) the(g) mountain(hi)  (i) the(k)  Lord,(i) and(h) see(hh) if(e) there(f) be(hh) an-(hi)y(h) sorrow(hg)  (h) like(hg) un-(f)to(hf)  My(gf) T(e) SOrrow.(e) |(f) e(h)  (g) S«(h) M(f)  (ef) el(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-108.png",
        nextFileName: "./pages/part-b-109.png",
    },
    {
        title: "part-b-109-0",
        gabc: "S(hg)  (ef) orrow(f) oppresseth(f)  (h)  (f) me,(fhffe) face(fh)  (hi) 1is(ih) swollen(gf)  (e) with(fg)  weeping,(gi)  (gh)  (g) and(ij) on(i) my(hi) eyelids(if)  (f) is(e) the(f) sha(fgh) dow(f) of(ef)  death.(f)  (hg)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-109.png",
        nextFileName: "./pages/part-b-110.png",
    },
    {
        title: "part-b-109-1",
        gabc: "smoke(f)  (f) of(f) the(f) incense(g)  (f) ascended(f)  (g)  (gh) up(hg) Before(fd)  (fg) God.(gf)  The(f) smoke.(f) [(f) A(hi) of(g) e(f) ](g) Angel’s(gh) |(hg) |(fd) (&amp;(fg) ](gf)  Glory(h)  (h) be.(h) The(f) smoke.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-109.png",
        nextFileName: "./pages/part-b-110.png",
    },
    {
        title: "part-b-110-0",
        gabc: "a(ig~)  (e)  (ef)  (f) a(fe)  (h)  (g)  (f) .(e)  (h)  (i)  (j)  (ih) i(i)  (i)  (j)  a(hg)  (h)  (i) a(j)  (i)  (hg) TR(hihg)  (f)  (f)  (f)  (fi) b(h)  (hf)  (g)  (f)  (e)  -(hgi) (c)  (ef) Angel(f) stood(fe)  (h) TR(i) the(i) altar(h)  (j) of(i) the(hg) temple.(hihg)  (f) j(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-110.png",
        nextFileName: "./pages/part-b-111.png",
    },
    {
        title: "part-b-110-1",
        gabc: "While(cc)  (dg) John(ef) :(fg) beheld(g) Tthe(gh) sacred(h)  (gf) mys-(gh)ter-(g)y,(g) the(g) Archan-(hj) (jji)  gel(h) Mi—cha-(ji)el(hg)  (g) sounded(eg) @(g) the(g) e(f) trumpet:(d) Forgive(g)  (h) us,(g) 0(f)  Lord(g) our(gh) Cod,(f) that(hj) o-(j)pen-(ji)est(hj) e(i) a(g) and(g) loosest(h)  (g)  the(g) seals(h) »(g) G(fed) al-(f)le-(fg)lu-(g)ia.(g) I_-(j)P(i)  (j)  (h) I(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-110.png",
        nextFileName: "./pages/part-b-111.png",
    },
    {
        title: "part-b-111-0",
        gabc: "An(ef) An-(h)gel(hi) stood(i) Tat(i) the(i) altar(h)  (i) of(j) the(ih) temple,(i)  (i) having(f)  (i)  in(g) his.(h) hand(f) &quot;a(fe) golden(de)  (fh) censer.(f)  (f)  (i) [y(h)  (i) g(j)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png",
    },
    {
        title: "part-b-111-1",
        gabc: "While(cc)  (e) the(g) Arch-(h)an-(ihj)gel(i) Mi-(i)cha-(h)el(f) contended(i)  (gh)  (e) with(f) the(e)  dragon,(def)  (f) a(fi) voice(h) was(hg) heard(ee) of(df) them(h) that(i) said:(hghih) Sal-(h) va-(h)tion(f) to(h) our(ef) God,(ed) al-(fe~)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png",
    },
    {
        title: "part-b-111-2",
        gabc: "O(g) Arch-(h)an-(g)gel(f) Mi—cha-(h) (j) el,(j) I(j) have(i) ap-(g)point-(j)ed(i) thee(g) )(g)  prince(g) o-(f)ver(h) all(j) the(j) souls(ig)  (j) about(g)  (h) to(hjh) be(i) received.(h)  (g)  (g)  .(j)  (i)  (j)  (h)  (g)  (f) &#39;(f) ",
        groupIndex: 2,
        filename: "./pages/part-b-111.png",
        nextFileName: "./pages/part-b-112.png",
    },
    {
        title: "part-b-112-0",
        gabc: "a(c) ye(d) Angels(f) 0(e) of(f) the(fg) Lord,T(g) bless(gh) &quot;(fe) the(d) Lord(f) o(gh)  ev-(g)er,(g)  (h)  (hi) e(h)  (hhh)  (g)  (f) ](ggg)  (d)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png",
    },
    {
        title: "part-b-112-1",
        gabc: "Angels(i)  (h) and(gh) Arch-(iji)an-(hi) (ie) Thrones(fi) ang(h) Do-(g)min-(e)ions,(e)  Prin-(iih)ci—pa-(gh)li-(j) (i) ties(h) and(i) Pow(ijji) ers,(i) Virtues(jk)  (k) of(i) the(k)  hea(jkjh) vens,(ji) O(ij) praise(h) the(f) Lord(g) of(h) hea-(fe)ven,(d) al(fe) le-(f) lu-(e)1ia.(e)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png",
    },
    {
        title: "part-b-112-2",
        gabc: "In(f) the(f) presence(g)  (f) of(f) the(f) An-(gh)gels(hg) I(g) will(f) sing(g) praise(gh)  un-(i) (g) to(fd) thee,(fg) O(g) my(f) God.(f) In(f) the(f) e(g) presence.(f) P(h) 11(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-112.png",
        nextFileName: "./pages/part-b-113.png",
    },
    {
        title: "part-b-113-0",
        gabc: "worship(ik)  (hi)  (h) to-(h)ward(h) thy(h) ho-(h)ly(h) temple,(fgh)  (g) and(g) praise(f) thy(gh)  Name.(i)  (hg) I(g) will(f) sing.(g) X.(fg)  (fhc) Glory(h)  (h) be.(h) Fy(fhefh) In(f) the(f) presence.(g)  (f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png",
    },
    {
        title: "part-b-113-1",
        gabc: "=(ki~) .(h)  (g)  (h) ...(gfef)  (dc) .(g) &amp;(g) CE(f)  (g)  (h)  (h)  (fgh)  (h)  (j)  (k)  (jih)  o(ik)  (h)  (i)  (i)  (g)  (f)  (g)  (h) Q)(h)  (h)  (g)  (h)  (gfef) a.(dc)  (g)  (g)  ¥.(f) An(gh) Angel(hgf) [(f) S(hfghg) e(e) [(fe) altar(d) of(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png",
    },
    {
        title: "part-b-113-2",
        gabc: "There(cc)  (fg) was(g) si-(hhij)lence(i) in(jkj)  (dhg)  (g) the(cfh)  (dfe)  (f) dra-(de)gon(f) wa—(gh)  ged(g) war:(g) and(jih) Mi—cha-(jkk)el(k)  (k) fought(i) against(j)  (dhg) him,(higgf) and(f)  (f) had(g)  the(h) vic-(fji)to-(dfhg)ry,(g) al(dfe) le-(fg)lu(dg) ia.(dgd) —;_I—I(dfhif)  (j)  (i)  (j)  (h) _(ghg)  (fg) ",
        groupIndex: 2,
        filename: "./pages/part-b-113.png",
        nextFileName: "./pages/part-b-114.png",
    },
    {
        title: "part-b-114-0",
        gabc: "(&quot;(cd) Prince(fg) most(fe) glo-(d)ri-(fe)ouk,(ddc) Mi-(f)cha-(ghg)el(h) the(gf) Archan(gh)  (fed) ge](d)  keep(gf) us(ghg) in(ef) A(fgf) re-(d)membrance:(d) here(h) and(g) ev(hij) -(ji)where,(hg)  al-(ki~) (iji) ways,(h) en-(h)4(ghgfed) the(cd) Son(dg) of(gh) God(df) &quot;(dedc) 8-(c)al-(dc~)le-(fgfe) lu-(ik) (gh) 1a,(fedc) al-(gd)le-(efe)lu-(d)ia.(d) [(h) e(g)  (f) e(gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-114.png",
        nextFileName: "./pages/part-b-115.png",
    },
    {
        title: "part-b-115-0",
        gabc: "—_(d)  (e) L(f)  (g)  (h)  (gh) 0(j)  (j)  (k)  (j)  (i)  (h) 0(j)  (i)  (g)  .(i)  (h) [(g) u(h) a(d)  (e) [(f) T(g)  (h) SR(gh) et(gf)  (g) R(h) S(j) ](i)  (h)  ¥(j) u(i)  (g)  (h) II(gh) 5(ed) of(hj) St.(g) [0(fed) S(fgh) |(g) M(fe) ;(d) S(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png",
    },
    {
        title: "part-b-115-1",
        gabc: "They(c)  (gd) are(fg) all(g) t(h) ministering(g)  (h)  (gf) spirits,(gh)  (f) sent(fh) forth(j) to(ji)  mi-(hi)F=(hg) nis—ter(g) to(eg) them(cdefef) who(d) shall(e) be(f) heirs(dgf) of(gh) U(ih) salvation.(g) e(g)  .(j)  (i)  (j)  (h)  (g) AT(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png",
    },
    {
        title: "part-b-115-2",
        gabc: "God(e) shall(f) e(h) his(h) oo(hj)  (i) o(hi) o-(j)ver(h) thee,(i) to(gihg)  keep(fe) thee(f) in(e) all(de) thy(fh) ways.(f)  (h) -(hid) (h)  (dfi)  (j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-115.png",
        nextFileName: "./pages/part-b-116.png",
    },
    {
        title: "part-b-116-0",
        gabc: "Let(c)  (f) us(e) praise(fh) the(hgf) Lord(fgh) whom(f) the(e) An(fgh) gels(hgf)  to(gi)  (h) whom(fh) Che-(h)ru-(i)bim(j) and(i)  (hi)  (h) cry(h)  (hi) a-(h)loud,(hi)  Ho(hg) 1y,(fe) Ho-(f)1ly,(ghg) Ho-(f)ly.(f) S(h) |(g)  (e) R(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png",
    },
    {
        title: "part-b-116-1",
        gabc: "Their(d) An-(fg)gels(ghgg) Tdo(g) al(fghg) —ways(h) behold(g)  (fg) the(f) face(f) of(e) my(f)  Father(g)  (f) which(fe) 1s(cddc) in(efe) heaven.(d)  (d) l__l(h) e(g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png",
    },
    {
        title: "part-b-116-2",
        gabc: "lessed(d)  (hf) be(hg) God,(fhiih) who(h) hath(i) sent(jk) his(ij) An-(hi)gel,(h) and(f) deliv-(f) (i)  er—ed(h)  (gh) his(fed) servants(ef)  (f) who(fe) put(g) their(ded) trust(efe) in(d) him.(d)  (highf) ",
        groupIndex: 2,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png",
    },
    {
        title: "part-b-116-3",
        gabc: "-(ik) (ed) God,(gjjh) all(i) ye(j) Angels(k)  (j) of(hi) his:(hg) praise(hg) him,(efg) all(gh) ",
        groupIndex: 3,
        filename: "./pages/part-b-116.png",
        nextFileName: "./pages/part-b-117.png",
    },
    {
        title: "part-b-117-0",
        gabc: "his(gf) host.(e)  (ji) SHORT(hi)  (h)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png",
    },
    {
        title: "part-b-117-1",
        gabc: "An(f) Angel(g)  (h) stood(g) At(f) the(hg~) altar(g)  (fd) of(f) the(g) temple.(g)  (f)  Angel.(g)  (hg) Having(hi)  (g) in(g) his(g) hand(h) a(g) golden(g)  (f) censer.(gh)  (hg) At(f)  the(ik)  (gh) altar.(g)  (fd) ¥.(c) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  and(ik)  (g) to(h) the(g) ly(g) Ghost.(gh) An(f) Angel.(g)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png",
    },
    {
        title: "part-b-117-2",
        gabc: "e(d)  (fh)  (h)  (i)  (hg)  (h)  (i) =(jh)  (k)  (i)  (j)  (h)  (ih)   (gf)  (e)  (f)  (d)  (d)  (e)  (d)  (gf)  (e)  (f)  (h)  *(gh) In(f) the(h) &#39;(f) .(g) of(fed) [](c) I(d)  &gt;(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-117.png",
        nextFileName: "./pages/part-b-118.png",
    },
    {
        title: "part-b-118-0",
        gabc: "A(c) nd(c) the(d)  (dhi)  (h) talked(hg)  (f)  (e) with(fg) me(h) came(g) again(fe)  (d)  (d)  and(dg) wa-(gf)ked(gh) me,(h) as(f) a(ef) man(ghg) that(f) is(e) wa-(df)ken-(f)ed(f) out(ef) of(gf)  his(ed) sleep.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-118.png",
        nextFileName: "./pages/part-b-119.png",
    },
    {
        title: "part-b-118-1",
        gabc: "Ye(e) ho-(eh)ly(f) Angels,(f)  (ed) our(ef) Guardians,(e)  (e) defend(e)  (f) us(e) in(d) tine(e)  of(f) hattle,(de)  (d) lest(e) we(f) pe(hijih) rish(ih) in(f) the(hg) dreadful(e)  (d) dey(ef)  of(f) judgment.(e)  (e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-118.png",
        nextFileName: "./pages/part-b-119.png",
    },
    {
        title: "part-b-119-0",
        gabc: "Who(fg) is(h) .(g) that(h) is(hgf) beautiful(f)  (hj) as(ji)  (hg) a(hi) dove,(g) like(jk) a(ji)  rose(hg) that(g) 1is(h) planted(ffd)  (d) by(e) the(f) rivers(gf)  (h) of(h) waters.(g)  (g)   (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png",
    },
    {
        title: "part-b-119-1",
        gabc: "Mighty(ic)  (c)  (fg) f(gf) Virgin,T(h)  (f) like(gi) the(h) tower(i)  (hg) of(f) Da-(g)vid,(h) whereon(f)  (f)  there(ik)  (d) a(c) a(e) thousand(ffgf)  (f) buck-(ifhihg)lers,(hg) all(gh) shields(fe) of(d)  wighty(ik)  (ghg)  (f) men.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png",
    },
    {
        title: "part-b-119-2",
        gabc: "Ma-(c) (c)  (d)  (dhi) ry,(h) thou(h) that(g) art(f) full(g) of(gh) grace;(h) the(f) Lord(h)  [(gf) L(g) thee:(d) R(g) e(h)  (g) e(fde)  (d) e(f) Vo(gf) women.(d) ypee(d) ety(hgfh) 1Y(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-119.png",
        nextFileName: "./pages/part-b-120.png",
    },
    {
        title: "part-b-120-0",
        gabc: "The(e) daughters(ed)  (g) of(hi) Si-(ij)on(i) tsaw(ik) her(j) a-(hi)dorn-(hg)ed(g) with(hj)  lands(hg) of(fe) ro-(fg)ses,(g) and(dg) proclaimed(h)  (gf) her(g)  (g) most(hg) blesseq,.(e)  (e)  SHORT(ji)  (hi)  (h)  (fh)  ‘A(f) fter(f) Child-(g)bearing,(f)  (f) O(f) Virgin,(h)  (hg) Thou(g) didst(f) remain(gh)  (gfd)  in-(fg)vi-(g)o-(f)late.(f) After(f)  (f) Child-(g)bearing.(f)  (f) Intercede(hi)  (h)  (gh) for(g)  us,(g) O(h) .(g) Mother(f) of(fh) God.(hg) e(g) Glory(h)  (h) Be.(h) After(f)  (f)  Child-(g)bearing.(f)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-120.png",
        nextFileName: "./pages/part-b-121.png",
    },
    {
        title: "part-b-120-1",
        gabc: "Biesséd(c)  (c)  (d)  (dc) art(d) thou,(f) fo(f)  (e) Ma-(c) (ef) ry,(d) Mother(fg)  (gf) of(fgh) God,(h) £(h) ",
        groupIndex: 1,
        filename: "./pages/part-b-120.png",
        nextFileName: "./pages/part-b-121.png",
    },
    {
        title: "part-b-121-0",
        gabc: "thou(g) hast(hj)  (ji) believed(g) the(hj)  (iih) Lord:(g) for(h) those(hk) things(j) are(ji)  accomplished(hg)  (h)  (gf) in(eef)  (gh) thee,which(h)  (f) were(ed) told(de) thee:(e) a(c) inter(d)  cede(fgf) for(gh) us(h) un-(g)to-(h)the(ef) Lord(g) our(fe) God.(d) el(h)  (g) e(f)  (g) WO(dgfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png",
    },
    {
        title: "part-b-121-1",
        gabc: "Be(c)  (gh)  (ih) joyful,tVirgin(gh)  (ij)  (j) Mother;(i)  (i) Christ(iji) hath(hg) ri-(fh)sen(gh) from(fgih)  the(fe) me(e) [(i) |(j)  (i)  (h) el(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png",
    },
    {
        title: "part-b-121-2",
        gabc: ")(e) is(f) .(hi) a(i) Twith(h) [(i) merry(j)  (ih) noise,(i) and(f) the(i) Lord(efghg)  1th(fe) the(fe) sound(de) of(f) the(h) trump.(f)  (h)  (dh)  (i)  (h)  (i) :(jd)  (h)  (f)  (ef) ",
        groupIndex: 2,
        filename: "./pages/part-b-121.png",
        nextFileName: "./pages/part-b-122.png",
    },
    {
        title: "part-b-122-0",
        gabc: "T(ik) he(d) Spi-(fhg)rit(gh) of(h) the(g) T(dfe) hath(d) filleld(fg)  (gd) the(ef)  world.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png",
    },
    {
        title: "part-b-122-1",
        gabc: "Ma-(g)a(e) a(e) taken(g)  (h) .(i) in-(j)to(h) a8(ii) heaven:(g) the(h) An-(hg)ge]s(ef) tris(h)  =(gi)  (g) ex-(h)alt-(ij)ing(i) and(hg) i(f) blessing(e) the(de) Lord,(ef) al-(g)e(f) ly-(e)ja,(e)   (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png",
    },
    {
        title: "part-b-122-2",
        gabc: "te(g) Virgin(gj)  (hgf) Ma-(gh)ry(gh) is(h) :(i) exalted(j)  (h) a-(g)hove(h) the(gf) choirs(g)  of(h) Angels:(hk)  (jkj) and(g) up-(fgh)on(fe) her(d) -(e)a(f) £(gh) of(h) D(g)  stars.(g) i(j)  (i)  (j) )(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-122.png",
        nextFileName: "./pages/part-b-123.png",
    },
    {
        title: "part-b-123-0",
        gabc: "hou(f) art(f) beautiful(g)  (gh) *(hg) And(fdfg) pleasant.(g)  (f) Thou(f) art(f) beauti-(g) (gh)  tal,(hg) V.(c) O(h) ho-(h)ly(h) Mother(hi)  (h) of(h) God,(g) in(g) thy(g) fe-(f)li-(g)ci-(fgh)ty.(hg)  And(fdfg) pleasant.(g)  (f) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh)  the(g) Son,(g) and(g) to(h) the(g) Holy(f)  (g) Ghost.(gh) Thou(f) art(f) beautiful(g)  (gh)  (hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-123.png",
        nextFileName: "./pages/part-b-124.png",
    },
    {
        title: "part-b-123-1",
        gabc: "T(ik)  (g) day(h) let(h) us(gf) cel-(fh)e-(h)brate(g)  (g) e(ij) the(h)  (h) So-(gf)lem-(fh) ni-(ik) (h) ty(g) of(gji) the(j) Ho-(k)ly(j) Ro-(ji)sa-(h)ry(h) of(j) Ma-(ihg)ry,(g) Mother(ghi)  (fh) of(gf)  :(ik)  (f) [(hgg) she(f) ](gh)  (hg) -(f) (g) for(hij) us(jijkj) un-(h)to(h) Je-(g)sus(f)  Christ(gh) the(g) Lord.(g) =i(j) we(i) bt(j) el(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-123.png",
        nextFileName: "./pages/part-b-124.png",
    },
    {
        title: "part-b-124-0",
        gabc: "O(e) blessed(eh)  (fed) Mother(df)  (e) fand(ei) spotlesis(hg)  (fh) Virgin,(gfe)  (e) thou(fh) 8lorigy,(eh)  (h)  Queen(ii) of(h) the(f) world,(hg) may(h) all(hihgijhih) acknowledge(hi)  (j)  (ih) the(g)  of(h) thy(i) prayer(ih) who(ie) cel-(fhi)e-(h)brate(hghih) the(f) so-(f)lem-(fi)ni-(hg)ty(e)  of(e) thy(ef) ho-(h)ly(fg) Bo-(f)sa-(e)ry.(e) 15(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-124.png",
        nextFileName: "./pages/part-b-125.png",
    },
    {
        title: "part-b-124-1",
        gabc: "He(ki~c)  (cg) shall(gf) be(d)  (fg) calledt(g) the(gh) Peaceful(gh)  (g) One,(f) and(g) his(f) thron(g)  ;(ki~) shall(h) be(j) IR(ji) established(h)  (g) for(h)  (hih) ‘ev-(gf)er(d) and(fg) ev-(g)er.(gdfd~dfd) |(dfdj)  (i) |(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-124.png",
        nextFileName: "./pages/part-b-125.png",
    },
    {
        title: "part-b-125-0",
        gabc: "is(c)  (h) kingdom(hih)  (hg) is(h) an(hg) ev-(f) (g) er-(hi)lasting(hg) kingdom,(e)  (e) and(f) all(d)  do-(f) (hg) nions(ef) shall(hig) serve(hf) and(f) o-(f)bey(gfe) him.(e) i(h)  (f)  (h) S|(i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png",
    },
    {
        title: "part-b-125-1",
        gabc: "_—(gi) a(c)  (e) Behold(g) the(h) man&#39;(i) whose(i) name(ij) is(h) the(f) Branch;(hhih) he(h) shall(i)  sit(g) and(h) rule(f) a(e) i(f) a(e) .(d) a(e) L](e) a(d) speak(ef)  peace(g) un-(f)-(e)the(d) —(e) heathen.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png",
    },
    {
        title: "part-b-125-2",
        gabc: "I(g) will(df) give(fg) thee(g) for(f) a(h) light(ji) to(j) the(k) Gentiles,(hg)  (g) that(g)  thou(gh) mayest(g)  (g) be(g) my(g) sal-(g)va-(fe)tion(d) un-(d)to(e) the(f) end(gf) of(gh)  the(h) earth.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-125.png",
        nextFileName: "./pages/part-b-126.png",
    },
    {
        title: "part-b-126-0",
        gabc: "A(f) scribe(g) un-(f)to(g) the(fgh) Lord,(defhg) O(f) ye(fgh) kindreds(g)  (fd) of(f) the(g)  (g)  Ascribe.(f)  (g) ¥.(h) Ascribe(hi) un-(h)to(gh) the(g) Lord(g)  (j) glory(h)  (g) and(g) _—(f)  (gh)  ion.(hg) 0(f) ye(fgh) kindreds.-(g) (fd) ¥.(c) Glory(h)  (h) be.(h) K.(f) Ascribe,(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png",
    },
    {
        title: "part-b-126-1",
        gabc: "%(ef)  (jfjk) [Erare(j)  (j)  (ji) e(ij) 07(i) el(ih) e(j) e(j) N(i) SR(hg) SRR(f)  :(ig~) et(gh)  (fe) e(ef) s(c) e(ef) e(f) elinds(fh) (LS(hf) BT(g)  (f) e(e)  (i)  (i)  .(gi) ALl(h) power(iji) is(gf) given(fgh)  (fe) unto(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png",
    },
    {
        title: "part-b-126-2",
        gabc: "The(cc)  (df) Lord(de) God(d) shall(dc) give(f) un-(g)to(fh) himt(h) the(h) throne(ihgg) of(ef) his(g)  ](g) father(d) David:(d)  (c) and(d) he(c) shall(d) reign(f) o-(f)ver(fe) the(g) house(hg)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-126.png",
        nextFileName: "./pages/part-b-127.png",
    },
    {
        title: "part-b-127-0",
        gabc: "Ja-(ef)cob(g) for(fe) ev(df) er;(fc) and(c) of(d) his(f) kingdom(fg)  (f) there(e) shall(f)  be(g) no(fe) end,(dc) al-(d)le(efe) 1lu-(d)ia.(d) B(h) i(g)  (f)  (gh) [(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-127.png",
        nextFileName: "./pages/part-b-128.png",
    },
    {
        title: "part-b-127-1",
        gabc: "T(ig~) he(fg) God(e) of(f) hea(fij) ven(h) shall(h) set(ge) up(g) a(gh) kingdom(f)  (f) which(fe)  (h)  shall(hi) break(j) in(ih) pie(hgf) ces(gf) and(fh) consume(g)  (h) all(fg) kingdoms&#39;,(ef)  (fgeec)  (fe)  N(gi) it(h) shall(g) stand(hge) for(gh) ev-(f)er.(f) _I(h)  (g) ewesscqmmnin(e) oy(f)  he-(dc)Lord(f) hath(g) gi-(f)ven(fgh) him(h) T(h) dominion(hj) and(h)  (g) glory(h)  (g) and(g) a(g)  S(fh) kl“gdc)m,(g) that(gg) all(eg) people,(h)  (g) nations,(h)  (g) and(f) languages(f)  (fe) —(c)  serve(d) him.(d) T(h)  (g) Rk(f) i(gh)  (gf) ]|(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-127.png",
        nextFileName: "./pages/part-b-128.png",
    },
    {
        title: "part-b-128-0",
        gabc: "—p(ig~)  (e) iving(f) waters(h)  (h) shall(h) go(hj)  (i) =4(hi) g(jh)  (i) a(i) L(i) an\\d(g)  the(i) Lord(h) shall(g) be(fe) King(fe) c-(de)ver(fg) all(h) the(hg) earth.(f) e(i)  (h) Rt(i) |(jh)  (fh)  H(g) e(e) shall(g) be(h) great,T(i) e-(ij)ven(h) un-(f)to(h) the(fh) ends(ih) of(ge) the(f) eart}.(fg)  and(g)  (g) this(hf) man(gg) shallbe(f) Y(e) the(de) peace.(e) E—(i) EE——&quot;———(j)  (i)  (h) b(gf)  T(ki~) he(f) na(fddcf) tion(f) and(f) kingdom(fg)  (f) that(f) will(gh) not(h) serve(hj) thee(h)  shall(jk)  shall(ik)  (gf) per-(ffgf)ish;(f) yea,(f) those(f) na(fdd) -(dfcfg)tions(f) shall(fg) be(gf)  ut-(ki~) (g) ter-(gh)ly(g) wasted.(f)  (f)  (h) :(f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-128.png",
        nextFileName: "./pages/part-b-129.png",
    },
    {
        title: "part-b-128-1",
        gabc: "There(f) is(f) given(g)  (f) un-(g)to(gh) me*All(hg) el(fdfg) power.(g)  (f) There(f) i(f) e(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-128.png",
        nextFileName: "./pages/part-b-129.png",
    },
    {
        title: "part-b-129-0",
        gabc: "heaven(g)  (f) and(gh) earth.(hg) All(fdfg) power.(g)  (f) V.(c) Glory(h)  (h) be.(h)  There(f) is(f) given.(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-129.png",
        nextFileName: "./pages/part-b-130.png",
    },
    {
        title: "part-b-129-1",
        gabc: "Un-(gic) (d) to(fh) God(hg) and(f) his(e) Father(hhi)  (h) hath(h) he(hi) made(h) us(h) to(g) be(i) a(ij)  ‘(gi) kingdom,(h)  (h) who(h) is(i) the(j) first(j) be-(ih)got-(hg)ten(fi) of(hi) the(f) dead,(f)  and(ig~)  (h) the(f) Prince(ih) of(h) the(g) kings(h) of(fe) the(f) —(e) al(e) le-(ef) lu-(gi) (d) ja.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-129.png",
        nextFileName: "./pages/part-b-130.png",
    },
    {
        title: "part-b-130-0",
        gabc: "He(e) hath(h) on(g) his(h) il(j) vesture(i) and(i) on(h) his(j) thigh(kj) o(ih) N(ij) wrig_(i)  .(jk)  (jk)  ten,(i) King(ij)  (k) of(k) kings,(i) and(i) Lord(kjhi) of(ijkijj) lords:(ji) ¢,(ig) o(hij)  be(i) glory(h) 2(g) and(h) do-(hi)min-(hg)ion(ef) for(df) ev-(h)er(gh) and(ihf) ev-(e)er,(e)  a(i) a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-130.png",
        nextFileName: "./pages/part-b-131.png",
    },
    {
        title: "part-b-130-1",
        gabc: "I(j) em(ih) Rapha-(ji) (h) el(g) the(h) Angel,(efg)  (g) that(h) stand(j) before(i)  (j) the(h) F(j)  ly(i) One:(g) wherefore(fgh)  (gfd) bless(g) ye(g) God(h) for(gf) ev-(gh)er,(h) and(gh) confe®(ji)  (hg)  ye(h) all(i) his(h) great(g) and(ef)  (g) wonderful(f) a(e) doings.(fg) [(e) 12(j)  (h)  (j)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-130.png",
        nextFileName: "./pages/part-b-131.png",
    },
    {
        title: "part-b-131-0",
        gabc: "The(f) An-(gf)gelT(gh) Ra-(f)pha-(g)el(hi) was(hg) sent(f) un-(h)to(j) To-(i)bit(j) and(h)  -(j)ra,(ij) that(h) he(f) might(gh) heal(g) them.(g) B(j) v(i)  (j) |(h) Gl(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png",
    },
    {
        title: "part-b-131-1",
        gabc: "a(e) An(ei) gel(i) :nt.(ij) N(h) un-(f)to(h) To-(gf)bit,(e) and(f) sa-(ed)lut-(ef)ed(f)  =(fi) say-(ihg)ing:(g) Joy(hhe~) be(fe) ev-(d)er(def) with(e) thee.(e) |(i) e(j)  (i)  (h) |(gi) ",
        groupIndex: 1,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png",
    },
    {
        title: "part-b-131-2",
        gabc: "Be(g) of(f) good(gf) EON(efgh) O(hg) O(fg) To(fe) bit;(e) for(e) the(f) [(g) is(f) nigh(dc)  at(de)  that(ef) God(gh) ,(fg) heal(g) n(e) @S(h)  (g) etas(h) i(ih) [0(gfe) @%(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png",
    },
    {
        title: "part-b-131-3",
        gabc: "Ble(f) 58(ge) Ye&quot;“the(f) &#39;God(e) o(df) heaven,T(hhi)  (h) and(i) praise(hi) him(f) a(g) the(h) ",
        groupIndex: 3,
        filename: "./pages/part-b-131.png",
        nextFileName: "./pages/part-b-132.png",
    },
    {
        title: "part-b-132-0",
        gabc: "sight(gi)  (i) of(h) all(jk) that(ih) live;(h) mag-(f)-(f)fy(fi) him(h) apgq(g) Praiss(h) i(f)  for(f) the(fe) mer-(g)ci-(e)ful(d) things(ef) which(f) he(d) hath(f) done(he)  you.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png",
    },
    {
        title: "part-b-132-1",
        gabc: "eace(hh) be(gf) with(hg) you,(e) fear(ef) not:(d) bless(f) ye(d) the(f) Lord,(h) ](g)  sing(f) praises(i)  (hg) un-(fghf)to(g) el(f) him.(e) [t(h)  (f)  (h) s(i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png",
    },
    {
        title: "part-b-132-2",
        gabc: "0(cd) Prince(fg) most(fe) glo-(d)ri-(fe)ous,(ddc) Ra-(f)pha-(ghg)el(h) the(gf) Arc(gh) e(fed)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-132.png",
        nextFileName: "./pages/part-b-133.png",
    },
    {
        title: "part-b-133-0",
        gabc: "keep(gf) us(ghg) 10(f) re(fgf) -(d)membrance:(d) here(h) and(g) ev-(hij)ery-(ji)where,(hg)  ways,(h) entreat(h)  (ghgfed) the(cd) Son(dg) of(efe) God(d) for(cd) us.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-133.png",
        nextFileName: "./pages/part-b-134.png",
    },
    {
        title: "part-b-133-1",
        gabc: "Let(f) the(f) righteous(gh)  (fedc) re(fghi) joice*(h) Be(hji~) fore(ihgfe) God.(ghggf) Let(f)  the(f) righteous.(gh)  (fedc) Let(f) them(f) al(g) so(f) be(f) merry(gh)  (fe) and(dc) joy-(hfghi) ,ful,(h) Be-(hj)fore(ihgfe) God.(ghggf) Glory(f)  (f) be(g) to(f) the(f) Father(gh)  (f) and(g)  0(fe) the(dc) o(c) et(c) to(df) the(f) Ho(hgih) ly(gf) Ghost.(f) Let(f) the(f)  rlghteous&#39;(gh)  (fedc) ",
        groupIndex: 1,
        filename: "./pages/part-b-133.png",
        nextFileName: "./pages/part-b-134.png",
    },
    {
        title: "part-b-134-0",
        gabc: "O(d) vye(cd) Angels(d)  (d)  (d) sndArchangéls,(df)  (d) ](dc) To(fghg) ye(fe) Thi.)nes(dc) and(d)  minions,(d)  (d)  minions,(d)  (d) Principa-(h) (h) li-(hg)ties(h)  (ji) and(jk) Powers,(jih)  (h) Virtyes(h)  (hg) of(fe) the(d)  heéavens,(ik)  (cd) -(d)Che~ru-(h)bim(ji)  (hg) and(fgh) Se(j) ra(jih) phim,(h) O(h) a(g) Patri-(h) (f)  archs(ghg) and(f) Prophets,(d)  (d) ye(f) ho-(f)ly(e) Doctors(fe)  (d) of(f) the(e) 14w,(ddc)  all(cd)  (fghg) ye(ed) A(efe) postles,(d)  (d) ye(f) Martyrs(f)  (f) of(de) Christ,(dc) ye(cd)  ho-(fgh)ly(f)  (ef) Confessors,(d)  (d) ye(f) irgins(fe)  (d) bf(ed) the(cd) Lord,(d) &#39;(hgfedc)  ho-(d)ly(efe) Hermits,(d)  (d) and(cd) all(fed) Saints:(deddc) gffer(c)  (d) for(fge) [(hghg)  s(fedc) in.-(gd)ter-(efe)B(d) cessions.(d) i(h) 00(g) g(f)  (g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-134.png",
        nextFileName: "./pages/part-b-135.png",
    },
    {
        title: "part-b-135-0",
        gabc: "I(d) beheld(f)  (d) la(dc) great(fg) mul(f) titude(gh)  (h) Twhich(h) no(hj) man(h) could(g) s(fh) number,(g)  of(g) all(eg)  (hg) nations,(fg) standing(f)  (e) before(c)  (eg) the(fe) throne.(d)  (h) REO(g)  (f)  (fgh)  (gf)  Alnd(d) all(f) the(g) Angels(fh)  (h) stood(hg) round(hi) about(g)  (f) the(gh) throne,(g) and(g)  (e)  a(e) before(g)  (hg) the(f) throne(f) on(g) their(fe) face&#39;s,(d)  (ef)  (cdcf) and(ef)  (g) worshipp’d(fe)  God.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-135.png",
        nextFileName: "./pages/part-b-136.png",
    },
    {
        title: "part-b-135-1",
        gabc: "Thou(ki~)  (c)  (g) hast(gd) redeemed(fg)  (gh)  (g) O(g)  (g) Lord(gh) our(g) God,by(hg)  (h) thy(ji) blood(g)  out(ik)  (f) of(h) ev-(jk) (k) ery(j) [(jih) kindred,(h) and(j) ~(hg) and(g) people,(g)  (e) and(g)  i(ki~) ~(fef) -(df)a(c) o(d) G(fg) p(gf) et(fh) to(j) e(i) God(hg) a(fg) e(g) 8(g)  :(j) 0(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-135.png",
        nextFileName: "./pages/part-b-136.png",
    },
    {
        title: "part-b-136-0",
        gabc: "()(e) bless(eh) the(fd) Lord,(efee) all(gh) his(hf) chosen;(h)  (g) keep(i) a(h) day(h) of(j)  rejoicing,(i)  (hg)  (ef) and(e) give(df) thanks(hf) un-(g)to(f) him.(e) -(h) (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png",
    },
    {
        title: "part-b-136-1",
        gabc: "A1l(eh) his(fed) SaintsT(e) skall(hg~) praise(iif) him,(hg) e-(i)ven(i) the(i) children(h)  (h)  of(h) Is-(ij)ra-(i)el,(hghih) e-(f)ven(e) the(f) people(f)  (f) that(f) serveth(h)  (g) him:(e)  (e)  such(ge) honour(fe)  (d) have(e) all(fh) his(h) Saints.(g) e(j)  (i)  (j) 1(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png",
    },
    {
        title: "part-b-136-2",
        gabc: "Tle(e) glorious(g)  (hi)  (ij) of(i)  (i)  (i) the(j) A-(hg)postles(hi) praise(i) thees(i)  the(i) goodly(j)  (i) fellowship(h)  (hg)  (ef) of(d) the(fh) Prophets(dhfd)  (dgf)  (d) praise(e) ghes?(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-136.png",
        nextFileName: "./pages/part-b-137.png",
    },
    {
        title: "part-b-137-0",
        gabc: "e(e) “hi;e-(g)robed(h)  (i) army(jji)  (h) of(i) Martyrs(ijji)  (i) praise(ijjk)  (k) thee;(iki)  (kjkjiji) .(i)  one(ij) heart(h) and(h) voice(f) do(df) all(h) the(i) elect(h)  (hgfg) acknowledge(fgf)  (e)  (de)  thee:(e) O(eghi) blessed(i)  (ef) Tri-(h)ni-(h)ty,(gh) one(ih) on-(f)ly(f) God.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png",
    },
    {
        title: "part-b-137-1",
        gabc: "O(efdd) Hhbw(dc) glo-(f)ri-(fg)ous(gf) is(g) the(ghg) kingdom(f) z(f) wherein(fg)  (hg) all(hiih) the(gf)  Saints(g) rejoice(fg)  (h) with(gf) Christ;(f) ar-(dc)ray-(f)ed(g) in(hg) white(fh) robes,(hih)  tiey(dc) 8(g) |(ghg) tEe(fe)  (dc) a8(g) ](g) ther-(f)—ev(g) —er(g) he(ghg) go-(f)eth.(f)  November(ik)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png",
    },
    {
        title: "part-b-137-2",
        gabc: "o(ik)  (f)  (g)  (h) 4(hhh) )(g)  (g)  (hhh) (G(g)  (f)  (f) |(d)  (d)  (ddd) ISR(h)  (dh)  (h) [T(d)  (d) 0(f)  (g) -(g)",
        groupIndex: 2,
        filename: "./pages/part-b-137.png",
        nextFileName: "./pages/part-b-138.png",
    },
    {
        title: "part-b-138-0",
        gabc: "O(ig~)  (fhhg) blessed(h) -(f)Mart:in,T(g)  (f) whose(e) righteous(fgh)  (fgf) soul(e) m(fe) possessety(h)  (g)  Pa-(f) (ef) ra—dise;(f) whereat(fe)  (h) the(i) Angels(j)  (i) _—(ji) triumph,(h) the(h) Archan-(hhg) (ji)  (T(gi) gels(h) are(g) ju-(fgf)bi-(f)lant:(f) thee(hh) the(fgf) choir(f) of(e) Saints(f) pro-(f) claimeth,(g)  (hg)  (e) th.e(c) throng(ef) of(f) Virgins(fg)  (f) in-(f) (h) viteth,(h) saying,(hj)  (j)  i(ig~) A(i) bide(hg) with(fe) us(f) for-(hg)ev-(f)er.(f) ](h)  (gf) ety(hg)  (e) oo(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-138.png",
        nextFileName: "./pages/part-b-139.png",
    },
    {
        title: "part-b-138-1",
        gabc: "is(g) B(h) disciples(j) B(i) tsaid(iihg) un-(f)s(gh) |(ih) T(f) Martin:(e)  (e) Father,(ij)  (i)  why(h) dost(h) thou(j) a-(k) (j) bandon(hi) us?(i) or(g) to(h) whom(hj) wilt(i) thou(h) Jeave(hg)  thy(f) fatherless(gh)  (ih)  (f) children?(e)  (de) for(dfeed)  (d)  (hedhddefdd)  (dd)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-138.png",
        nextFileName: "./pages/part-b-139.png",
    },
    {
        title: "part-b-139-0",
        gabc: "on-(de)ter(ef) in(hi) a-(h)mong(hg) us,(hih) mot(fe) sparing(f)  (h) the(g) flock.(e)  a(ig~)  (i)  (j)  (i)  (h)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png",
    },
    {
        title: "part-b-139-1",
        gabc: "~‘O(gi)  (igij) Lord,(i) if(i) I(i) am(jji) yet(j) needful(i)  (i) un-(hg)to(i) thy(g) A(e) people,(e)  1(g)  (g) refuse(g)  (g) not-(h)to(f) la-(h)bour:(g) thy(f) will(h) be(g)   (ig~)  (i)  (j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png",
    },
    {
        title: "part-b-139-2",
        gabc: "O(g) man(h) of(gf) worth(g) past(hih) telling,(g)  (g) whom(g) labour(h)  (gf) could(g) not(gh)  conquer,(f)  (f) ;(g) death(f) :(gh)  (jk)  (jijkj) who(k) neither(i)  (j) feared(h)  (h) to(g)  die,(h) nor(h) re-(g)fus-(ef)ed(gh) to(h) live.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-139.png",
        nextFileName: "./pages/part-b-140.png",
    },
    {
        title: "part-b-140-0",
        gabc: "](e) eyes(g) and(h) hands(iji) ev-(j)er(k) raised(j)  (ih) toward(j) heayen(ji)  (i)  his(ig~)  (j)  (i) undaunted(h)  (f) spirit(hh)  (g) ceased(i)  (h) not(g) from(h) sup-(f)pli-(e) p(ig~)  (f) =(h) le-(i)1lu-(hg),(f) S(g) PR(fg) VA(e)  (e) -(j) (i) i(h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png",
    },
    {
        title: "part-b-140-1",
        gabc: "Mar-(dg)tin(fg) is(g)  (g) received,T(gh)  (g) rejoicing,(g)  (h)  (g) in-(g)to(g) the(g) bo-(gh)sonm(g)  of(i)  (ge) A-(fg)bra-(ef)ham:(d) Mar-(gf)tin,(gf) poor(hj) and(h) low-(h)ly(gf) here(gh) on(h)  earth,(g) en-(jj)ter-(h)eth(hj) rich(ji) in-(h)to(g) heaven,(hg)  (f) and(f) is(g) sa-(h)lu-(j) ted(i)  (h) with(gf) heaven-(h)ly(h) songs.(g) [(j)  (i) -(j) (h) o(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png",
    },
    {
        title: "part-b-140-2",
        gabc: "a(cdf) blessed(fe)  (d)  (ed) who(d)  (f) with(hg) all(h) his(fgf) heart(ddfgd)  (fe)  (dc) ",
        groupIndex: 2,
        filename: "./pages/part-b-140.png",
        nextFileName: "./pages/part-b-141.png",
    },
    {
        title: "part-b-141-0",
        gabc: "he(d)  (fe) King,(d) and(d) fear-(gd~) (gf) ed(g) not(ghg) the(f) do-(fg)minion(fe)  (cd) of(f)  princes!(d)  (d) 0(dh) ho-(hj)ly(hg) soul,(h) which,(g)  (f) although(g) withheld(g)  (hg)  from(g) the(f) per-(fe)se-(fg)cu-(ef)tor’s(def) sword,(fc) lacked(c)  (d) not(f) the(fe) palm(gh)  of(fe)  (d) martyrdom.(d)  (d) el(h) T(g) R(f) Y(g)  (gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-141.png",
        nextFileName: "./pages/part-b-142.png",
    },
    {
        title: "part-b-141-1",
        gabc: "Let(d) @11(dc) the(d) a(f)  (e)  (dc)  (c) a(e) the(f) :(g) faithful(ced) a(efe) 2(d) -(d)the(dh)  8lory(hi)  (h) of(g) the(g)  (gh)  (h)  (f)  (cd) and(d)  (dfdgf)  (dc)  (d)  (f) of(f) all(ef)  3(g) his(fe) fol(d)  (cd)  (d)  (d) {53@{:}’&amp;(ef)  (ghgdfedd) ~(dc) in(d) his(efe) foot-(d)",
        groupIndex: 1,
        filename: "./pages/part-b-141.png",
        nextFileName: "./pages/part-b-142.png",
    },
    {
        title: "part-b-142-0",
        gabc: "steps:(d) and(dhi) chiefly(h) -(h)let(h) the(h)  (hg) pajy(fe) of(dc)  (cd) monks(fgh)  joyful,(fgf) S(d) ce-(h) (j) le-(ji)brating(hg) their(h) fes-(jk)ti-(ih)val(j)  in(ik)  (h) whose(hg) goodly(fe)  (fg) fel-(e)low-(efe)ship(dc) the(cd) Saints(d) rejoice(fe)  (fgf) iy(ed)  heaven.(i)  (ef)  (d) [forawwm(h) e(g)  (f)  (g) O(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png",
    },
    {
        title: "part-b-142-1",
        gabc: "T(gic) hen(f) shall(h) the(g) righteous(fg) L(fe) shine(hi) forth(ji) as(h) the(g) sun(fhih) [(e)  the(ig~)  (f) _-(hhi)kingdom(h) of(i) their(h) Father,(hg) I_I-(fe)saith(f) the(ghg) Lord.(f) o[(h) ||(g)  (e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png",
    },
    {
        title: "part-b-142-2",
        gabc: "Blessed(cdf)  (fe) are(de) ye,(ddc) when(gfhi) men(hgfe) shall(fgf) hate(d) you,(d) and(d)  they(d) shall(dg) se-(f)pa-(fe)fate(dc) you(cded) from(d) their(effd~) com-(d) (g) pa-(fde)ny:(e) &amp;&#39;(f)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-142.png",
        nextFileName: "./pages/part-b-143.png",
    },
    {
        title: "part-b-143-0",
        gabc: "shall(fe) reproach(de)  (d) you,(c) @nd(dc) cast(d) out(d) your(f) name(gfd) as(f) -(edc)vil(c)  (j)  for(ki~)  (e) the(cd) Son(dc) of(fe) man’s(d) sake:(d) rejoice(fh)  (hgfe) and(fg) be(fe) exceeding(de)  (d) a(c)  gl;&#39;d;(ki~)  (c) for(f) i(ec) hold,(d) your(e) rewarJ(f)  (gfedc) is(egf) great(ed) in(cd) heaven.(d)  (d)   (ki~)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-143.png",
        nextFileName: "./pages/part-b-144.png",
    },
    {
        title: "part-b-143-1",
        gabc: "In(ij)  (cf) the(f) heavenly(f)  (f)  (gf) kingdom(e)  (fd)  (f) |(fg) rejoice(g) the(f) souls(gh) of(g) the(ghg)  Blessed,(f)  (f) who(f) fol-(df)lowed(f) the(gi)  (ih) footsteps(gh) of(hgf) Christ(g) their(ghg)  Master:(f) -(f)and(df) since(fg) for(f) love(hij) of(ih) him(gf) =(g) [(ii) scorned(h) this(gf)  vorld(ki~)  (g) of(ghg) e(f) —vil,(f) therefore(f)  (gh) ot(h) Christ(ih) do(gf) they(gh) ex(hg)  ult(g) for(ghg) ev-(f)er,(f)  (h)  (f)  (h)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-143.png",
        nextFileName: "./pages/part-b-144.png",
    },
    {
        title: "part-b-144-0",
        gabc: "0(c) ve(d) Saints(f) of(f) 3(fg) Lord,(g) bless(hhg) ye(h) the(g) Lorq(f) 0(e)  ev-(d)er(f) and(gh) ev-(g)er,(g)  (g) S(g) O(d)  (f) U(ed) ",
        groupIndex: 0,
        filename: "./pages/part-b-144.png",
        nextFileName: "./pages/part-b-145.png",
    },
    {
        title: "part-b-144-1",
        gabc: "In(d) the(c) re-(d)ge-(f) (e) ne-(de)ra—tion,(ddc) when(hf) the(fg) Son(gh) &amp;f(fe) man(dc) shall(d)  sit(fge) in(g) the(ghg) throne(fe) of(d) his(cd) glory,(d)  (d) ye(dhi) al-(hg)so(h) shall(j) sit(h)  up-(g)on(ef) twelve(gfe) thrones,(dfddc) judging(ffg)  (f) the(e) twelve(fhgf) tribes(ef) of(gf)  Is-(d)ra-(cd)el.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-144.png",
        nextFileName: "./pages/part-b-145.png",
    },
    {
        title: "part-b-145-0",
        gabc: "Go(cd) forth,(dhi) O(h) ve(h) daughters(hj)  (h) of(h)  (h) e(hghihg) and(f) behold(g)  (h) Ger-(hg) trude(g) with(fg) the(f) crown(f) wherewith(f)  (ef) Christ(gfe) crowned(def)  (fe) hen(ddc)  in(d) the(c) day(d) of(f) her(fg) es-(fe)pou-(gh)sals,(h) and(h) in(h) the(g) day(f) of(f)  the(g) gladness(f)  (ef) of(g) her(fe) heart.(d)  (h) e(g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-145.png",
        nextFileName: "./pages/part-b-146.png",
    },
    {
        title: "part-b-145-1",
        gabc: "0(eed) most(f) worthy(de) [(e) TBride(g) of(gh) a(g) whom(g) light(j) propEetic(h)  (gf) a(g)  :(gh) 11—1u—mi-(g)ned,(fe)  (e) [(c) ;-(df)pos-(d)to&#39;—lic(c) zeal(de) in-(fed)fla-(gh)med,(g) the(g) 3(hj)  rel(i)  garland(k)  (j) of(ji) virgins(h)  (hg) crowned,(hi) A(i) and(j) the(j) fire(hij) of(hg) love(def)  ;(ki~)  (gh) =(gfe) (¥(e)  (ji) [Tt(hih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-145.png",
        nextFileName: "./pages/part-b-146.png",
    },
    {
        title: "part-b-146-0",
        gabc: "C(e) les-(fe)tial(d) spirits(gh)  (g) e(e)  (g)  (f) descending(e)  (ghj)  (j) tq(ji) eart,(hg)  from(e) heaven;(fe)  (d) who(g) called(g)  (ef) Gertrude(f)  (e) to(d) the(g) Jjoys(gh) of(g) p,.(hj)  ra-(j)dise(j) with(k) me-(j)lo-(ji)di-(h)ous(ih) voices,(g)  (ef) saying:(gh)  (g) Come,(jj) 0(g)  come,(h) be-(g)lov-(fe)ed(d) one,(e) for(gh) heavenly(g)  (e) -(fe)delights(d)  (efgh) are(hg) a-(f) waiting(fe)  (d) thee,(e) al-(g)le~-(h)lu-(gjh~)ia,(j) al-(k)le-(ihgh)lu-(efgfe)ia.(e)  (ji) W,(hih) ",
        groupIndex: 0,
        filename: "./pages/part-b-146.png",
        nextFileName: "./pages/part-b-147.png",
    },
    {
        title: "part-b-146-1",
        gabc: "(0)(g) ev-(g)er(f) blessed(e)  (d) Mother(f)  (dddhg) of(dfgdd) God,‘r(dgd)  (cf) Ma-(j)ry(h) ev-(j)er(i) Virgil(g)  (g)  temple(j)  (k) of(j) the(djdfidf) S(ddfhdfhhhfhhhf~) B(jfd) )(ji)  (hdf) shrine(ghdfdfghfddf) of(fdg) the(dff) fis&#39;&quot;(dh) ",
        groupIndex: 1,
        filename: "./pages/part-b-146.png",
        nextFileName: "./pages/part-b-147.png",
    },
    {
        title: "part-b-147-0",
        gabc: "Spirit:(g)  (g) thou(gh) on(fg) ly,(f) a-(f)bove(f) all(hj) o(jk)  (kj) thers,(k) ac-(k) cep-(j)ta-(i)ble(hj) to(jk) our(ji) Lord(ghgf) Je(hijh) .sus(ih) Christ,(gh) al(i) le(h)  lu(g) 1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-147.png",
        nextFileName: "./pages/part-b-148.png",
    },
    {
        title: "part-b-147-1",
        gabc: "D(ki~) a(e) a(e) O(e) [(e) B(e) Va-(g)le-(ff)ri-(f)an,(df) a(c) [)(efe) I(d)  ¥ish(fh) to(gh) tell(egfe) thee:(e) I(e) have(g) an(fh) An-(h)gel(h) of(h) God(h) who(gf)  loves(ghge) a-(e))(e) guards(f) my(g) bo-(gh)dy(g) with(gf) ex-(d)ceed-(dg)ing(f)  Zea],(e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-147.png",
        nextFileName: "./pages/part-b-148.png",
    },
    {
        title: "part-b-148-0",
        gabc: "organs(d)  (f)  (f) made(e) me(fg) lo(cfed) dy(def) Twhile(fd) Ce-(f)ci-(gh)lig(h) Sang(i) o(h)  gain(gg) to(e) the(f) Lord,(g) and(f) said:(d) Let(h) my(g) heart(j) be(h) soung(g)  thy(e) s(f) 5(d) that(d) I(f) be(g) not(ef) n(e) 2(d) shamed.(d) =(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png",
    },
    {
        title: "part-b-148-1",
        gabc: "Then(e) did(g) Va-(h)le-(hji)an(hi)  (i) L(j)  (h) findaCe=gi=)ia~insherschailies(i)  (h)  (g)  (h)  (ij)  (i)  with(h) an(f) An-(gfe)gel,(f) making(e)  (d) her(def) a(g) supplication.(f)  (e)  (e) ||(i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png",
    },
    {
        title: "part-b-148-2",
        gabc: "Ce-(g)ci-(hj)lia(j) Tthine(j) =(h) handmaid,(g) O(hiji) Lord,(hg) ev-(g)er(h) serveth(j)  (i)  —}__I(h)  (j)  (ih)  thee(h) as(g) -(g)zealously(gf) as(d)  (fh) a(f) bu-(g)sy(f) bee.(e)  (j) —}__I(h)  J&#39;(cgd) bless(fg) thee,(g) 10(f)  (fdg) Father(gfffgfgf) of(fddfdhffdfidfij) Lord(df) Je-(h)sus(i) Christ:(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-148.png",
        nextFileName: "./pages/part-b-149.png",
    },
    {
        title: "part-b-149-0",
        gabc: "for(g) by(g) thy(h) Son(ji) the(h)  (g) fire(ge) is(g) quenched(fe)  (f) round(d) a-(ef)bout(gh)  thine(h) handmaid.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png",
    },
    {
        title: "part-b-149-1",
        gabc: "I(ik)  (d) -(ef)de-(g)si-(g)rediof(g) the(g) Lord(gh) a(g) three(g) days’(f) E(gf) respite,(e) —(ef)  I(gf) micht(ef) hallow(gh) a(g) my(f) ](g) dwelling(ef) as(g) a(f) temple.(e)  (e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png",
    },
    {
        title: "part-b-149-2",
        gabc: "the(cc)  (d)  (f) dawn(d)  (cd) day(f) was(g) breaking,(fh)  (h) T(h) Ce~ci-(h)lia(g) the(g)  Martyr(ik)  (e)  (f) cri-(g)ed,(fe) saying:(d)  (d) %—————————f————*(h) Forward,(g) soldiers(j)  (h) of(gf) Christ!(gh)  Cast(h) off(gh) tEe(fe) works(g) o|(def) darknEss,(df)  (fc) and(c) put(d) on(f) the(f) ar-(ef) mour(g) of(fe) 1jght.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-b-149.png",
        nextFileName: "./pages/part-b-150.png",
    },
    {
        title: "part-b-150-0",
        gabc: "T(ig~) his(h) no-(h)ble(fh) N(f) maiden(f) al(hh) +(fhge) bare(h) the(i) glo-(j)ri-(i)oyg(h) 0(i)  pel(gi)  (f) of(i) Christ(hg) in(e) her(gh) bosom:(f)  (f) I.:(e) without(f) -(hh) con-(gi) (i) ti-(ji)nu-(hi)ed(h) in(hi) prayer(j) and(i)  (j) supplication,(h)  (i) 10(h) and(gh) ce-(f)]es(f)  3(gi) tial(fi) con-(hi)verse,(f) night(hg) and(dgh) day.(f) el(h)  (g) e(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-150.png",
        nextFileName: "./pages/part-b-151.png",
    },
    {
        title: "part-b-150-1",
        gabc: "Let(ef) us(ed) all(ef) pray(e) Tto(f) our(h) Lord(ih) Je-(fh)sus(hg) Christ,(e) that(e) he(d)  would(f) o(hg) pen(ef) a(fgh) fountain(ij)  (h) for(f) his(h) Confessors.(g)  (e)  (ee) i(h)  (g)  (h)  (f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-150.png",
        nextFileName: "./pages/part-b-151.png",
    },
    {
        title: "part-b-151-0",
        gabc: "While(g) ho(ighj) ly(i)  (ij) ClementTpray—ed,(i)  (hih) Bl(hhg~) the(h) Lamb(hgf) of(gh) God(gf) ap-(e) peared(hf)  (gf) un-(e)to(de) him.(e)  (i) _I—I(j)  (i)  (h) l(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png",
    },
    {
        title: "part-b-151-1",
        gabc: "Not(ii) for(g) my(ij) own(i) merits(hi)  (i) Tdid(i) the(i) Lord(i) send(g) me(h) un-(g)to(e)  you,(e) that(h) I(h) might(h) be(fh) made(g) partaker(f)  (e)  (f) of(h) your(g) crowns.(e)   (gi)  (i)  (j)  (i)  (h)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png",
    },
    {
        title: "part-b-151-2",
        gabc: "Up-(gi) (i) on(i) the(g) mountain(ij)  (i) fI(i) .(i) a(g) Lemb(hg) K(e) [(e) from(h)  beneath(gi)  (h)  (h) whose(fh) foot(g) floweth(f)  (e) a(f) fount(f)  (gh) of(f) living(g)  (f) waters.(e)  (e)  [(ik)  (i)  (j) ](i)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-151.png",
        nextFileName: "./pages/part-b-152.png",
    },
    {
        title: "part-b-152-0",
        gabc: "rom(i) [}(i) underneath(g)  (ij) his(i) foot(i) floweth(i)  (i) a(i) fount(ji) a(g) L](h)  (g)  waters:(e)  (e) a(h) river,(h)  (h) the(h) streams(h) whereof(fh)  (g) make(f) glad(e) the(f)  ci-(fh)ty(f) of(gf) God.(e) e(i) e(j) R(i)  (h) ST,(gh)  A(j) the(j) nations(jkj)  (ji) Troud(hj) about(j)  (i) believed(g)  (hf)  (fh) in(h) Christ(g)  Lord.(g)  (j) ANTIPHON(h)  (j)  (k)  (j)  W(ikcc) hen(d) he(d) had(f) start-(d):lta&#39;d(dc) going(f) O(g) to(f) the(h) sea,T(h) the(h) peo-(hjj)ple(hih)  cri-(h)ed(g) out(ef) with(g) loud(fe) voices,(d)  (d) O(f) Lord(fed) Je-(fg)sus(gf) Christ(ed)  save(fe) -(dc)a(c) Clement(cd)  (d) B(d) responded,(d) [(c) weeping,(ffg) =(f) Hee-(f) (fh) ven-(g)1(f)  a-(fe)ther,(c) receive(cd)  (f) my(gf) spirit.(d)  (d)  (h) :(g)  (df)  (gh)  (dgf)  (d) 456(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-152.png",
        nextFileName: "./pages/part-b-153.png",
    },
    {
        title: "part-b-153-0",
        gabc: "princes(h)  (hg) *(fgh) In(fd) all(fg) lands.(gf) Thou(f)  (f)  Thou(f) shalt(f) make(g) them(f)  shalt(i)  (f) make.¥.(g) They(hi) shall(h) remember(h)  (fh) cervenstmomnte|(g) thy(gf) Name,(g) O(gh) Lord.(hg)  H.&#39;In(fd) all(fg) lands.(gf) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(fgh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Thou(f) shalt(f) make.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-153.png",
        nextFileName: "./pages/part-b-154.png",
    },
    {
        title: "part-b-153-1",
        gabc: "hou(fg) shalt(f) make(fe)  (dc) ¢(jifghi)  (h)  (efh) Tn(gfe) all(ghgf) lands.(f)  (efgh)  (f) Thou(fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-153.png",
        nextFileName: "./pages/part-b-154.png",
    },
    {
        title: "part-b-154-0",
        gabc: "shalt(f) make.(fe)  (c) They(f) shall(f) remember(f)  (gh)  (f) tihy(fe) 0(dc)  (fghi)  (h)  R.(ik) In(gfe) all(hgf) lands.(f) V.(c) Glory(f)  (f) be.(g) Thou(fg) shalt(f) nghe,(fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-154.png",
        nextFileName: "./pages/part-b-155.png",
    },
    {
        title: "part-b-154-1",
        gabc: "will(d)  (d) de-(dc)liv-(f)er(gh)  (hgg) up(f) to(gh) the(fe) councils,(d)  (d) and(g) they(g)  —(g) scourge(h) you(fgf) in(e) their(f)  (g) WP(fe) synagogues;(d) and(d) ye(dc) shall(f) =(g)  brought(h) before(g)  (f) governors(gh)  (fe)  (d) and(fed) kings(ed) for(dfgf) my(fd) sake;(fgf) 1or(df)  a(fg) testimony(h)  (g)  (f)  (g) against(gh)  (g) them(dfedc) Tw(c) the(d) =(ffg) 7(d)  (hgfdgh)  (dgdf) ",
        groupIndex: 1,
        filename: "./pages/part-b-154.png",
        nextFileName: "./pages/part-b-155.png",
    },
    {
        title: "part-b-155-0",
        gabc: "is(j)  (ji) my(hg)  (hih) commandment,t(gh)  (g) el(h) that(g) ye(g) love(g) one(e) o(g) another,(fe)  (f)  as(jk)  as(d) I(e) have(f) loved(gh)  (h) you.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png",
    },
    {
        title: "part-b-155-1",
        gabc: "(Greater(dd) ](c) love(d) hath(fe) no(def) man(f) than(fghg) :,(ih) this,(ih)  (h) that(h) a(g) man(df)  =(fg) down(hf) his(g) life(fe) for(cd) his(fe) R(d) ||(h) S(f) @(e) 5(c)  (d) |(fg) ",
        groupIndex: 1,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png",
    },
    {
        title: "part-b-155-2",
        gabc: "-(dh)are(j) my(hg) frien&amp;,f(h) if(fe) ye(def) do(cfgc) [(e) so-(f)ev-(gh)er(g) 1(fg) com-(f) mand(ef) you,(dc) saith(d) the(efe) Lord.(d)  (h)  (g)  (f)  (gh) ;(gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png",
    },
    {
        title: "part-b-155-3",
        gabc: "BleSSEd(d)  (dc) are(f) the(g)  (f) peacemakers,T(gh)  (h) blessed(hi)  (h) are(g) the(g) pure(f)  \\\\;(gh) A(g) for(gg) they(ef) e(g) ](fe) God.(d) |(h) o(h) tiah(g)  (f) i)(gh) R(gf) ",
        groupIndex: 3,
        filename: "./pages/part-b-155.png",
        nextFileName: "./pages/part-b-156.png",
    },
    {
        title: "part-b-156-0",
        gabc: "In(dd) your(cd) LTSI(fe) patience(dc) e(f) possess(fg) ye(e) your(fe) souls,(d) I(f) ](e)  (c)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png",
    },
    {
        title: "part-b-156-1",
        gabc: "Their(c)  (c)  (f) sound(g) is(f) gone(gh) out(hg) In-(g)to(fd) all(fg) lands.(gf) Treir(f) so(g)  .(c) And(h) their(h) words(hi) %.(h)  (gh) ends(g)  (gf) of(g) the(gh) world,(hg)  In-(g)to.(fd) Glory(h)  (h) be.(h) Their(f) sound.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png",
    },
    {
        title: "part-b-156-2",
        gabc: ".(ik) .(dc)  (cf) -(ed)e(dh)  (h) s(g) e(f) T(eghd) ](f)  (ed)  (ed) ](g)  ®(ge) 2(f)  (e)  (ded)  (dh)  (g)  (h)  (g)  (f)  (h)  (g)  (hhgfed)  X,(dg) They(g) declared(f)  (ghg) the(gd) work(f) of(e) God.(defdcd) ",
        groupIndex: 2,
        filename: "./pages/part-b-156.png",
        nextFileName: "./pages/part-b-157.png",
    },
    {
        title: "part-b-157-0",
        gabc: "Y(dd) which(c) have(df) for-(fe)sa-(fg)ken(fed) all,T(df) and(cd) fol(ffd) low-(fh)ed(fgh) me,(g)  shall(hi) receive(g)  (f) an(f)  (g) hundredfold,(fe)  (df) and(efh)  (dc) shall(dd) in-(cd)her-(f)it(f)  [}(e) ev—er-(f)lasting(g)  (fe) life.(d) Melody(h)  (g) is(f)  (gh) used(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png",
    },
    {
        title: "part-b-157-1",
        gabc: "he(gi) Lord(k) sware,(jkj) and(j) will(h) not(jh) re-(ih)pent:(g) Thou(g) art(fe) a(d)  Priest(ef) for(gh) .-(g)8-(g) (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png",
    },
    {
        title: "part-b-157-2",
        gabc: ":&#39;May(ji) the(hg) Lord(hih) set(fh) him(g) with(fge) the(g) princes(dfe)  (d) of(f) his(gh)  People.(g)  (g)  (f) =(j)  (h)  (j)  (k)  (j) ",
        groupIndex: 2,
        filename: "./pages/part-b-157.png",
        nextFileName: "./pages/part-b-158.png",
    },
    {
        title: "part-b-158-0",
        gabc: "Thou,(c)  (e) 0(f) Lord,(h) hast(h) broken(ij)  (i) 1&#39;my(ih) bonds(f) in(h) ..(fg)  (e) I(f) 2(e)  offer(gi)  (d) &quot;(e) to(f) thee(h) :(ge) sacrifice(gh)  (f)  (f) 3(g) of(f) thanksgiving,(e)  (e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png",
    },
    {
        title: "part-b-158-1",
        gabc: "F(h) irmly(h) stab-(ihij)1ished(i)  (i) tis(ih) their(fh) prince-(ghffe)dom:(e) and(f) highly(e)  (d)  a(e) honoured(f)  (f) are(f) thy(i) e(fh) 0(gf) Vo(e) e(j)  (i) (|(h) )|(ih) ",
        groupIndex: 1,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png",
    },
    {
        title: "part-b-158-2",
        gabc: "Be(c)  (ch) ve(g) valiant(h)  (g) in(f) warfare,(g)  (d) and(hhi) contend(h)  (jk) ye(jkj) with(ji) the(g)  old(ij) ser-(hih)pent:(h) s(h) ve(ghg) shall(e) e(f) receivefan(gh) -(g)|(g) ter-(hf)nal(g)  .(i)  (fe) .(dc) W(d) al—le—lu-(efe)el(d) ia.(d) €(dg)  (e) ~ter(dg)  nal(ik)  (fe) kingdom.(d)  (d)  (h)  (g) .(f)  (gf)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-b-158.png",
        nextFileName: "./pages/part-b-159.png",
    },
    {
        title: "part-b-159-0",
        gabc: "Ligbt(f) per-(f)pe-(g)tu-(f)al(f) shall(f) shine(f) up-(f)on(f) thy(e) Saints,(g) O(g)  Lord,(h) *Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Light(f) perpe-(f) (g) tual.(f)  (f)  And(f) an(f) ageless(f)  (f) e(e) ter-(g)ni-(g)ty.(h) Al-(h)le(hg) lu-(g)ia.(f)  Glory(f)  (f) be(f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(h)ly(g) Ghost.(gf) Light(f) per-(f)pe~tu-(g) (f) al.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-159.png",
        nextFileName: "./pages/part-b-160.png",
    },
    {
        title: "part-b-159-1",
        gabc: "[(efg)  (fe)  (d)  (e)  (dc) p(d) e(fd)  (efe) e(edc) e(g) e(h)  (i)  |(j)  (ihg) [Tl(j)  (ihg)  (ih) s(g) [«(hg) 9(fed) e(efg) (78(f)  (e)  i(h)  (g)  (h)  (ihg) D(h)  (gfdefg) L(fe)  (e) |(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-159.png",
        nextFileName: "./pages/part-b-160.png",
    },
    {
        title: "part-b-160-0",
        gabc: "L(gi) ight(h) per-(h)pe-(h)tu-(f)al(g) x;ha.]l(h) shine(i) up-(g)on(hi) thy(gh) Saints,(f)  (ef) Lorg(f)  and(gi)  (h) an(i) ageless(j)  (i) e-(h)ter-(i)ni-(h)ty,(gh) al-(i)le-(ih)lu-(g)ia.(g)  (j) =(i)  (j)  (kj)  (ihg) ",
        groupIndex: 0,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png",
    },
    {
        title: "part-b-160-1",
        gabc: "hy(h)  (hih) Lord,(h)  (fh) shall(gf) blossom(e)  (e) as(i) a(hf) li-(h)ly,(gh) al-(hi)le-(f) lu-(e)A(e) L](e) as(g) the(h) o-(i)dour(h) of(i) balsam(ih)  (i) ahall(ii) they(ef) be(h)  be-(h)fore(gf) thee,(e) al-(gf~)le-(f)lu-(e)ia.(e) ___l_l(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png",
    },
    {
        title: "part-b-160-2",
        gabc: "In(e) the(e) heavenly(h)  (g)  (h) kingdom(hij)  (i) the(h) Blessed(j)  (k) have(j) their(i) dwell-(j) ing-(gi) (i) place,(h) al-(ji~)le-(j)lu-(i)ia:(i) and(ji~) their(i) rest(hd) -(f)ev-(hf)er(g) and(i) ",
        groupIndex: 2,
        filename: "./pages/part-b-160.png",
        nextFileName: "./pages/part-b-161.png",
    },
    {
        title: "part-b-161-0",
        gabc: "ev-(hg)er,(ef) al-(g)le-(f)lu-(e)ia.(e) S(j) e(i)  (h) e(gf)  :(gi)  (ff) blessed(e)  (fh) Saints,(hg) &#39;C(fe) Lord,(h) 1-(h)cri—ed(i) out(j) within(ih)  (i) the(j)  7(gi) veil,(j) al(h) le(jhk) lu-(i)ia,(h) al-(i)le-(h)lu-(h)1a,(fe) al-(f)le-(ghg)lu-(f)ia.(f) |(f)  Spiritus(h)  (g)  (e) et(f)  O(h) ye(fg) spirits(g)  (g) and(g) souls(gf) tof(gh) the(fe) righteous,(d) L(d) sing(g) a(g) hymn(g)  un-(h)to(g) the(f) Lord(g) our(gh) God,(f) al-(fh)le(j) -(ihj)ia,(hgf) al-(gh)le-(h)lu-(g)ia.(g)  S(j) Fulgebunt(i)  (j)  (h) justi(gh)  :(f) shall(h) the(g) righteous(fg)  (fge) shine(ih) RN(ji) o(h) the(g) sun(fhih)  i(gi)  (e) the(f) 5(h) T(dhg)  (fe) s(f) 7(ghg) s(f) S(f) |(d) e(h)  (g) T(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-161.png",
        nextFileName: "./pages/part-b-162.png",
    },
    {
        title: "part-b-162-0",
        gabc: "O(ik)  (f) ye(f) ho-(f)ly(f) and(f) ¥(g) righteous,(f) rejoice(f)  (f) a(e) the(g) Lorg,(h) Al(h)  le(ik)  (hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) O(f) ye(f) ho-(f)ly.(f)  (d) ¥.(c) God(f) haty(f)  chosen(f)  (f) you(f) to(f) him(g) to(f) be(f) his(f) a(e) he-(g) (g) ri-(h)Al(h)  le-(hg)lu-(g)ia.(f) X.(c) Glory(f)  (f) be.(f) O(f) ye(f) ho-(f)ly.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png",
    },
    {
        title: "part-b-162-1",
        gabc: "-(f) (ffe) a(d)  (e) a(g)  (h) -(f) (e)  (g)  (h)  (g)  (hjji)  L(g) i(g)  (f)  (fgh)  (h)  (h) 0(g)  (hjji)  (gf)  (h)  (h)  (dffe)  7.(ed) O(c) dear(eg) in(gfh) the(fgf) sight(g) of(fe) the(e) ",
        groupIndex: 1,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png",
    },
    {
        title: "part-b-162-2",
        gabc: "D(c) —_——(c) aughters(d) of(f) Je-(gf)ru-(d)si-(cd) (d) t(h)  (cd) forth(ffgh) and(d)  (fh) behold(dffddfgddf) ",
        groupIndex: 2,
        filename: "./pages/part-b-162.png",
        nextFileName: "./pages/part-b-163.png",
    },
    {
        title: "part-b-163-0",
        gabc: "the(d) Martyrs’(fe)  (dc) with(c) the(cg) di&#39;—(g) a(fghg) dems(fed) wherewith(c)  (d) the(dg)  Lord(i)  (fe) hath(dc) crowned(d)  (efe) them(d) in(hiji) the(h) day(gfd) of(e) so-(f)lem-(gh)ni-(g) ty(gf) and(d)  (f) rejoicing,(de) =(dc) &amp;1(cd) le(fgfe) lu-(ghg)ia,(fedc) al-(dg)le-(efe)lu-(d)ia.(d)  Hymn(h) a(g)  (f) a(g) Melody(gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-163.png",
        nextFileName: "./pages/part-b-164.png",
    },
    {
        title: "part-b-163-1",
        gabc: "cO(g) ye(f) ho-(gf)ly(e) and(f)  (h) -(g)rejoice(g)  (h) in(ggh) the(f) Lord,(fh) al-(h) le-(fg)lu=jia:(gh)  (g) God(g) hath(g) chosen(h)  (fg) you(g) to(fh) him(f) to(h) be(f) his(g) in-(h) b(j) i(ih) tance,(hjk) al(h) le-(h)lu-(g)ia.(g) |(j) e(i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-163.png",
        nextFileName: "./pages/part-b-164.png",
    },
    {
        title: "part-b-164-0",
        gabc: "hou(f) hast(gh) set(hg) Up-(f)on(f) his(gh) head,(gfd) O(fg) Lord,(gf) Thou(f) hast(gh) o(hg)  M.(jk)  M.(c) A(hi) crown(g) of(f) pure(gh) B(hg) Up-(f)on(f) his(gh) head.(gfd) Glory(h)  (h)  be(h) to(h) the(h) Father(hi)  (h) and(h) to(h) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)P(g)  Ghost.(gh) Thou(f) hast(gh) [(hg) ",
        groupIndex: 0,
        filename: "./pages/part-b-164.png",
        nextFileName: "./pages/part-b-165.png",
    },
    {
        title: "part-b-164-1",
        gabc: "[(c) I(fe) e(fg) o(g) |(gh)  (hg)  (f)  (g)  (f)  (hg)  (hj)  (jk)  I(ji) W(g) e(gh) OO(hgf) s(fgh)  (h) w0(gf)  (g)  (fe)  (dc)  (de)  (edc)  L](g) ](g) hast(hj) crowned(j) :(hg)  (e) with(f) P(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-164.png",
        nextFileName: "./pages/part-b-165.png",
    },
    {
        title: "part-b-165-0",
        gabc: "This(f) is(e) 2(d) l\\‘!ar’ter(ef)  (e) who(df) strove(h) for(h) his(h) Master’s(hi)  (h) precepts,(hg)  (f)  e-(h)ven(f) un—-(d)to(de) death:(e) and(df) feared(hhi)  (h) not(h) the(ih) words(i) of(iji) e-(h)vil(fh) men,(h)  forasmuch(h)  (h)  (i) as(g) he(h) was(f) stablished(h)  (e) an(efe) on(c) a(d) sure(ef) foundation.(f)  (e) -(e) AT(h)  (g)  (h)  (f)  (ef) ",
        groupIndex: 0,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png",
    },
    {
        title: "part-b-165-1",
        gabc: "bo:so-(d)ev-(f) (d) er(dc) shall(f) confess(g)  (fh) me(h) tbefore(gf)  (h) men,(g) him(gg) a(e) I(g)  confess(h)  (fg) al-(fe)so(c) before(e) g(ge) my(fe) Father.(d)  (d) RS(h) m(g) e(f) o(gh) 0(gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png",
    },
    {
        title: "part-b-165-2",
        gabc: "cHe(g) that(g) followeth(ghj)  (h)  (ghhj) me(j) Tshall(i) not(j) walk(k) in(hj)  (ji) darkness,but(hg)  (g)  shall(jk)  (jk)  shall(h) have(j) the(i) light(h) a(g) life,(hhj) a(g) the(gf) Lord.(e)  (j)  (h)  (j)  (fih) ",
        groupIndex: 2,
        filename: "./pages/part-b-165.png",
        nextFileName: "./pages/part-b-166.png",
    },
    {
        title: "part-b-166-0",
        gabc: "f(df) a-(d)ny(dc) man(fg) serve(fgh) me,(h) let(ih) him(g) follow(f)  (gh) me;(g) ang(g) wherg(eg)  I(hgf) am,(f) there(g) shall(f) al-(f)so(e) my(f) servant(g)  (f) be.(d)  (h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png",
    },
    {
        title: "part-b-166-1",
        gabc: "If(d) a-(d)ny&#39;(dc) man(f) have(g) served(f)  (h) me,(h) he(f) shall(f) be(ih) honoured(g)  (f)  (gh) of(f)  my(ik)  (ef) Father(d)  (d) which(g) is(fh) in(f) heaven,(fe)  (dc) saith(d) the(efe) Lord.(d)  (h)  (g) 1(f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png",
    },
    {
        title: "part-b-166-2",
        gabc: "Fathe_r,T(fe) .(d) I(d) will(e) that(f) where(g) I(h) am,(g) there(h) may(g) al-(f)so(e)  my(f) [}(g) servant(f) be.(d) J(h)  (g)  (f)  (gf)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png",
    },
    {
        title: "part-b-166-3",
        gabc: "hou(f) hast(f) -(g)crowned(fh) him(hg) With(g) glory(fg)  (g) and(fhh) honour,(g)  (fd) 0(gf~)  Lord.(gf) Thou(f) hast(f) crowned.(g)  (gh) X.(c) And(h) madest(hi)  (h) him(h) to(h) have(h) ",
        groupIndex: 3,
        filename: "./pages/part-b-166.png",
        nextFileName: "./pages/part-b-167.png",
    },
    {
        title: "part-b-167-0",
        gabc: "dominion(h)  (h)  (g) of(g) the(h) works(g) of(f) thy(fh) hands.(hg) With(g) glory.(f)  (g)  X.(c) Glory(h)  (h) he.(h) Thou(f) hast(f) crowned.(g)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png",
    },
    {
        title: "part-b-167-1",
        gabc: "a(e) a(e) r.(ed) a(g) |(gh)  (j) a(j)  (ih) e(i) 0(j) a(i) a(h)  (g)  A(hiji)  (hg) e.(g) i(gh) 30(j)  (i) [suidimaDwsy(h) e(g) -(i)a(g) [,(hg)  The(hi) :(g) righteous(h) shall(fe)  (d) flourish(efg) like(fe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png",
    },
    {
        title: "part-b-167-2",
        gabc: "He(ghjj) that(j) ha-(j)teth(ji) his(hi) life(h) tin(g) this(hj) world(ij) shall(ij) keep(k)  it(i) un-(j)to(hg) life(hgf) e-(g)ter-(e)nal.(e) |(ji) —l(hi)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-167.png",
        nextFileName: "./pages/part-b-168.png",
    },
    {
        title: "part-b-168-0",
        gabc: "W(cc) ho-(d)so-(f)ev-(d)er(dc) will(f) come(g) after(f)  (gh) me,(h) let(ih) him(g) de-(g)ny(f) hip.(hg~)  self,(g) and(g) take(ef) up(h) his(g) cross,(ff) and(f) EERGER(g) follow(fe) me.(d) I(h)  (g)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-168.png",
        nextFileName: "./pages/part-b-169.png",
    },
    {
        title: "part-b-168-1",
        gabc: "._L(ik) et(f) the(f) righteous(g)  (f) rejoice(gh)  (hg) Before(fd)  (fg) God.(gf) Let(f) the(f) right-(g) eous(i)  (f) rejoice.(gh)  (hg) Let(hi) them(h) al-(gh)so(g) be(g) merry(h)  (g) and(f) jOYfUI&#39;(h)  (hg)  Before(fd)  (fg) God.(gf) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Mo-(f)ly(g) Ghost.(gh) Let(f) the(f) righteots:(g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-168.png",
        nextFileName: "./pages/part-b-169.png",
    },
    {
        title: "part-b-169-0",
        gabc: "](e)  (g)  (h)  (ij)  (ih) e(i)  (e)  (fg)  (h) e(gfe)  (f)  (e)  [](e)  (g) &amp;(h)  (ij) a(ih) 3(i) —(e)  (fg)  (h)  (gfe)  (f)  (e)  (ef)  g(ih)  (i)  (hj) ﬁ-(k) (k)  (ji) L(k)  (j) “(j)  (i)  (ih)  (fgfg)  L(ghi)  (f)  (ed)  (e)  (f)  (g)  (hgf)  (fe) ",
        groupIndex: 0,
        filename: "./pages/part-b-169.png",
        nextFileName: "./pages/part-b-170.png",
    },
    {
        title: "part-b-169-1",
        gabc: "For(g) theirs(gj) is(h) the(g) kingdom(h)  (g) of(f)  (gh) heaven,(g) who(h)  (j) despised(j)  (g)  %g(h)  (j) =(ij) living:(j) who(i) have(j) won(k) the(j) rewards(i)  (j) of(h) &quot;(g) king-(h) dom,(ghihgg) .(e) have(f) washed(g)  (h) B(gf) dl(efd) in(g) the(h) blood(ghijh)  ‘(i) the(ffh) MY(g) &amp;(j) =(i) e(ff)  (dj) e(h) o(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-169.png",
        nextFileName: "./pages/part-b-170.png",
    },
    {
        title: "part-b-170-0",
        gabc: "(O(g) how(gd) great(fh) torments(g)  (g) have(c)  (g) all(h) the(f) Saints(gh) en=(h)  ed,(dffedd) a(c) they(d) might(fg) surely(g)  (h) attain(g)  (ij) to(h) ‘the(g) paln(h)  of(gf) martyrdom.(h)  (g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png",
    },
    {
        title: "part-b-170-1",
        gabc: "T(c) le(h) Plessed(fg) a-(g)Twith(g) their(h) palms(j) have(i) en(j) ter-(i)ed(h) in-(j)to(g)  the(h) king-(h)dom;(hghih) they(f) have(g) ear(hgfg) ned(gf) their(h) di(j) a-(i)dems(j)  of(ki~)  (h) glory(j) a(g) from(h) the(gf) hand(hg) of(h) God.(g)  (j) BT(i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png",
    },
    {
        title: "part-b-170-2",
        gabc: "fe(dc) bodies(f)  (g) of(f) the(gh) Saints(h) Tare(h) bu-(h) (hg) ri-(f)ed(gh) 1n(ef) peace:(d) ",
        groupIndex: 2,
        filename: "./pages/part-b-170.png",
        nextFileName: "./pages/part-b-171.png",
    },
    {
        title: "part-b-171-0",
        gabc: "and(g) their(g) name(gh) liveth(fg)  (fe) for(dc) ev-(d)er(efe) —more.(d)  (fgh) e(h) e(g)  (f) )(gh) P(gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png",
    },
    {
        title: "part-b-171-1",
        gabc: "0(d) T(c) Martyrs(d)  (f) of(f) the(fg) Lord,T(g) bless(h) ye(g) the(f) Lord(e) for(d)  ev-(f)er(f) and(gh) ev-(g)er.:(g)  (g)  (d)  (f)  (ed) ",
        groupIndex: 1,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png",
    },
    {
        title: "part-b-171-2",
        gabc: "O(ki~)  (j) choir(i) of(j) L(hg) Martyrs,t(h) praise(gf) ye(g) the(h) Lord(j) of(h) heav’n,(hj)  al-(h)le-(h)lu-(g)ia.(ef)  (j)  (h)  (j)  (k)  (j)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png",
    },
    {
        title: "part-b-171-3",
        gabc: ":(c) Be(c)  (f) glad,(g) O(f) ye(f) g(gh) [T(hg) TR(g) And(f) v(fh) i(gfd) e(f) e(g) )(gf) |(efg)  Be(f) glad.(g) X.(efghifhic) And(hi) be(h) joyful,(fh)  (g) all(j)  (g) ye(h) that(g) are(f) true(g) of(gh)  eart.(hg) |(hdefhi) .(f) And(df) rejoice.(ghf)  (gfd) o(fdd) .(ffc) Ay(h) Glory(d)  (h) be.(h) B.(efhij) Pe(f) glad.(g) |(efgh)  eart.(d)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-b-171.png",
        nextFileName: "./pages/part-b-172.png",
    },
    {
        title: "part-b-172-0",
        gabc: "A(fgf) a(e) a(g) -(fgh) (hg) U(fe) s(d)  (e) :P—Q(fe)  (d)  LT(fe) GO(d) Gape(c)  (d) TR(f) WRSSMs(d)  (c) i(e) 17(df)  (d)  (c)  (e)  V.(f) the(g) Saints(fgh) be(hg) joyful(ed)  (f) with(gf) glory.(e) ",
        groupIndex: 0,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png",
    },
    {
        title: "part-b-172-1",
        gabc: "be(f) ve-(d)ry(f) hairs(h) of(hg) your(f) head(h) Tare(hi) all(kj) numbered:(i)  (h)  (i) fear(h)  Ye(f) not(fg) )(d) therefore,(d) ye(g) are(g) of(g) more(e) value(g) B(fe) than(d) ma-(eg)ny(f)  sparrows.(d)  (d)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png",
    },
    {
        title: "part-b-172-2",
        gabc: "These(gic)  (h) are(hg) the(e) ho-(gh)ly(f) ones(f) who,(ff) for(e) the(f) co-(h)ve-(fg)nant(f) 9%(f)  God,(e) have(e) de-(f)liv-(fij)B(hg) d(fe) up(f) their(hg) ho(f)  (gdhed) dies,(dhfded)  (fddfh) am(deffd) ",
        groupIndex: 2,
        filename: "./pages/part-b-172.png",
        nextFileName: "./pages/part-b-173.png",
    },
    {
        title: "part-b-173-0",
        gabc: "qashed(g)  (h)  (gf) their(hi) robes(i) in(e) the(f) blood(hg) of(e) the(fh) Lamb.(f)  (h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png",
    },
    {
        title: "part-b-173-1",
        gabc: "The(c)  (f) Saints(e) through(fh) faith(h)  (gf) Sub-(fe)du-(f)ed(hg) kingdoms,(gf)  (f) wrought(ff)  {(g) righteousness,(h)  (hj)  (i) ob~tain-(i) (jjki) =(ghg) the(ef) prom-(hgih)is-(f)es.(f)  (h)  (g)  (ef) ",
        groupIndex: 1,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png",
    },
    {
        title: "part-b-173-2",
        gabc: "The(g) youth(h) of(f) all(g) the(h) ho-(j)ly(j) Saints(i) Shall,(g) like(i) the(j)  eagle’s,(h)  (g) be(h) re-(g)newed:(f) And(g) as(g) the(f) li-(g)ly(h) shall(j) they(j)  bloom(i) :(i) the(j) ci-(h)ty(h) of(i) the(h) Lord.(g)  (j)  (i)  (j) |(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png",
    },
    {
        title: "part-b-173-3",
        gabc: "od(ehg) shall(h) wipe(i) a-(hg)way(fi) all(gh) t.e-(ef)from(f) the(f) of(ed)  (fghf)  he(gf) Saints:(e) L(e) there(ehg) e(d)  (d)  (ih) |(iji)  (hg) more(hi) sorrow,(i)  (i) ",
        groupIndex: 3,
        filename: "./pages/part-b-173.png",
        nextFileName: "./pages/part-b-174.png",
    },
    {
        title: "part-b-174-0",
        gabc: "neither(j)  (k) crying,(j)  (i) neither(j) shall(j) there(i) be(gf) a-(h)qv(ih)  (fg)  T(e) for(f) the(ed) former(e)  (fh) things(hgf) are(gh) pass-(ih)ed(f) a-(f)way(e)  a(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-174.png",
        nextFileName: "./pages/part-b-175.png",
    },
    {
        title: "part-b-174-1",
        gabc: "[(f) the(f) heavenly(f)  (f)  (gf) king—-(edf) (f) domT&#39;rejoice(fg)  (g) the(f) souls(fh) of(g)  the(ghg) Blessed,(f)  (f) who(f) fol-(df)low’d(f) the(gi) footsteps(ih)  (h) of(hgf) Christ(g)  their(ghg) Master:(f)  (f) and(df) since(fg) for(f) love(hij) of(ih) him(gf) they(g)  (i)  (h)  forth(fg) their(ghg) life-(f)blood,(f) therefore(f)  (gh) with(h) Christido(idih)  (ddd)  (gdf)  (d)  (dd)  they(h) ex-(hg)ult(g) for(ghg) ev-(f)er.(f) B(h)  (f) B(dgh) e(gddfddd) ",
        groupIndex: 1,
        filename: "./pages/part-b-174.png",
        nextFileName: "./pages/part-b-175.png",
    },
    {
        title: "part-b-175-0",
        gabc: "Lord(f)  (fg) chose(gh) him(hg) For(g) a(f) priest(fh) un-(g)to(fd) himself.(fg)  (gf) The(f)  Lord.(ik)  (fg) To(h) of-(hi)fer(h) un-(fh)to(g) him(g) the(g) sacrifice(h)  (g)  (f) of(fh) praise.(dhg)  For(g) a(f) priest.(gh) Glory(h)  (h) be(h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) The(f) Lord.(fg) ",
        groupIndex: 0,
        filename: "./pages/part-b-175.png",
        nextFileName: "./pages/part-b-176.png",
    },
    {
        title: "part-b-175-1",
        gabc: "The(f) Lord(f) chose(g) him(f) for(f) a(f) priest(f) a(e) unto(g) himself,(g) v(h) *Al-(h)le(hg)  lu-(g)ia,(f) al-(d)le-(fg)1(gf) ia.(f) The(f) Lord.(f) To(f) offer(g)  (f) e(f) untohim(f)  (f) the(f)  L(f)  (e)  (g) of(g) praise.(h) Al-(h)le-(hg)lu-(g)ia.(f) ¥.(c) Glory(f)  (f) be(f) to(f) [(e)  Father(g)  (h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g) Ho-(h)ly(g) Ghost.(gf) B.The(f) Lord.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-175.png",
        nextFileName: "./pages/part-b-176.png",
    },
    {
        title: "part-b-176-0",
        gabc: "——(ghg)  (e)  (f) T(g)  (g)  (h)  (f)  (h) e(j)  (ih)  (g)  (j)  £(h)  (j)  (ih)  (g)  (h)  (g)  (e) .(f)  (g)  (g) 0(g)  (e)  (g)  For(ki~)  (fe)  (dc)  (c)  (d)  (e) a(f) Doctor(fgh) —————————ha(h)  (f)  (h)  (ijh) viij(i)  (h)  (g) &#39;(g)  A(ghg)  (e)  (f)  (ed) L}(de)  (c) .(e)  (g)  (h)  (h) [(g)  (ghg)  (e)  a(f)  (ed)  (de)  (c) [(e)  (g) .(h)  (h)  (g) i(jj)  (h)  (j) |(ih)  7(ik)  (gf)  (j)  (h) &quot;(j)  (i) a(h)  (g) .(hih) an.(gg) .(e) Tarwel(f)  (g) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-176.png",
        nextFileName: "./pages/part-b-177.png",
    },
    {
        title: "part-b-176-1",
        gabc: "()(dd) a(c) Priest(d) and(f) Bishop!(d) B(dfddc) Tthou(fg) worker(h)  (g) of(f) .(gh) mighty(gf)  (d)  works,(f) thou(h) good(g) shepherd(h)  (g) of(ef) the(f) people,(g)  (dddgdfeddd) pray(d)  (ffdgdddfdefddf) i(fdefdf)  Lord(ki~)  (d) for(cd) us.P.T.(d) Al-(e)le=(fe) lu-(dd) (dd) ia.(d) -(ddddd) (ddhddg) i(fd)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-176.png",
        nextFileName: "./pages/part-b-177.png",
    },
    {
        title: "part-b-177-0",
        gabc: "Teacher(h)  (g) right(fg) .(gf) ex—cellent,(ef)  (f) 0(f) light(g) of(hf) Ho-(g)1y(f) Church,(e)  0(g)  (f) blessed(cf)  (f) N.,*(jghijijkj) lover(j)  (i) of(h) the(hg) divine(fh)  (hhg) law:(e) in-(ehh) tercede(f)  (gf) for(def) us(fec) un-(f)to(e) the(f) Son(hg) of(eg) God.(f) Al-(g)le(hg)  Jp-(f)ia.(f) Names(h) i(gf) of(hg) the(e) |(f)  [EEmaa(gi) An-(gh)brose(jijijkj) A-(g)tha(f) Ot(g) si-(h)s(ijijkj) Gre-(g)go-(h)el(ijijkj)  John(gi)  (gf) Chrysostom(g)  (h) e(kijijkj)  Al-(g) (f)  (c) phon-(cgh)sus(ijijkj)  (fg)  Bo-(g)na-(f)ven-(f)tu-(gh)ra(kjijijkj)  ](gh) £3(kijijkj) (T(gh) 0(kijijkj) 0(f) R(cf) AR(gh) Bede(kjijijkj) ",
        groupIndex: 0,
        filename: "./pages/part-b-177.png",
        nextFileName: "./pages/part-b-178.png",
    },
    {
        title: "part-b-178-0",
        gabc: "B(i) hold(i) a(g) great(hj) A(i) who(ig) in(h) his(g) n-(e)pleaseq(h)  (fh)  :(e) was(f) found(fg) righteous.(e)  (e) Al-(gf~)le-(f)lu-(e)ia.(e)  (j)  (i)  (h)  (fh) ",
        groupIndex: 0,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png",
    },
    {
        title: "part-b-178-1",
        gabc: "here(ig) was(j) none(i) Tlike(ig) un-(h)to(g) him,(e) who(h) kept(h) the(fh) law(gf) of(e)  the(f) Most(gf) High.(e) Al-(gf~)le-(f)lu-(e)ia.(e) |(j)  (i)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png",
    },
    {
        title: "part-b-178-2",
        gabc: "The(fg) Lord,(g) therefore,(h)  (j) sur-(j)ed(h) him(h) by(i) an(h) oath(g) that(g)  he(i) would(j) bless(h) the(g) na-(fh)tions(fed) in(ef) hisTseed.(gh)  (g) p.(ef)  (d) fseed(gfd)  al(f) le-(fg)lu-(g)ia.(g) :(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 2,
        filename: "./pages/part-b-178.png",
        nextFileName: "./pages/part-b-179.png",
    },
    {
        title: "part-b-179-0",
        gabc: "/O(i) ye(g) priests(i) of(j) God,¥(i) bless(ig) ye(h) the(g) Lord:(e) O(e) ye(f) ser-(h) ats(h) of(g) the(f) Lord,f(f) sing(hij) a(i) hymn(h) unto(h)  (hg) God,(f) al-(g)le-(fg)lu-(e)ia.(e)  sing(h)  (i) a(i) hymn(hg) un-(fg)to(fe) God.(e) |(i) e(j) i(i)  (h) 2(gh)  and(g)  (h) faithful(ghj)  (ji) servant,(hh)  (g) en-(h)ter(hj) thou(h) in-(g)to(h) the(g) joy(gf)  of(f) thyTLord.(gf)  (e) Lord,(eef) al-(g)le(gf) —lu-(e)ia.(e) e(ji)  (hi) e(h) B(g) |(efghi) ",
        groupIndex: 0,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png",
    },
    {
        title: "part-b-179-1",
        gabc: "(Good(g) and(hj) faithful(j)  (hi) servant‘,T(h)  (g) en-(gi)ter(hg) a(e) in-(fg)to(g) the(g)  joy(hf) of(g) 3(gf) Lord.(e) p.T.T&quot;Lord,(ef) M(g) le(gf) lu-(e)ia.(e) il(h)  (f)  (h) @S(g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png",
    },
    {
        title: "part-b-179-2",
        gabc: "T&#39;]~(ik)  (f) -(fg)—(g) S(gh) Wt(hg) *(d) And(fd) T(d)  (fg)  (g) Tt(f)  (d) him.(f) e(f) Lord.(fg) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-b-179.png",
        nextFileName: "./pages/part-b-180.png",
    },
    {
        title: "part-b-180-0",
        gabc: "lle(h) clothed(hi) a_(g) him(g) with(h) a(g) robe(g) of(f) glory.(gh)  (hg) Apq(fd) 143(fg)  (g)  (f)  X.(c) Glory(h)  (h) be.(h) The(f) Lord.(fg) ",
        groupIndex: 0,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png",
    },
    {
        title: "part-b-180-1",
        gabc: "T(ik) he(f) Lord(f) lov-(g)ed(f) him(f) and(f) a-(e)dorned(g) him,(h) Al(h)  (hg)  (g)  (f)  al-(ki) (d) le-(fg)lu-(gf)ia.(f) The(f) Lord.(f) He(f) clothed(g)  (f) him(f) with(f) a(f)  robe(ki~)  (f) of(e) glory.(g)  (h) Al-(h)le(hg) lu-(g)ia.(f) Clory(f)  (f) be.(f) The(f)  Lord.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png",
    },
    {
        title: "part-b-180-2",
        gabc: "&quot;(f)  (ffe)  (d) [(e) L](g) se———mmmee(h) R(f)  (e)  (g) 0(h)  (g)  (hjji)  a(g) a4(g)  (f)  (gh)  (h) —(h)  (g)  (hjji)  (gf)  (h)  (dh)   (dffe)  (ed)  (c)  (eg)  (gf)  (gf)  (g)  (fe)  (d)  (dded) ",
        groupIndex: 2,
        filename: "./pages/part-b-180.png",
        nextFileName: "./pages/part-b-181.png",
    },
    {
        title: "part-b-181-0",
        gabc: ".(d)  a(e) .(e)  (e)  (efe)  (ec)  (d)  (e)  (f)  (hg)  (f)  (e)  ](f)  (e)  (ec) .-(d) (e) ](e)  (ehg)  (hi)  (i) -(iji) (h)  (g)  (fge)  &amp;(e) Lord(e) guided(e) the(efe)  (ec) righteous(d) in(e)  &amp;(d) ",
        groupIndex: 0,
        filename: "./pages/part-b-181.png",
        nextFileName: "./pages/part-b-182.png",
    },
    {
        title: "part-b-181-1",
        gabc: "Well(ki~)  (defe) done,(d) good(d) al;ld(c) faithful(d)  (f) ser-(dfc)vant:(c) thou(fh) hast(gh)  |(i) =(fg) A(h) faithful(fgf) o(g) ver(dfg) a(f) (2(dedc) «-(c)a(c) will(d) make(f)  thee(f) ruler(f) ](e) o(d) ver(c) ma-(f)ny(f) things,(f) saith(g) the+(fe) Lord.(d)  (efh)  *Lord,(dc) al-(d)le(efe) lu-(d)ia.(d)  (h)  (g)  (f)  (g)  (dgfed)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-181.png",
        nextFileName: "./pages/part-b-182.png",
    },
    {
        title: "part-b-182-0",
        gabc: "T(c) &amp;(c) Lord(df) lov-(f)ed(fe) T(dc)  (f) tand(f) a-(gh) (hg) dorned(fg) him;(gfd) he(g)  (h)  (g)  him(f) 5(f) a(e) robe(d) of(f) (4(edc) LE(c) and(cd) at(f) a(fe) gates(d) iof(dc) pa?E(f)  :(fh) dise(hghihgg) he(f) __l_l_-(g)crowned(fe) him.(d) him,(dc) mi(d) al~le-(efe)]u..ia_(d)  (d)  ;(h) A(g)  (f)  (g)  (gfedf) ",
        groupIndex: 0,
        filename: "./pages/part-b-182.png",
        nextFileName: "./pages/part-b-183.png",
    },
    {
        title: "part-b-182-1",
        gabc: "he(f) mouth(g) of(f) the(f) righteous(gh)  (hg) Is(fg) ex-(h)er-(g)ci-(fd)sed(f) in(g)  wisdom.(g)  (f) The(f) mouth.(g) And(h) his(h) tongue(hhi) will(h) be(h) talk-(gh) ing(g) of(f) judgment.(gh)  (hg) Is(fg) ex-(h)er-(g)cis(fd) ed.(f) Glory“bfff(dhddhd)  (h)  (d) I(d)  The(f) mouth.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-182.png",
        nextFileName: "./pages/part-b-183.png",
    },
    {
        title: "part-b-183-0",
        gabc: "he(f) mouth(f) of(f) the(f) righteous(g)  (f) is’(f) ex-(f)er-(f)cis-(f)ed(f) in(e) wisdom,”(g)  (h)  (h)  al-(h) (hg)  (g)  (f)  (d) le-(fg)lu-(dgf)ia.(f)  (efhfgh) The(f) mouth.(f) ¥.(efghih)  (c) And(f) his(f)  tongue(g) will(f) be(f) talking(f)  (f) of(e) judgment.(g)  (h) Al-(h)le-(hg)lu-(g)ia.(f)  (f)  Y.(c) Glory(f)  (f) be.(f) B/(fh) The(f) mouth.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-183.png",
        nextFileName: "./pages/part-b-184.png",
    },
    {
        title: "part-b-183-1",
        gabc: "-(f) (e)  (fh)  (hg)  (fg) e(f)  (f)  (e) e(f)  (h) L6(h) L(ih)  (i)  -(gi) (j)  (ih)  (i) ‘(h)  (g)  (f)  (g)  (f)  (e)  (eh)  (hhg)  (f)  (e)  G(gi)  (h) =(h) ](i) r(j)  (i)  (h) “__I(g)  (f)  (h)  (h)  (g)  (h) I(fe)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-183.png",
        nextFileName: "./pages/part-b-184.png",
    },
    {
        title: "part-b-184-0",
        gabc: "I&#39;(c) will(c) liken(d)  (d)  (fdefec) a(f)  (h)  (g) wise(ig) man,(hih) whi(hg) .(ef)  house(fe) a(c) on(eg) a(fe) rock.(d) u(dc) al-(d)le(efe) Ju-(d)jq,(d)  (hgf)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png",
    },
    {
        title: "part-b-184-1",
        gabc: "ord,(f) thou(h) de-(h)liv-(h)er-(g)edst(hg) Tun-(e)to(f) me(g) five(fe) talents:(d)  (d)  behold,”(f)  (ffdeefec) I(f) gained(h)  (g) beside(g)  (fggh) them(hg) five(ef) talents(g)  (ef)  T(d) e(dc) v(d) B(efe) lu-(d)ia.(d) |(h) v(g)  (f)  (h) ||(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png",
    },
    {
        title: "part-b-184-2",
        gabc: "ell(d) done,(dc) thou(f) good(g) —1——E.—\\____—————(fh) servant,t(h) in(g) little(i)  (h)  (d)  (gd) d(dg)  .(fh) faithful,(g) en-(gg)ter(e) thou(g) 4(h) to(g) the(f) v(f) of(dg)  (fd~) th(hdefddf) thy&#39;:¢%™(fddd)  (dfd~dd) ia(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-184.png",
        nextFileName: "./pages/part-b-185.png",
    },
    {
        title: "part-b-185-0",
        gabc: "ord,(dc) al-(d)le-(efe)lu-(d)ia,(d)  (h)  (g)  (f) iij(gh)  (gf)  A(g) wise(g) and(h) faithful(j)  (h) servant,(j)  (i) whom(g) the(h) Lord(h) hath(h)  made(h) tu-(ih)ler(g) o-(g)ver(gh) all(hgf) o(gf) hisf&#39;household.(e)  (e) a(c)  (e)  )(ef)  (g) ML(gf) i(e)  (e) P(j)  (h)  (j) PR(ih)  lessed(e)  (e) is(f) that(ge)  (f) servant(e) whom(e) his(ei) Lord,(i) when(h) he(f)  cometh(h)  (g) and(h) knocketh(iji)  (hf) at(hi) the(g) door,(ef) shall(gh) find(ihf) watching..(e)  Al(f) -(f)1lu-(e)ia,(e)  (j)  (i)  (h)  (gf)  ood(g) and(h) faithful(ih) Bttt(f) Sk(h) servant,+(g)  (d) i,(i) alds(h) oo(f) e(h) to(h) the(h)  3%(gf) of(ef) :(gf) Lord.(dedd)  (dd) P.T.(d) I(d) Al-(gfdf)lu-(e)ia.(h)  (e) BV(j)  (di) WY(h) i(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-185.png",
        nextFileName: "./pages/part-b-186.png",
    },
    {
        title: "part-b-186-0",
        gabc: "a(g)  (g)  (f)  (e)  (d)  (fhg)  (fg)  (g)  (fg)  (hjji)  (h)  a(h)  [T(ig)  (h) et(g)  (f) e(g)  (g) b(f)  (g)  (h)  (j)  (g)  Hymn(h) Melody(h) wa(ghg) a(e) Doctor(f) as(hg) on(fg) page(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-186.png",
        nextFileName: "./pages/part-b-187.png",
    },
    {
        title: "part-b-186-1",
        gabc: "ale,(eefed) d(ed) good(g) and(f) faithful(gh)  (gf) R-(e)8-(e)thou(d) hast(e)  been(ffg) faithful(gh) 0(g) o-(def)ver(g) a(gf) few(e) things,(e) I(d) will(e) make(fgh) thee(fg)  ruler(g)  (g) o-(gh)ver(g) ma(hiji) ny(hg) things:(g) en(ggh) ter(hi) thou(ddgdd) t0(deffddfgddffg)  Jjoy(ik)  (fe) of(dg) .(gf) R(c)  (e) ’Tl,ord,‘(ef) Bl(fg) ia.(fgdffddeffffeffddfefhfg) .(hfih)  (geffef) ",
        groupIndex: 1,
        filename: "./pages/part-b-186.png",
        nextFileName: "./pages/part-b-187.png",
    },
    {
        title: "part-b-187-0",
        gabc: "E(e) world,(eh) and(f) all(f) things(ed) earthly,(def)  (e) t(fgh) this(e) man(g)  (h) despised,(i)  (h)  ¢riumphant:(fh)  (h)  (d)  (g) he(i) laid(i) up(i) treasures(i)  (g) in(h) hea(iji) ven(dfhghih) by(dfe)  (f)  and(cdgf) deed.(e) i(efg)  (ef) Al-(gf)le-(f)lu-(e)ia.(e) |(f)  (fghi) T(h)  (g) e(h)  (f) T(e) |(efghi) ",
        groupIndex: 0,
        filename: "./pages/part-b-187.png",
        nextFileName: "./pages/part-b-188.png",
    },
    {
        title: "part-b-187-1",
        gabc: "od(fg) shall(f) help(gh) zer(hg) his(efd)  (fg)  (g) countenance.(f)  (f) God(efgde)  (fg) shall(f)  help.(fgh) W,(fggh) God(hi) is(h) in(h) the(h) midst(fgh) of(g) her,(g) therefore(h)  (g) shall(g)  she(g) &amp;(g) L(g) re-(f) (gh) ISR(fhg) |(fghi)  (dfghi) With(fd) BTNV(fg) e(g) TRV(f)  (f) |(fghief)  T,(c)  (f)  (h) ry(h) be.(h) B.(f)  (f) God(fg) shall(f) help.(gh)  (efg) ",
        groupIndex: 1,
        filename: "./pages/part-b-187.png",
        nextFileName: "./pages/part-b-188.png",
    },
    {
        title: "part-b-188-0",
        gabc: "(0d(f) shallhelp(f)  (g) her(f) with(f) L(e) L](g) &quot;(g) countenance,(h) .(h) Q(h) Wy(e)  al-(d)le-(fg)lu-(gf)ia.(f) God(f) shall(f) help.(g) ¥,(h)  (c) Gogd(f) is(f) in(f) the(f) m§&#39;d(g)  of(f) her,(f) therefore(f)  (f) shall(f) she(f) not(g) be(f) a(e) mo-(g)ved,(h) 4(h)  lu-(g)ia.(f) V.(c) Glory(f) be(f)  (f) to(f) the(e) Father(g)  (h) and(h) to(hi) the(h) Son,(h)  and(h) to(h) the(g) Ho(h) ly(g) Ghost.(gf) God(f) shall(f) help.(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-188.png",
        nextFileName: "./pages/part-b-189.png",
    },
    {
        title: "part-b-188-1",
        gabc: "thou(i)  (g) Bride(i) of(j) e(i) ](g) receive(h) a(g) a.(e)  (f)  which(h) the(fh) Lord(g) hath(f) prepared(e)  (f)  (f) for(d)  (df)  (d)  (d) thee(ddh)  (d)  (g)  (chd~ed)  (dde)  (d)  =“ev-(e)er,(ef) al-(g)le-(f)L(e) (](dded)  (d) ,(djdddi)  (d)  (h)  (dghd)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-b-188.png",
        nextFileName: "./pages/part-b-189.png",
    },
    {
        title: "part-b-189-0",
        gabc: "0(ig~)  (f) ve(f) wise(ef) O(ih) a(i)  (j)  (i) -(h)and(i) trim(j) your(fhi) lamps:(i)  (f)  for(i) behold(i)  (f) the(i) Bridegroom(g)  (h) cometh;(fe)  (fe) go(d) ye(e) out(f) to(h)  meet(f) him.(f) Al-(de)le-(fgh)lu-(f)ia.(f) |(ghi) T(ih) e(i)  (j)  (h) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-189.png",
        nextFileName: "./pages/part-b-190.png",
    },
    {
        title: "part-b-189-1",
        gabc: "This(c)  (c)  (d) is(d)  (dc) wise(fg) Virgin,(fh)  (hggf) and(fh) one(hgfg) of(d) the(f) number(f)  (g) L](e)  th*&#39;(fe)  (d) pPrudent.(ddh) N(d) e(c) isiiing(d) ooy(dc) =(d) o(efe) R(d)  (d) |(egh) N(hg)  (f)  (fgh)  (gf)  (efg) ",
        groupIndex: 1,
        filename: "./pages/part-b-189.png",
        nextFileName: "./pages/part-b-190.png",
    },
    {
        title: "part-b-190-0",
        gabc: "T(c) his(dd) is(c) &#39;a(d) wise(fe) Virgin,T(d) (](dc) whom(fh) the(g) Lord(hdfhghihgg) hath(e)  (fg)  fwatching.(d) —(d) T(d) ing,(dc) al-(d) (efe) lu-(d)ia,(d) |(h) &quot;|(g)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png",
    },
    {
        title: "part-b-190-1",
        gabc: "is(cc)  (ff)  (ef)  (dg) the(g) barren(jh)  (j) is(j)  (i) un-(h)de-(h)fi-(gi)led;(h) she(h)  shall(g) have(g) :(fg) in(g) i(e) vi-(gf)si-(e)ta-(fe)tion(d) of(ef) ho-(g) (gf) lylsoyls,(e)  p.7}souls,(c)  (ef) al-(g)le-(gf)lu-(e)ia.(e) |(ji) R(hi) T(h) S|(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png",
    },
    {
        title: "part-b-190-2",
        gabc: "Come,(d) D(cd) thou(f) my(g) chosen(f)  (fgh) one,(h) and(gh) Iwill(h)  (g) a(e) my(f)  throne(g) with-(fe)in(d) ee,(dc) al(d) ~le-(efe)=(d) ia.(d) 1(d) ;(d)  (d)  ‘(d)  Fwithin(fe)  (dd) thee.(dddd) |(d)  (jfghdd)  (dddh) e(dgddfddghd) ",
        groupIndex: 2,
        filename: "./pages/part-b-190.png",
        nextFileName: "./pages/part-b-191.png",
    },
    {
        title: "part-b-191-0",
        gabc: "This(g) w_,mn‘l&#39;(hj)  (j) is(j) TR(h) beautiful(hji) a-(g) (g) mong(hj) the(j) e(j) i(j) B(h) e(c)  (hgf)  p.THe-(chgf)ru-(g)sa-(gf)lém,(ed) al(ef) -(fg)lu-(e)ia.(e)  (f)  (j) l(h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png",
    },
    {
        title: "part-b-191-1",
        gabc: "I(f) thy(fh) grace(hg) And(h) in(gfd) thy(fg) beauty.(g)  (f) In(f) thy(gh) grace.(hg)  f.(c) Go(h) forth,(hi) ride(h) prosp’&#39;rously,(gh)  (g) and(f)  (fh) reign.(hg) And(h) 1in(gfd)  thy(i)  (fg) beauty.(g)  (f) Glory(h)  (h) be(h) to(h) the(h) Father(ihi)  (h) and(h) to(gh) the(g) Son,(g)  and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) B2(h) In(f) thy(gh) grace.(hg) ",
        groupIndex: 1,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png",
    },
    {
        title: "part-b-191-2",
        gabc: "In(f) thy(f) grace(g) and(f) in(f) -(e)beauty,(g)  (h) Al-(h)le(hg) ia,(f) al-(d)le-(fg) lu-(gf)ia.(f) 1In(f) thy(f) grace.(g) Go(f) =(g) ride(f) prosp’(f) 0(e) rously,(g)  and(g) E(h) i(eh) iuern(h) Al-(f)le~(hg) lu-(g)ia.(f) .(c) |(f) e(f) |(f)  (f) In(f) thy(f) SRS(g) ",
        groupIndex: 2,
        filename: "./pages/part-b-191.png",
        nextFileName: "./pages/part-b-192.png",
    },
    {
        title: "part-b-192-0",
        gabc: "ﬁ—.—&#39;—&#39;——’—\\(g)  (hi)  (j)  (ih)  (g)  (h)  (f)  (g)  (i)  (j)  ——__—_—__NQ](i)  (k)  (ih)  (f) |(g)  (h) [}(f)  (g)  (e)  (f)  Y.(ed) .(c) 8(g) are(hi) thy(j) lips.(ih)  (g)  (h)  (f)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-192.png",
        nextFileName: "./pages/part-b-193.png",
    },
    {
        title: "part-b-192-1",
        gabc: "lLe(g) kingdom(g)  (k) of(k) heav’n(hj) v(ih) e(g) e(g)  (g) un-(g)to(k) a(j) mer-(j) chantman(jh)  (i) [T(hg) seeking(h) 1(jh) i(ih) pearls;(g) who,(gd) when(g) he(f) had(h)  found(hj) one(ihj) pearl(j) of(j) great(jh) price,(g) went(g) and(g) sold(kjh) all(ij)  a(h) he(g) had,(h)  (ijh) and(hi) bought(g) it,(g) Al-(hi)le-(h)lu-(g)ia.(g)  n(j)  ¥(k) *}Y.(k)  (j) The(ik) ",
        groupIndex: 1,
        filename: "./pages/part-b-192.png",
        nextFileName: "./pages/part-b-193.png",
    },
    {
        title: "part-b-193-0",
        gabc: "](g) theirs(gj) is(h) the(g) kingdom(h) ](g) of(f) heaven,T(gh)  (g) who(h) despised(j)  (j)  worldly(h)  (j) living:(ij)  (j) who(i) have(j) won(k) the(j) rewards(i)  (j) of(h) the(g) king-(h) d°m,.(ghihgg) a(e) bave(f) washed(g)  (h) their(gf) B(efd) in(g) the(h) blood(gijh) of(i)  the(h) aL(g) =(ddghd) 5(i) le-(h)G|(g)  (g) |(j) SNt(i)  (j)  (h) |(g) ",
        groupIndex: 0,
        filename: "./pages/part-b-193.png",
        nextFileName: "./pages/part-b-194.png",
    },
    {
        title: "part-b-194-0",
        gabc: "While(gj) the(hghj)  (j) tsitteth(i)  (j) at(k) his(ji) table,(h)  (g) my(gh)  (j) .(i)  [(g) sendeth(i) forth(hg) a(def) sweet-(gf) (gh) e(gf) smelllngTsavour.(e)  (e) y(e)  (ef)  al-(g)p(gf) lu-(e)ia.(e) R(j)  (h) )(j) el(ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png",
    },
    {
        title: "part-b-194-1",
        gabc: "We(c)  (e) will(f) run(h) after(h)  (j) theel(i) because(i)  (i) of(h) the(i) savour(j)  (i) of(h) thine(hj)  ointments:(gi)  (gh)  (f) ex(gihg) O(f) ceedingly(e) L(fe) do(d) the(e) i(f) virgins(h) love(f) thee.(f)  Al-(de)le-(fh)1lu-(f)ia.(f) T(i)  (h)  (i) ;(j)  (h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png",
    },
    {
        title: "part-b-194-2",
        gabc: "-(gj)the(h) winter(h)  (fgf) is(gh) past,(g) the(g) rain(if) is(j) o-(dk)ver(j) and(hj) O™(i)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-b-194.png",
        nextFileName: "./pages/part-b-195.png",
    },
    {
        title: "part-b-195-0",
        gabc: "UP(i) myFlovs(j) ,(hgf) and(f) comeT(hjh) a-(ih)way.(g) a-(ih)way,(gfd)   (ef)  (fg)  (g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png",
    },
    {
        title: "part-b-195-1",
        gabc: "C(ki~) one.,(d)  (dc) thou(f) my(g) chosen(f)  (fgh) one,T(h) and(h) I(h) will(g) set(e) my(f) throne(g)  tyithin(fe)  (d) thee,(dc) al-(d)le-(efe)lu-(d)a.(d) After(dfe)  “in(ik)  (d) thee.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png",
    },
    {
        title: "part-b-195-2",
        gabc: "This(c)  (g) wo-(ghj)man(j) ig(j)  (h) beautiful(hji)  (g) a-(g)mong(hj) the(j) daughters(j)  (hij) of(h)  &quot;Je(hgf) -(g)-(gf)lem.(e) P.T.TJe(hgf) ru-(g)sa-(gf)Yem,(ed) al(ef) le-(fg) lus(e) g,(e)  (dd)  (d)  (djd)  (dh)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-b-195.png",
        nextFileName: "./pages/part-b-196.png",
    },
    {
        title: "part-b-196-0",
        gabc: "a(f)  (h)  (hg)  (i)  (hf) &quot;(g)  (i)  (h) %(h)  (f) ‘(g)  [(ig~)  (h)  (h)  (f)  (g)  (f) %(f)  (h)  (hg)  (i)  ¥.(hgi) Full(g) [(i) 5(h) are(h) thy(f) _—_—:MI(g) lips.(h)  (gh)  (f)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png",
    },
    {
        title: "part-b-196-1",
        gabc: "ive(hg) her(f) of(h) the(hi) fruit(ij) of(h) her(hf) hands;(g) and(i) let(hg) .(e)  (f)  works(ed) praise(f) her(f) S(hf~) the(g) e(e) le-(gf)Y|(f) ia.(e)  (j) ’(ihih) ",
        groupIndex: 1,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png",
    },
    {
        title: "part-b-196-2",
        gabc: "Sh::(c) stretcheth(cdf)  (f) outT(d)  (f) her(dfd) hand(dfg)  (dd) to(dfe) the(fde) poor;(e) Yea,(dhi) she(h) ",
        groupIndex: 2,
        filename: "./pages/part-b-196.png",
        nextFileName: "./pages/part-b-197.png",
    },
    {
        title: "part-b-197-0",
        gabc: "forth(fg) her(dc) hands(c)  (fd) to(f) the(fe) needy;(de)  (e) she(f) eateth(efg)  (gd)  ot(d) the(dg) bread(gf) of(ghg) gt(e) g(e) st(e) |(e)  (e) al-(cef) (g) le-(gf) 1u—ia.(e)  (e)  (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-197.png",
        nextFileName: "./pages/part-b-198.png",
    },
    {
        title: "part-b-197-1",
        gabc: "This(fg) place(g) is(f) ho-(h)ly(hg) Wherein(fgh)  (g) the(fd) priest(fg) &quot;=(g) prayeth.This(f)  (fg)  place.(g) ¥.(c) For(h) the(h) sins(hi) and(h) e(h) offences(gh)  (g) of(g) the(f) people.(gh)  (hg)  Wherein,(fgh)  (g) Glory(h) be(h)  (h) to(h) the(h) Father(hi)  (h) and(h) to(gh) the(g) Son,(g)  *d(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) This(fg) place.(g) ",
        groupIndex: 1,
        filename: "./pages/part-b-197.png",
        nextFileName: "./pages/part-b-198.png",
    },
    {
        title: "part-b-198-0",
        gabc: "This(c)  (f) place(f) is(f) ho-(g)ly,(f) wherein(f)  (f) -(e)a(g) pr&amp;\\)’eth(g) i(h)  le(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) This(f) place,(f) Fok(f) f\\(f)  sins(f) and(f) of-(f)a(g) fences(f) of(f) a(e) a-(g)people.(h) Al-(h)le.(hg) ],(g) ;(f)  Glory(f)  (f) be(f) to(f) the(e) ](g) Father(h) and(h) to(hi) the(h) Son,(h) and(h) to(h) the(g)  Ho-(h)ly(g) Ghost.(gf) This(f) place.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-198.png",
        nextFileName: "./pages/part-b-199.png",
    },
    {
        title: "part-b-198-1",
        gabc: ":—_h(j)  (j)  (j)  (ih)  (i)  (j)  (j)  (f)  (h)  (i)  (g) }(h)  (f)  (e)  (f)  Tt(h)  (f)  (g)  (h)  (i)  (j)  (ihg)  (f)  (g) :(h)  (g)  (f)  (g)  (f) |(e)  L}(c)  (ef)  (f) R(fe)  (h) e(i)  (i) T(h) e(j)  (i) R(hg)  (hihg) T(f) ..(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-b-198.png",
        nextFileName: "./pages/part-b-199.png",
    },
    {
        title: "part-b-199-0",
        gabc: "Tord(e) path(cd) hal-(dhi)low-(h)ed(g) This(ef) ta-(g)ber-(fe)na-(d)cle:(d) for(d) this(df)  %(c) “:3(dc) hoiuse(f) of(g) the(fh) Lord,(h) wherein(h)  (fgh) men(j) may(i) call(g) up-(h) on(j) his(i) Name;(h) whereof(hg)  (eef) it(g) is(fe) written,(d)  (d) My(dde) Name(c) shall(e)  pe(g) therein,(f)  (ef) saith(g) 5(fe) thelLord.(d) P.T.*Lord,(dc) al-(d)le(efe) -(d)ia.(d)  :(h)  (g)  (f) at(gh)  (g)  1(e) li-(f)ness(h) becometh(h)  (ij) t(i) thine(fi) house,(hg) O(ef) Lord,(f) for(hg) ev-(e)er.(e)  Al-(gf~)le-(f)lu-(e)ia.(e)  (j)  (i)  (h) -(gf) house(cf)  (c)  (cd)  (dfg) 1&#39;shall(gh) Ee(gf) call-(fghg)ed(f) the(ef) house-(g) (fe) of’prayer.(d)  Prayer,(dfd~fddfhddhdffdefcffdfdfddf) al-(fddd)le(defefdd) lu-(d)ia.(d)  (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-b-199.png",
        nextFileName: "./pages/part-b-200.png",
    },
    {
        title: "part-b-200-0",
        gabc: "tis(dc) is(f) the(g) Lord’s(fh) house,(h) firmly(h)  (gf) buildeq:(g)  (d) 1(c) i(d)  founded(hg)  (g) 5(e) the(f) sol-(g) (fe) idfrock.(c)  (d) al&lt;]e(dc)  (d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png",
    },
    {
        title: "part-b-200-1",
        gabc: "Well(ikc)  (c)  (ji) founded(hg)  (g) Tis(g) the(e) Lord’s(f) house(d) on(e) the(f) solid*mck_(h)  (h)  (g)  rock,(ik)  (gfd) al-(ef)le-(fg)lu-(g)ia.(g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png",
    },
    {
        title: "part-b-200-2",
        gabc: "Al(f) thy(e)  (fh) shall(e) be(f) stones(h) e(g) S(fgh) W(he) and(e) the(f)  tow’rs(hhi) of(h) Je-(h)ru-(i)sa-(hg)lem(fgh) shall(ef) be(h)  (g) upbuilded(ij)  (h) withtjends(g)  (f)  (f)  T(gi) Seter(f)  (fe) -(f)al-(ghg)lu-(f)ia.(f) s(h)  (g) e(e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-b-200.png",
        nextFileName: "./pages/part-b-201.png",
    },
    {
        title: "part-b-201-0",
        gabc: "i-(f)ness(f) becometh(f)  (h)  (hg) Thine(fgh) house,(gfd) 0(fg) Lord.(gf) Ho-(fg)li-(f)ness.(f)  7,(jk) For(g) ev-(h)er:(hg) Thine(fgh) house.(gfd) Glory(h)  (h) be.(h) Ho-(fg)li-(f) (f)  ev-(g) ness.(f) ",
        groupIndex: 0,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png",
    },
    {
        title: "part-b-201-1",
        gabc: "[(g) 1i-(f)ness(f)  (f) becometh(f)  (f) thine(e) house,(g) 0(g) Lord,(h) Al-(h)le-(hg) lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Ho-(g)li-(f)ness.(f) For(e) ev-(g)er.(h)  Al-(h)le-(hg)lu-(g)ia.(f) e(f) Glory(f) be.(f) Ho-(g)li-(f)ness.(f) ",
        groupIndex: 1,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png",
    },
    {
        title: "part-b-201-2",
        gabc: "i(e)  (ed)  (f)  (edc)  (d)  (dfd) T(e) o(e) 2T(ed) S(fgh) e(h) I(g) R(fe)  (de) |(e)  -(e) (h) —=(h)  (g) oot(hj)  (h) Y(gfe) T(e) e(ed) Pl(fgh) ST(h)  (g) o(fe) A(de) 0(e)  0(e)  (ed)  (f)  (edc)  (d) e(dfd)  (e)  (e)  (ed) R(ffh) M(h)  (g) AR(fe)  (de) |(e) ",
        groupIndex: 2,
        filename: "./pages/part-b-201.png",
        nextFileName: "./pages/part-b-202.png",
    },
    {
        title: "part-b-202-0",
        gabc: "_(gi)  (d)  (fe)  (e)  (f) q(hg)  (f)  (fe~) —ap.(eed)  (d) 0(f)  (hiij)  I(i) must(hg) &#39;a-(fe)bide(f) at(de) thy(fh) house:(gfe) and(d) he(fe) made(f) haste,(hg)  and(f) came(fe) down,(eed) and(d) received(f)  (h)  (g) him(hfi) joyfully(f)  (e)  (d) in-(e)¢q(f) his(f)  house,(g)  (e) This(d) day(de)  (j) is(df) v(hij) va-(hf)tion(fi) come(hge) e(f) this(fe) house(fh)  from(f) [(e) Lord,(fe) lal(d) le-(de)lu-(e)ia.(e) 1:fmn(f)  the(de) Lord.(e)  (h)  (g)  (h)  (f)  (efe) ",
        groupIndex: 0,
        filename: "./pages/part-b-202.png",
        nextFileName: "./pages/part-b-203.png",
    },
    {
        title: "part-b-202-1",
        gabc: "O(efd) 1&amp;%(dc) dreadful(gf~)  (g) Tis(d)  (fgf)  (f) this(dffdghg)  (f) place!(ddfdf)  (f)  (dd) truly(df)  (dfdffhf) this(hdfgdfdfdhf) is(fdi)  (dd) noﬂe(hdf) ",
        groupIndex: 1,
        filename: "./pages/part-b-202.png",
        nextFileName: "./pages/part-b-203.png",
    },
    {
        title: "part-b-203-0",
        gabc: "ther(f) put(f) the(f) house(g) of(f) God,(fhihghg) and(edf) the(dc) gate(ffhig) of(hg)  heaven-(f) (f) Leaven,(f)  (fg) al-(h)le-(g)lu-(f)ia.(f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-b-203.png",
        nextFileName: "./pages/part-b-204.png",
    },
    {
        title: "part-b-203-1",
        gabc: "0(d)  (hi)  (g)  (hi) 0(k)  (jihgh)  (h)  (h) -(de) (gf)  B(e) =(d) S=———(f) a(e)  (g)  (h) 5(h)  (defedc)  i(e) Vouchsafe(g) [(e)  (f) a(e) ;(d) ",
        groupIndex: 1,
        filename: "./pages/part-b-203.png",
        nextFileName: "./pages/part-b-204.png",
    },
    {
        title: "part-b-204-0",
        gabc: "a(ik)  (eg)  (ddc) 1y(de) a(e) L](e) help(gh) thou(hhg) the(ed) suf(e)  (gfe) fero(de)  (e)  then(gf) the(d) faint-(ef)hearted,(de)  (e) comfort(de)  (dc) th.e(c)  SOT(fe)  pray(dfhhg) for(gf) the(dc) peéople,(df)  (efed) entreat(d)  (dh) for(hih) the(gh) Clergy;(gf) ey(ed)  (d)  (f)  tercede(fh)  (h) for(g) all(gf) -(dc)man-(df)kind(efed) -(fhhgf)D-(g)un-(gfe)-(de)Codl(e)  ~(c) all(df) dc-(fd)L](ef) knowledge(g) a(g) help(gh) of(gf) thy(de) praye;;(dd) .(c)  who(d) ce(fe) le-(fg)a(gh) thy(gf) a(g) ly*(ghg) es~ti-(fe) (de) val.(e) P.T.Ffeq-(fe)|(d)  ti-(de)val,(ef) al-(g))(gf) lu-(e)ia.(e) e(h) l-(g)|(h) l_.&#39;_l(ih) _l(gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-b-204.png",
        nextFileName: "./pages/part-b-205.png",
    },
    {
        title: "part-b-204-1",
        gabc: "While(gj) the(hghj) King(j) Tsitteth(i)  (j) at(k) his(ji) table,(h)  (g) my(gh) spikenard(j) =(i)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-b-204.png",
        nextFileName: "./pages/part-b-205.png",
    },
    {
        title: "part-b-205-0",
        gabc: "¢h(i) forth(hg) a(ef) i(gf) i(gh) A(gf) smellingTsavour.(e)  (e) p.T.Fsavour,(e)  (def)  :i.a.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png",
    },
    {
        title: "part-b-205-1",
        gabc: "fis(f) left(ih) hand(i) Tis(hi) under(j)  (i) my(h) head,(i) and(ig) his(hg) right(fe) hand(ef)  doth(de) embrace(fh)  (f) me.(f) P.T..Al(ed) le(fh) -(f)ia.(f) ||(i) e(h)  (hj)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png",
    },
    {
        title: "part-b-205-2",
        gabc: "[(g) am(h) black,(j) but(h) comely,T(j)  (i) O(g) ye(h) daughters(h)  (h) of(h) Je-(h)ru-(i) sa-(h)lem;(g) therefore(g)  (h) the(i) King(i) delighteth(h)  (j)  (i) in(gh) me,(h) and(g)  T(e) brought(fe) me(d) in-(ef)e(g) W(fgf) hisTchambers.(e) T(e)  (h) 5(e)  (ef)  A-(dfgdf)le-(dfgdff) (d) 1y(de) e(e) ssruul(j)  (h)  (j) Ellrcin](ih) ",
        groupIndex: 2,
        filename: "./pages/part-b-205.png",
        nextFileName: "./pages/part-b-206.png",
    },
    {
        title: "part-c-000-0",
        gabc: "%(h) the(h) Father(ihi)  (h) and(h) to(gh) the(g) Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh)  Hail(f)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-000.png",
        nextFileName: "./pages/part-c-001.png",
    },
    {
        title: "part-c-000-1",
        gabc: "Heail,(f) Ma-(f)ry,(f) full(f) of(f) grace,(g) the(f) Lord(f) is(e) with(g) thee,(h)  Al-(h)le-(hg)lu-(g)ia,(f) al-(d)le-(fg)lu-(gf)ia.(f) Hail.(f) |(ghi) Blessed(f) e(f) art(f)  thou(f) a-(f)mong(f) R(g) men,(f) and(f) e(f) e(f) is(f) e(f) e(f) T(e) thy(g)  womb.(h) B,(h) Al-(hg)lu-(g)ia.(f) Glory(f)  (f) be(f) to(f) &quot;(e) Father(g)  (h) and(h)  to(hi) the(h) Son,(h) and(h) to(h) 5(g) Ho-(h)o(g) &lt;(gf) B(f) e(f) ",
        groupIndex: 1,
        filename: "./pages/part-c-000.png",
        nextFileName: "./pages/part-c-001.png",
    },
    {
        title: "part-c-001-0",
        gabc: "Hail(ik)  (c)  (c)  (f) Ma-(gh)ry,(f) full(fedc) of(fghi) erace,(h) The(hij) Lord(ihgfe) ig(gh)  (gf)  thee.(f) FHail.(f) Plessed(f)  (f) art(f) thou(g) a-(f)mong(f) Wo-(gh)nen(f)  (f)  blessed(g)  (f) is(f) the(f) fruit(fe) f(dc) thy(fghi) womb.(h) The(ihij) Lord,(i)  Glory(f) be(f)  (g) to(f) the(f) Father(gh)  (f) and(g) to(fe) jhe(dc) to(c)  (df) the(f)  Ho(ighhih) ly(gf) Ghost.(f) Mail.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-001.png",
        nextFileName: "./pages/part-c-002.png",
    },
    {
        title: "part-c-001-1",
        gabc: "a(g) 0(gfef) L}(dc)  (f) R(gi) -(ih) (g) :(h) i(j) o(jid)  (d)  (hdd)  (ihd)  (](g)  (hg)  (fg)  (g)  (gj)  (j)  (ji)  (j)  (jkj)  (idh)  (d)  (dgdfddhgfd)  V.(ih)  (ij) grace(h)  (ih)  (g) DR(hg)  (fg) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-001.png",
        nextFileName: "./pages/part-c-002.png",
    },
    {
        title: "part-c-002-0",
        gabc: ".(ki~) PBlessed(gj)  (h) art(g) thou,(h) 0(gf) Ma(gh) ry,(gh) for(g) thou(gf) hast(g) be(h) -(h) ljev-(h)ed:(jkj) and(h) there(i) shall(j) he(h) a(h) ](g) performance(h)  (g) in(fg) thee(g)  of(h) those(fe) things(d) which(e) were(f) told(gh) thee(h) from(g) the(fg) Lord,(gfd)  al-(ef)1le-(fg)lu-(g)1ia.(g) Tthee(h) from(h) the(fg)  Lord.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-002.png",
        nextFileName: "./pages/part-c-003.png",
    },
    {
        title: "part-c-002-1",
        gabc: "An(gj) ge-(h)ne-(g)-(h)ra-(g)shall(fg) call(g) me(gh) blessed:(f)  (f) for(fg) God(h)  “(ik) hath(g) re-(f)gard-(g)ed(h) the(j) T(jk) li-(j)i(jijkj) of(h) et(h) hand(fhij)  Tnaig(g) T(g) i(g) =(gh) .(i)  (ddh) o(dd) 1lu-(g)ia.(gd) |(dd)  (d)  (d) e(j) e(di)  (j)  (h) |(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-002.png",
        nextFileName: "./pages/part-c-003.png",
    },
    {
        title: "part-c-003-0",
        gabc: "()(hig~)  (f) blessed(f)  (h) Mother(f)  (e) Tand(ef) spotless(f)  (h) Vir-(hg)gin,(e) thou(ef) glo.(h)  |(hgi) ri-(g)ous(h) Queen(i) of(hg) the(fe) world,(f) in-(e)ter-(f)cede(hih) for(hg) us(fe) to(g)  the(hgi)  (hg) Lord.(f) B(h) i(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png",
    },
    {
        title: "part-c-003-1",
        gabc: ".M._ay(ig) all(hj) the(i) Saints(i)  (i) i_&#39;__|:__|(g) for(hg)  (f) us(f) to(g)  (fd)  (d)  (de) ‘(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png",
    },
    {
        title: "part-c-003-2",
        gabc: "ay(g) all(ef) the(fgh) Saints(g)  (j) Tin-(fhi)tercede(hj)  (i)  (hgdffgh) M’&quot;(fedddfddf)  (ddfef) ",
        groupIndex: 2,
        filename: "./pages/part-c-003.png",
        nextFileName: "./pages/part-c-004.png",
    },
    {
        title: "part-c-004-0",
        gabc: "Queen(i)  (dc)  (f) of(fg) hea(gff) en,T(dc) be(f) joyful,(ed)  (f) al-(g)le(fe) 1lu-(d)ia;(d) Pe-(d) -(ik) (dedc) .(c) whom(fe) T(fg) ](gff) e(dc) thou(f) R(ed) barest,(f) al-(g)i(fe) lu-(d)Y(d)  Hath(ik)  (h) a-(g)ris-(h)en,(h) as(j) he(ig) promis’d,(h)  (hih) al-(g)le-(gh)lu-(h)ia;(h) Pray(hgf)  :(ik) for(g) us(gh) to(fe) the(dc) —(f) l_—l_-(ef)al-(g)le(ef) lu-(d)ia.(d) l(fh)  (g) MY(f)  (gf) |(d) ",
        groupIndex: 0,
        filename: "./pages/part-c-004.png",
        nextFileName: "./pages/part-c-005.png",
    },
    {
        title: "part-c-005-0",
        gabc: "I(h) will(j) walkt(j) before(j)  (hi) the(h) Lord(g) ;(g) the(g) land(fg) of(gh)  living.(ki~)  (e)  (e) Psalm(j)  (h) 116(j)  (i) ",
        groupIndex: 0,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png",
    },
    {
        title: "part-c-005-1",
        gabc: "Woe(ig~cc)  (h) is(hg) me(f) that(fe) T(f) am(h) constrained(fg)  (e)  (e) to(gihji) dwell(h) with(ge)  Mesech.(gh)  (f) Psalm(h)  (g) 120(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png",
    },
    {
        title: "part-c-005-2",
        gabc: "he(h) Lord(fg)  (g) preserve(g)  (h) thee(g) from(g) all(hg) evil:(f)  (f) yea,(h)  it(j) is(id) e-(jk)ven(h) he(h) that(g) shall(f) keep(gh) thy(h) soul.(g)  (h) Psals(j)  (ij) 121(h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png",
    },
    {
        title: "part-c-005-3",
        gabc: "£(i) thou,(i) Lord,(i) wilt(h) w(g)  (h)  (i) Tto(i) mark(j) what(id) is(dd)  (dhddd) don®(hd)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-005.png",
        nextFileName: "./pages/part-c-006.png",
    },
    {
        title: "part-c-006-0",
        gabc: "a-(g)miss,(h) O(h) Lord,(ih) who(dfhf) may(g) a-(f)bide(e) it?(e) Psalm(j)  (i) 130.(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png",
    },
    {
        title: "part-c-006-1",
        gabc: "D(h) espise(h) not(h) then,(f) O(e) Lord,(f) the(h) works(hge) of(gfh) thine(i) own(hg)  hands.(f)  (i) Psalm(h)  (g) 138.(e)  (f)  I(h) heard(h) a(h) un-(i)to(h) »(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png",
    },
    {
        title: "part-c-006-2",
        gabc: "11(ighij) that(i) the(i) i(ij) Father!(i) e(i) giveth(hih) me(defghgh) shall(ffh) come(ghi) to(hg) me;(e) |(fi)  and(e) him(fh) that(h) cometh(h)  (gf) to(h) me,(g) I(e) will(f) in(f) no(hf) wise(g)  cast(f) out.(e)  (j)  (i)  (h)  (fgh)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-c-006.png",
        nextFileName: "./pages/part-c-007.png",
    },
    {
        title: "part-c-007-0",
        gabc: "God,(c)  (f)  (h) make(h) speed(hi) to(h) save(gh) me.(h)   (f)  (h)  (h)  (h)  (h)  (gh)  (h)  Glory(h)  (h) be(h) to(h) the(h) Father(h)  (h) and(h) to(h) the(h) Son,and(h)  (h) to(h) the(h) Ho-(gh)ly(h)  Ghost;(h) As(h) it(h) was(h) in(h) the(h)  (h) beginning,(h)  (h) is(h) now(h) and(h) ev(h) —er(h)  shall(h) be,(h) world(h) without(h)  (h) end.(gh) A—men.(h)  (h) tAl-(h)le-(i)1lu-(h)1ia.(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png",
    },
    {
        title: "part-c-007-1",
        gabc: "Praise(h) be(h) to(h) thee,(h) O(h) Lord,(h) King(h) of(h) e(h) —ternal(h)  (i) glory.(hg)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png",
    },
    {
        title: "part-c-007-2",
        gabc: " (h)  (h)  (h)  (g)  (f)  (h)  (h)  (h)  (h)  (h)  (h)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-007.png",
        nextFileName: "./pages/part-c-008.png",
    },
    {
        title: "part-c-008-0",
        gabc: "Al-(c) (f) le-(fdefe)M_ia,(d)  (c) al(f) -(g)1lu-(fg)ia.(f)  (h)  (f) Y(gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-008.png",
        nextFileName: "./pages/part-c-009.png",
    },
    {
        title: "part-c-008-1",
        gabc: "Al—le-(c) (eh)  (f) a(f)  (e) —lu-(d)a(efe) —ia,Tal—le—lu—ia,(de) -(e)&gt;(g) al&quot;le&quot;l“~\\ia;(h) a(i)  (f)  Al(h) le(h) 1(hih) ia,(g) al(f) le(gh) lu(ef) ia,(e) al(e) -(e)le‘lu,fia;(e)  (e)  Al(d) le(f) lu(h) —ia,(g) LI(e) Btk(gh) lu(f) 1a,(ed) al(ef) -(f)le—lu_ia,(e) (N(e)  a(h)  (g)  (h)  (f)  (e)  At(g) the(gh) king’s(hgf) [N(gh) commandment,(h)  (g) the(g) three(hi) [(ghgf) T(f) were(f)  (f) cast(dhj)  in-(j)to(i) the(h) furnace,(ji)  (hg) fearing(j) i(i) not(j) the(h) flame(j) of(g) the(h) fire&#39;(fgf) =i(d)  LS(fg) ing,(gf) Blessed(h) I(ji) be(hg) our(fg) L(g) ¢(j) Em—,(i)  (j) ;(h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-008.png",
        nextFileName: "./pages/part-c-009.png",
    },
    {
        title: "part-c-009-0",
        gabc: "is(f)  (g) ri-(h)—sent(g) from(g) the(gh) grave,(fgf) who(fgh) de-(g)liv—er-(h) (g) ed(fgh) the(hg)  three(df) children(gf)  (df) from(c) the(d) burning(f) .(f) 2(g) ry(f) furndce,(fe)  (dc) al-(f) (c) le-(g)lu-(fg).(f)  -(h) (f) Alleluia(gh)  (g)  (f)  Al—le—lu-(h) (gf) —ia,(gh)  (g) tal-(h)le-(j)lu-(h)ia,(f) al-(h)le~1lu-(h) (g) 1ia.(g)  (j)  (i)  (j)  (h)  (g)  Al-(ik) (cf) le-(ghg)lu-(h)1a,(gf) tal(gh) -(g)lu-(fe)ia,(d) al(f) —le(g) —lu—1ia.(g)  (f) S(h) s(f) g(fh) s(g) |(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-009.png",
        nextFileName: "./pages/part-c-010.png",
    },
    {
        title: "part-c-009-1",
        gabc: "B(c) lessing,(h)  (h) and(h) glory,(h)  (h) and(h) wisdom,(h)  (h) and(h) e(h) thanksgiving,{(h)  (f) and(h)  :(h) honour,(h) and(h) power,(h)  (h) and(h) might,(h) be(h) unto(h)  (g) our(f) God(h) for(h)  e(h) ev—er(h) e(h) S(h) ev—er.(h) A—men.(f) .-(ef)Thanks(h) Il(f) to(e) God.(ef) ",
        groupIndex: 1,
        filename: "./pages/part-c-009.png",
        nextFileName: "./pages/part-c-010.png",
    },
    {
        title: "part-c-010-0",
        gabc: "n—cline(h)  (gh) my(h) heart,(hj) O(hg) God,(gh) Un-(gf)to(g) thy(hj) m‘r-(i)tes—tipg_(ih)  (gh) I(h)  Incline.(h)  (gh) ¥.(c) Turn(ih) a-(gh)way(gf) mine(gi) eyes,(i) lest(h) they(gh) be-(g)N(g) L](i)  .1-(i) (hi) ty,(ih) and(gf) quicken(gh) e(h) thou(h) me(hj) in(h) thy(hg) way.(fh) Un-(gf)to(g) thy(hj)  tes(i) t1(ih) —mo(h) —nies.(h) V.(c) Glo-(ih)ry(fgh) be(gf) to(gi) the(h) Fa-(gh)ther,(g) and(g) to(g)  the(g) Son,(gh) and(g) to(gf) the(g) Ho-(i)1ly(hi) Ghost.(ih) Incline.(h)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-010.png",
        nextFileName: "./pages/part-c-011.png",
    },
    {
        title: "part-c-010-1",
        gabc: "a(f)  (f)  (g)  (h) a(i) a(h)  (g) 2(h) [(h)  (g)  (j) a(j)  (g)  (h)  (i) |(hdg)  (d)  a(h)  (h)  (g)  (h)  (g)  (f)  (e)  (f)  (g) .(h)  (g)  (f)  (e)  (fg) |l(edddhdded)  (cdh)  The(h)  (h) Lord(h) aPPar&#39;;l&#39;(h)  (d)  (dh) ",
        groupIndex: 1,
        filename: "./pages/part-c-010.png",
        nextFileName: "./pages/part-c-011.png",
    },
    {
        title: "part-c-011-0",
        gabc: "Lord,(h)  (hh) ref(h) -(hhf)uge.(f) O(hgfef) ",
        groupIndex: 0,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png",
    },
    {
        title: "part-c-011-1",
        gabc: "O(e)  (f)  (e)  (d)  (e)  (e)  (d)  (c)  (d) a(e)  (e) T(e)  (c)  (e) a(gh)  (g)  a(g) .(f)  (e)  (f)  (h)  (g) ;(h)  (i)  (h)  (gh) -(f)[(e)  (f) a(g)  (d)  ..(ed)  (c)  (f) q(f)  (e) 3(d) -(e) (efe) glorious(de) ",
        groupIndex: 1,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png",
    },
    {
        title: "part-c-011-2",
        gabc: "L(c)  (h) have(h) mercy(h) a8(g) up-(f)on(g) us.(h) Christ,(h) have(h) mercy(h)  (g) up-(f) on(g) us.(h) Lord,(h) have(h) mercy(h)  (g) up-(f)on(g) us.(hd) ",
        groupIndex: 2,
        filename: "./pages/part-c-011.png",
        nextFileName: "./pages/part-c-012.png",
    },
    {
        title: "part-c-012-0",
        gabc: "Father,(f)  (g)  (h) who(h) art(h) in(h) heaven,(h)  (g) Hallow-(h)ed(g)  (f) be(h) thy(h) Nane(h)  Thy(f) kingdom(g)  (h) come.(h) Thy(f) will(g) be(h) done,(h) On(h) earth(h) ag(h) it(h) 5(g)  in(f) heaven.(h)  (h) Give(f) us(g) this(h) day(h) our(h) dai-(h)ly(f) bread,(g) And§(f)  forgive(f)  (g) us(g) our(h) trespasses,(h)  (h) B(h) As(h) we(h) s(h) Wi(h) those(h) who(h)  trespass(h)  (g) a-(f) (h) us..(h) And(f) lead(f) us(g) not(g) in-(h)to(h) temp-(h) (h)  ta—tion.(h)  (f) But(h) de-(h)liv-(h)er(h) us(h) from(h) e(h) vil.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-012.png",
        nextFileName: "./pages/part-c-013.png",
    },
    {
        title: "part-c-012-1",
        gabc: "The(f) Lord(h) be(gh) with(hg) you.(g) And(f) with(h) thy(gh)  (hg) spifitti(g)  Let(h) us(h) pray.(gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-012.png",
        nextFileName: "./pages/part-c-013.png",
    },
    {
        title: "part-c-013-0",
        gabc: "May(gi)  (e) the(df) blessed(h)  (hg) Mother(f)  (g) of(f) God,(e) the(fg) Virgin(f)  (e) Ma-(gh)ry,(f) and(hi)  all(gi)  (hg) the(i) Saints,(kjiji) intercede(e)  (f)  (hi) for(hg) us(fe) to(g) the(hg) Lord.(f)  .(chgi) The(h)  (h) Lord(h) up(h) won—der—ful.,(f) him.(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-013.png",
        nextFileName: "./pages/part-c-014.png",
    },
    {
        title: "part-c-013-1",
        gabc: "He(f) that(g) was(f) cru-(f)ci-(ghg)fi-(h)ed(gf) is(h) ri-(gf)sen(df) from(fef) the(dedcd) dead;(dc)  and(fd~) hath(f) re(fhg) —deem-(h)ed(g) us,(f) al(fd) -(f) (fe) So(dedcd) 7a,(dc) al(f) -(fg)lu-(fg)ia.(f)  .(i) Tell(jj)  (j) 1lu-(j)1ia,(h) ",
        groupIndex: 1,
        filename: "./pages/part-c-013.png",
        nextFileName: "./pages/part-c-014.png",
    },
    {
        title: "part-c-014-0",
        gabc: "¥.(c) The(f) Lord(h) be(gh) with(hg) you.(g) And(f) with(h) thy(gh)  (hg)  (g)  V.(c) Let(i) us(i) bless(i) the(i) Lord.(ihg) Thanks(i) be(i) to(i) Gog,(ihg)  May(e)  (e) the(e) in(e) peace.(e) A(e) men,(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png",
    },
    {
        title: "part-c-014-1",
        gabc: "ave(f) mer—cy(h)  (g) tup—on(f)  (gh) me,(g) C(g) God.(f) |(h) ;(f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png",
    },
    {
        title: "part-c-014-2",
        gabc: "Al-(f)le-(f)lu-(gh)ia,(h) tal-(h)le-(g)lu-(hg)ia,(f) al(g) le(h) lu-(f)1ia.(f) e(hf)  (fhdg)  (df) ",
        groupIndex: 2,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png",
    },
    {
        title: "part-c-014-3",
        gabc: "Con—si—der(h)  (fh) t(f) my(ed) 5(e) med—i-(f)ta—tion,(g)  (fd) O(fe) Lord.(e) |(h) A(f)  (h)  (i)  (h) ",
        groupIndex: 3,
        filename: "./pages/part-c-014.png",
        nextFileName: "./pages/part-c-015.png",
    },
    {
        title: "part-c-015-0",
        gabc: "qercy,(g)  (h) 1O(g) Lord,(efg) reacheth(f)  (gh) un-(f)to(f) the(f) heavens.(fg)  (e)  (h)  (f)  (h)  (i)  (h)  Thy(h) qercy,(h)  an-(fe~)ger’[is(g) turn-(h)ed(j) a-(j)way,(h) O(j) Lord,(ij) and(h) thou(hf)  Thiﬂe(c)  (h) an-(fg) (g)  com-(g)fort-(h)edst(hi) me.(g) P.T.Al(hi) —le-(h)lu~ia.(g)  (g) AR(j)  (i) A(j)  (h) |(fh) ",
        groupIndex: 0,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png",
    },
    {
        title: "part-c-015-1",
        gabc: "Wala(dc) praise(f) thy(g) glo-(h)ri-(g)ous(f) Name,(fc) O(d) our(fe) God.(d)  God,(dc) al(d) —le-(efe)lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png",
    },
    {
        title: "part-c-015-2",
        gabc: "O(dh) praise(hg) the(ef) Lord(g) of(fe) hea-(d)ven.(d) RN(h) e(g) e(f) m(gf) y(fgh) ",
        groupIndex: 2,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png",
    },
    {
        title: "part-c-015-3",
        gabc: "T(dh)  (hg) o(hi) v(h) al-(h)e(g) lu-(hg)ia,(ef) e(g) -(fe)e(d) lu.1a.(d) S(h)  (g) i(f) ||(gf)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-c-015.png",
        nextFileName: "./pages/part-c-016.png",
    },
    {
        title: "part-c-016-0",
        gabc: "Heal(c)  (cfe) my(f) soul,(gh) For(h) I(f) have(gh) sinned(g)  (fd) a-(fg)gainst(g) thee,(f)  Ryl(h) said,(ihi) Lord(h) be(h) mer-(gh)ci-(g)ful(g) un-(fe)to(f) me.(gh) For(h) I(f) Have(gh) g(g)  ned(fd) a-(gf~)gainst(g) thee.(f) Glory(h)  (h) be(h) to(h) the(h) Father,(ihi)  (h) and(h) to(gh) the(g)  Son,(g) and(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) Heal(fe) my(f) soul,(gh) for(h) I(f) haye(h)  B(g) sinned(fd) a—-(fg)gainst(g) thee.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-016.png",
        nextFileName: "./pages/part-c-017.png",
    },
    {
        title: "part-c-016-1",
        gabc: "[(f)  (f)  (g)  (h) L](i)  (h)  (g)  (h) a(h)  (g)  (j) [(j) ](g)  (h)  (i)  (hg)  (h)  on(h)  (h) Coeesceenss(g)  (h) s(g)  (f)  (e)  (f)  (g) 2(h)  (g)  (f)  (e)  (fg) [(e) .(d)  (ded)  (d)  .(e)  (c)  (d)  (f) O(ef)  (g)  (f)  (e) [(e)  (c)  (d)  (f) [](ef)  (g) .-(h) (g)  (h)  :(g)  (f)  (g)  (h) w(f)  (g)  (f)  (e) [](e)  (c)  (d)  (f) Lk(ef)  (g)  (hf)  (e) ;(ddefe)  (de)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-016.png",
        nextFileName: "./pages/part-c-017.png",
    },
    {
        title: "part-c-017-0",
        gabc: "B]ess—ed(f)  (gh) be(h) the(f) Lord(g) God(fgfd) of(fg) Is-(h)ra-(g)el.(f)  (h)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png",
    },
    {
        title: "part-c-017-1",
        gabc: "Do(e) a-(f)vay,(g) O(f) Lord,(df) mine(fd) of-(fg)T(e) fences.(e) e(h)  (g) |(h) |(ih) ¢(gfe) S(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png",
    },
    {
        title: "part-c-017-2",
        gabc: "Al-(i) (e) le_lu-(f) (g) ia,(g) fal-(gh)le—lu-(g) (gf) da(d) sl(fd) e(fg) Sl(e) W(e) g(h)  (ghih) @(gfee) ",
        groupIndex: 2,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png",
    },
    {
        title: "part-c-017-3",
        gabc: "he(c)  (f) help(h) of(f) my(gh) coun-(g)R(fe) e(d) and(f) my(gh) lol(gf) ||(h) eineecal(f)  (gh)  (g) |(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png",
    },
    {
        title: "part-c-017-4",
        gabc: "my(f)  (h) soul(ji) T(jk) trusteth(h) in(dfg) thee.(g)  (f) P(fffdjddiddj) o(hf)  (ghg) ",
        groupIndex: 4,
        filename: "./pages/part-c-017.png",
        nextFileName: "./pages/part-c-018.png",
    },
    {
        title: "part-c-018-0",
        gabc: "B(c)  (g) thou(g) rea-(hj)dy(j) to(h) save(j) us(i) all(g) the(h) days(h) of(h) gy,(gf)  Tife,(g) O}(gf) Lords.(e) Lotd;(f) sl(g) o(gf) el(e) on(e)  (j)  (h) g(j) ",
        groupIndex: 0,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png",
    },
    {
        title: "part-c-018-1",
        gabc: "x(c)  (ef) tol(hjh) the(i) ev-(g)er-(i)last-(hg)ing(f) King(f) in(f) all(hgf) your(gf) ings,(e)  Al-(fg)le-(f)lu-(e)ia.(e)  (i)  (j)  (i)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png",
    },
    {
        title: "part-c-018-2",
        gabc: "L](e) ye(ef) An-(ff)gels(d) of(f) his,(hhih) O(i) praise(h) the(gh) Lord(c)  (f) of(ef) heaven.(d)  (d)   (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png",
    },
    {
        title: "part-c-018-3",
        gabc: "Al-(gi) (e) le-(f)lu-(ffe)ia,(d) al-(f)le-(h)lu-(hi)ia,(hg) al-(f)le(ef) ~lu-(d)ia.(d) .(h)  (digfh)  (f)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-018.png",
        nextFileName: "./pages/part-c-019.png",
    },
    {
        title: "part-c-019-0",
        gabc: "The(e) Lord(g) hath(h) rais—ed(i)  (hg) up(h) for(hi) us(i) an(i) horn(ji) of(j) sal-(k)va-(i)tion(i)  in(i) the(j) house(hf) of(h) his(gh) ser(ihf) —vant(g) Da(e) vid.(e)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png",
    },
    {
        title: "part-c-019-1",
        gabc: "Wash(gg) me(fh) through-(j)ly,(ih) O(hj) Lord,(h) from(gf) my(h) wick—ed-(i) (h) ness.(g)  [(j)  (i)  (j)  (h) ](g) ",
        groupIndex: 1,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png",
    },
    {
        title: "part-c-019-2",
        gabc: "Al-(g)le-(fh)lu-(j)ia,(ih) al-(hj)le(h) lu-(hg)ia,(f) al-(g)le-(h)lu-(ihg)1a.(g) |(j) e(i)  (j)  (h) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png",
    },
    {
        title: "part-c-019-3",
        gabc: "L(hg) P(h) serve(hg) %(f) life,(h) O(h) Lord,(hg) from(f) fear(fe) of(f) the(hg) e-(f)ne-(f)x|(f)   (gi)  (h)  (g)  (e)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-c-019.png",
        nextFileName: "./pages/part-c-020.png",
    },
    {
        title: "part-c-020-0",
        gabc: "0(gi)  (h)  (hih) -(e)art(fe) prais-(f)ed(d) 5(gf) Si(f) on,(e)  (h) |(f)  (h)  (i)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png",
    },
    {
        title: "part-c-020-1",
        gabc: "T(c) he(f) Lord(fh) shall(g) judge(h) the(g) ends(ef) of(g) the(fe) earth.(d) 1(dc)  al(d) le(efe) lu(d) 1a.(d) ([(h) e(g) e(f)  (g) \\(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png",
    },
    {
        title: "part-c-020-2",
        gabc: "()(hi) lord,(i) thou(h) art(i) great(ji) tand(h) glo-(i) (i) ri—ous,(i) won-(fi)der—ful(hg)  (fe) 1n(fe)  strength(de) and(f) in-(h)vin-(f)ci-(f)ble.(f) Al(de) le(fh) lu-(f)ia,(f)  (i) |(h) ",
        groupIndex: 2,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png",
    },
    {
        title: "part-c-020-3",
        gabc: "O(gi)  (h) all(h) ye(f) hea-(gh)vens,(g) [(fe) ’ye(f) the(ghg) Lord.(f) e(h) ;(gde)  (df) ",
        groupIndex: 3,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png",
    },
    {
        title: "part-c-020-4",
        gabc: "e(gi)  (h)  (f) Al&quot;le—lu*ia,Tal—le—lu—ia,(gh)  (g)  (f)  (e) IJ(f)  (g) al&#39;=(h) Te&#39;=(g) Tu&#39;—(f)  (f)  (d) 18-(dh) (fg)  (e) S(f) ",
        groupIndex: 4,
        filename: "./pages/part-c-020.png",
        nextFileName: "./pages/part-c-021.png",
    },
    {
        title: "part-c-021-0",
        gabc: "Fron(h) the(g) hand(h) of(fg) all(g) that(d) hate(fe) us,(f) the(f) Lord(g) hath(e) de-(f) .(g) liv—er—ed(e)  (f) us.(d)  (h) THURSDAY(g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png",
    },
    {
        title: "part-c-021-1",
        gabc: "A(h) e(f) thee(fg) on(gh) ly(g) have(f) I(h) sin-(j)ned,(k) O(jh) Lord:(j)  have(h) mer(h) —cy(i) up-(h)on(g) me.(g)  (j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png",
    },
    {
        title: "part-c-021-2",
        gabc: "Al-(h)le—lﬁ-(fg)ia,(gh) O(g) al-(f)le-(h)lu-(jk)1ia,(jijkj) al-(hi)le-(h)lu-(g)ia.(g) EEE(j)  (i) e(j)  (h) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png",
    },
    {
        title: "part-c-021-3",
        gabc: "LEt(gi)  (f) my(df) prayer,(h) O(gf) Lord,(fh) en-(h)ter(h) in(h) to(hi) thy(fe) pre-(fe)sence.(d)  L(h)  (i)  (g)  (h)  (f) ",
        groupIndex: 3,
        filename: "./pages/part-c-021.png",
        nextFileName: "./pages/part-c-022.png",
    },
    {
        title: "part-c-022-0",
        gabc: "QO(f) [lord,(h) thou(f) hast(g) been(fd) our(fg) re—fuge.(g)  (f) [T(h) o(f)  (gh) |(g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png",
    },
    {
        title: "part-c-022-1",
        gabc: "I(e) will(f) sing(hi) un(hi) to(j) the(h) Lord,(i) for(gihfg) he(fe) hath(fe) tri-(d)A(e)  ed(fh) glo-(f)rious-(f)ly.(f) Al(cde) le(fh) lu-(f)ia.(f) e(i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png",
    },
    {
        title: "part-c-022-2",
        gabc: "M’y(fd) peo-(e)ple(f) shall(g) be(g) sat-(g)1s—fi-(ge) (f) ed(ed) with(d) my(dh) good-(h) ness,(gf) saith(g) the(gf) Lord.(e) Lord,(ef) al(gf) le(d) lu(e) ia.(e)  :(h)  (g)  (h)  (ih)  (gfe) i(e)  O(fg) praise(hgfg) God(fd) in(f) his(g) ho-(g)-(f)li(f) o(h) e(f)  (gh)  (g)  (f) |(d) ",
        groupIndex: 2,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png",
    },
    {
        title: "part-c-022-3",
        gabc: "Al(c)  (fg) le(hf) lu-(g)ia,(g) al-(gh)le-(g)lu-(f)ia,(d) al(f) -(g)lu-(g)ia.(f)  (dfh)  (fdfdfdghd)  (gff)  (df) ",
        groupIndex: 3,
        filename: "./pages/part-c-022.png",
        nextFileName: "./pages/part-c-023.png",
    },
    {
        title: "part-c-023-0",
        gabc: "Let(c)  (g) s(h) serve(i) the(i) Lord(j) in(h) ho-(i)1i(h) -(g)and(h) he(ij) will(i) de-(h) liv-(h)er(g) us(e) from(f) the(h) hand(hf) of(g) our(f) en-(e)e(e) -(e)ey(i)  (j)  (i) ]|(h)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png",
    },
    {
        title: "part-c-023-1",
        gabc: "1th(c)  (dc) thy(f) free(g) Spi(fh) rit(hgg) stab-(h)lish(g) my(ef) heart,(g) &#39;O(fe) God.(d)  .(h)  (g)  (f)  (h)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png",
    },
    {
        title: "part-c-023-2",
        gabc: "l-(d)le-(d)lu-(d)=(c) al(f) —-(g)lu-(fh)ia,(hg) |(efg) L(fe) lu-(d)ia.(d) L(hg) e(fgh) |(gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png",
    },
    {
        title: "part-c-023-3",
        gabc: ":(h) Nare(hg) lis(fe) great(f) in(ef) Is(g) ra(dfe) —el.(fe) f_l_l(h)  (f) P(h) h(i) el(h) ",
        groupIndex: 3,
        filename: "./pages/part-c-023.png",
        nextFileName: "./pages/part-c-024.png",
    },
    {
        title: "part-c-024-0",
        gabc: "Jt(ch) is(h) a(h) good(hi) =(f) to(f) :(f) thanks(f) =(e) un—to(f) the(f) Lo(e)   (h)  (f)  (h)  (i)  (h)  .(cfd) Lord,(f) I(e) have(f) heard(gh) thy(h) speech,(g) and(f) was(g) a(f) frajq(e)  Al(g) le(gf) lu(e) 1ia.(e) “I_-(h) (g)  (h) I(ih)  (gfe)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png",
    },
    {
        title: "part-c-024-1",
        gabc: "In(cf) the(e) Lord(f) tshall(df) all(h) the(f) seed(g) of(h) Is-(i)ra-(hi)el(f) be(f)  (f)  jus—ti(fi)  (h) fi(gh) ed,(fe) and(d) shall(e) glo-(fe)ry.(d) Al(e) —le—lp—la-(edf) (d)  (d)   (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png",
    },
    {
        title: "part-c-024-2",
        gabc: "[(d) the(d) cym-(f)bals(e) and(d) dan-(d)es,(dc) lup(dc) on(ddfg) the(hgd)  (d) strings(dfg)  (dd)  (d) and(fd)  (dd) ",
        groupIndex: 2,
        filename: "./pages/part-c-024.png",
        nextFileName: "./pages/part-c-025.png",
    },
    {
        title: "part-c-025-0",
        gabc: "Lord.(h)  (g)  (f)  (gh)  (gf)  (fgh)  praise(e) the(fe) Lord.(d)  pipe,(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png",
    },
    {
        title: "part-c-025-1",
        gabc: "A]_]e_lu_.(d)  (fe)  (d) a,(dc) tal(fg) —le(hg) lu-(fg)1a,(f) al(fgf) —le(ef) lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png",
    },
    {
        title: "part-c-025-2",
        gabc: "Through(c)  (gj) the(hgf) ten—der(g)  (h) mer—cy(jk) t(jijkj) of(jh) our(ih) God:(g) whereby(g)  (g) the(g) day-(g) S(j) R(i)  (j) L(h) |(g)  spring(ge) from(fgh) on(fe) high(d) hath(ef) vi-(gh)sit-(h)ed(h) us.(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png",
    },
    {
        title: "part-c-025-3",
        gabc: "Be(f) [(g) M(f) e(e) ble,(d) O(ef) and(d) 7(gf) el(e) |(h) SESRERECS(g) &quot;(h) IS(ih) [(gfe) ](e) ",
        groupIndex: 3,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png",
    },
    {
        title: "part-c-025-4",
        gabc: "N(cd) S(f)  (gf)  (e) PNy(e) le-(f) (ghdd) lu—ia,(d)  (g) P(dgd) —le—lu-(gdfdd)U(dde) ia.(e) |(f) e(hg)  (h) P(ih) a(gfe) e(e) ",
        groupIndex: 4,
        filename: "./pages/part-c-025.png",
        nextFileName: "./pages/part-c-026.png",
    },
    {
        title: "part-c-026-0",
        gabc: "Hear—ken(c)  (h)  (f) un-(g)to(g) me,(h) O(g) Lord,(f) for(h) thy(hij) truth(ji) and(gh) Tight.(h)  eous-(i)ness’(hg) sake.(g) R(j) R(i)  (j) SRR(h) AT(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png",
    },
    {
        title: "part-c-026-1",
        gabc: ":(c) As—cribe(f)  (fg) ye(hf) greatness(g)  (d) un-(f)to(g) our(g) God.(f) Al-(g)le-(gh)lu(f) i,(f)  .(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png",
    },
    {
        title: "part-c-026-2",
        gabc: "Shewus,t(hj)  (i) O(h) ,(hjg) the(gf) light(g) of(h) thy(gf) e(e) mer—cy.(e) .(e)  cy,(ef) al(g) le(gf) lu(e) 1a.(e) [(j) T(h)  (j) ——(i) ",
        groupIndex: 2,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png",
    },
    {
        title: "part-c-026-3",
        gabc: "Up-(d)on(f) the(d) well(ef) ~tun-(g)ed(e) cym-(ef)bals(d) [0(dc) praise(df) God.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 3,
        filename: "./pages/part-c-026.png",
        nextFileName: "./pages/part-c-027.png",
    },
    {
        title: "part-c-027-0",
        gabc: "2(d)  (e) [A(fe) _ia,(d) tal-(ef)le-(g)lu-(f)1ia,(d) [al(dc) le-(cdf)lu-(e)ia.(e) |(h) raenen(g)  (h) e(ih) |(dgfe) ||(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png",
    },
    {
        title: "part-c-027-1",
        gabc: "Give(c)  (e) light,(h) &#39;O(fd) Lord,(e) to(e) them(g) that(h) sit(i) in(fh) darkness:(h)  (g) and(i)  guide(i) our(i) feet(i) in-(h)to(h) the(h) way(hij) of(i) peace,(hghih) thou(fe) God(fghf) of(gf)  Is-(e)ra-(e)el.(e)  (h) Suffrage(g)  (h)  (f) All(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png",
    },
    {
        title: "part-c-027-2",
        gabc: "M(c) ay(ig) all(j) the(i) S(i) epa(i) i(g) |(hg) for(f) o(f) to(g) the(f) v(e) ||(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png",
    },
    {
        title: "part-c-027-3",
        gabc: "May(g) —(f) the(gh) Saints(g) f(hi) in-(ij)tercede(i) for(hgfgh) us(fe) to(d) the(ded) [(c) ",
        groupIndex: 3,
        filename: "./pages/part-c-027.png",
        nextFileName: "./pages/part-c-028.png",
    },
    {
        title: "part-c-028-0",
        gabc: "n(gg) that(fgh) day(hg) Tthe(g) mountains(g)  (g) shall(g) drop(hi) down(g) ney(hg) Wine,(f)  and(f) the(g) hills(g) shall(h) flow(j) with(g) milk(h) and(g) ho(g) ney,(gfd)  al(f) -(fg)lu(g) ia.(g)  (j) y(i)  (j)  (h)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-028.png",
        nextFileName: "./pages/part-c-029.png",
    },
    {
        title: "part-c-028-1",
        gabc: "Be(fg) ioy(gjkji) -(kj)ful,(kj) O(j) daughter(ji)  (h) of(j) Si-(hg)on,(g) and(g) ex-(g) ceeding(g)  (g) glad,(fe) O(f) daughter(d)  (e) of(fh) Je-(h)ru-(g)sa-(hfg)lem,(gfd)  al(ef) —-(fg)lu-(g)1ia,(g)  (j)  (i)  (j) -(h) (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-028.png",
        nextFileName: "./pages/part-c-029.png",
    },
    {
        title: "part-c-029-0",
        gabc: "hold,(f)  (h) the(g) Lord(eg) cometh,(fe)  (d) and(e) all(e) his(e) Saints(df) with(hhi)  him;(h) and(h) there(h) shall(h) be(i) in(g) that(h) day(f) a(e) great(de) light,(fe)  al—(f) le-(e)lu-(d)ia.(d)  (h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png",
    },
    {
        title: "part-c-029-1",
        gabc: "H(c)  (cgeh) ev—ery(gh)  (g) one(g) that(e) thirsteth,(ghgg)  (f) come(f) ye(e) to(c) the(d)  waters:(d)  (c) seek(h)  (ji) ye(hihf) the(hi) Lord(hg) while(gg) he(ce) may(gf) be(df) found,(ec)  al(ed) -(d)..(c) -(c) (g)  (h) :(g)  (f)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png",
    },
    {
        title: "part-c-029-2",
        gabc: "o,(e) there(f) cometh(hi)  (i) a(hi) mighty(j)  (h) Prophet:(i)  (i) and(i) he(f) a-(i)lone(g)  :(h) reneweth(fe)  (f) e(e) Je_ru-(d)sa-(e)lem,(fg) al(h) —le-(h)lu-(f)ia.(f)  (d) e(i) ‘(h)  (i) ||(j)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-029.png",
        nextFileName: "./pages/part-c-030.png",
    },
    {
        title: "part-c-030-0",
        gabc: "than(h) when(h) we(h) be(h) liev(f) —ed.(ef) Thanks(h) be(f) ¢,(e) Gog(def) ",
        groupIndex: 0,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png",
    },
    {
        title: "part-c-030-1",
        gabc: "and(c)  (f)  (fd) save(ef) us,(g) O(f) Lord(dc) God(df) of(fe) hosts.(e) Come(f) and(fd) save(ef) ys(g)  u(c) the(df) light(f) of(f) thy(f) countenance,(ef)  (f)  (f) and(f) we(fd) shall(e) be(f) a-(g) O(f) Lord(dc) God(df) of(fe) hosts.(e) ¥.(c) Glory(g)  (g) be(g) to(g) the(g) Fa_ther,(fh)  (h) and(h)  to(g) the(h) L](e) and(f) to(f) the(f) Ho(fd) ly(ef) Ghost.(g) Come(f) and(fd) save(f)  us,(ik)  (g) O(f) Lord(dc) God(df) of(fe) hosts.(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png",
    },
    {
        title: "part-c-030-2",
        gabc: "a(e) &quot;(c) [(e)  (g) ‘a(h)  (i) -(h) (h)  (g) g(h)  (j)  (j) 0(ig) &amp;(h)  (i) )(h)  R(h)  (h) a(i) ](g)  (eg) &quot;(f)  (e)  (d) n(e) 3(c) «(e) [}(g) -(h) (i)  (h)  (h)  (hihd)  (dfgh) ",
        groupIndex: 2,
        filename: "./pages/part-c-030.png",
        nextFileName: "./pages/part-c-031.png",
    },
    {
        title: "part-c-031-0",
        gabc: "The‘fo—ly(c)  (gd)  (cfe)  (fg) Ghost(g) shall(g) come(g) up-(g)—on(gh) thee,(f) NMa(cgh) ry;(h) fear(hj)  not,(hg) thou(g) shalt(g) bear(g) in(h) thy(g) womb(fe) the(d) Son(f) of(h) God,(gfd)  al(ef) —le(fg) lu—1a.(g)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-031.png",
        nextFileName: "./pages/part-c-032.png",
    },
    {
        title: "part-c-031-1",
        gabc: "The(c)  (dc) [(e) gel(f) of(gf) the(d) L&#39;ord(dc) an(fg) &lt;nounc’d(h) un-(g)to(f) Ma-(g)ry,(f) and(fg)  (e)  8(e) con-(f)ceiv—ed(def) —(fc) &amp;-(e)the(f) Ho-(g)ly(fe) ost,(dc) al(d) —le—lu—(efe) :_I(d) ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-031.png",
        nextFileName: "./pages/part-c-032.png",
    },
    {
        title: "part-c-032-0",
        gabc: "B(c)  (c) e(d) fore(d) tﬂey(dc) came(f) to-(g)geth-(fh)er(h) Ma-(i)ry(h) was(g) found(f) with(gh)  child(g) .(e) the(f) Ho-(g)ly(fe) Ghost,(dc) al(d) le-(efe)lu-(d)1ia,(d)  (hgfgh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png",
    },
    {
        title: "part-c-032-1",
        gabc: "Qut(ig~)  (f) of(f) Si-(i)on(h) shall(h) go(g) forth(e) the(f) law,(f) and(e) the(f) word(h)  of(gi)  (h) the(g) Lord(e) from(eg) Je—ru-(fh) (g) —sa-(h)—lem.(f) e(h)  (g) |(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png",
    },
    {
        title: "part-c-032-2",
        gabc: "——(gi) Bless—ed(e)  (f) art(hi) thou(i) a-(hi)mong(jh) women,(i)  (i) and(gihg) bless—ed(fe)  (fe) 1is(d)  the(e) fruit(fg) of(h) thy(hg) womb.(f) N(i) .(h) ——-(i) (j)  (h) ](fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png",
    },
    {
        title: "part-c-032-3",
        gabc: ".o,(idhi) there(h) cometh(hj)  (h) one(hghih) that(hg) is(f) both(ef) God(fg) and(efdf) Man,(d)  (d) of(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-032.png",
        nextFileName: "./pages/part-c-033.png",
    },
    {
        title: "part-c-033-0",
        gabc: "4(ik) the(e) house(d) of(e) Da-(f)vid,(ghg) to(g) sit(f) up—on(ed)  (dg) the(fe) th(dc)  al(d) —le(efe) -(d)lu—1a.(d) /(h)  (g)  (f)  (gf)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png",
    },
    {
        title: "part-c-033-1",
        gabc: "Fear(c)  (hi) not,(i) O(hi) Si-(jh)on,(i) be-(i)hold(f) thy(i) God(gh) com—eth,(fe)  (fe) al(d) —le—(fh)  lu-(f)1a(f)  (i)  (h)  (hj)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png",
    },
    {
        title: "part-c-033-2",
        gabc: "Be—hold,(dd)  (c) the(d) Lord(ef) L](g) ap-(fe) of(ik)  (g) hea-(hg)-(f)with(f) e(f) er(e) s(f) [(fg) |(fe) P(dc)  al(ik)  (d) ~le(efe) lu—ia.(d)  (d)  (f)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-033.png",
        nextFileName: "./pages/part-c-034.png",
    },
    {
        title: "part-c-034-0",
        gabc: "i-(ccdg)on(g) is(g) our(g) strong(ig) ci-(fg)~ty,(g) a(e) Saviour(g)  (f) wil](g) d(efe)  (de)  point(eg)  (f) with—in(ed)  (c) her(c) for(ghgfg) walls(g) and(gj) bul-(j)warks:(g) 0(g) ~pen(g)  ye(eg)  (h) the(f) gates,(geedf) for(f) God(fe) him-(d)self(ef) is(d) with(dc) Us,(c) &amp;(cd) le_J(d)  lu(eg)  (c) ia.(c)  (h)  (g)  (f)  (eg) ",
        groupIndex: 0,
        filename: "./pages/part-c-034.png",
        nextFileName: "./pages/part-c-035.png",
    },
    {
        title: "part-c-034-1",
        gabc: "P(gi) Lo,(e) in(e) the(ee) time(g) ap,(h) I(ihj) -(i)the(i) Lord(ij) will(i) come,(h)  and(h) will(fh) not(fg) lie:(ef) though(d) he(f) tar-(hhi)ry,(i) wait(h) for(f) him;(fe)  for(e) he(e) will(e) sure-(ef)ly(dc) he(d) will(ef) not(f) tar(e) Y,(edc)  (f)  al(gi)  (cd) le(de) lu(e) 1a.(e) YT(j) e(i) ](h) |(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-034.png",
        nextFileName: "./pages/part-c-035.png",
    },
    {
        title: "part-c-035-0",
        gabc: "T(c) ®(dc) mountains(f)  (g) and(f) the(gh) hills(h) shall(h) break(hg) forth(h) be(g) fore(f)  God(ef) in-(g)to(fe) singing,(d)  (d) and(d) all(f) the(fg) trees(h) of(g) the(f) for(gh) —est(h)  shall(hjj) clap(g) their(hj) hands:(h) for(f) be—hold(gh)  (hgg) he(e) com-(fg)eth,(g) our(d)  Lord(ef) and(f) Rul(dd) .(c) to(d) reign(dd) for-(cde)ev-(ge)er,(fg) al-(e)0(c) lu-(e)ia,(g)  al(e) -(fe)lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-035.png",
        nextFileName: "./pages/part-c-036.png",
    },
    {
        title: "part-c-035-1",
        gabc: "B(g) hold,(hj) our(j) Lord(j) shall(j) come(j) with(h) pow-(ih)er,(g) to(g) en-(h) lighten(j)  lighten(j)  (i) the(g) eyes(gh) of(f) his(g) ser-(f)=(fd) -(f)le-(fg)lu-(e)ia.(e)  |(j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-035.png",
        nextFileName: "./pages/part-c-036.png",
    },
    {
        title: "part-c-036-0",
        gabc: "Now(c)  (d) when(cd) John(f) had(hg) heard(h) in(h) the(h) pri-(h)son(g) the(ef) works(g) of(fe)  7(d) he(d) sent(f) two(d) of(dc) .(f) .(g) -(fh)ples,(h) and(h) said(h) Unto(g)  (h)  (f)  him:(f) Art(f) thou(gh) he(h) that(gh) should(fe) come,(dfddc) or(cd) do(f) we(ef) look(g) 0(e)  an(fe) —oth(d) —er?(d) P.B.(h) ANTIPHON(g)  (f) ON(gh)  (gf)  He(c)  (g) shall(gd) sit(f) up-(fg)on(h) the(g) throne(h) of(g) Da(f) vid,(ghghih) and(f) of(g) his(h)  (j)  king—dom(ik)  (hj)  (g) there(fe) shall(d) be(f) no(gh) end,(gfd) al-(f)le-(fg)lu-(g)ia.(g)  (j) |(i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-036.png",
        nextFileName: "./pages/part-c-037.png",
    },
    {
        title: "part-c-036-1",
        gabc: "From(c)  (e) hea—ven(e) a(g) there(h) com-(j)eth(i) the(i) Lord,(ih~) the(f) Rul(hg) er,(e) and(e)  (d)  in(i) his(h) hand(f) are(h) hon-(h)our(ih) and(f) do(f) ~min-(e)ion.(e)  (e) &#39;(j)  (i)  (dh) g(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-036.png",
        nextFileName: "./pages/part-c-037.png",
    },
    {
        title: "part-c-037-0",
        gabc: "The(gi)  (f) Lord(e) shall(f) a—rise(h)  (h) up—on(h)  (j) thee,(i) O(h) Je-(i)ru-(j)sa-(ih)lenm,(i)  and(f) ;(h) glo—ry(fe)  (fe) shall(d) be(e) seen(f) up(h) —on(f) thee.(f) e(i)  (h) o(i)  (j) e(h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png",
    },
    {
        title: "part-c-037-1",
        gabc: "Be-(c) (ch) hold(j) I(jk) send(kji) my(hj) @(i) mes—sen—ger,(h)  (g) and(j) he(ij) shall(h) pre—pare(g)  (g)  my(gh) way(fed) be_fore(ef)  (gh) thy(h) face.(g) THURSDAY(j)  (i)  (j)  (h) :(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png",
    },
    {
        title: "part-c-037-2",
        gabc: "T}iou,(c)  (ig) O(ij) Lord,t(i) art(i) he(i) that(g) is(h) to(g) come,(e) for(h) whom(h) we(fh) look,(g)  to(f) save(ef) thy(gf) peo-(e)ple.(e) FRIDAY.(j)  (i)  (h)  (gh)  (g)  Say(f) to(ghg) them:t(h) Ye(h) that(h) are(g) of(h) 4(g) fear—ful(e)  (f) heart,(g) be(fe) strong:(ded)  for(g) (-(e)be_hold(f) the(g) Lord(f) our(fg) God(e) all(f)  (d) come.(d)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-037.png",
        nextFileName: "./pages/part-c-038.png",
    },
    {
        title: "part-c-038-0",
        gabc: "e(cd) Lord(c) shall(d) set(ef) up(g) an(fe) en-(d) (d) for(fh) the(g) na-(hg)tions,(f)  a(e) as-(g)sem-(h)ble(f) the(ef) out-(g)casts(e) of(fe) Is-(d)ra-(d)el.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png",
    },
    {
        title: "part-c-038-1",
        gabc: "The(ik)  (f) Lord(h) will(g) surely(h)  (g) [}(e) and(f) o(gh) not(ef) tarry:(d)  (d) and(d)  will(f) bring(g) to(g) light(g) the(g) hid-(h)den(fg) things(g) of(fgh) darkness,.(f)  (f)  and(f) will(g) ma-(h)ni-(g)fest(h) him-(g)a(e) to(f) all(fg) na-(fe)tions,(cd)  al(d) le(efe) lu-(d)1ia.(d)  (h)  (g)  (f)  (g)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png",
    },
    {
        title: "part-c-038-2",
        gabc: "%-(c)s(e) sa-(f)1lem,(g) Tjoy(fe) with(f) great(d) rejoicing,(ef)  (fh)  (g) for(ddhjdddjkidd) ",
        groupIndex: 2,
        filename: "./pages/part-c-038.png",
        nextFileName: "./pages/part-c-039.png",
    },
    {
        title: "part-c-039-0",
        gabc: "Zaviour(hi)  (hg) cometh(h)  (g) un-(f)to(fe) thee,(d) al(e) le-(de)lu-(c)1ia.(c)  (h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png",
    },
    {
        title: "part-c-039-1",
        gabc: ";(ik) will(g)  (gfd) place(fe) sal-(fg)va-(fh)tion(g) Tin(fh) Si-(h)on,(g) and(h) in(j) Je-(g) ri-(ik) (hg) sa-(fg)lem(g) my(hg) glo-(fe)ry,(d) al(f) ~le-(fg)lu-(g)ia.(g) ||(j) SNSRI(i)  (j)  (h) ||(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png",
    },
    {
        title: "part-c-039-2",
        gabc: "Mountains(cgi)  (c)  (f)  (d) and(f) all(hi) hills(h) {shall(hi) be(j) a-(ih) (hi) bas—ed,(f) and(f) the(i)  crook—ed(h)  (h) shall(f) be(e) made(ef) straight,(f) and(d) the(e) rough(fd) pla—ces(e)  (ef)  plain,(d) Come,(hf) O(hih) Lord,(ggf) and(e) tar-(e)ry(e) not,(de) al(f) o(ef) lu-(d)ia.(d) B(ig)  (h) |(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png",
    },
    {
        title: "part-c-039-3",
        gabc: "Let(ff) ](e) live(f)  (g) righteously(h)  (i) and(h) godly,(f)  (f) looking(e)  (f) for(h) L](fe)  A(gi) blessed(g)  (ig) R(hg) and(e) R(f) -(h) (g) of(e) U0(d)  (fgh) Lord.(f) o(d) Y(h)  (g)  (e) |(f) ",
        groupIndex: 3,
        filename: "./pages/part-c-039.png",
        nextFileName: "./pages/part-c-040.png",
    },
    {
        title: "part-c-040-0",
        gabc: "He(cg) shall(gd) sit(f) up-(f)on(gh) the(g) thronet(h) of(g) Da(f) vid,(ghghih) and(f) of(g) hig(h)  kingdom(hj)  (g) there(fe) shall(d) be(f) no(gh) end,(gfd) al-(ef)le-(fg)lu-(g)ia,(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png",
    },
    {
        title: "part-c-040-1",
        gabc: "Nev(d) when(cd) John(f) had(gh) heardt(h) in(h) the(h) prison(h)  (g) the(ef) works(g) of(fe) Christ,(d)  he(d) sent(f) two(d) lof(dc) his(f) dis—ci-(g) (fh) ples,(h) and(h) said(h) un-(g)to(h) him:(f) Art(f)  (g)  thou(gh) he(h) that(gh) should(fe) come,(dfddc) or(cc) do(f) we(ef) look(g) for(e) an—oth-(fe) (d) er?(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png",
    },
    {
        title: "part-c-040-2",
        gabc: "B(c)  (f) hold(e) the(f) Lord(h) shall(ij) come,(i) the(i) Prince(i) of(f)  (h) the(i) kings(dfjf) of(dhi) ",
        groupIndex: 2,
        filename: "./pages/part-c-040.png",
        nextFileName: "./pages/part-c-041.png",
    },
    {
        title: "part-c-041-0",
        gabc: "che(h) earth:(i) bless—ed(gi)  (hg) are(fe) they(f) that(e) are(d) pre(e) —par-(gf~)ed(h) to(h)  meet(f) him.(f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png",
    },
    {
        title: "part-c-041-1",
        gabc: "When(c)  (h) the(h) Son(h) of(hg) man(hiih) com(fhg) eth,(e) shall(hhg) he(fef) find(de) faith(ef)  on(ig~)  (g) the(f) earth?(e)  (h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png",
    },
    {
        title: "part-c-041-2",
        gabc: "Lo,(df) now(hf) com—eth(hi)  (h) the(h) fulness(f)  (e) of(f) the(e) time,(d) wherein(d)  (e) God(fe) sent(d)  &quot;(gi) forth(ef) his(f) Son(h) in-(e)to(f) the(e) world.(d)  (h)  (i)  (g)  (h)  (fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png",
    },
    {
        title: "part-c-041-3",
        gabc: "ith(c)  (h) joy(hg) shall(fh) ye(h) draw(fe) wa(fe) —ter(d) out(f) of(d) the(f) wells(h) of(e) sal-(fe) T(d) 3(d)  (h)  (i) ;(g)  (h)  (d)  (hfh) ",
        groupIndex: 3,
        filename: "./pages/part-c-041.png",
        nextFileName: "./pages/part-c-042.png",
    },
    {
        title: "part-c-042-0",
        gabc: "he(f) Lord(e) shall(f) go(hi) forthTout(i)  (i) of(h) his(i) ho(j) 1y(h) place:(i)  he(jk)  he(gihg) shall(ef) come(f) to(e) save(de) his(fh) people.(f)  (f)  (i)  (h)  (i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png",
    },
    {
        title: "part-c-042-1",
        gabc: "D(c) rop(f) down,(e) ye(f) heavens,(h)  (h) from(h) a-(ij)bove,(i) and(i) let(h) the(i)  skies(jh) pour(i) down(ij)  (h) righteousness:(g)  (f) let(f) the(i) earth(h) o(f) pen,(f)  [(e) let(d) them(e) bring(fg) forth(h) [(h) salvation.(f) o(f) e(i)  (h) |(i)  (j)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png",
    },
    {
        title: "part-c-042-2",
        gabc: "end,(e) O(f) Lord;(h) the(hi) Lamb,(i) the(i) Ruler(h)  (i) of(j) the(h) land,(i)  from(i) the(i) rock(fi) of(g) the(h) de-(fe)sert(f) un-(e)to(d) the(e) mount(f) of(g)  the(h) daughter(hg)  (hi) of(hg) Si-(f)on.(f) e(i)  (h) ittt(i)  (j)  (h) |(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-042.png",
        nextFileName: "./pages/part-c-043.png",
    },
    {
        title: "part-c-043-0",
        gabc: "That(e) thy(f) way,(h) O(ij) Lord,(i) may(h) be(i) known(j) up(i) —on(h) earth,(i)  thy(jk)  thy(ig~)  (gihg) saving(f)  (e) health(f) a-(e)mong(de) all(fh) nations.(f)  (f) |(i) .(h)  (i)  (j) i(h) iv(fh)  Re.-(f)ward(e) thou(f) them,(h) O(ij) Lord,(i) that(hi) wait(j) for(h) thee,(i) and(f) let(g)  thy(h) =(fe) pro—phets(fe) be(de) found(f) faith—ful.(f)  (f)  (i)  (h)  (i) i1(j)  (h)  (f)  he(dd) &quot;(c) was(d) )(ef) en(g) by(fe) Moses,(d)  (d) but(fg) grace(hg) and(gf) truth(f)  5(jk)  came(f) by(g) n(e) Je—sus(fe) Christ.(d) e(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-043.png",
        nextFileName: "./pages/part-c-044.png",
    },
    {
        title: "part-c-043-1",
        gabc: "Te(c)  (d) prophets(dd)  (c) did(d) foretéll(fe)  (dc) fthat(f) 2(g) Saviour(h)  (g) should(fg) be(f) born(f)  of(f) the(g) T(e) gin(f) Ma(c)  (cd) —ry.(d) e(h)  (g)  (f)  (d)  (fgh)  (g)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-043.png",
        nextFileName: "./pages/part-c-044.png",
    },
    {
        title: "part-c-044-0",
        gabc: "T(gi) he(f) Spi—ritTof(fgh)  (f)  (f) the(f) Lord(fe) is(f) up-(hg)on(e) me:(e) he(f) hath(g)  T(g) sent(f) me(e) to(g) preach(i) the(h) Gospel(h)  (fh) to(i) the(hg) poor.(f)  (h) ](g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png",
    },
    {
        title: "part-c-044-1",
        gabc: "or(f) Si-(h)on’s(hi) sake(i) TI(i) will(h) —_—\\.(i) hold(j) my(ih) peace;(i) until(i)  (f) the(i)  righteous-(g) (h) ness(f) L](e) thereof(f) ](e) forth(de) as(fh) brightness(f)  (f)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png",
    },
    {
        title: "part-c-044-2",
        gabc: "Be-(f)hold,(e) the(f) Lord(h) shall(hj) come,(i) that(i) he(h) —Q—————‘(i) sit(j) a—mong(i)  (h)  princes,(i)  (i) and(g) in-(h)he-(fe)rit(f) the(e) tkrone(de) of(fh) glo-(f)ry.(f) |(i) a0,(h)  (i)  (j) |(h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png",
    },
    {
        title: "part-c-044-3",
        gabc: "ell(h) it(hi) TR(i) R(i) mong(h) B(i)  (j) e(i) and(h) e(i) say:Be-(i)=(fi)  our(gh) God(fe) and(ef) Sa-(de)viour(fh) e(f) e(f) &#39;(i) ‘(h)  (hj) )(i)  (d) ",
        groupIndex: 3,
        filename: "./pages/part-c-044.png",
        nextFileName: "./pages/part-c-045.png",
    },
    {
        title: "part-c-045-0",
        gabc: "rom(f) Si(gh) on(h) draweth(h)  (g) nigh(h) the(ef) Lord(g) Al-(f)migh-(d)ty(d) to(d)  Si(i)  bring(fe) salvation(fg)  (fe)  (c) un-(eg)to(e) his(fe) people.(d)  (d) ™(h) WIF(g)  (f) BT(g) Wi(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png",
    },
    {
        title: "part-c-045-1",
        gabc: "T;m&#39;(he) thee(f) &#39;a-(ed)gain,(efe) O(de)  (e) at(gh) the(if) last,(hg) and(i) do(i) not(h)  T;m&#39;(c)  de-(h)lay(ij) to(i) come(hghih) un-(ef)to(fh) thy(gf) e(e) servants.(e) |||(h) e(g)  (h)  (f) W(e)  From&#39;Si-(f) (gh)  (h) onTcomet.h(h) a(g) he(h) that(g) is(e) to(f) reign(g) as(fe) Lord:(d) e(f)  Fm-(f) (gh) man(gf) el(f) 1is(fe) his(dc) migh-(d)ty(efe) Name.(d) [(h) e«(g) e(f) e(g) ](ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png",
    },
    {
        title: "part-c-045-2",
        gabc: "ET(c)  (gd) o(f)  (g) my(h) God,(g) tand(g) I(g) will(g) give(hg) him(f) honour:(gh)  (h) my(hj) fa—(g)  (f)  thers’(fe) God,(f) and(d) I(df) will(fgh) ex-(h)alt(g) him.(g) &#39;(j)  (i) bial(j)  (h) O(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-045.png",
        nextFileName: "./pages/part-c-046.png",
    },
    {
        title: "part-c-046-0",
        gabc: "T(g) Lord(hj) is(j) O(h) B(j) SO(i) S(i) e(g) ey(hi) St(i) s(h) King,(g) he(i)  himself(h)  (j) will(i) 0(g) and(h) will(f) save(g) -(e)us.(j)  (h)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png",
    },
    {
        title: "part-c-046-1",
        gabc: "B(gi) |(fi) ye(hg) steadfast,T(ef)  (f) and(f) see(f) the(h) sal-(g)(T(e) va—tion(e) of(g) 5(e)  [(gi) Lord(f) with(gh) you.(f) S(h) 7y(g) sy(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png",
    },
    {
        title: "part-c-046-2",
        gabc: "](e) to(f) thee,(h) 0(hi) Lord,(i) Tdo(i) I(i) lift(i) up(h) my(ij) soul:(i)  =(fi) and(g) de-(h)1liv-(f)I+(e) me,(fe) for(d) I(e) flee(fg) un-(h)to(hg) thee,(hi)  0(hg) Lord.(f) e(i) —I—=(h) e(i) ey(j) S(h) e(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png",
    },
    {
        title: "part-c-046-3",
        gabc: "RGN(gi) Clome,(h) 0(hi) Lord,T(i) and(i) do(hi) S(jh) tarry:(i) (i(i) forgive(i)  (fi) the(g) ",
        groupIndex: 3,
        filename: "./pages/part-c-046.png",
        nextFileName: "./pages/part-c-047.png",
    },
    {
        title: "part-c-047-0",
        gabc: "of-(h)fen-(fe)ces.(fe) of(d) thy(e) people(f)  (h) Is-(f)ra-(f)el.(f)  (i) i(h)  (hj) 4(i)  God(dd) shall(c) come(d) £rom(f) Le—ba-(g) (fe) rion,(dc) and(f) his(g) bright-(h)ness(f)  shall(f) be(fg) as(e) the(fe) light.(d) N(h) e(g)  (f) e(gh) eE(g)  Therefore(hi)  (i) I(i) will(h) look(ij) un-(h)to(i) the(j) Lord,(i) and(i) I(f) will(i) T(g)  -(gh)for(f) the(e) God(f) of(e) my(ed) sal-(fh)va-(f)tion.(f) o(i) .(h)  (hj) s(i) ",
        groupIndex: 0,
        filename: "./pages/part-c-047.png",
        nextFileName: "./pages/part-c-048.png",
    },
    {
        title: "part-c-047-1",
        gabc: "The.word(gi)  (f)  (h) of(h) the(hj) t(i) shall(h) be(i) look—ed(j)  (i) for(h) as(ij) the(j) rain,(i)  and(gihg) as(f) 0(e) dew(fe) L(d) N(e) God(f) e(g) down(h) [(fghg) B,(f) us.(f)   (i)  (h)  (i)  (j)  (h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-047.png",
        nextFileName: "./pages/part-c-048.png",
    },
    {
        title: "part-c-048-0",
        gabc: "Be(eh) not(f) a-(de)fraid,(e) for(i) up-(g)on(j) the(i) fifth(hi) day(h) oyr(hgf) ot(hi)  shall(jk)  shall(gi)  (hf) come(g) to(f) you.(e) SEC(h) 8T(g) L(h)  (f) RayR(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-048.png",
        nextFileName: "./pages/part-c-049.png",
    },
    {
        title: "part-c-048-1",
        gabc: "There(d) shall(dc) come(fg) fortht(ihi) a(h) rod(ihghihgg) out(f) of(e) the(f) stem(g) of(fe) Jes-(de)se,(d)  and(d) all(ff) the®(defedcd) ejr.th(dc) shall(ffg) be(ihi) fill-(hi)ed(h) with(h) the(ghg) glo-(hg)ry(fe) of(fg)  the(fe) Lord:(f) and(f) all(def) flesh(fe) shall(df) o(fc) the(e) sal-(f)va-(g)tion(e) of(fe) God.(d)  .(h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-048.png",
        nextFileName: "./pages/part-c-049.png",
    },
    {
        title: "part-c-049-0",
        gabc: "Thou&#39;(c)  (g) Beth—-(hj)le-(j)hem,(j) in(j) the(j) land(j) of(hj) Ju—da,(ji)  (g) shalt(gi) not(hg) be(e)  the(fg) least:(g) for(g) out(g) of(h) thee(j) shall(j) come(j) a(h) Gov—er-(j) (i) nor,(g)  that(g) shall(g) rule(fh) my(g) peo-(h)ple(gf) Is-(g) (gf) ra~el.(e) e(j)  (h) e(j) Ao(ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png",
    },
    {
        title: "part-c-049-1",
        gabc: "The(h) An—gel(fg)  (gh) t(f) Ga—bri—el(g) e(ihi) was(hf) sent(h) to(j) Ma—ry,(i)  (j) a(h) Vir—gin(j)  (ij)  es—pous(h)  (gf) —ed(gh) to(i) Jo-(h)—seph.(g)  (ef)  (j)  (i)  (j) ‘(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png",
    },
    {
        title: "part-c-049-2",
        gabc: "~(e) Ye(f) =(g) watchful(f) 3(g) your(f) 3(efhhg) for(e) the(f) Lord(gf) e(df) (iod(fc)  1s(fd) nigh(f) at(fg) hand.(e) :(h) SR(h) R(g)  (h) ;(ih) T(gfe) P,(e) ;(fh) ",
        groupIndex: 2,
        filename: "./pages/part-c-049.png",
        nextFileName: "./pages/part-c-050.png",
    },
    {
        title: "part-c-050-0",
        gabc: "For(c)  (d) lo,(f) as(fg) soon(g) as(g) the(g) voice(g) of(g) thy(f) sal(gh) —u-(h)ta-(g)tjon(g)  sound-(dg)ed(f) in(e) mine(df) ears,(df) the(cd) babe(ffd) leap-(fh)ed(g) in(h) my(gf) womb(ghg) fo,(fe)  T(d)  T(dc) al(d) -(efe)lu-(d)1a.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-050.png",
        nextFileName: "./pages/part-c-051.png",
    },
    {
        title: "part-c-050-1",
        gabc: "H(c) n(c) shall(e) this(gf) be,(df) O(f) An-(f)gel(e) of(d) a(cdfdefe) see-(e)ing(f) I(ghg)  :(eg) know(fd) not(e) a(d) man?(c) Hearken,(ghg) e(g) O(hj) Vir-(ji)gin(hg) Ma(h) ry:(hge) the(f)  Ho(h) ly(g) Ghost(fgf) shall(ef) come(fh) up-(g)on(fe) thee,(df) and(f) the(g) pow&#39;r(ffe) of(d)  the(ge~)  (ef) Highest(d)  (c) shall(c) ov-(c) (cd) -(dc)er(c) thee.(c)  (h)  (g)  (f)  (ed)  er(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-050.png",
        nextFileName: "./pages/part-c-051.png",
    },
    {
        title: "part-c-051-0",
        gabc: "?(c) Be-(cj)hold(ji) all(h) things(g) are(hi) fulfilled(h)  (g) t(g) which(gh) were(g) spo-(g)ken(e) by(g)  the(g)  (ef) An—gel(f) of(d) the(ef) Vir-(gh)gin(h) Ma-(g)ry.(g) ADVENT(j)  (h)  (j)  (k)  (j) ",
        groupIndex: 0,
        filename: "./pages/part-c-051.png",
        nextFileName: "./pages/part-c-052.png",
    },
    {
        title: "part-c-051-1",
        gabc: "ﬁlow(c)  (f) the(c)  (d)  (dhi)  (h) Si(hgfg)  (fghghi) on,(hgg) for(f) the(g) day(h) of(g) the(f)  Lord(g) is(dg) nigh&#39;(gfed) =(fed) at(cdfede) hand:(e) behold,(f)  (fg) he(fe) cometh(c)  (d) to(f) save(ed)  us,(def) al-(c)le-(d)lu-(fg)ia,(fe) al-(g)le(fe) lu-(d)ia.(d)  (h)  (g)  (f)  (h)  (g)  TtheDesire(ikc)  (d)  (dc)  (f)  (g)  (fh) of(h) all(h) nations(ih)  (g) shall(fh) come:(g) and(g) the(g) house(g)  a(e) the(g) Lord(h) shall(g) be(f)  (f) &lt;(g) filledwithglory,(f)  (fe) al-(dc) (d) le(efe) —lu-(d)ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-051.png",
        nextFileName: "./pages/part-c-052.png",
    },
    {
        title: "part-c-052-0",
        gabc: "The(c)  (cd) crook—ed(dh) f(hi) shall(h) be(g) made(h) straight,(h)  (fhg) and(f) the(g) rough(hgef) a(g) places(fe)  plain:(d) come,(fg) O(ef) Lord,(d) and(ef) do(g) not(f) tar-(fe)ry,(dc) al(d) —le(efe) lu-(d)ia,(d)  Dominus(h) veniet(g)  (f) .(gh) .(g)  &#39;he(cdc) Lord(f) will(gh) come,(h) go(h) ye(hj) out(h) to(g) meet(hg) him,(e) say-(ff)ing:(d)  Great(hihh) is(g) his(hj)  (j) do—min—1ion,(jih)  (h) and(hgg) of(f) his(gh) king-(gfg)dom(g) there(h) shall(g)  be(f) no(gf) end:(d) .the(g) migh-(ggg)ty(gd) God,(efd) the(e) Gov-(f) (de) er—nor,(dc) the(cd)  Prince(ffe) of(fg) peace,(g) al(c) —le-(d)lu-(f)1ia,(e) al(g) -(fe)le-(d)1ia.(d)  (h) ||(g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-052.png",
        nextFileName: "./pages/part-c-053.png",
    },
    {
        title: "part-c-052-1",
        gabc: "Thine(hg)  (h) Al-(gh)mighty(f)  (fe) Word,(f) O(hg) Lord,(e) leapeth(g)  (h) down(i) from(hg) heaven(f)  (f)  out(ig~)  (h) of(g) thy(h) roy-(i)al(h) throne,(ge) al(f) —-(ghg)lu-(f)ia.(f) ;(h)  (ddg)  (edd)  (df)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-052.png",
        nextFileName: "./pages/part-c-053.png",
    },
    {
        title: "part-c-053-0",
        gabc: "H(c)  (c) ail,(cd) Ma—ry,(dhi)  (h) thou(h) that(g) art(f) full(g) of(gh) grace,(h) the(f) Lord(h) is(gf)  with(g) thee:(d) blessed(g)  (h) art(g) thou(fe) e(f) a—mong(gf) e(dc) =(ef) al-(g)le(fe) lu-(d).(d)  0(h)  (g)  (f) 3(gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-053.png",
        nextFileName: "./pages/part-c-054.png",
    },
    {
        title: "part-c-053-1",
        gabc: "Thus(g) saith(f) the(e) Lord(d) your(d) God:(fdfghhg) Re-(cd)pent(ffg) ye,(g) and(g) turn(h)  a(ghgfg) gain;(gf) for(f) the(gh) kingdom(j)  (g) of(h) hea—ven(gd)  (f) 1s(gh) at(h) hand,(gfd)  (f)  al(ik)  (f) —-(fg)le—lu-(g)ia.(g)  (h) PR(j)  (i) .(j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-053.png",
        nextFileName: "./pages/part-c-054.png",
    },
    {
        title: "part-c-054-0",
        gabc: "Awake,(hgicf)  (fi) a-(hg)wake,(ef) put(f) on(h) strength,(e) O(e) arm(ge) of(f) the(fh) Lorq,(f)  |(h)  (g)  (e) WEDNESDAY(f)  I(f) will(g) place(h) sal-(g)va-(fg)tion(g) in(fh) Si-(h)on,(g) and(h) in(j) Je-(g)ru-(hg) (f)  sa—lem(fg) W(g) my(hg) glo-(fe)ry,(d) al-(f)le-(fg)lu-(g)ia.(g) :(j)  (i) SRl(j)  (h) v(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-054.png",
        nextFileName: "./pages/part-c-055.png",
    },
    {
        title: "part-c-054-1",
        gabc: "Com—fort(h) i~(hg) ye,(f) AN(f) ye(fh) my(hih) peo-(hg)ple,(fe) saith(f) your(ghg) God.(f)  A(gi) 3(h)  (g) a(e) .(f)  Be-(j)hold,(hji) all(h) things(g) are(hi) e(h) fulfilled(g) t(g) which(gh) were(g) spoken(g)  (e) by(g)  the(g) An—gel(ef)  (f) of(d) the(ef) Vir-(h)gin(h) Ma(g) —ry.(g) :(j)  (h) |(j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-054.png",
        nextFileName: "./pages/part-c-055.png",
    },
    {
        title: "part-c-055-0",
        gabc: "Mere(cdc) was(f) a(g) marriage(fh)  (h) tin(h) Ca—na(h)  (hjj) of(h) Ga-(h)1i(gf) lee,(icgihghg) and(g)  Je(e) sus(g) was(hg) there(fgf) with(c) Ma(dg) —ry(e) his(fe) Mo(d) —ther.(d) [(h) i:_l__l(g)  (f)  (gh) =(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-055.png",
        nextFileName: "./pages/part-c-056.png",
    },
    {
        title: "part-c-055-1",
        gabc: "Je—sus(g)  (h) saw(ghj) the(j) heavens(ji)  (h) o(hi) —pen—ed,(hg)  (g) and(g) the(hi) Spi-(h)rit(gf) like(e)  a(fg) dove(g) de-(gh)e(hgf) scend—ing(g) up(gf) —on(e) him.(e) e(ji) ¢(hi) e(h) el(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-055.png",
        nextFileName: "./pages/part-c-056.png",
    },
    {
        title: "part-c-056-0",
        gabc: "\\M\\en(c)  (g) —(h) sus(gf) was(g) come(hj) down(hj) from(i) the(h) mountain,(g)  (g) be-(f)hold(g)  there(hj) came(ji) alep(hg)  (hihg) er(g) and(fh) wor-(j)[t(ji) shipped(hg) him,(hih) say-(g)ing,(g) Lord,(gfd)  if(e) thou(fg) wilt,(ghgf) thou(h) canst(j) make(i) me(hih) clean.(g) And(g) Je(g) sus(g) put(h)  orth(eg) his(fg) hand(gfed) and(e) touch-(f)ed(g) him,(ghgf) =(h) ing:(h) =(hjjihg) will;(hi) be(i)  thou(hih) clean.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-056.png",
        nextFileName: "./pages/part-c-057.png",
    },
    {
        title: "part-c-056-1",
        gabc: ".(f) when(g) Je(if~hi) sus(i) was(ih) en-(g)ter—ed(f)  (g) in-(ghg)to(f) aship,(ef)  (f) be-(f) (f)  hold,(fe) there(d) |a(dc) rose(ifghihg) a(g) great(gf) tem-(g)pest(iih) in(gh) the(gf) sea:(df) and(fghidhg) ",
        groupIndex: 1,
        filename: "./pages/part-c-056.png",
        nextFileName: "./pages/part-c-057.png",
    },
    {
        title: "part-c-057-0",
        gabc: "his(gf) dis—ci-(fg) (fe) ples(d) |a(dc) woke(gf) him,(ghg) say-(f)ing:(f) Lord,(g) save(fi) us,(ih)  per—ish.(f)  (f)  (h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png",
    },
    {
        title: "part-c-057-1",
        gabc: "Sir,’[(dh) didst(h) not(g) thou(h) sow(gf) géod(fd) seed(fgh) én(f) téy(edfede) tglem,(ed) ;rom(gf)  whence(fghgfgh) then(g) hath(fe)  (dc) tares?(d) Hé(c) said(d)  (f)  (d) An(dc)  (cg)  en(fghgfgh) e-(g)my(fe) hath(dc) done(efe) this.(d) ey(h)  (g) oty(f) P(gf)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png",
    },
    {
        title: "part-c-057-2",
        gabc: "un—to(i) a(h) grain(ih) of(f) mus—(hi)  |-(hg)seed,(f) which(eh) is(h) the(h) least(hg) |(fe) all(gf~fe) 8(e) |(fhi) oW(e) when(hg~) it(ij)  :(k) grown,(ji) [(hg) is(h) S——(i) e(ihij) e(i) ey(gh) e(ihfg) e(fe) e(j) e(i) dg(h) et(gi) ",
        groupIndex: 2,
        filename: "./pages/part-c-057.png",
        nextFileName: "./pages/part-c-058.png",
    },
    {
        title: "part-c-058-0",
        gabc: "A(g) the(h) lightning(ghj)  (j) com-(i)eth(j) out(k) of(ji) the(hi) east,(hg) and(hg) shineth(j)  (i)  e-(hi)ven(hg) un-(fe~)to(g) the(h) west;(gfd) so(dh) shall(h) al(hj) —so(h) the(g) [(e) ing(f) of(g)  the(ik)  (f) Son(g) of(h) man(gfe) be.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 0,
        filename: "./pages/part-c-058.png",
        nextFileName: "./pages/part-c-059.png",
    },
    {
        title: "part-c-058-1",
        gabc: "Have(h) Sleol(h) -(h)O(e) God,(g) up-(i)R(h) me,(h) and(h) cleanse(h) me(j) from(i) my(j)  wick-(h)ed-(g)ness;(hg) for(e) a-(f)gainst(g) thee(g) on-(e)1ly(f) have&#39;l(gh) e(fe) sin-(d)ned.(d)   (h)  (g)  (f)  (g)  (h)  I(f) will(fg) thank(g) thee,(gf) for(h) thou(j) hast(i) heard(g) me.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-058.png",
        nextFileName: "./pages/part-c-059.png",
    },
    {
        title: "part-c-059-0",
        gabc: "0(d) God,(d) thou(f) art(e) my(d) God,(d) N(dc) ly(fg) :(jihi) I(h) seek(fg) theed,(fgfefedcdc) :(dc)  he—cause(cd)  (fg) thou(f) hast(ef) been(g) my(fe) hel—per.(d)  (d) R(h) s(g) e(f) e(gh) P(gf)  Bless—ed(f) g(e) art(f) thou(d) in(d) the(dc) fir-(f)ma-(g)ment(hi) of(g) hea—ven:(iig)  (h) and(h)  wor—thy(h)  (g) to(f) be(e) prais—ed(f)  (f) for(fg) ev-(fe)er,(c) Q(d) our(efe) God.(d)  (h) g(g)  (fh) i7(g)  ()(dh) praise(hg) the(ef) Lord(g) of(fe) heaven.(d)  (d) |(h) R(g)  (f) s(gf) s(gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-059.png",
        nextFileName: "./pages/part-c-060.png",
    },
    {
        title: "part-c-059-1",
        gabc: "T(cd) e(idhi) kingdom(h) of(h) heaaven(h)  (ihghih) 1s(h) like(h) un—to(h)  (g) a(f) man(e) that(f) is(g) an(fe)  (d)  e(ki~) hOUSeholder,(d)  (cd)  (d) which(cd) went(idhi) out(h) ear—ly(h)  (h) in(h) the(g) morning(hg)  (e) to(f) hire(ghfe) |(d)  labourers(d)  (cd) Sy(d) N(fd)  (e) his(f) S(h) =(ghg) U(ef) the(gf) Lord.(d) Y(h) e(g)  (ffgh) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-059.png",
        nextFileName: "./pages/part-c-060.png",
    },
    {
        title: "part-c-060-0",
        gabc: "Af—ter(f) L](g) thy(h) great(gf) a(g) =(gh) have(f) mer-(f)7(e) up-(f)op(g) :(e)  0(fe) God.(d) S(h) s(g) iR(f)  (g) (e(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png",
    },
    {
        title: "part-c-060-1",
        gabc: "[(f) the(g) Lord(h) be(gf) on(g) my(fe) side,(d) I(f) will(gh) not(h) fear(ghg) what(f) man(gf) do-(f) eth(ef) R(g) I(fe) me.(d) SR(h)  (g) e(f) e(g) 1(ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png",
    },
    {
        title: "part-c-060-2",
        gabc: "With-(c) (ff) ®(e) the(f) veil(h) thave(f) I(g) call-(fe)a(e) a(e) —ry(f) ear-(h)ly(h) in(h) the(h)  morning:(hi)  (h) O(h) God,(ij) thou(ji) art(h) my(i) God,(iji) ear-(e)ly(f) will(h) I(g) seek(egdd)  thee.(gi)  (f) ,(h)  (g) ;(e)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-060.png",
        nextFileName: "./pages/part-c-061.png",
    },
    {
        title: "part-c-061-0",
        gabc: "Lot(g) us(g) sing(g) @(h) hymn(gf) un(hj) to(ji) the(hg) Lord(hi) our(h) God.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png",
    },
    {
        title: "part-c-061-1",
        gabc: "In(d) the(d) cym-(f)bals(e) and(d) danc-(d)és,(dc) 5—on(dc)  (f) the(hg) .(fg) and(f)  pipe,(f) O(fgf) praise(e) the(fe) Lord.(d) e(h) i(g) Zos(f) T(gh) Py(gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png",
    },
    {
        title: "part-c-061-2",
        gabc: "When(c)  (g) much(gj) people(hg)  (h) were(g) gath-(gh)er-(g)ed(g) to-(g)geth-(hi)er(h) to(g) Je(fg) sus,(g)  and(j) to(kj) him(jkkj) out(h) of(gf) ev(gh) —ery(ih) ci—ty,(g) &amp;(g) he(g) g(gh)  by(g) a(fe) pa(de) —(dc) A(c)  (g) sow—er(hj)  (j) went(j) out(gh) to(gf) sow(gh) his(h) seed.(g)  a(j)  (i)  (j) .(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-061.png",
        nextFileName: "./pages/part-c-062.png",
    },
    {
        title: "part-c-062-0",
        gabc: "Ac-(d)cord-(d)&#39;ng(dc) to(f) the(g) mul-(f)ti-(gh)tude(h) of(h) thy(h) mer—cies,(hj)  (h) 0(gf) Lord,(ghg)  do(hg) a-(f)way(ef) mine(g) &#39;of(fe) fences.(d)  (d) SRR(h) N(g) e(f)  (gh) |(gf)  T}xou(c)  (h) art(h) my(hi) God,(hghih) and(h) I(f) will(hg) thank(e) thee:(e) thou(fe) art(df) my(hi)  God,(hghih) and(f) I(h) will(g) praise(e) thee.(e) [(h) e(f)  (h)  (i)  (h)  =(e) 1y(fh) will(i) I(i) seek(j) thee,(i) O(ih~) God,(g) that(h) I(iji) may(hghih) be-(f)hold(gh)  thy(gf) PO(e) o(e) [(j) Wy(i) o(h) e(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-062.png",
        nextFileName: "./pages/part-c-063.png",
    },
    {
        title: "part-c-062-1",
        gabc: "Sing(f) a(e) hym,(fed) and(cd) mag-(fg)ni-(h)fy(gf) him(fd) for(ef) ev(gfe) er.(e) -(h) (g) T(h) ,(ih)  (gfee) ",
        groupIndex: 1,
        filename: "./pages/part-c-062.png",
        nextFileName: "./pages/part-c-063.png",
    },
    {
        title: "part-c-063-0",
        gabc: "All(e) ye(ef) An(ff) gels(d) of(f) his,(hhih) O(i) praise(h) the(h) Lord(f) of(def) heaven.(d)  (d)  a(h)  (i)  (g)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-063.png",
        nextFileName: "./pages/part-c-064.png",
    },
    {
        title: "part-c-063-1",
        gabc: "e-(f)hold,(fed) a(c) go(de) up(ed) to(e) Je—ru-(f) (g) sa-(h)lem,(g) and(g) all(gh) things(i)  that(h) are(g) w.rit:—ten(hg)  (g) con—cern—-(h) (fe) ing(d) the(ef) Son(gf) of(de) man(e) shall(gf)  be(ik)  (g) ac(ghg) com-(fe)plish(de) ed:(e) for(e) he(gh) shall(hg) be(f) de(gh) liv(g)  er(fe) ed(e) un-(ef)to(g) the(f) n-(edc)t:.i&#39;les,(c) and(dc) shall(ef) be(gh) mock-(g)ed,(f)  :(ik) and(gh) spit-(g)—ted(fe) on;(e) and(e) they(gh) shall(hg) 0(hgf) =(f) and(h) put(gf) him(d)  to(ded) death;(c) and(c) the(d) third(ef) day(gh) he(g) .shall(f) rise(fh) a(gfe) gain.(e)   (h)  (g)  (h)  (ih)  (gfe)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-c-063.png",
        nextFileName: "./pages/part-c-064.png",
    },
    {
        title: "part-c-064-0",
        gabc: "When(c)  (g) ye(h) fast,fbe(i)  (i) not(j) as(i) the(h) hy-(ih) (fg) po—crites,(h) of(h) a(h) sad(if)  coun-(g)te-(f)nance.(e)  (j)  (i) THURSDAY(h)  (ih)  [ord,(c)  (f) my(gh) servant(h)  (g) li(h) ‘eth(ghg) at(ef) home(g) sick(g) of&#39;(f) the(g) pal-(fe) grievous-(ef)ly(g)  (fe) tormented.(cd)  (d)  (d) Vé-(c)ri-(d)1ly(f) I(f) say(g) un-(e)to(f) thee,(d) I(f)  will(g) come(hg) and(fe~) heal(d) him.(d) i(h) g(g) ey(f) s(g)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-064.png",
        nextFileName: "./pages/part-c-065.png",
    },
    {
        title: "part-c-064-1",
        gabc: "When(c)  (d) thdu(dc) do-(f)est(g) thine(fh) alms,(h) let(i) not(h) thy(g) left(fgh) hand(f)  know(d) what(g) thy(fg) right(e) hand(ef) do-(d)eth.(d) -(h)2(hdffg)  (fhf) U(dfghddfdgdffdfhd~) ",
        groupIndex: 1,
        filename: "./pages/part-c-064.png",
        nextFileName: "./pages/part-c-065.png",
    },
    {
        title: "part-c-065-0",
        gabc: "et(ig~)  (f) they(fc) seek(eg) me(f) dai-(fg)ly,(fe) and(h) light(jki) to(gh) know(i) my(hg) ways(f)  .(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-065.png",
        nextFileName: "./pages/part-c-066.png",
    },
    {
        title: "part-c-065-1",
        gabc: "Make(cdh) me(hi) a(hg) clean(hf) heart,!0(gh)  (fe) God,(d) and(f) re(e) —new(d) a(e) right(f)  spl-(g)rit(e)  (fe) me.(d)  (d)  (h)  (g)  (f)  (gf)  (gh)  Help(ig~)  (c)  (h) me(hgf) now,(fgh) O(fe) Lord:(fh) &#39;O(hf) Lord,(hij) send(iji) us(gh) now(i) i(ef) e(f) |(f)  SO(ig~) 1(f) ty.(f) A(h)  (g) e(e)  (f)  As(e) long(ehg) as™(h) 1(i) 2(i) &#39;O(hg) g(g) will(f) I(f) mag-(g)ni—fy(h)  (gf) thee(e) on(e)  P(h) 3(hgf) e(ghg) e(gh)  (iji) e(h) my(fgh) 1(fed)  (ef) e(gf) v(e) e(j)  (i)  (h) i(gf)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-065.png",
        nextFileName: "./pages/part-c-066.png",
    },
    {
        title: "part-c-066-0",
        gabc: "In(g)  (e) the(f) spirit(h)  (g) of(f) humil-(ef)i-(h) (f) ty(f) and(ef) with(h) a(f) contrite(h)  (ghf) heart,(fe) let(fe)  us(hgi)  (h) be(i)  (j) accepted(j)  (iji) by(gh) thee,(i) O(hg) Lord:(f) and(f) so(fi)  (ih) let(jh)  (ijijk) our(ji) sacri_(ih)  (i)  (j)  fice(gi)  (j) be(ih) of-(i)fered(f)  (f) as(f) to(i) be(h) ac-(fh)cepted(f)  (e) by(fe) thee(fgh) to-(e)day,(ec) e(e)  be(ef) pleasing(f)  (ef) in(f) =(fhj) sight,(hg) O(f) Lord(fi) 0o(gh) God.(f) e(h) e(g) e(e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png",
    },
    {
        title: "part-c-066-1",
        gabc: "O&#39;praise(hhg)  (fggh) God,(f) all(h) ye(ji) R(j) &lt;R(h) end(ji) all(h) ye(h) waters.(g)  (g) ||(j) |(i)  (j)  (h) e(fh) ",
        groupIndex: 1,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png",
    },
    {
        title: "part-c-066-2",
        gabc: "e(cf) shall(f) de-(f) (g) liver(gh) thee(hg) From(f) the(gh) share(gfd) of(f) the(g) hunter.(g)  (f) He(f)  shall.(f) ¥.(i) And(hi) from(h) the(h) [(h) noisome(g) e(f) pestilence.(gh) NN(hg) From(f) the(gh)  snare(gfd) .of(f) the(g) hunter.(g)  (f) ¥.(c) Glory(h)  (h) be(h) to(h) the(h) Father,(hi)  (h) and(dh) to(fh) the(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-066.png",
        nextFileName: "./pages/part-c-067.png",
    },
    {
        title: "part-c-067-0",
        gabc: "Son,(g) end(g) to(h) the(g) Ho-(f)ly(g) Ghost.(gh) He(f) shall.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png",
    },
    {
        title: "part-c-067-1",
        gabc: "|(hgi)  (fe)  (f)  (hg)  (h)  (fg)  (gf)  (ef)  (f) ()(hg)  (hi)  (ihg) R(f)  1(hi)  (hg) N(fg) W(fe) 1ot(e) T(e) P(f) R(g) [(hg) e(f) e(hg) el(hi) il(i)  e(ef) shall(hi) give(g) [(hg) his(f) Angels(gf) charge(ef) over(f) thee.(fgf) B(ef) ",
        groupIndex: 1,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png",
    },
    {
        title: "part-c-067-2",
        gabc: "hen(c) was(cd) Je-(d)TR(d) led(d) up(d) of(d) the(d) Spirit(f)  (cd) in-(d)to(c) the(d) wil-(fdfgh)der—(fe)  ness(d) to(f) be(g) tempted(h) .(g) of(f) the(e) de-(fgfd)vil:(d) and(d) ](dc) he(f) had(g) fas-(fh)ted(hgg)  forty(f) &quot;(g) days(h) [(g) for-(h)ty(fe) nights,(d) he(e) was(f) af-(g) (f) terward(g) an(fe) PR(d) hungred.(d)   (h)  (g)  (f)  (g)  (gf)  (d) ",
        groupIndex: 2,
        filename: "./pages/part-c-067.png",
        nextFileName: "./pages/part-c-068.png",
    },
    {
        title: "part-c-068-0",
        gabc: "ome,(hg) ye(hi) blessed(i)  (g) fof(ij) my(i)  (hhi) £(h) Father,*in—he—rit(h) a(i) the(hg)  (f) kingdon(hh)  (e) b(f)  pared(gf)  (e) for(fg) you(f) from(h) the(g) foundation(h)  (i) o(if) of(g) the(f) world.(e) e(j)  (i)  (ih~)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png",
    },
    {
        title: "part-c-068-1",
        gabc: "A(c) nd(cd) -(dhi)sus(h) twent(h) in—to(hj)  (h) the(h) tem—ple(h)  (h) of(h) God,(hghihgg) and(g) cast(h)  out(g) all(fg) them(e) that(f) sold(g) and(f) bought:(d) and(d) o(dgfgh) ver-(g)threw(f)  the(g) ta-(h)bles(g) of(fg) the(d) mo-(fe) (de) ney—changers,(dd)  (c) and(d) ;e(cd) seats(f) of(f) then(fghg)  &quot;that(ed) sold(efe) doves.(d) b(h)  (g) e(f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png",
    },
    {
        title: "part-c-068-2",
        gabc: "This.(g) crooked(gj) t(h) and(f) perverse(fg)  (gh) e(jk) e(j) ge—ne—raftlion(i) e(h) seeketh(j)  (dij) af-(d) (dhdd) ter(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-068.png",
        nextFileName: "./pages/part-c-069.png",
    },
    {
        title: "part-c-069-0",
        gabc: ".(gh) sign:(gf) and(g) there(g) shall(hi) no(ihihg) sign(g) be(ij) gi-(k)ven(j) it,(hj) but(j) the(j)  cign(jkj) of(i) the(h) prophet(j)  (i) Jo-(g)nas.(g) e(j) i(i)  (j) 0(h) e(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png",
    },
    {
        title: "part-c-069-1",
        gabc: "J(c) e(cd) sus(d) went(ef) thence,(d) and(d) d;—part—ed(c)  (fg)  (h) -(h)to(h) the(gf) coasts(gg)  of(d) T;re(dg) and(fe) S1(de) 0.1&#39;1:(dc) and(d) behold,(f)  (g) a(g) woman(h)  (g) of(g) Ca-(gf)na-(gf)an(d)  came(fhg~) out(h) of(fe) the(d) same(fg) coasts,(d) and(d) cri-(d)ed,(fe) Q-(c).(c) Have(d)  NN(f) mer—cy(hg)  (ed) on(fe) me,(c) thou(d) Son(dg) of(fe) Da-(d)vad.(d) B(h) W(g) A(f)  (g) i(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png",
    },
    {
        title: "part-c-069-2",
        gabc: "An(f) -(e)gel(f) of(h) the(hi) Lord(i) went(hi) down(j) from(ih) hea-(i)ven,(i) and(i)  Toubled(fi)  (g) the(h) Lo(fe) S(f) e(e) N(de) S(fh)  (f) S(f) e(i)  (h) o(i)  (j)  (h)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-069.png",
        nextFileName: "./pages/part-c-070.png",
    },
    {
        title: "part-c-070-0",
        gabc: "nd(f) Je(h) —sus(f) ta—keth(h)  (hf) his(f) .(e) dis—ci-(h)ples,(f) and(h) po(j) —eth(jk) iy(i)  to(gi)  (g) a(i) mountain,(ij)  (h) and(h) was(h) trans-(hi)fi-(h)gu-(hg)red(e) be—fore(gh)  (f) thep,(f)  :(ig~) :(h)  (g) II(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png",
    },
    {
        title: "part-c-070-1",
        gabc: "Thou(c)  (i) shalt(h) o(i) pen(h) my(g) lips,(ij) O(hi) lord,(f) and(h) my(g) mouth(h) shall(fd)  shew(ef) thy(f) praise.(e) -(j) (i) :(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png",
    },
    {
        title: "part-c-070-2",
        gabc: "The(h) right(hg) hand(ef) of(fg) the(f) Lord(e) bringeth(e)  (e) migh(f) -(ed)things(e) to(ef)  pass:(f) the(h) right(hg) hand(ef) of(fg) the(f) Lord(e) hath(f)  (e) ~em=1-(d) (def)  (f)  BT(e) !(h) ;(f)  (h) B(i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-070.png",
        nextFileName: "./pages/part-c-071.png",
    },
    {
        title: "part-c-071-0",
        gabc: "Thou(c)  (f) hast(ghg) been1(h) my(f) help-(hg)er,(ef) O(g) my(fe) God.(d) e(h) e(g) e(f)  (g) e(ghg)  [et(c)  (g) us(g) sing(h) the(h) song(g) of(g) the(g) three(hg) chil-(fgh)dren,(h) which(f)  they(h) sang(j) as(k) they(i) bless-(j)ed(h) the(g) Lord(h) in(h) the(g) burning(g)  (f) fi—ery(fgh) T(h)  furnace.(g)  (g)  (j)  (i)  (j)  (h)  (g)  He(ce) hath(f) made(h) them(j) fast(i) for(ij) ev—er(j)  (i) and(fh) ev—(gf) er:(e) he(f) hath(f)  giv-(de).(e) them(f) a(h) law(g) which(h) shall(df) not(f) be(f) broken.(e) et(e) |iesenseraleesl](j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-071.png",
        nextFileName: "./pages/part-c-072.png",
    },
    {
        title: "part-c-071-1",
        gabc: "A”d(f) Je-(h)sus(f) ;(h) taketh(hf) his(f) a(e) ci-(gh)ples,f(f) and(h) go—eth(j) g(jk) up(i) in-(i)a(g) a(i)  Mountain,(ij) e(h) and(h) ‘__l_-(h)transfi-(hi)gu-(h)red(hg)  (e) be-(fgh)fore(f) l(f) [(h) pe(g) e(e)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-071.png",
        nextFileName: "./pages/part-c-072.png",
    },
    {
        title: "part-c-072-0",
        gabc: "J(c) e(cd) sus(d) went(f) thence,(d) and(d) «(c) part-(fg)ed(h) in-(h)to(h) the(gf) coasts(gg) of(d)  Tyre(dg) and(fe) Si(de) don:(dc) and(d) i(f) behold,(g) a(g) woman(h) .\\(g) of(g) Ca-(gf)na-(gf)[(d) came(fgh)  (g)  out(h) of(fe) the(d) same(gf) coasts,(d) ahd(d) cri-(d)ed,(fe) ssyir.l&#39;g:(c)  (c) Have(d) mer—cy(fhg)  (ed)  on(fe) T(c) thou(d) Son(dg) of(fe) Da-(d)vid.(d) e(h) a(g) e(f)  (g) ANGRA(gfed) ",
        groupIndex: 0,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png",
    },
    {
        title: "part-c-072-1",
        gabc: "[(ig~)  (ch) am(h) the(h)  (h) Beginning,(h) [Fe(hghih) [V(hf) ven(gf) I(e) that(ef) speak(ed) e(ef) to(f) you.(e)  TUESDAY(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 1,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png",
    },
    {
        title: "part-c-072-2",
        gabc: "A(hg) o(h) is(hg) your(e) Mas-(gh)ter,(f) fwhich(fe) is(hi) in(hj) hea(jihg) -(ihi)ven,(ih) e-(i)ven(hg)  |(ig~) Christ(e) the(gh) Lord.(f) ey(h) T(g)  (e) el(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-072.png",
        nextFileName: "./pages/part-c-073.png",
    },
    {
        title: "part-c-073-0",
        gabc: "a(ce) Be_hold.(gh) we(i) go(j) up(ji~) fto(hg) Je—(f)  (h) ru—sa—lem:(i)  (g) and(h) the(h) Son(i) of(g)  man(h) shall(f) be(f) be-(ed) (ef) tray—ed(f) to(i) be(j) cru-(hf) (gf) fi(e) —ed.(e)  (j) e(i)  (h) ||(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png",
    },
    {
        title: "part-c-073-1",
        gabc: "So’ﬁ,(eh) te(fd) —mem-(ef)ber(e) that(e) thou(e) in(g) thy(h) lifetime(i)  (h) receivedst(h)  (i)  (h)  thy(gf) good(g) things,(h) and(h) likewise(hi)  (hghih) La-(f)za-(e)rus(f) e-(h)vil(g) things.(e)  E(h)  (g)  (h) [(f)  (e) ",
        groupIndex: 1,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png",
    },
    {
        title: "part-c-073-2",
        gabc: "He(g) will(h) mi(ghj) se(j) ra(j) —bly(ji) des—troy(hg)  (hg) those(g) wicked(gh)  (i) men:(h) and(i)  will(h) let(h) out(i) his(h) vineyird(h)  (ed) —(g) to(h) o(j) ther(j) husbandmen,(h)  (hk) Mhich(k)  shal](j) ren-(ji)der(hg) him(h) o(g) =(ghjjg) e(h) their(h) R(e) W(e) o(dji) RS(hi)  (h) |(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-073.png",
        nextFileName: "./pages/part-c-074.png",
    },
    {
        title: "part-c-074-0",
        gabc: "will(cdh)  (h) gotto(j)  (h) my(g) father,(h)  (g) and(h) will(g) say(ge) un-(fgh)to(fe) him:(d) ‘Fa-(ff) ther&#39;(c)  make(fhghi) me(h) as(g) one(fg) of(f) thy(ef) hir(g) &#39;ed(fe)  (d) servants.(d) B(h) |(g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-074.png",
        nextFileName: "./pages/part-c-075.png",
    },
    {
        title: "part-c-074-1",
        gabc: "O(g) be(h) d(gi) vour-(i)a-(i)ble(ik) and(j) gracious(ji)  (h) fun—to(ij)  (i) Si-(g)—on:(g) build(ge)  thou,(f) O(e) Lord,(d) the(d) walls(f) of(gh) Je(gf) —ru-(e)sa-(de)lem.(e) I(ji)  (hi) &lt;(h)  (g)  The(c)  (h) Lord(fg) is(hg) on(fgh) my(fe) side:,(d) I(f) will(gh) not(h) fear(ghjijkj) what(hg) man(hg)  [(e) eth(f) -(hg~)to(h) me.(g)  (j)  (i)  (j)  (h)  (gh)  My(g) lips(f) shall(h) praise(j) thee(i) as(g) long(i) as(j) I(h) live,(i) O(h) my(gf) God-(dg) 3(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-074.png",
        nextFileName: "./pages/part-c-075.png",
    },
    {
        title: "part-c-075-0",
        gabc: "fire(c)  (d)  (dh) for-(h)gat(hj) his(h) pow—er(h)  (hghihgg) and(f) vir-(g)tue,(df) that(d) thy(fe) chil-(fg) dren(g) might(gg) be(c) de-(d).(fe) liv—er—ed(f)  (g) un-(fe)harm-(d)g(d) ed.(h)  (g)  (f)  (gh)  (gh)  O(f) ve(gh) sun(h) and(gh) moon,(ef) praise(g) ve(fe) the(df) Lord:(cfc) f8r(c) his(d) Name(c)  (fg)  on—ly(f) a(e) is(f) ex—(g) cel(fe) lent.(d) [(h) [[EETrrawicannings(g)  (f) e(g) AR(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png",
    },
    {
        title: "part-c-075-1",
        gabc: "When(c)  (g) a(g) strong(jg) man(h) arm—ed(ghjh) t(iji) keepeth(i)  (j) his(kj) palace,(h)  (g) all(g)  (ig) his(hg)  (e)  goods(f) are(g) in(f) peace.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png",
    },
    {
        title: "part-c-075-2",
        gabc: "V‘e~ri_1y(d)  (d)  (f) l.say(dc)  (f) un—to(g)  (fh) you,(hgg) No(dfg) prophet(hg)  (f) is(f) ac(f) cep(fg) ~ted(f)  In(ki~)  (f) his(g) own(fe) country.(d)  (d) Lo(h)  (g)  (dfdghdgf) ",
        groupIndex: 2,
        filename: "./pages/part-c-075.png",
        nextFileName: "./pages/part-c-076.png",
    },
    {
        title: "part-c-076-0",
        gabc: "I(c)  (cd) two(dhi) of(h) f(h) shall(h) a-(h)gree(hj) on(h) earth(h) as(h) touching(h)  (h) an-(h)y_(h)  thing(hghihgg) that(f) they(h) sgall(fe) ask,(d) it(f) shall(fe) be(df) done(f) for(dedcd) of(dc)  (c)  my(ik)  (d) Fa(f) ther,(ef) saith(g) the(fe) Lord.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png",
    },
    {
        title: "part-c-076-1",
        gabc: "Hearken,(j)  (i) and(g) un-(i)der-(j)stand(hg) ye(f) the(f) tra—di-(h) (j) tions(i) which(j) the(h)  Lord(i)  (i) hath(h) R(g) gi—ven(fg) you.(g) a-(j) (h)  (j) -(k) (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png",
    },
    {
        title: "part-c-076-2",
        gabc: "a(c)  (e) de-(eh)vils(f) al(f) a(e) F.(ed) a(e) of(fgf) /-(e)B(e) a(e) ing(h) out(i) and(ji) -(dd) (d)  saying:(gh)  (hh)  (g) Thou(gh) art(ih) Christ(fed) the(f) el(f) of(gf) God.(e) And(fijihfd) he(dj)  (d) rebuk-(dkdjddi) (d)  .(ij) them(i) suffered(i)  (g)  (i) them(ji) not(h) to(f) =(fgh) for(ih) they(fe) D(dcefeddd) that(he~ed~) ",
        groupIndex: 2,
        filename: "./pages/part-c-076.png",
        nextFileName: "./pages/part-c-077.png",
    },
    {
        title: "part-c-077-0",
        gabc: "Chrast.(e)  (h)  (g)  (h)  (f)  (e)  he(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png",
    },
    {
        title: "part-c-077-1",
        gabc: "who_so—ev—er(j)  (ji)  (hg) drinketh(hih)  (gh)  (g) of(g) the(g) wa-(g)ter(e) that(g) I(g) shall(g)  ive(fe) him(d) shall(ef) nev—er(gh)  (h) thirst.(g)  (g)  (j)  (h)  (j)  (k)  (j) ",
        groupIndex: 1,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png",
    },
    {
        title: "part-c-077-2",
        gabc: "ut(d) Je(e)  (fg) sus(e) stooped(gh)  (fe) do(dfddc) and(f) wrote(h) on(g) the(f) =(gh) If(d)  (f)  a-(i) (fe) ny(d) is(e) without(f) ——(h) sin,(g) let(f) him(ef) cast(g) &#39;a(fe) stone(d) at(cd) her.(d) e(h)  (g)  (fgh) e(gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png",
    },
    {
        title: "part-c-077-3",
        gabc: "Then(c) R(e) »(e) A(g) be(h) pleas—ed(ihji)  (i) fwith(i) the(i) L)(i) sacrifice(h)  (ij) of(i) —(hi)  €ousness,(hg)  (e) if(h) thou(hi) wilt(h) turn(h) thy(h) face(hghih) from(f) my(hg) sins.(e) IR(j)  (i) e(h)  (gf) ",
        groupIndex: 3,
        filename: "./pages/part-c-077.png",
        nextFileName: "./pages/part-c-078.png",
    },
    {
        title: "part-c-078-0",
        gabc: "J-(c) (f) is(fg) better(g)  (g) to(h) trust(ge) in(fgh) the(fe) Lord,(d) than(d) to(e) put(f) a-(g)ny(h)  con-(h)fi—-(g)dence(ghjijkj) 1in(fh) princes.(hg) e(g) e(j)  (i) e(j)  (h) S(ghg)  I(c)  (h)  (g) not(hg) thought(f) up-(h)on(h) thee,(hg) O(hi) Lord,(i) when(ef) I(hig) was(hg)  .(hig~) [BasmaE(f) w(f) Rrir(h) o(g) e(e) AT(f)  Mj_ghty(f)  (fg) art(g) thou,(h) O(fg) Lord,(g) to(g) de-(h)liv—er(j)  (i) us(j) from(h) the(g) hand(h)  of(g) the(h) strong:(ghg) save(f) and(g) de~liv(h)  (h) =(ghjijkj) us,(hgf) O(gh) our(h) God.(g)  5(i) Reges(j)  (i) terree(j) aa(h)  (ghg)  Klngs(f) of(e) the(d) =(d) and(d) all(ef) peo-(g)p]e,(ghg) praise(def) e(fddgd) ye(d) e(fdffddfd) t.he]..q,x(dfd)  (df)  .(h)  (g)  (f)  (g)  (h) ",
        groupIndex: 0,
        filename: "./pages/part-c-078.png",
        nextFileName: "./pages/part-c-079.png",
    },
    {
        title: "part-c-079-0",
        gabc: "When(c)  (df) Je—sus(ff)  (ded) lift—ed(cd)  (fg) up(ed) his(fe) eyes,(d) and(cd) saw(dhi) a(h) great(hgfe) com—(h)  him,(fe)  (dc)  (dc)  (d)  (f)  (g) he(cd) saith(fe) un-(fgf)to(d) Philip:(cd)  (d) Whence(i)  (dh)  (i)  shall(h) we(hggf) buy(ghg) bread(hiih) that(fg) these(ed) may(efe) eat?(d)  (g) And(f) this(fe) he(d) said(fhgf)  o(ed) M(ec) him;(d)  (e) for(d) he(ffd) himself(ed)  (cd) knew(ffgf) what(fhg) he(ed) would(efe) do.(d) ||(h) e(g) |(f)  (fh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png",
    },
    {
        title: "part-c-079-1",
        gabc: "Take(gj) these(hg) things(hjh) M(ij) saith(k) the(ji) Lord,(hg) and(gh) make(ji) not(g)  my(ef) [(g) Father’s(fgh) house(gfd) an(fed) house(f) of(gh) 500(g) merchandise.(ffg)  (e) (SR(j) §(h) et(j) el(ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png",
    },
    {
        title: "part-c-079-2",
        gabc: "WIY(c)  (h) go(i) ye(j) a-(i)bout(h) fto(f) kill(hi) me,(h) a(h) man(fe) that(f) hath(ed) told(ef) you(g)  ‘?he(f) truth?(e)  (j)  (i)  (h)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-c-079.png",
        nextFileName: "./pages/part-c-080.png",
    },
    {
        title: "part-c-080-0",
        gabc: "M(c)  (c) aster,(fg)  (g) vwherein(fh)  (j) hath(k) this(ji) man(hj) sinned,(ji)  (g) that(g) he(h) was(g)  blind?(ik)  (g) Jesus(j)  (j) 2(ji) answered(h) s(ij) and(ji) said:(g) Neither(ji)  (jk) hath(k) this(k) map(jk)  TV(ji) sinned,(h) nor(i) his(j) pa-(ji)rents;(g) e(h) that(g) the(f) works(g) of(h) God(jk)  should(ik)  (i) be(j) [(hg) ma—ni—fest(f) R(fh) in(h) him.(g) RO(j) R(i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png",
    },
    {
        title: "part-c-080-1",
        gabc: ".(c) sus(cd) went(d) .(ef) to(d) a(c) ci(d) .(ef) ty(fc) call-(fh)ed(fg) Na(gfd) i(d) and(g)  behold(fg)  (fh) there(g) was(g) a(f) dead(fg) man(f) car-(g)ri(fe) ed(d) out,(d) the(f) on-(f)ly(def)  v(i) son(g) of(f) his(fe) mother.(d)  (d) P(h) Jale(g)  (f) Sl(g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png",
    },
    {
        title: "part-c-080-2",
        gabc: "Our(f) friend(ghg) La-(h)za-(g)rus(f) sleepeth:(gf)  (d) let(d) us(f) go,(f)  (fd)  (fdefc~f)  (d)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-080.png",
        nextFileName: "./pages/part-c-081.png",
    },
    {
        title: "part-c-081-0",
        gabc: "that(f) we(f) may(hi) a(g) —wake(hg) him(ef) out(g) of(fe) =leep.(d) R(h) S(g)  (f) E(g) SRS(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png",
    },
    {
        title: "part-c-081-1",
        gabc: "He(cg) that(g) fol-(gj)low-(h)eth(hhj) me(j) shall(i) not(j) walk(k)  chall(h) have(j) the(i) light(h) of(g) life,(hhj) saith(g) the(gf) Lord.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png",
    },
    {
        title: "part-c-081-2",
        gabc: "O(h) Lord,(fg) be-(g)hold(h) my(g) af-(f)flic-(gh)tion:(f) for(g) mine(h) en-(jk)e(ij) —my(hg)  hath(g) mag-(g) (gf) ni—fi—ed(d)  (f) him-(fg)self.(g)  (j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png",
    },
    {
        title: "part-c-081-3",
        gabc: "[(ig) calleq(ij)  (i) up—-(i)on(j) the(h) Lord(i) in(gh) a(e) [(e) and(h) the(fh) Lord(gh)  heard.me(ih)  (f) at.(f) large.(e) (BT(fh)  (j) RG](i)  (h)  (gh) ",
        groupIndex: 3,
        filename: "./pages/part-c-081.png",
        nextFileName: "./pages/part-c-082.png",
    },
    {
        title: "part-c-082-0",
        gabc: "O(f) a(e) thou(f) hast(h) pleaded(hj)  (i) the(i) causes(h)  (i) of(j) my(ih) soul:(i) ol(i)  hast(f) de-(i)fend-(g)ed(h) my(fe) life,(f) O(e) Lord(de) my(fh) God.(f) &amp;(i)  (h) i(i)  (j)  (h)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png",
    },
    {
        title: "part-c-082-1",
        gabc: "(O(f) my(h) e(hi)  (i) what(i) have(h) I(i) e(j) un-(i)to(h) thee?(i) and(i) wherein(f)  (i)  have(g) I(h) wea-(f)ri—ed(f) .(e) thee?(fe) tes-(d)ti~fy(e)  (f) against(h)  (f) me.(f) I(i) &amp;(h)  (i)  (j) e(h)  (i) ",
        groupIndex: 1,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png",
    },
    {
        title: "part-c-082-2",
        gabc: "Shall(h) e-(hi)vil(i) be(i) re—com-(i) (h) pensed(ij)  (h) for(ij) good?(i) for(fi) they(g) have(h)  dig-(fe)ged-(f)a(e) pit(d) for(f) my(fh) soul.(f) e(i) o(h) 1(i) ",
        groupIndex: 2,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png",
    },
    {
        title: "part-c-082-3",
        gabc: "D(f) li-(g)ver(f) my(f) soul,(g) O(fh) God,(hg) From(fd) the(fg) sword.(gf) De-(f)li-(gd)ver:(f)  My(h) darling(gh)  (g) from(g) the(g) pow—er(h) 5(g) of(f) the(gh) dog.(hg) B.(i) From(fd) the(dfg)  (d) sword:(gf) ",
        groupIndex: 3,
        filename: "./pages/part-c-082.png",
        nextFileName: "./pages/part-c-083.png",
    },
    {
        title: "part-c-083-0",
        gabc: "De-(f)li-(g)ver(f) my(f) soul,(g) O(h) God,(hg) from(fd) the(fg) sword.(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png",
    },
    {
        title: "part-c-083-1",
        gabc: ".(j)  s(d)  (e) o(gh) St(hg) s(h)  (j) E-(ji)S(hg) e(i) o(j) .(k) gt(hg) (g(j) e(ih) ](h)  fa(h)  (hji) a(g) M(ge) [(f) [(dc) g(de) R(efe) e(d) e(dh) S(hg) R(ed) AT(f) R(ed) N1(d)  Deliver(h)  (hji) a(g) A(ge) from(f)  (dc) mine(de) enemies,(efe)  (d) O(dh) God.(hg) e(ed)  (f) e(ed) [(d)  (ded) I(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png",
    },
    {
        title: "part-c-083-2",
        gabc: "Je-(ki~) (gj) sus(h) said(ghj) un-(j)to(i) the(h) mul-(i) (j) ti—tude(k) of(ji) the(h) Jews,(hg) and(gh) to(j)  the(i)  (i) chief(hgf) y(fe) He(e) that(ed) is(g) of(hi) God(i) e(j) heareth(h) A(ik) words;(iji)  (g)  Ye(i)  (g) therefore(hi)  (hgf) hear(ghg) them(e) @(e) RS(f) RRRR(eff) ye(f) are(ghgf) not(g) of(gf) God.(e)   (ik)  (j)  (h)  (j)  (ih) ",
        groupIndex: 2,
        filename: "./pages/part-c-083.png",
        nextFileName: "./pages/part-c-084.png",
    },
    {
        title: "part-c-084-0",
        gabc: "a(e) the(e) great(eh) day(fed) of(ef) the(f) feast,f(e) —(igij) sus(i) stood(ijji) and(gi) Cri-(hi)ed(hg)  T(e) saying:(e) If(e) a—ny(g) O(g) man(ef) thirst,(f) let(f) him(f) come(fi) un—(h) to(hf) me(g) and(f)  drink.(e)  (h)  (g)  (h)  (f)  (e) ",
        groupIndex: 0,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png",
    },
    {
        title: "part-c-084-1",
        gabc: "MY(chi) time(i) 1is(i) not(hi) yet(jh) come,(i) but(gihg) Yyour(fe) time(f) is(e) al-(de)way(fh)  (f)  ready.(f)  (f)  (i)  (h) WEDNESDAY(i) ",
        groupIndex: 1,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png",
    },
    {
        title: "part-c-084-2",
        gabc: "My(chi) sheep(i) hear(hi) my(fjh) i(i) and(i) I(cf) the(i) Lord(g) both(c)  (hf) know(fdfdedf)  (fd~f) thef:(ddfefd)  and(de) they(fh) fol-(f)low(f) me.(f) =(i)  (h) &#39;(difdf)  (ff) ",
        groupIndex: 2,
        filename: "./pages/part-c-084.png",
        nextFileName: "./pages/part-c-085.png",
    },
    {
        title: "part-c-085-0",
        gabc: "The(c)  (f) Mas(h) ter(hj) saith,(i) My(i) time(hi) is(j) at(hi) hand;(i) I(f) will(i) keep(g)  the(h) Pass-(f)o-(fe)ver(f) at(e) thy(de) house(f) with(gg) my(h) dis—ci-(h) (f) ples.(f) |(i) e(h)  (hj) |(i) ",
        groupIndex: 0,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png",
    },
    {
        title: "part-c-085-1",
        gabc: "N(gw(c) the(d) feast(dh) day(hi) of(h) the(g) Jews(hg) tdrew(h) nigh;(ghg) and(f) the(g) chief(ihg)  priests(hgfed) sought(dgfgh) how(g) they(hfgf) might(d) kill(fgg)  (gf) Je(ig) —(h) but(e) they(f)  fear—-(g)ed(e) the(fe) people.(d)  (d) [(h) mraeme(g)  (f) e(gh) W(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png",
    },
    {
        title: "part-c-085-2",
        gabc: "OFa—tﬂgr,(ki~d)  (d)  (dc) glo-(f)ri—fy(g)  (f) thou(gh) me(h) with(hi) thine(g) own(fh) self(g) with(g)  the(g) glo—ry(g)  (g) (](e) I(g) had(h) with(gf) thee(fg) be—fore(f)  (c) the(eg) world(e) be-(fe)gan.(d)  =](h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 2,
        filename: "./pages/part-c-085.png",
        nextFileName: "./pages/part-c-086.png",
    },
    {
        title: "part-c-086-0",
        gabc: "For(fh) the(f) Lord(fg) God(fe) will(f) help(hg) &quot;(e) and(h) therefore(i)  (h) shal]l(f) 0(g)  not(hi) be(g) con-(gh)e(f) founded.(f) o(h) e(g) el(e) e(f)  They(ik)  (d) compassed(f)  (f)  (f) me(f) a-(e)bout,(d) yea,(f) they(e) compassed(d)  (e) me(f)  (h) a-(h)hout:(g)  but(f) »(e) the(f) Name(g) of(f) a(e) Lord(f) N(e) I(d) be(c) a-(c)—#e%ged(c)  (de) on(d) :(d)  3(ik)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-086.png",
        nextFileName: "./pages/part-c-087.png",
    },
    {
        title: "part-c-086-1",
        gabc: "Judge(c)  (h) thou(f)  Judge(h) thou(fg) my(gh) cause:(g) de—fend(fh)  (j) me,(jdijkj) for(h)  (gf) 0(ghd) Lord,(c)  (i) art(dh)  mighty.(g)  (g) ‘(j)  (i)  (j)  (h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-086.png",
        nextFileName: "./pages/part-c-087.png",
    },
    {
        title: "part-c-087-0",
        gabc: "May(e) the(g) faithful(i)  (h) to-(fh)day(ji) be(hi) found(i) a-(g)mong(ij) the(i) Angels(h)  (hg) and(f)  the(h) children,(hg)  (e) crying(e)  (e) un-(e)to(f) the(e) Conqueror(f)  (e) e(d) of(ef) death,(f) Ho-(cf) san-(hi)na(iihf) in(g) the(f) highest.(e)  (e)  (h)  (j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png",
    },
    {
        title: "part-c-087-1",
        gabc: "Let(c)  (e) them(f) be(h)  (h) confounded(hj)  (i) that(i) persecute(h)  (i)  (jh) me,(i) but(i) let(f) not(i) me(g)  be(h)  (f) confounded,(ef) =&quot;(f) O(e) Lord(de) my(fh) God.(f) |(i)  (h) S(i) RO(j) e(h)  (fh) ",
        groupIndex: 1,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png",
    },
    {
        title: "part-c-087-2",
        gabc: "he(c)  (g) =(fg) multitudes(f)  (f) a(e) came(f) together(g)  (g)  (g) for(g) the(f) feast(gh) day(ghg)  cried(e)  (f) P(g) un—to(fe) the(de) Lord:(e) Blessed(e)  (f) is(g) he(fgh) that(g) cometh(f)  (g) in(f) the(e)  Name(df) of(e) the(de) Lord.(c) Ho-(f) (ef) san—ha(dc) in(df) the(fg) highest.(e)  (e) |(h) e(g)  (h) e(ih)  (gfee) ",
        groupIndex: 2,
        filename: "./pages/part-c-087.png",
        nextFileName: "./pages/part-c-088.png",
    },
    {
        title: "part-c-088-0",
        gabc: ".(e) hid(gh) not(h) tmy(hi) face(g) from(f) shame(g) and(fg) v(e)  (e) |§|(h)  (h) [(h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png",
    },
    {
        title: "part-c-088-1",
        gabc: "Awake,(g)  (ef)  (h) O(hgf) sword,(fh) t(f) against(hgf) them(fh) that(hg) scatter(hi)  (g) my(f) flock.(f)  3(gi) Appenderunt(h)  (g)  (e)  (f)  So(d) they(ef) L](g)  (e) for(gh) my(fe) price(d) thirty(f) [}(f) pieces(d) a(e) of(gf) silver,(g) -(d)the(f)  price(fe) that(d) I(e) was(f) prised(g)  (f) at(gh) of(f) them,(d) I(h) e(g)  (f) e(gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png",
    },
    {
        title: "part-c-088-2",
        gabc: "Wa—(c)  (g) ter(g) flow-(h)ed(h) o-(g)ver(f) tmine(h) head:(g) then(h) said,(g) I(h) am(hi)  cut(gf) off:(f) I(f) will(h) call(jk) up-(ij)on(h) thy(gh) Name,(gf) O(fh) Lord(hi) God.(g)  (j) e,(idj)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-088.png",
        nextFileName: "./pages/part-c-089.png",
    },
    {
        title: "part-c-089-0",
        gabc: "Be_hold,(c)  (g)  (h) O(g) Lord,(f) the(f) lips(g) of(h) them(j) that(i) rise(hj) up(i) a-(h)gainst(g)  me,(h) and(h) their(i) de-(h)vices.(g)  (g)  (h)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png",
    },
    {
        title: "part-c-089-1",
        gabc: "O(d)  (d)  (dc) glo-(f)ri—fy(g)  (f) thou(gh) me(h) with(ihi) thine(g) own(fh) self,(g) with(g)  the(g) glo-(g)ry(g) which(e) I(g) had(h) with(gf) thee(fg) be-(f)](c) the(eg) world(e) be—gan.(fe)  (d)   (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png",
    },
    {
        title: "part-c-089-2",
        gabc: "See,(g) O(h) Lord,(i) and(j)  (i) consider,(h)  (g) for(g) I(f) 0(e) in(f) trouble:(h)  (g) O(f) haste(ef)  thee(g) and(h) hear(f) -(e) (j) ;(i)  (hd)  (dih) ",
        groupIndex: 2,
        filename: "./pages/part-c-089.png",
        nextFileName: "./pages/part-c-090.png",
    },
    {
        title: "part-c-090-0",
        gabc: "De-(c) (g) fend(igji~) thou(i) tmy(j) cause,(k) O(j) Lord:(iji) O(i) de-(g)li-(hih)ver(fe) me(e) from(f) the(e)  deceitful(f)  (hhg) T(f) and(hhi) wick(ghf) —ed(ef) man.(e) W(j) (st(i)  (h) (](g) ",
        groupIndex: 0,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png",
    },
    {
        title: "part-c-090-1",
        gabc: "g(ig~) When(e) I(e) was(g) in(h) trouble(i)  (hih) I(f) cri-(h)ed(g) un—to(f)  (e) the(f) Lord(e) out(f) of(e)  the(d) belly(e)  (e) of(ef) hell,(f) and(h) he(fe) heard(fgf) e(j)  (i)  (h) ](gf)  [ord,(g) I(h) am(j)  (j) oppressed,(hj)  (i) T(jk) un—dertake(jh) for(i)  (h) me:(g) for(g) I(h) know(j)  not(ik)  (i) what(h) I(g) shall(hi) say(hg) to(f) mine(ghg) en-(e)e(e) mies.(e) e(j)  (h) ([(j) i(ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png",
    },
    {
        title: "part-c-090-2",
        gabc: "T}le(g) ungodly(g)  (g) [(fe)  (dc) Let(g) us(f) oppress(g)  (h) the(gf) righteous(g)  (h) man,(f) be-(g) cause(f) he(g) 1is(h) clean(j) con-(i)tra-(ji)-(hg)to’our(fe) v(fg) doings.(g)  (g) e(j)  (i)  (j)  (h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-090.png",
        nextFileName: "./pages/part-c-091.png",
    },
    {
        title: "part-c-091-0",
        gabc: "Now(d) pefore(cd)  (dhi) the(h) feast(h) of(gh) the(f) Pass—o-(fh)ver,(h)  (ihghihgg) when(fg) Je—sus(h)  (g) knew(f)  (f)  that(f) his(df) hour(g) was(fe) come,(d)  (fed) having(d) »(c) loved(d) [(c) 3(d) own,(ffgf) he(f) loved(f)  (hg)  (hi)  them(hgg) un—to(f)  (g) the(fe) end.(d) ST(h) A(g)  (f) e(gh) :(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png",
    },
    {
        title: "part-c-091-1",
        gabc: "ti-(jk) (ji) ness,(j) O(jh) God(hj) my(i) God:(gh) and(f)  De-(h)liver(f)  (h) me(gf) from(h)  T(h) tongue(i) shall(j) sing(h) of(g) thy(gh) righteousness.(hg)  (g) e(j) e(i)  (j) )(h)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png",
    },
    {
        title: "part-c-091-2",
        gabc: "5(h) ReproaChesTand(hg)  (e)  (f) 5(hih) terrors(gh) have(hg) I(f) suffered(g)  (h)  (f) of(e) them:(e) and(e) the(d)  Lord(ef) =(hi) with(hg) me(ihih) as(h) a(h) mighty(hgf)  (f) terrible(gh)  (f)  (gf) one.(e) :(h)  (f)  (h)  (i)  (h) ",
        groupIndex: 2,
        filename: "./pages/part-c-091.png",
        nextFileName: "./pages/part-c-092.png",
    },
    {
        title: "part-c-092-0",
        gabc: "These(ef) al(hi) ~so(i) that(hi) seek(jk) the(i) hurt(hi) of(g) my(hg) soul,(f) shal](f)  (h)  y(gi) go(hi) un-(h)der(e) GE(gh) earth.(f) |(h) y(g) PRyyees(e) Tae(f)  a(e) .(h) en-(i) (j) .(ih) have(jk) heard(j) of(h) my(jk) trouble,(j)  (ih) 0(j) Lord:(i)  they(i) are(hg) glad(e) that(i) thou(hf) hast(fg) done(e) it.(e) ](j) A(i)  (h)  (gf)  Bind(i)  (f) the(hi) nations(hg) t(h) of(g) the(ig) heathen(h)  (g) with(ef) chains,(g) O(fe) Lord;(d)  j(jk)  a(e) their(f) ](ge) princes(f) with(e) SO(d) fetters.(d) e(h) S(g) i(f)  (g) T(ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-092.png",
        nextFileName: "./pages/part-c-093.png",
    },
    {
        title: "part-c-092-1",
        gabc: "i-(eh)mon,(fed) sleepest(ef)  (f) thou?(e) couldest(gh)  (i) not(hf) thou(hhg) watch(hih) with(hg)  (h)  me(hf) one(gf) hour?(e) e(h) e(g) _l__(h)  (f) |(e) ",
        groupIndex: 1,
        filename: "./pages/part-c-092.png",
        nextFileName: "./pages/part-c-093.png",
    },
    {
        title: "part-c-093-0",
        gabc: "E(c) zeal(h)  (h) of(h) thine(hih) house(gh) hath(h) e(h) ven(f) eat—en(h)  (g) me;(e) and(e) the(d)  rebukes(f)  (h) of(g) them(ef) that(d) re-(f)buk-(hi)ed(g) thee(h) are(fe) fallen(fg)  (f) up-(f)on(e) me.(e)  9(h) Avertantur(f)  (h) retrorsum(i)  (h)  et(h) them(h) be(h) e(hi) turned(i) backward(ih)  (ih) and(h) put(h) to(hg) con—fu-(fh) (hih) 1(e) that(hi)  (ih)  seek(f) to(df) do(hf) me(g) e-(e)—vil.(e) cau(h) ok(f)  (h) caate(i) Saes(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-093.png",
        nextFileName: "./pages/part-c-094.png",
    },
    {
        title: "part-c-093-1",
        gabc: "De~(h) 1itver(h)  (hg) me,(f) O(ghg) my(ef) -(e)out(hi) of(h) the(h) hand(h) of(hih) the(f)  N(gi) un(e) —god(f) ly.(f) e(h) ee——l|(g)  (e) Ao(f) ",
        groupIndex: 1,
        filename: "./pages/part-c-093.png",
        nextFileName: "./pages/part-c-094.png",
    },
    {
        title: "part-c-094-0",
        gabc: "was(g) of-(h) (hg) fer—ed(f) .(fe) be—cause(f) he(h) will-(h)ed(hiih) it:(h) and(h)  (ji) himself(i)  (hi)  was(gi)  (h)  hath(gi)  (h) borne(hg) our(e) 1(fh) -(f)ni-(f)qul-(f)l(h)  (g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png",
    },
    {
        title: "part-c-094-1",
        gabc: "Mine(c)  (h) own(h) familiar(h)  (h)  (h) friend(h) whom(i) I(h) trusted.(g)  (g)  Who(h) did(h) also(h)  (h) eat(h) of(h) my(h) bread,(h) hath(h) laid(i) great(h) wait(g) for(g) me.(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png",
    },
    {
        title: "part-c-094-2",
        gabc: "NOW(d) he(f) t}l:it(c)  (d) be—tray—ed(dhi)  (h) f(h) gave(h) them(g) a(e) sign,(fgfe) say-(d)ing:(d)  Whom-(f) (d) so—ev—er(e)  (f) I(cgh) shall(fg) kiss,(f) that(fg) same(f) is(fe) he;(ce) hold(ge) him(f)  fast.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-094.png",
        nextFileName: "./pages/part-c-095.png",
    },
    {
        title: "part-c-095-0",
        gabc: "t(ffgf) for(f) our(ghfedgefg) sake,(f) be(f) came(hfghjjk)  (kj) 0(jij) be(hghj) di(jh) ent(f)  un(fihgh) to(f) death.(ffgf) ",
        groupIndex: 0,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png",
    },
    {
        title: "part-c-095-1",
        gabc: "’Ihe(c)  (cgh) kings(h) of(h) the(h) earth(jj) stand(h) up,(h) and(g) the(h) ru—lers(jj)  (i) take(hg)  coun-(ik) (h) sel(i) to-(j)P(ihg) o(g) a-(h)gainst(f) the(h) Lord,(jj) and(i) a—-(g)gainst(j)  his(ik)  (h) A-(h)noint(g) —ed.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png",
    },
    {
        title: "part-c-095-2",
        gabc: "&#39;I}ley(ikc)  (c)  (g) part(h) my(h) garmentst(g)  (g) a-(ih)—mong(ji) them,(h) and(j) cast(jk) lots(h) up-(gf) (f) on(gh)  my(ik)  (h) -(g)vesture.(g) w-(j) (i)  (j)  (h) —(g) ",
        groupIndex: 2,
        filename: "./pages/part-c-095.png",
        nextFileName: "./pages/part-c-096.png",
    },
    {
        title: "part-c-096-0",
        gabc: "Re-(ik) (g) mem(h) be(gf) bernert(g) 0(h) Lord(j) my(i) God,(j) when(h) thoy(g) com-(i)est(ghg) in-(ef) to(gh) thy(hg) kingdom.(g)  (g)  (j)  (i)  (j)  (h) Psaln(gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png",
    },
    {
        title: "part-c-096-1",
        gabc: ":(h) hath(h) laid(h) me(h) in(i) the(h) darkness.(g)  (g)  As(h) the(h) men(h) that(h) have(h) been(i) long(h) dead.(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png",
    },
    {
        title: "part-c-096-2",
        gabc: "T}ley(c)  (cd) set(idhi) up(h) o-(h)ver(h) his(h) head(ihghihgg) his(f) ac-(g)cu(h) —sa-(g)tion(fe) writ—(fg)  .(d) Je(d) sus(gd~gf) of(hg) Na-(f)za-(e)reth,(fgfd) the(ef) King(g) of(gh) the(fe) Jews.(d)   (ki~)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-096.png",
        nextFileName: "./pages/part-c-097.png",
    },
    {
        title: "part-c-097-0",
        gabc: "&quot;(ffgf) for(f) [(ghfedgefg) T(f) be(f) came(hfghjjjk) 0(jji) be(hghj) dj(jh) ent(f)  un(fihgh) to(f) death,(ffgf) e(fhhi) ven(g) the(gj) death(jhjig) 8(ihg) of(f) the(f) cross(ffffc) ",
        groupIndex: 0,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png",
    },
    {
        title: "part-c-097-1",
        gabc: "I(h) will(eg) lay(g) me(h) down(fe) r(f) peace,(df) and(fh) take(g) my(f) W(e) [(h) B(f) Psalm(h)  (i) 4(h) ",
        groupIndex: 1,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png",
    },
    {
        title: "part-c-097-2",
        gabc: "He(fe) shall(d) dwell(f) {in(e) thy(f) e(g) e(fe) cle:(fg) w-(g)he(g) shall(e) R(d) F(fe)  -(d)on(f) |(fd) ho-(f)1ly(fg) =(h) e(g)  (h) o(ih) 0(gfed) ](e) ",
        groupIndex: 2,
        filename: "./pages/part-c-097.png",
        nextFileName: "./pages/part-c-098.png",
    },
    {
        title: "part-c-098-0",
        gabc: ";(c) wo(cd) —(dhi) men,(h) 1sitting(h)  (h) o-(h)ver(h) a(h) gainst(h)  =(fg) lam(h) en-(gf)ta-(g)tion,(d) weep—ing(f)  (ef) for(g) the(fe) Lord.(d)  (h) Iy(g)  (fgh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png",
    },
    {
        title: "part-c-098-1",
        gabc: "Christ,(c)  (ffgf) for(f) our(fh) O(fedgefg) sake,(f) be.-(f)came(hfghjj) R(kj) o(jij) be(hghj) di(jh) ent(f)  un(ik)  (fihgh) to(f) death,(ffgf) e(fhhi) ven(g) the(gj) death(jh)  (jighihg) of(f) the(f) cross:(ffffc)  -(fghgf)8(eghfhghgegf) .(f)  (hgi) -(d)](d) God(fe) al-(eh)so(h) hath(h) high-(h)ly(h) ex-(h)",
        groupIndex: 1,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png",
    },
    {
        title: "part-c-098-2",
        gabc: "a(hf) -(hhhhfghihijhhiih)which(d) is(d) a-(d)bove(dfedef) ev(fhgf) ery(hhh) name.(hhf) -(ggfged)",
        groupIndex: 2,
        filename: "./pages/part-c-098.png",
        nextFileName: "./pages/part-c-099.png",
    },
    {
        title: "part-c-099-0",
        gabc: "day(j)  hen(g) Je-(gj)sus(h) was(gf) risen(gh)  (g) early(g)  (i) the(j) first(k) day(k) of(kj) the(i) week(i)  he(k)  (j) appeared(hj)  (h) first(h) to(fh) Ma-(ji)ry(g) Magda-(g)le(eg)  (ffg) G(gfed) M(gg)  (c)  whom(d) he(f) had(fg) cast(g) seven(gh)  (h) de-(gf)vils,al-(gh) (g) le-(ef)lu—1ia.(gh)  (g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png",
    },
    {
        title: "part-c-099-1",
        gabc: "go(i)  (i) before(h)  (g) you(h) in-(j)to(j) Ga-(i)li-(i)lee:(i) there(ij) shall(h) ye(i) see(hg) me,(g)  as(hg) I(f) said(h) un-(i)to(h) you,(fh) al(ih) —le-(f)i1a,(f) al-(fg)le-(fg)ia.(e)  (i) —1)(j)  (i)  (h)  (dgh) ",
        groupIndex: 1,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png",
    },
    {
        title: "part-c-099-2",
        gabc: "I(f) i(f) the.(e) true(g) B(h) al-(e)le-(f)lu-(d)(¥(c) and(f) ye(f) are(f) the(f)  (ff) true(ef)  (df)  [(g) branches,(h) al-(h) (hg) lu-(gf)1ia.(f)  (h)  (f) 5(ghf)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-099.png",
        nextFileName: "./pages/part-c-100.png",
    },
    {
        title: "part-c-100-0",
        gabc: "heart(cf)  (fg) a(ghggf) with—in(hj)  (jih) me;(h) I(chi) desire(g)  (fe) to(d) be-(ef)hold(ghc) my(h)  Jord:(g) I(gj) seek,(jkjjih) and(h) find(ij) not(hg) where(h) they(g) have(f) laid(g) him,(h)  al—-(i)le-(j)lu-(h)1a,(gf) al(gh) le(h) lu—-(g)ia.(g)  (j) _(i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-100.png",
        nextFileName: "./pages/part-c-101.png",
    },
    {
        title: "part-c-100-1",
        gabc: "There(d) came(dc) un—to(f) B(g) the(fh) tomb(h) {Ma(h) —(jijkj) ry(hih) Magdale(h)  (gf) —(ghihg) ne(hg) |(g)  the(e) o(g) ther(hg) Ma-(f)ry,(f)  (j) to(f) see(fg) the(f) sepu]chr.e,(f)  (ef)  (dc) al-(d)le(efe) lu-(d)ia.(d)   (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 1,
        filename: "./pages/part-c-100.png",
        nextFileName: "./pages/part-c-101.png",
    },
    {
        title: "part-c-101-0",
        gabc: "](fg) t(ggf) the(h) Shepherd(j)  (ij) of(hg) the(fg) sheep:(g) T(ji) am(jkji) the(h) way,(ji) he(hg) i,(hi)  my(hg) sheep,(g)  and(h) the(g) life:(ghg) I(fg) am(g) the(f) Good(gh) Shepherd;(f)  (f) and(f) I(hj) know(j)  ‘and(e) am(f) known(g) of(f) miNe,(edc) al-(c)le-(d)lu-(e)ia,(f) al-(h)le-(h)lu-(g)ia,(g)  (j)  (i)  (j) |(h) ",
        groupIndex: 0,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png",
    },
    {
        title: "part-c-101-1",
        gabc: "Go(f) ye(f) in-(f)a(e) the(g) world,f(h) al-(e)le-(f)P(d) a-(c)and(f) teach(f) e(e) allnations,(g)  (h)  al(h) le(hg) lu-(gf)1a.(f)  (h)  (f)  (fgh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png",
    },
    {
        title: "part-c-101-2",
        gabc: "Go(h) ye(fg) in-(g)to(g) the(h) world,(g) and(g) teach(h) all(gf) nations,(fh)  (f) baptizing(gf)  (dgh)  (djkd)  of(de)  them(jijkj) in(h) the(h) Name(h) of(h) the(h) Father,(j)  (ih) and(g) of(g) the(fg) Som,(d)  (g) and(dg)  the(f) Ho-(h)ly(h) Ghost,(gf)  (d) al(f) —le(fg) —Ju-(g)1ia.(g) |(j) :(i)  (j)  (fdh)  (dddfgh)  (d)  (dd) ",
        groupIndex: 2,
        filename: "./pages/part-c-101.png",
        nextFileName: "./pages/part-c-102.png",
    },
    {
        title: "part-c-102-0",
        gabc: "-(c) Go(f)  (ed) un—-(d)to(e) my(fg) brethren{(gfgff) S(d) and(f) say(gh) un-(h)to(gf) them,(f) al-(g)le(gf) lu-(e)ia:(e)  [(j)  (d) =(fg) go(h) in-(hi)to(h) Ga-(g)li-(gf)lee,(e) al-(de)le-(fg)lu-(f)ia:(e) there(ef) shall(g) they(ef)  that(e) they(gh) go(h)  e(dc) me,(e) al_le-(c) (d) -(e)lu—ia,(f) al(gf) —le-(de)lu-(e)ia,(e) al-(eh)le(hghg) lu-(e)ia.(e)  (h)  (ghihgfee) ",
        groupIndex: 0,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png",
    },
    {
        title: "part-c-102-1",
        gabc: "A.rt,(c) thou(d) on(dhi) ly(h) .a(hg) stranger,(gh)  (f) and(g) hast(d) not(dg) heard(g) con—(f)  cerning(f)  (d) Je(cf) ](ffggf) how(h)  (f) :(ifhi) de-(h)2(gih) ver—ed(g) :(g) him(hg) to(d) be(d)  (](g) condemned(f) L](e) to(dc) death?(f) al(g) —le—(fe) lu-(d)ia.(d) B(h) ;(g) e(f) :(h) T(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png",
    },
    {
        title: "part-c-102-2",
        gabc: "ught(f) not(fg) Christ(g) to(h) have(j) e(ji) e(j)  (h) these(jg) things,(g) and(g) to(g)  ®h-(hi)ter(h) a(g) ‘in-(h)C](g) glory?(fe)  (d) o(f) e(fh) Pa(g) o)(g) e(j)  (i) s(j) ¢(h) 00(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-c-102.png",
        nextFileName: "./pages/part-c-103.png",
    },
    {
        title: "part-c-103-0",
        gabc: "A(cf) little(f)  (ef) while,(d) and(de)  (c) shall(d) not(fg) see(fg) me,(f) saith(f) the(gh) Lorq:(hgf)  and(f)  and(f) again,(gh)  (h) a(h) little(h)  (gfgf) while,(d) and(de) ye(cd) shall(gf~) see(fg) nle;(f) because(d)  (f)  I(g) go(h) to(g) the(f) Father,’aﬁ-(g) (d) —]e-(fedc) (c) —]u-(d) (ffg) ia,(gf) al-(g)le-(fh)lu-(f)ia.(f)  (h) B(ffh)  (g)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png",
    },
    {
        title: "part-c-103-1",
        gabc: "A.nd(c) be-(d)gin-(dhi)ning(h) at(h) Mo(hjh) ses(h) and(ih) all(gh) the(f) prophets,(fhge)  (e) he(e)  s(e) expounded(ce)  (g) un-(fgh)to(g) them(gf) the(d) e(ed) e(c)  (c) himself,(d)  (f)  (fe) -(h) al(f) le-(fe)lu-(d)ia.(d) -(h)e(g)  (f) &amp;gl(gh) e(g) ",
        groupIndex: 1,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png",
    },
    {
        title: "part-c-103-2",
        gabc: "And(cgi)  (eh) they(h) constrained(g)  (h)  (f) him,(gf) saying,(ef)  (f) A(hf) bide(g) with(hi)  (d) us,(di) 0(d)  (hi)  Lord,(ghi)  (ffe) for(hj) it(ij) is(h) to-(i)ward(h) eve-(hg)ning,(fe) al-(f)le-(ghg)lu-(d) (fd) 1a.(f)  (h) |(g)  (e)  (df) ",
        groupIndex: 2,
        filename: "./pages/part-c-103.png",
        nextFileName: "./pages/part-c-104.png",
    },
    {
        title: "part-c-104-0",
        gabc: "bide(eg) with(fgh) us,(g) for(hi) it(h) is(f) to-(h)ward(g) eve-(ih)ning,(g) and(h) the(i) day(j)  !(ih) far(gh) spent,(gfd) al(e) -(d)lu-(c)ia.(c) a.(h)  (g)  (f)  (ed) ",
        groupIndex: 0,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png",
    },
    {
        title: "part-c-104-1",
        gabc: "&#39;And(ki~)  (g) he(g) went(gj) in(h) to(g) tar-(h)ry(g) with(hhj) them:(iji) and(i) it(j) came(k) to(j) pass,(ji) T(h)  as(h) he(g) sat(h) at(ji) meat(hi) with(h) them,(g) he(gh) took(ji) bread,(ghighg) and(ef) blessed(g)  (gh)  (g)  D(gfd) and(d) brake,(gh) R(h) gave(hgf) L(g) them,(gfd) al(f) [](e) -(f).(e) al(f)  le(fg) lu-(e)ia.(e)  (j)  (h)  (j)  (ih) ",
        groupIndex: 1,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png",
    },
    {
        title: "part-c-104-2",
        gabc: "»They(c)  (f) knew(g) the(f) Lord(e) Je-(g)sus,(h) al(e) -(f)lu-(d)ia,(c) in(f) breaking(f)  (e)  of(g) bread,(h) al(h) le(hg) lu-(fg)ia.(f) ;(h)  (f)  (gh)  (g)  (f) ",
        groupIndex: 2,
        filename: "./pages/part-c-104.png",
        nextFileName: "./pages/part-c-105.png",
    },
    {
        title: "part-c-105-0",
        gabc: "Now(dh) I(j) go(h) my(g) way(h) fto(f) him(gh) that(fe) sent(d)  (e) me;(d) and(df) none(fe) o(d)  (fg)  asketh(f)  (ed) T(c) Whi(ifhi) ther(h) goest(h) TR(g) thou?(ghg) al-(f) (f) .(e) le_ly_j,(f) :(g) allel(fe)  lu-(d)ia.(d)  (h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 0,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png",
    },
    {
        title: "part-c-105-1",
        gabc: "Did(c) not(cd) our(ddc) heart(ffd) tburn(f) within(g)  (h) us(i) concerning(h)  (g)  (hg) Je-(fe)sus;(d)  while(i)  (e) he(f) talk-(g)ed(gh) with(gf) us(d) by(f) the(f) way?(ed) al(c) le(cd) lu-(d)1ia.(d) IR(hgfggfd) ",
        groupIndex: 1,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png",
    },
    {
        title: "part-c-105-2",
        gabc: "eace(f) be(f) un-(f)to(f) you,(e) it(g) is(g) I,(h) al-(e)le-(f)lu-(d)ia:(c) be(fe) not(g) afraxt(g)  (h)  al(h) ~le-(hg)lu-(fg)ia.(f) B(h)  (f) Tn(h) v(g) e(f) ",
        groupIndex: 2,
        filename: "./pages/part-c-105.png",
        nextFileName: "./pages/part-c-106.png",
    },
    {
        title: "part-c-106-0",
        gabc: "spi-(cf) (fg) Tit(g) hath(hj) not(g) flesh(h) and(f) bones,(ghg) as(g) ye(g) see(hg) me(fe) haves:(d)  pelieve(g)  (gh) Y€(g) therefore,(fe)  (d) al(f) —le-(gh)lu-(g)ia.(g) I(j)  (i) —(j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png",
    },
    {
        title: "part-c-106-1",
        gabc: "e(c)  (c) dis—ci-(d) (dhi) ples(h) of-(h) (g) fer—ed(f) the(gh) Lord(hghih) a(g) piece(h) of(f) broil—ed(igig) —(hi)  fish,(h) and(hgg) of(f) an(gh) ho-(f)ney-(fe)b,(dfddc) al(e) —le(ig)  (hih) —lu—ia,(g)  (fe) al(g) —le—(fe)  (d)  lu-(d)1ia.(d) .(h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png",
    },
    {
        title: "part-c-106-2",
        gabc: "hese(fg) are(ggf) the(gh) words(hg) twhich(g) I(gh) spake(hg) un—to(fgh) 8(fg) you,(f) &lt;(fh) I(ji)  :(jk) yet(ji) with(h) you,(h) al-(f)le-(h)lu-(j)ia,(i) al-(h)le-(hi)lu-(g)ia.(g)  (j) o(i)  (j)  (h) D(ghg) ",
        groupIndex: 2,
        filename: "./pages/part-c-106.png",
        nextFileName: "./pages/part-c-107.png",
    },
    {
        title: "part-c-107-0",
        gabc: "H(hg)  (f) itherto(ef)  (f) have(f) ye(gh) asked(i)  (i) nothing(j)  (i) in(g) my(hg) Name:(f) L(g) and(dfe)  .(hg) ye(f) 0(e) receive,(fh) =(gh) al-(i)le(hg) lu-(f)ia.(f) PR(h) ——————T(g)  (e)  (f) ",
        groupIndex: 0,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png",
    },
    {
        title: "part-c-107-1",
        gabc: "Ask,(fg) and(g) ye(h) shall(g) receive;(f)  (gh) seek,(ji) and(h) ye(h) shall(ih) find;(g)  (g)  knock,(g) and(fe) 1t(d) shall(e) be(f) o-(g)pen-(g)ed(f) un—to(gh)  (h) you,(gfd) al(ef) le(fg) lu-(g)ia.(g)  e(j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png",
    },
    {
        title: "part-c-107-2",
        gabc: "It(f) be-(fg)hov—ed(g)  (ghgf) Christ(h) to(j) suf-(ji)fer,(g) tand(g) to(g) rise(hi) a-(h)gain(dged) from(ddfg)  (d)  (d)  the(fe) dead,(d) al(f) -(gh)le-(g)1ia.(g) gl(j)  (i) e(fjdffddfh) e(ddghgd) A(dd) |(d) ",
        groupIndex: 2,
        filename: "./pages/part-c-107.png",
        nextFileName: "./pages/part-c-108.png",
    },
    {
        title: "part-c-108-0",
        gabc: "ther,(f) the(g) hour(f) is(gh) come:(h) glo-(h)ri~-(g)fy(i) thy(h) Son(g) with(g) the(g)  glo-(fh)ry(g) which(g) I(e) had(g) with(hg) thee(fg) be—fore(ec)  (eg) the(e) world(fe) was,(dc) al(d) —(e)  le(efe) lu(d) ia.(d)  (h)  (g)  (f)  (gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-108.png",
        nextFileName: "./pages/part-c-109.png",
    },
    {
        title: "part-c-108-1",
        gabc: "F(fg) u(g) A(h) [(gf) m-(g)a(g) |(hgf) —cy(g) on(gh) me,(f) and(g) send(hj) ww(jk) La—za—(j)  TUs,(j) that(j) he(j) may(j) dip(jig) the(j) tip(jk) of(j) his(j) finger(ji)  (h) in(ij) wa—ter,(hh)  (g) and(dfg)  my(ik)  (f)  (fh) tongue.(g)  (j)  (i)  (j) :(h)  (ghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-108.png",
        nextFileName: "./pages/part-c-109.png",
    },
    {
        title: "part-c-109-0",
        gabc: "A(g) certain(h)  (hi) man(i) made(ij) a(hg) great(hi) L(g) supper,(g) and(gh) bade(jihi) ma-(h)ny;(g)  and(ik)  (g) sent(ghij) his(i) servants(k)  (j) at(hj) supper:time(i)  (hg) a.F(g) to(g) say(h) to(ij) them(h)  that(h) were(i) [(g) bidden,(g) Come;(ghiji) for(hg) all(hij) things(h) a(g) now(hi) ready,(h)  (gf)  al(g) le(gf) lu-(e)1ia.(e) be(ji) cnn(hih) |(gfe) k@5(e) ",
        groupIndex: 0,
        filename: "./pages/part-c-109.png",
        nextFileName: "./pages/part-c-110.png",
    },
    {
        title: "part-c-109-1",
        gabc: "What(ed) man(g) of(hj) you,(j) hav-(ik)ing(j) an(i)  (h) sheep,(ji)  (g) 1f(g) he(hj) lose(jih)  one(gf) of(ghg) B(e) doth(de) not(g) leave(hj) the(hj) e(k) ninety(j) and(j) nine(hg) in(h) the(j)  wilderness,(j)  (ij)  (j) and(ij) go(kj) after(h)  (g) that(hi) which(g) is(f) lobst,(eed) un-(hi)til(h) he(hg)  un-(d) find(fg) it?(df) al-(g)le-(gf)lu-(e)ia.(e) ISR(ji)  (d)  (hi)  (h) [(gh) T(d) ",
        groupIndex: 1,
        filename: "./pages/part-c-109.png",
        nextFileName: "./pages/part-c-110.png",
    },
    {
        title: "part-c-110-0",
        gabc: "BB(df) ye(d) therefore(de)  (d)  (fe) Tmer—ci—iul,(de) as(dc)  (f) your(g) Father(h)  (gf) al-(g)so(d) 1is(g)  erci-(g) (fe) ful,(dc) saith(d) the(efe) Lord.(d)  (h) e(g)  (f) e(gh) T(g) e(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png",
    },
    {
        title: "part-c-110-1",
        gabc: "Ar:d(c) Je-(cd)sus(d) en—ter—ed(ef)  (d)  (d) in—t.o(d)  (c) a(df) ship,(fc) and(f) sat(ghg) down,(hiih) and(fg)  (h)  taught(h) the(gf) -(g)people,(df) al-(g)le-(fe)lu-(d)1a.(d) |(h) e(g)  (f) 2(g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png",
    },
    {
        title: "part-c-110-2",
        gabc: "Y(ig~) e(e) have(e) heard(eh) that(f) it(f) was(e) said(f) .;y(ed) them(ef) of(f) old(e) time,(e)  Thou(gi)  (hg) shalt(h) not(ij) kill;(i) and(i) whoso-(j)ev-(i)er(h)  (i) shall(hg) I‘(eef) shall(f)  be(e) e(d) )(c)  (d) of(ef) the(f) judgment.(e)  (e) .(h)  (g)  (h)  (f) ¢(e) ",
        groupIndex: 2,
        filename: "./pages/part-c-110.png",
        nextFileName: "./pages/part-c-111.png",
    },
    {
        title: "part-c-111-0",
        gabc: "he(gd) mul-(f)ti-(fg)tude(gh) being(g)  (ge) ve-(f)ry(e) great,(df) and(cd) having(ffg)  (g) nothing(f)  (h)  to(fh)  to(gh) eat,(f) Je-(f)sus(hj) called(j)  (ji) his(h) T(g) disciples(h) T(g) un-(ji)to(hg) him,(ghg) and(f) -(gh) un-(h)to(g) them,(g) I(jj) have(k) oY(i) compassion(j) b(h) on(g) the(h) LR(i) multitude,(hg) (1.(g) because(fg)  (f)  they(g) have(h) now(gh) been(gf) with(f) me(h) three(jjk) days,(j) and(j) have(ik) nothing(j)  (h)  to(j) eat,(ghg) al(f) ~le-(fg)lu-(g)1ia.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-111.png",
        nextFileName: "./pages/part-c-112.png",
    },
    {
        title: "part-c-111-1",
        gabc: "B(fg) a-(g)of(hj) false(ji) Ta(hg) prophets,(hg) which(gh) come(f) to(fg) you(g) in(fg) sheep’s(hj)  clothing,(jk)  (jijkj) but(j) in-(ki)wardly(ji)  (hhg) they(fg) are(fgh) ra(i) e(h) vening(di) ](g) Ye(gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-111.png",
        nextFileName: "./pages/part-c-112.png",
    },
    {
        title: "part-c-112-0",
        gabc: "know(d) them(ef) by(gh) their(h) fruits,(gfd) al(f) -(fg)lu-(g)ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png",
    },
    {
        title: "part-c-112-1",
        gabc: "he(d) lc;rd(ef) said(ge) un-(gh)to(f) the(e) s(d) steward,(d) How(d) is(cd) it(d) that(f) I(g) hear(hg)  this(f) of(ghg) thee?(h) [}(c) an(d) account(f)  (ffgf) cf(f) thy(ef) ](g) a(fe) =(dc) al(d)  le(efe) lu—-(d)1a.(d)  (h)  (g)  (f)  (gh)  (g)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png",
    },
    {
        title: "part-c-112-2",
        gabc: "O(dh) will(h) go(j) to(h) my(g) father,(h) [(g) and(h) will(g) say(ge) un-(fgh)to(fe) e(d) him:Fa—ther,(ff) e(dfec)  make(fhghi) me(h) O(g) one(fg) of(f) |(ef) [(g) [(fe) IR(d) servants.(d) |(h)  (g) ey(f)  (gh) i(gh) ",
        groupIndex: 2,
        filename: "./pages/part-c-112.png",
        nextFileName: "./pages/part-c-113.png",
    },
    {
        title: "part-c-113-0",
        gabc: "0(c) the(d) Lord(dhi) was(h) come(h) near(hg) to(e) Je~ru-(f) (g) 0(fe) 6(d) pe(d) 8(dc)  held(f) the(g) ci-(fh)ty,(h) and(h) wept(hjhih) o-(h)ver(ge) 1it,(fe) say-(d)ing:(d) If(de) th.ou(c)  hadst(ik)  (d) known,(fe) e(ghe) W(fe) T(d) For(hi) e(h) days(hij) shall(hg) come(gi) up-(ki)on(ji)  thee,(h) that(j) thine(i) e(j) ne-(i)T(h) shall(g) cast(h) a(g) trench(h) i(j) about(j)  thee,(g) and(h)  (j) compass(i) thee(ji) round,(h) and(i) keep(hg) thee(fh) in(jk) on(ji) a(hg) very(j)  side,(h) and(h) shall(i) a(e) e~(g) ven(i) with(i) the(ji) ground;(h) be(h)  cause(hkkj) thou(hg) knewest(j)  (ij) not(ih) the(fgh) z(e) of(f) thy(gh) vi-(g)gi-(fe)ta(d) -(dc) al(d) le(efe) lu-(d)ia(d) ,(h) ;(g)  (f)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-113.png",
        nextFileName: "./pages/part-c-114.png",
    },
    {
        title: "part-c-114-0",
        gabc: "A;d(c) the(df) ‘publicen,(ed)  (cd)  (d) {standing(f) ;(d) a-(e)far(dc) off,(c) would(d) not(dc) 1ift(fh)  up(g) SO(hg) much(fe) as(f) his(g) eyes(gfed) un-(e)to(fe) heaven,(d)  (d) but(gf) smote(g) up—(fe) on(d)  hys(ef) breast,(gfe) saying,(dc)  (c) God(cd) be(d) merci-(e)ful(f)  (ghghih) to(gf) me(ed) a(efe) sinner.(d)  (d)   (h)  (g)  (f)  (gf)  (d) ",
        groupIndex: 0,
        filename: "./pages/part-c-114.png",
        nextFileName: "./pages/part-c-115.png",
    },
    {
        title: "part-c-114-1",
        gabc: "When(gh)  (d) the(f) Lord(h) had(gg) pass(fh) —ed(h) through(ih) the(i) coasts(ffh) of(gg) Tyre,’(efed)  he(gi)  (d) made(e) the(f) deaf(e) to(d) hear(ff) and(f)  (gh) the(f) dumb(ef) to(d) speak.(d)  i(h) ](i)  (h)  (g)  (h)  (f) ",
        groupIndex: 1,
        filename: "./pages/part-c-114.png",
        nextFileName: "./pages/part-c-115.png",
    },
    {
        title: "part-c-115-0",
        gabc: "Mascer,(fg) a(g) what(hij) shall(ji) I(hg) do(hg) to(ji) in-(hg)e(h) herit(g) e-(gf)ter(fh) —na)(h) lifey(g)  He(hj) said(ji) un-(h)to(g) him,(hg) What(g) is(h) g(g) e(g) in(fh) the(fe) law?(d) hoy(ef) read.(gh)  est(ik)  (g) thou?(g) Thou(dfgh) shalt(g) love(g) the(gh) Lord(g) thy(hg) God(f) with(h) al](ij) thy(jh)  heart,(gh) al(i) le(hi) —1lu-(g)~1ia.(g)  (j)  (i)  (j)  (h)  (ghg) ",
        groupIndex: 0,
        filename: "./pages/part-c-115.png",
        nextFileName: "./pages/part-c-116.png",
    },
    {
        title: "part-c-115-1",
        gabc: "&quot;(c) Je-(cd)sus(d) passed(f)  (d) through(d) =(c) acertain(d)  (f) village,(d) [(dfddc) there(fg) met(hgf) him(dg)  ten(gf) men(f) that(d) were(fe) lepers,(de)  (c) which(f) stood(gghgf) a-(g)far(gh) off:(f) and(f)  they(f) lifted(fg)  (f) up(ef) their(g) voices,(fe)  (d) and(d) said,(dfddc) Je(f) sus,(fhghih) Master,(fe)  (c)  have(ef) mer-(g)B(e) Te(fe) on(d) s(d) |(h) D(g) (e(f)  (g) e(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-115.png",
        nextFileName: "./pages/part-c-116.png",
    },
    {
        title: "part-c-116-0",
        gabc: "g:(gj) not(h) therefore(h)  (g) anxious,}(h)  (gf) saying,(fgh)  (g) What(fgh)  (h) shall(g) we(h) eat?(gf) or(g)  (g)  What(fh) shall(f) we(fg) drink?(f) for(jk) your(i) heavenly(j)  (h) Father(j)  (g) knoweth(fe)  (f) that(d)  a(e) have(f) need(gh) of(h) all(g) these(fg) things,(gfd) al(eef) -(fg)—le(g) ia.(g)  (j)  (i)  (jh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-116.png",
        nextFileName: "./pages/part-c-117.png",
    },
    {
        title: "part-c-116-1",
        gabc: "J;sus(c)  (cd) went(fd) in—to(d)  (d) a(f) ci(def) ty(fc) called(fh)  (gf) Na(gfd) in;(d) and(d) behold,(g)  (g)  there(g) was(g) a(f) dead(gh) man(g) e(f)  (e)  (f) &lt;(fgf) the(f) on-(f)ly(ef) son(g) of(f) his(fe)  :(d) +(d) e(h) a(g) e(f) e(g) |(gfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-116.png",
        nextFileName: "./pages/part-c-117.png",
    },
    {
        title: "part-c-117-0",
        gabc: "A(e) Je-(gh)sus(ij) went(g) in-(h)to(i) the(i) house(hj) of(i) one(k) of(j) the(ij) chief(hf) -(hi) .(g)  (g) to(hg) eat(fg) bread(g) on(gf) the(g) sabbath(fg) o(e) day,(e) [(e) —hold(ghij) there(i)  was(h) a(i) certain(i)  (jkj)  (h) man(i) before(k)  (k) him(j) which(ih) had(i) the(kj) dropsy;(hi)  (i) and(j)  he(i) took(jh) him,(h) and(hf) healed(hhi) him,(i) and(j)  (ji) let(hf) him(gf) go.(e) {(i) e(j)  (i)  (h)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-117.png",
        nextFileName: "./pages/part-c-118.png",
    },
    {
        title: "part-c-117-1",
        gabc: "M(fg) aster,(g) which(h) is(j) the(i) great(j) commandment(h)  (h) a(g) in(hi) the(h) law?(g)  Jesus(gj)  (i) said(jk) un-(hg)to(fg) him,(g) Thou(dfgh) shalt(g) love(gh) the(g) Lord(h) thy(gh) God(gf)  with(h) all(jh) thy(ih) heart,(gh) al(i) le-(h)lu-(g)ia.(g)  (j)  (i)  (j) L(h)  (dg) ",
        groupIndex: 1,
        filename: "./pages/part-c-117.png",
        nextFileName: "./pages/part-c-118.png",
    },
    {
        title: "part-c-118-0",
        gabc: "This(c)  (dd) kind(c) of(d) Fro(efg) vil(fe) han(d)  (dc) can(fh) come(gh) forth(g) by(f) nothing(fg)  (f)  put(cd) by(fe) prayer(g) and(fe) fasting.(d)  (d) |(h) o(g) o(f)  (gh) )(g) ",
        groupIndex: 0,
        filename: "./pages/part-c-118.png",
        nextFileName: "./pages/part-c-119.png",
    },
    {
        title: "part-c-118-1",
        gabc: "A(ij)  (g) vonan(i)  (i) in(ij) the(h) ci-(h)ty,(g) which(h) was(gf) a(fh) sinner,(h)  (g) stood(gh) at(i) the(j)  A(g)  (h)  Lord&#39;s(ij) feet(k) e(jh) e(j) him,(i) e(h) o(g) began(h) to(d) wash(e) his(f) feet(gh) with(h)  tears,(g) and(h) 5(i) wipe(j) them(h) with(g) the(h) hairs(e) of(f) her(gh) head,(g) and(h)  kissed(ji)  (h) .(ij) feet,(k) and(j) a-(i) (hh) nointed(gh) them(ef) with(g) the(gf) ointment.(e)  (e)  %?(j)  (h)  (j)  (ih)  (d)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-118.png",
        nextFileName: "./pages/part-c-119.png",
    },
    {
        title: "part-c-119-0",
        gabc: "The(c)  (d) Lord(ef) said(gh) un-(g)to(g) the(e) sick(gh) L](fe) the(d) palsy,(cd) B(d) Son,(ffh) be(g) of(h)  good(ik)  (fg) =(gh) thy(cd) sins(ffg) be(f) S(ef) forgiven(g)  (fe) thee.(d) I(h)  (g) =T(f) N(gh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png",
    },
    {
        title: "part-c-119-1",
        gabc: "Te]](fg) them(ggf) which(h) are(h) bidden,t(g)  (g) Behold,(g)  (gh) I(g) have(g) prepared(g)  (gh)  (g) my(g)  e(ik)  (ghgf) dinner;(f) come(hj) un-(j)to(ji) the(h) o)(j) marriage,(hg)  (ghg) al(f) —le-(fg)lu-(g)ia.(g)  (j)  (ijhghg) ",
        groupIndex: 1,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png",
    },
    {
        title: "part-c-119-2",
        gabc: "There(dfd) was(d) &#39;a(dc) certain(f)  (g) nobleman,(f)  (gh)  (hggf) whose(fg) son(h) was.sick(g)  (fg) at(f)  Ca-(fe)per-(g) (fe) na—um:(d) when(dfd) he(dc) heard(f) that(g) Je(fh) sus(h) was(h) come(hj)  out(h) of(g) Ju-(h)de-(g)a(f) in-(g)to(gh) Ga-(ffg)1li-(gf)lee,(f) he(g) besought(fe)  (ddf) him(fc) ",
        groupIndex: 2,
        filename: "./pages/part-c-119.png",
        nextFileName: "./pages/part-c-120.png",
    },
    {
        title: "part-c-120-0",
        gabc: "that(df) he(f) would(ef) heal(g) his(fe) son.(d)  (h)  (g)  (f)  (fh)  (gf) ",
        groupIndex: 0,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png",
    },
    {
        title: "part-c-120-1",
        gabc: "Then(ghj) said(h) the(h) lord(fg) un—to(gh)  (i) the(hi) servant,(g)  (g) Pay(h) me(h) that(g) thou(f)  -(fgh)owest.(h) The(h) servant(j)  (i) therefore(j)  (h) fell(j) down(g) and(i) worshipped(k)  (j) him,(k)  (hij)  have(jh) patience(ij)  (i) =(gh) me,(g) =(gh) Iwill(ih)  (gf) pay(gh) thee(h)  saying,(jj)  (i) Lord,(ik)  all.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 1,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png",
    },
    {
        title: "part-c-120-2",
        gabc: "aster,(fg)  (g) we(h) know(jh) that(gf) thou(gh) art(h) true,(g) and(h) teachest(j)  (i) the(h)  Y2y(ik)  (jg) of(hi) God(h) in(gd) truth,(hgf) al(fdfghd) —le-(h)e(g) e(g) A(j)  (i)  (j) SN(h)  (g) ",
        groupIndex: 2,
        filename: "./pages/part-c-120.png",
        nextFileName: "./pages/part-c-121.png",
    },
    {
        title: "part-c-121-0",
        gabc: "or(dd) u(c) said(d) within(f) .(g) herself,(fe)  (d) u(c)  (d) Imay(f) but(ed) touch(fg) the(f) hep(g)  of(ik)  (h) his(fg) garmc:nt,(fe)  (c) I(dc) shall(d) be(fe) whole.(d)  (h) |§(g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png",
    },
    {
        title: "part-c-121-1",
        gabc: "When(c)  (dc~) ye,(d) ——_—_—__—-(fe)therefore,(de) sial](dc) s;e(c) the(cd) a-(fe)bom—i-(g) (fe) na-(d)jion(dc)  of(fg) de-(h)so-(gf)la-(fh)tion,(h) spoken(h)  (g) of(h) by(f) Da-(g)ni-(fe)el(d)  (fe) the(gfe) prophet,(de)  (dc)  stand(c) in(d) the(ffe~) ho-(g)1ly(fe) place;(dc) whoso(d)  (dc) readeth,(df)  (f) let(df) him(ef) un-(d)der(cd)  stand.(d)  (h) i(g)  (f)  (gf)  (d) ",
        groupIndex: 1,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png",
    },
    {
        title: "part-c-121-2",
        gabc: "When(df) Je-(ff)sus(ded) lift-(cd)ed(fg) up(ed) his(fe) eyes,(d) and(cd) saw(dhi) a(h) great(hgfe) ",
        groupIndex: 2,
        filename: "./pages/part-c-121.png",
        nextFileName: "./pages/part-c-122.png",
    },
    {
        title: "part-c-122-0",
        gabc: "com—(gh) Ppa—1y(fe)  (dc) come(dc) un—to(d)  (fe) him,(fg) he(cd) saith(ffe) un(fgf) to(d) Philip:(cd)  (d)  Whence(dhi) shall(h) we(hggf) buy(ghg) bread(i)  (hiih) that(fg) these(ed) may(efe) eat?(d) And(f)  this(fe) he(d) said(fhgf) to(ed) prove(ec) him;(d) for(d) he(f)  (efd) himself(ed)  (cd) knew(ffgf) what(fhg)  e(ed) would(ef) do.(d)  (h)  (g)  (f)  (gh)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-122.png",
        nextFileName: "./pages/part-c-123.png",
    },
    {
        title: "part-c-123-0",
        gabc: "T(gi) hen(f) shall(h) the(g)  (fg) righteous(fe) shine(h) forth(ji) as(h) the(g) sun(fhih) ip(e) g,(f)  presence(gi)  (hi)  (g) of(hg) God.(f) ",
        groupIndex: 0,
        filename: "./pages/part-c-123.png",
        nextFileName: "./pages/part-c-124.png",
    },
    {
        title: "part-c-123-1",
        gabc: "Ve-(c) (d) ri(d) ~ly(f) IT(dc) say(f) un-(g)=(fh) you,(hgg) that(fg) -(h)S(fd~dgdddfd) dome(gdd)  (d)  -(k) (g) to(f) one(fe) of(f) the(d) L](c) -(df)T(fd) mine,(dddfd) :(fdddfgd) un=t(efddddfed) ",
        groupIndex: 1,
        filename: "./pages/part-c-123.png",
        nextFileName: "./pages/part-c-124.png",
    },
    {
        title: "part-c-124-0",
        gabc: "comes(f) Y€(d) blessed(ef)  (ghg) of(fg) my(f) Fa-(df)ther,(fc) in-(d)he-(ffg)rit(f) the(f) kingdom(g)  (fe)  prepar-(g) (fe) ed(de) for(dc) you(c) from(e) the(f) be(ge) -(gh)ginning(fe) of(d) the(cd) world.(d) ",
        groupIndex: 0,
        filename: "./pages/part-c-124.png",
        nextFileName: "./pages/part-c-125.png",
    },
    {
        title: "part-c-124-1",
        gabc: "eek(dh) ye(hj) first(h) the(h) kingdom(h)  (h) of(h) God,(hghihgg) and(gf) his(hf) rightecus-(fgh) (fe)  -(d)and(g) all(h) these(gf) things(f) shall(e) be(f) add-(g)ed(fe) un-(d)—to(fe) you:(d)  |(h)  (g)  (f)  (gh)  (gh) ",
        groupIndex: 1,
        filename: "./pages/part-c-124.png",
        nextFileName: "./pages/part-c-125.png",
    },
    {
        title: "part-c-125-0",
        gabc: "Be(gj) not(h) therefore(h)  (g) anxious,(h)  (gf) t(gh) saying,(g) What(h) shall(g) we(h) eat?(gf) 5(g)  What(gh) shall(f) we(fg) drink?(f) for(jk) your(i) heavenly(j)  (h) Father(j) 0(g) knoweth(fe) =(f)  that(d) ye(e) have(f) need(gh) of(h) all(g) these(fg) things.(g)  (j)  (i)  (j)  (h)  (g) ",
        groupIndex: 0,
        filename: "./pages/part-c-125.png",
        nextFileName: "./pages/part-c-126.png",
    },
    {
        title: "part-c-125-1",
        gabc: "O(g) ev-(g)er(f) 0(e) blessed(d) Mother(f)  (hg) of(fg) God,(g) Ma(j) —.ry(h) ev(j) —er(i)  (d) Virgin,(g)  (g)  temple(j)  (k) of(j) the(ji) Godhead,(h)  (h) hallowed(j)  (ji)  (gh) shrine(gh) of(g) the(f) Ho(h) 1y(hih) ",
        groupIndex: 1,
        filename: "./pages/part-c-125.png",
        nextFileName: "./pages/part-c-126.png",
    },
];
